// ../wistia-player/dist/wistia-player.js
var __webpack_modules__ = {
  /***/
  159(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Rb: () => (
        /* binding */
        findScriptInDomBySrc
      )
      /* harmony export */
    });
    var utilities_wlog_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(6637);
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(731);
    var utilities_runScript_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(1248);
    function ownKeys2(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
          return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread2(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
          _defineProperty2(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
          Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
      }
      return e;
    }
    function _defineProperty2(e, r, t) {
      return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    var findScriptInDomBySrc = function findScriptInDomBySrc2(targetSrc) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var scriptTags2 = document.getElementsByTagName("script");
      for (var i2 = 0; i2 < scriptTags2.length; i2++) {
        var s = scriptTags2[i2];
        var src2 = s.getAttribute("src") || "";
        if (options.ignoreQueryParams) {
          var matches2 = src2.split("?");
          var urlWithoutParams = matches2[0];
          src2 = urlWithoutParams;
        }
        if (!options.scriptRegex && options.ignoreProtocol) {
          src2 = src2.replace(/^https?:/, "");
          targetSrc = targetSrc.replace(/^https?:/, "");
        }
        if (options.scriptRegex && options.scriptRegex.test(src2)) {
          return s;
        }
        if (options.testStartsWith && src2.indexOf(targetSrc) === 0) {
          return s;
        }
        if (src2 === targetSrc) {
          return s;
        }
      }
      return null;
    };
    var removeScriptsBySrc2 = function removeScriptsBySrc3(targetSrc) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var s;
      var _loop2 = function _loop3() {
        if (s) {
          s.onload = s.onreadystatechange = s.onerror = null;
          if (s.parentNode && typeof s.parentNode.removeChild) {
            try {
              s.parentNode.removeChild(s);
            } catch (e) {
              setTimeout(function() {
                throw e;
              }, 0);
            }
          }
        }
      };
      while (s = findScriptInDomBySrc(targetSrc, options)) {
        _loop2();
      }
    };
    var runScript = function runScript2(src2) {
      var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 8e3;
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (timeout == null) {
        timeout = 8e3;
      }
      if (options == null) {
        options = {};
      }
      var s;
      var alreadyExists;
      return new Promise(function(resolve) {
        if (options.once === true && (s = findScriptInDomBySrc(src2))) {
          alreadyExists = true;
        }
        if (options.once && alreadyExists) {
          if (!s.readyState || /loaded|complete/.test(s.readyState)) {
            setTimeout(function() {
              resolve();
            }, 1);
          }
        } else {
          runScriptWithPromise(src2, timeout).then(resolve).catch(function(msg) {
            resolve(msg);
            setTimeout(function() {
              console.error(msg);
            }, 1);
          });
        }
      });
    };
    var runScripts2 = function runScripts3() {
      var scripts;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (args[0] instanceof Array) {
        scripts = args[0];
      } else {
        scripts = args;
      }
      scripts = scriptInputsToHash(scripts);
      var asyncScripts = [];
      var syncScripts = [];
      var scriptPromises = [];
      scripts.forEach(function(s) {
        var script = _objectSpread2({}, s);
        var p = new Promise(function(resolve) {
          script.resolve = resolve;
        });
        script.promise = p;
        scriptPromises.push(script.promise);
        if (s.async) {
          asyncScripts.push(script);
        } else {
          syncScripts.push(script);
        }
      });
      syncScripts.reduce(function(prev, script) {
        if (script.fn) {
          try {
            script.fn();
          } catch (e) {
            wlog.error(e);
          } finally {
            script.resolve();
          }
        } else if (script.src) {
          runScript(script.src, null, script).then(script.resolve);
        }
        return prev.then(script.promise);
      }, Promise.resolve());
      setTimeout(function() {
        asyncScripts.forEach(function(script) {
          if (script.fn) {
            try {
              script.fn();
            } catch (e) {
              wlog.error(e);
            } finally {
              script.resolve();
            }
          } else if (script.src) {
            runScript(script.src, null, script).then(script.resolve);
          }
        });
      }, 1);
      return Promise.all(scriptPromises);
    };
    var scriptInputsToHash = function scriptInputsToHash2(scripts) {
      var result = [];
      for (var i2 = 0; i2 < scripts.length; i2++) {
        var script = scripts[i2];
        if (typeof script === "string") {
          result.push({
            src: script,
            async: false
          });
        } else if (isObject(script)) {
          result.push(script);
        } else {
          result.push({
            fn: script,
            async: false
          });
        }
      }
      return result;
    };
  },
  /***/
  267(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      O: () => (
        /* binding */
        hasPerformanceMeasureSupport
      )
      /* harmony export */
    });
    var hasPerformanceMeasureSupport = function hasPerformanceMeasureSupport2() {
      var _window = window, performance2 = _window.performance;
      return Boolean(performance2) && Boolean(performance2.measure);
    };
  },
  /***/
  438(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      $F: () => (
        /* binding */
        choosePlayer
      ),
      /* harmony export */
      gC: () => (
        /* binding */
        buildContext
      )
      /* harmony export */
    });
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var utilities_detect_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(7231);
    var utilities_metrics_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(655);
    var utilities_legacyLocalstorage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(3695);
    var utilities_root_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(8176);
    var utilities_wlog_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(6637);
    var _assets_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__3(7209);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__3(5509);
    function ownKeys2(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
          return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread2(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
          _defineProperty2(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
          Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
      }
      return e;
    }
    function _defineProperty2(e, r, t) {
      return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    var wlog2 = utilities_wlog_js__WEBPACK_IMPORTED_MODULE_5__.ct.getPrefixedFunctions("judy");
    var AUTO = "auto";
    var CAROUSEL_HARD_WALL = "carouselHardWall";
    var EXTERNAL = "external";
    var HLS_VIDEO = "hlsVideo";
    var HTML5 = "html5";
    var MANUAL_QUALITY_VIDEO = "manualQualityVideo";
    var NATIVE_HLS_VIDEO = "nativeHlsVideo";
    var NOT_PLAYABLE = "notplayable";
    var PASSWORD_PROTECTED = "passwordprotected";
    var SIMPLE_HTML5 = "simplehtml5";
    var VULCAN_V2 = "vulcan-v2";
    var SPHERICAL_VIDEO = "sphericalVideo";
    var PLAYERS = [VULCAN_V2, HTML5, SIMPLE_HTML5, EXTERNAL, NOT_PLAYABLE, PASSWORD_PROTECTED];
    var HLS_ENGINE_PATH = "engines/hls_video.js";
    var NATIVE_HLS_ENGINE_PATH = "engines/native_hls_video.js";
    var SIMPLE_AUDIO_ENGINE_PATH = "engines/simple_audio.js";
    var MANUAL_QUALITY_ENGINE_PATH = "engines/manual_quality_video.js";
    var SPHERICAL_VIDEO_ENGINE_PATH = "engines/spherical_video.js";
    var PLUGIN_CONFIGS = {
      notPlayableVideo: {
        on: true,
        initBeforeHasData: true,
        async: false,
        loadWeight: -1
      },
      vulcanV2Player: {
        on: true,
        initBeforeHasData: false,
        async: false,
        loadWeight: -1
      },
      hlsVideo: {
        on: true,
        initBeforeHasData: false,
        async: false,
        loadWeight: 0
      },
      nativeHlsVideo: {
        on: true,
        initBeforeHasData: false,
        async: false,
        loadWeight: 0
      },
      passwordProtectedVideo: {
        on: true,
        initBeforeHasData: true,
        async: false,
        loadWeight: -1
      },
      externalPlayer: {
        on: true,
        initBeforeHasData: false,
        async: false,
        loadWeight: -1
      },
      html5Player: {
        on: true,
        initBeforeHasData: false,
        async: false,
        loadWeight: -1
      },
      playlist: {
        on: true,
        initBeforeHasData: false,
        async: false,
        loadWeight: -1
      }
    };
    var bestPlayer = function bestPlayer2(context, mediaData, embedOptions) {
      var detect = context.detect, logger = context.logger;
      var isSpherical = isSphericalVideo({
        mediaData,
        options: embedOptions
      }, detect);
      if (detect.oldandroid) {
        logger.info("external on old android");
        return EXTERNAL;
      }
      if (canUsePlayer(context, VULCAN_V2, mediaData)) {
        logger.info("default, ret", VULCAN_V2);
        return VULCAN_V2;
      }
      if (mediaData.mediaType === "Audio" || mediaData.mediaType === "LiveStream") {
        return VULCAN_V2;
      }
      if (canUsePlayer(context, HTML5, mediaData)) {
        logger.info("default, ret", HTML5);
        return HTML5;
      }
      logger.info("nothing left, use", EXTERNAL);
      return EXTERNAL;
    };
    var bestUsableEngine = function bestUsableEngine2(context, mediaData) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var detect = context.detect, logger = context.logger;
      logger.info("bestUsableEngineClass");
      var allowHls = shouldServeHls(context, mediaData, options);
      var isSpherical = isSphericalVideo({
        mediaData,
        options
      }, detect);
      if (options.engine) {
        return options.engine;
      }
      if (isSpherical) {
        logger.info(SPHERICAL_VIDEO);
        return SPHERICAL_VIDEO_ENGINE_PATH;
      }
      if (mediaData.mediaType === "Audio") {
        return SIMPLE_AUDIO_ENGINE_PATH;
      }
      var isApple = detect.safari || detect.ios.version > 0;
      var allowsSameOrigin = window.origin !== "null";
      var restrictedBySameOrigin = isApple && !allowsSameOrigin;
      if (allowHls && detect.nativeHls && (detect.managedMediaSource === false || restrictedBySameOrigin)) {
        logger.info(NATIVE_HLS_VIDEO);
        return NATIVE_HLS_ENGINE_PATH;
      }
      if (allowHls) {
        logger.info(HLS_VIDEO);
        return HLS_ENGINE_PATH;
      }
      logger.info(MANUAL_QUALITY_VIDEO);
      return MANUAL_QUALITY_ENGINE_PATH;
    };
    var bestUsableEngineClass = function bestUsableEngineClass2(context, mediaData) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var detect = context.detect, logger = context.logger;
      logger.info("bestUsableEngineClass");
      var allowHls = shouldServeHls(context, mediaData, options);
      var engines = Wistia.engines || {};
      if (mediaData.mediaType === "Audio") {
        return engines.SimpleAudio;
      }
      if (allowHls && detect.nativeHls && engines.NativeHlsVideo) {
        logger.info(NATIVE_HLS_VIDEO);
        return engines.NativeHlsVideo;
      }
      if (allowHls && engines.HlsVideo) {
        logger.info(HLS_VIDEO);
        return engines.HlsVideo;
      }
      logger.info(MANUAL_QUALITY_VIDEO);
      return engines.ManualQualityVideo;
    };
    var buildContext = function buildContext2() {
      var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var pageUrl = contextUrl(overrides);
      return _objectSpread2(_objectSpread2(_objectSpread2({}, getDefaultContext()), overrides), {}, {
        pageUrl
      });
    };
    var canPlayInline = function canPlayInline2(context) {
      var detect = context.detect;
      return detect.android || detect.ios.version >= 10;
    };
    var canUsePlayer = function canUsePlayer2(context, player, mediaData) {
      return isSupportedPlayer(context, player) && hasAssetsForPlayer(context, player, mediaData);
    };
    var choosePlayer = function choosePlayer2(context, mediaData, embedOptions) {
      var detect = context.detect;
      var logger = context.logger;
      var playerForce = embedOptions.playerForce;
      logger.info("choosePlayer input", mediaData.hashedId);
      var playerPreference = determinePlayerPreferenceFromInput(context, mediaData, embedOptions);
      if (playerForce && !isValidPlayer(context, playerForce)) {
        logger.error('Invalid playerForce option: "'.concat(playerForce, '", ignoring'));
        playerForce = null;
      }
      if (playerPreference && playerPreference !== AUTO && !isValidPlayer(context, playerPreference)) {
        logger.error('Invalid playerPreference option: "'.concat(playerPreference, '", ignoring'));
        playerPreference = AUTO;
      }
      logger.info("playerPreference is", playerPreference);
      if (playerForce) {
        logger.info('"playerForce" used, return', playerForce);
        return playerForce;
      }
      if (mediaData.carouselHardWall) {
        logger.info("return", CAROUSEL_HARD_WALL);
        return CAROUSEL_HARD_WALL;
      }
      if (isPasswordProtected(context, embedOptions)) {
        logger.info("return", PASSWORD_PROTECTED);
        return PASSWORD_PROTECTED;
      }
      if (isNotPlayable(context, mediaData, embedOptions)) {
        logger.info("return", NOT_PLAYABLE);
        return NOT_PLAYABLE;
      }
      if (mediaData.protected) {
        return VULCAN_V2;
      }
      if (playerPreference !== AUTO && canUsePlayer(context, playerPreference, mediaData)) {
        var isSpherical = isSphericalVideo({
          mediaData,
          options: embedOptions
        }, detect);
        if (playerPreference !== VULCAN_V2 && isSpherical) {
          logger.info("this player doesn't support spherical, return", VULCAN_V2);
          return VULCAN_V2;
        }
        logger.info('"playerPreference" used, return', playerPreference);
        return playerPreference;
      }
      logger.info("choosing player with no preference");
      return bestPlayer(context, mediaData, embedOptions);
    };
    var contextUrl = function contextUrl2() {
      var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (opts.pageUrl) {
        return opts.pageUrl;
      }
      if (Object(window.FreshUrl).originalUrl) {
        return window.FreshUrl.originalUrl;
      }
      if (window.top === window.self) {
        return location.href || "";
      }
      return document.referrer || "";
    };
    var determinePlayerPreferenceFromInput = function determinePlayerPreferenceFromInput2(context, mediaData, embedOptions) {
      var playerPreference = embedOptions.playerPreference || embedOptions.platformPreference;
      if (playerPreference && playerPreference !== AUTO) {
        if (playerPreference === HTML5) {
          if (isMobile(context)) {
            return HTML5;
          }
          return VULCAN_V2;
        }
        if (playerPreference === SIMPLE_HTML5) {
          return HTML5;
        }
        return playerPreference;
      }
      return AUTO;
    };
    var doesBrowserSupportHlsTools = function doesBrowserSupportHlsTools2(detect) {
      var hasPromise = Boolean(window.Promise);
      return (detect.mediaSource || detect.nativeHls) && hasPromise;
    };
    var enginesToLoad = function enginesToLoad2(context, mediaData) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var detect = context.detect, logger = context.logger;
      var engineNames = [];
      logger.info("enginesToLoad");
      var allowHls = shouldServeHls(context, mediaData, options);
      if (allowHls && detect.nativeHls) {
        logger.info(NATIVE_HLS_VIDEO);
        engineNames.push(NATIVE_HLS_VIDEO);
      } else if (allowHls) {
        logger.info(HLS_VIDEO);
        engineNames.push(HLS_VIDEO);
      } else {
        logger.info(MANUAL_QUALITY_VIDEO);
        engineNames.push(MANUAL_QUALITY_VIDEO);
      }
      var isSpherical = isSphericalVideo({
        mediaData,
        options
      }, detect);
      if (isSpherical) {
        engineNames.push(SPHERICAL_VIDEO);
        logger.info(SPHERICAL_VIDEO);
      }
      var tmpHash = {};
      engineNames.forEach(function(engineName2) {
        tmpHash[engineName2] = true;
      });
      var result = [];
      for (var engineName in tmpHash) {
        result.push(engineName);
      }
      return result;
    };
    var cachedDefaultContext;
    var getDefaultContext = function getDefaultContext2() {
      if (cachedDefaultContext) {
        return cachedDefaultContext;
      }
      cachedDefaultContext = {
        detect: (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.o8)((0, utilities_detect_js__WEBPACK_IMPORTED_MODULE_1__.o1)()),
        inIframe: top !== self,
        location: window.location,
        logger: wlog2,
        pageUrl: location.href,
        silenceGlobalWarnings: utilities_root_js__WEBPACK_IMPORTED_MODULE_4__.z.wistiaSilenceGlobalWarnings,
        userAgent: navigator.userAgent
      };
      return cachedDefaultContext;
    };
    var getPluginConfig = function getPluginConfig2(context, pluginName) {
      var result = {};
      result[pluginName] = PLUGIN_CONFIGS[pluginName];
      return result;
    };
    var canUseInstantHls = function canUseInstantHls2(context, mediaData) {
      var embedOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return embedOptions.instantHls !== false && mediaData.instantHlsAssetsReady && shouldServeHls(context, mediaData, embedOptions);
    };
    var canUseOriginalFilePlayback = function canUseOriginalFilePlayback2(context, mediaData) {
      var embedOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return mediaData.originalIsEligibleForDirectPlayback && shouldServeHls(context, mediaData, embedOptions);
    };
    var hasAssetsForPlayer = function hasAssetsForPlayer2(context, player, mediaData) {
      if (!isValidPlayer(context, player)) {
        return false;
      }
      if (player === NOT_PLAYABLE || player === PASSWORD_PROTECTED || player === CAROUSEL_HARD_WALL) {
        return true;
      }
      var assets = mediaData.assets;
      if (player === VULCAN_V2) {
        return canUseInstantHls(context, mediaData) || canUseOriginalFilePlayback(context, mediaData) || hasReadyVideoAssets(assets) || hasReadyAudioAssets(assets);
      }
      if (player === HTML5) {
        return (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.Fi)(assets).length > 0;
      }
      if (player === EXTERNAL) {
        return (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.Fi)(assets).length > 0;
      }
      throw new Error("Unhandled player type '".concat(player, "'"));
    };
    var hasReadyVideoAssets = function hasReadyVideoAssets2(assets) {
      return (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.Fi)(assets).length > 0 || (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.x4)(assets).length > 0;
    };
    var hasReadyAudioAssets = function hasReadyAudioAssets2(assets) {
      return (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.o2)(assets).length > 0;
    };
    var hasEnoughReadyMp4Assets = function hasEnoughReadyMp4Assets2(assets) {
      var mp4Assets = (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.pb)(assets, {
        container: "mp4",
        metadata: function metadata(m) {
          return m && m.max_bitrate;
        },
        public: true,
        sortBy: "width desc",
        status: _assets_js__WEBPACK_IMPORTED_MODULE_6__.yE,
        type: /\b(?!captioned_video)\S+/
        // no burned in captions
      });
      var hasAssetWithBitRateAndSize = Boolean(mp4Assets[0] && mp4Assets[0].width >= 400);
      return hasAssetWithBitRateAndSize;
    };
    var hasSupportedHlsAssets = function hasSupportedHlsAssets2(mediaData) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (options.instantHls !== false && mediaData.instantHlsAssetsReady) {
        return true;
      }
      if (mediaData.originalIsEligibleForDirectPlayback) {
        return true;
      }
      var hasAssets = hasEnoughReadyMp4Assets(mediaData.assets);
      if (!hasAssets) {
        (0, utilities_metrics_js__WEBPACK_IMPORTED_MODULE_2__.U9)("player/originV2/media-has-no-metadata", 1, {
          hashedId: mediaData.hashedId
        });
      }
      return hasAssets;
    };
    var hlsOverrideValue = function hlsOverrideValue2(_ref, embedOptions) {
      var pageUrl = _ref.pageUrl;
      var paramVal = hlsQueryParamValue(pageUrl);
      if (paramVal != null) {
        return paramVal;
      }
      var localStorageVal = (0, utilities_legacyLocalstorage_js__WEBPACK_IMPORTED_MODULE_3__.Qy)("forceHls");
      if (localStorageVal != null) {
        return localStorageVal;
      }
      return embedOptions.hls;
    };
    var hlsQueryParamValue = function hlsQueryParamValue2(pageUrl) {
      var match = pageUrl && pageUrl.match && pageUrl.match(/[&?]whls=([^&]+)/);
      var val = match && match[1];
      if (val != null) {
        return (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.wg)(val);
      }
      return null;
    };
    var isBrowserInNativeAndroid = function isBrowserInNativeAndroid2(detect, embedOptions) {
      return detect.android && (embedOptions.playsinline === false || embedOptions.nativeMode === true);
    };
    var isBrowserOldChrome = function isBrowserOldChrome2(detect) {
      return detect.chrome && parseInt(detect.chrome.version, 10) < 50;
    };
    var isHlsEnabled = function isHlsEnabled2(context, mediaData, embedOptions) {
      var overrideValue = hlsOverrideValue(context, embedOptions);
      if (overrideValue === true || overrideValue === false) {
        return overrideValue;
      }
      if (mediaData.hls_enabled === false) {
        return false;
      }
      return true;
    };
    var isMobile = function isMobile2(_ref2) {
      var detect = _ref2.detect;
      return detect.iphone || detect.ipad || detect.android;
    };
    var isNotPlayable = function isNotPlayable2(context, mediaData) {
      var _embedOptions$authori;
      var embedOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var assets = mediaData.assets;
      if (!mediaData.protected && (canUseInstantHls(context, mediaData, embedOptions) || canUseOriginalFilePlayback(context, mediaData, embedOptions))) {
        return false;
      }
      var assetsArentReady = mediaData.type === "Audio" ? (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.o2)(assets).length == 0 : (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.Fi)(assets).length == 0;
      if (mediaData.mediaType === "LiveStream") {
        return false;
      }
      if (mediaData.protected && !((_embedOptions$authori = embedOptions.authorization) !== null && _embedOptions$authori !== void 0 && _embedOptions$authori.jwt)) {
        embedOptions.notPlayableOptions = {
          fadeIn: false,
          message: "This video is set to private.",
          shouldRefresh: false
        };
        return true;
      }
      var allowHls = shouldServeHls(context, mediaData, embedOptions);
      if (mediaData.protected && allowHls === false) {
        embedOptions.notPlayableOptions = {
          fadeIn: false,
          message: "This video is not playable.",
          shouldRefresh: false
        };
        return true;
      }
      return assets.length === 0 || assets.length === 1 && assets[0].type === "original" || assetsArentReady || (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.aF)(assets).length > 0 && (0, _assets_js__WEBPACK_IMPORTED_MODULE_6__.n9)(assets).length === 0;
    };
    var isPasswordProtected = function isPasswordProtected2(context, embedOptions) {
      var pluginOpts = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.b$)(embedOptions, "plugin.passwordProtectedVideo");
      return pluginOpts != null && pluginOpts.on !== false;
    };
    var isSphericalVideo = function isSphericalVideo2() {
      var _mediaInfo$mediaData, _mediaInfo$opts;
      var mediaInfo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (mediaInfo.options.overrideSpherical) {
        return false;
      }
      var mediaDataSpherical = String((_mediaInfo$mediaData = mediaInfo.mediaData) === null || _mediaInfo$mediaData === void 0 ? void 0 : _mediaInfo$mediaData.spherical);
      var optsSpherical = String((_mediaInfo$opts = mediaInfo.opts) === null || _mediaInfo$opts === void 0 ? void 0 : _mediaInfo$opts.spherical);
      return mediaDataSpherical === "true" || optsSpherical === "true";
    };
    var isSupportedPlayer = function isSupportedPlayer2(context, player) {
      if (!isValidPlayer(context, player)) {
        return false;
      }
      return (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.qh)(supportedPlayers(context), player) >= 0;
    };
    var isValidPlayer = function isValidPlayer2(context, player) {
      return (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.qh)(PLAYERS, player) >= 0;
    };
    var logWarnings = function logWarnings2(context) {
      var detect = context.detect, userAgent = context.userAgent, logger = context.logger, silenceGlobalWarnings = context.silenceGlobalWarnings;
      if (silenceGlobalWarnings) {
        return;
      }
      var isHeadless = /phantomjs/i.test(userAgent);
      if (xhrHasBeenTamperedWith()) {
        if (!isHeadless) {
          logger.error("The XMLHttpRequest constructor has been tampered with. Because this affects CORS/Range XHR requests, HLS playback has been disabled. To enable HLS playback and other important features, please remove code that changes the definition of window.XMLHttpRequest.");
        }
      }
      if (urlHasBeenTamperedWith()) {
        if (detect.mediaSource && !isHeadless) {
          logger.error("window.URL.createObjectURL has been tampered with. Because this affects use of Media Source Extensions, HLS playback has been disabled. window.URL is a browser API that should not be clobbered. Its current value is:", window.URL);
        }
      }
    };
    var playerPlugins = function playerPlugins2(context, player, mediaData, embedOptions) {
      var logger = context.logger;
      var plugins = {};
      logger.info("playerPlugins input", player, mediaData.hashedId, mediaData, embedOptions);
      if (player === NOT_PLAYABLE) {
        merge(plugins, getPluginConfig(context, "notPlayableVideo"));
      } else if (player === PASSWORD_PROTECTED) {
        merge(plugins, getPluginConfig(context, "passwordProtectedVideo"));
      } else if (player === HTML5) {
        merge(plugins, getPluginConfig(context, "html5Player"));
      } else if (player === EXTERNAL) {
        merge(plugins, getPluginConfig(context, "externalPlayer"));
      } else if (player === VULCAN_V2) {
        merge(plugins, getPluginConfig(context, "vulcanV2Player"));
      }
      var pluginNames = [];
      for (var k in plugins) {
        pluginNames.push(k);
      }
      logger.info.apply(logger, ["playerPlugins output"].concat(pluginNames, [plugins]));
      return plugins;
    };
    var report = function report2(context, mediaData, embedOptions) {
      return {
        bestPlayer: bestPlayer(context, mediaData, embedOptions),
        playerPreferenceFromInput: determinePlayerPreferenceFromInput(context, mediaData, embedOptions),
        supportedPlayers: supportedPlayers(context),
        usablePlayers: usablePlayers(context, mediaData.assets)
      };
    };
    var shouldServeHls = function shouldServeHls2(context, mediaData, embedOptions) {
      if (mediaData.type === "LiveStream") {
        return true;
      }
      var detect = context.detect;
      return doesBrowserSupportHlsTools(detect) && !isBrowserOldChrome(detect) && !isBrowserInNativeAndroid(detect, embedOptions) && // the account has hls enabled or explicitly trying to force
      isHlsEnabled(context, mediaData, embedOptions) && // the media actually has desktop assets compatable with the delivery system
      hasSupportedHlsAssets(mediaData) && // Some sites completely replace the XMLHttpRequest constructor with one
      // that doesn't work with hls.js. If we detect that, don't use HLS
      // (...unless we explicitly say to try it.)
      (!xhrHasBeenTamperedWith(context) && !urlHasBeenTamperedWith(context) || hlsOverrideValue(context, embedOptions));
    };
    var supportedPlayers = function supportedPlayers2(context) {
      var detect = context.detect;
      var result = [NOT_PLAYABLE, PASSWORD_PROTECTED, EXTERNAL, CAROUSEL_HARD_WALL];
      if (detect.vulcanV2Support) {
        result.push(VULCAN_V2);
      }
      if (detect.video.h264) {
        result.push(HTML5);
      }
      return result;
    };
    var usablePlayers = function usablePlayers2(context, mediaData) {
      var result = [];
      var candidates = supportedPlayers(context);
      for (var i2 = 0; i2 < candidates.length; i2++) {
        var player = candidates[i2];
        if (canUsePlayer(context, player, mediaData)) {
          result.push(player);
        }
      }
      return result;
    };
    var urlHasBeenTamperedWith = function urlHasBeenTamperedWith2() {
      return typeof (window.URL && window.URL.createObjectURL) !== "function";
    };
    var XMLHTTPREQUEST_CONSTRUCTOR_RE = /\s*function\s+XMLHttpRequest\(\)\s*{\s*\[native code\]\s*}\s*/m;
    var XMLHTTPREQUEST_CONSTRUCTOR_IN_SAFARI_9_RE = /\[object XMLHttpRequestConstructor\]/m;
    var xhrHasBeenTamperedWith = function xhrHasBeenTamperedWith2() {
      if (XMLHttpRequest && XMLHttpRequest.prototype && XMLHttpRequest.prototype.constructor) {
        var constructorString = XMLHttpRequest.prototype.constructor.toString();
        return !(XMLHTTPREQUEST_CONSTRUCTOR_RE.test(constructorString) || XMLHTTPREQUEST_CONSTRUCTOR_IN_SAFARI_9_RE.test(constructorString));
      }
      return true;
    };
  },
  /***/
  541(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      z: () => (
        /* binding */
        maybeStartWistiaQueue
      )
      /* harmony export */
    });
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(5509);
    var QUEUE_INTERVAL = 500;
    var wistiaQueue = null;
    var maybeStartWistiaQueue = function maybeStartWistiaQueue2() {
      if (wistiaQueue) {
        return;
      }
      wistiaQueue = setInterval(function() {
        var queue = window._wq;
        if (!queue || queue.length === 0) {
          return;
        }
        queue.slice(0).forEach(function(item) {
          if (typeof item === "function") {
            item(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s);
            queue.splice(queue.indexOf(item), 1);
          } else if (!_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s.flushInitQueue) {
            queue.splice(queue.indexOf(item), 1);
            console.warn("<wistia-player> elements must be configured via window.wistiaOptions instead of window._wq. Config not applied", item);
          }
        });
      }, QUEUE_INTERVAL);
    };
    var stopWistiaQueue = function stopWistiaQueue2() {
      if (wistiaQueue) {
        clearInterval(wistiaQueue);
        wistiaQueue = null;
      }
    };
  },
  /***/
  655(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      U9: () => (
        /* binding */
        count
      )
      /* harmony export */
    });
    var utilities_timeout_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(3737);
    var utilities_wlog_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(6637);
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(731);
    var utilities_elem_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(7715);
    var utilities_url_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(2671);
    var utilities_hosts_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(5857);
    var utilities_trackingConsentApi_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__3(4755);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__3(5509);
    var _this = void 0;
    var W = (
      /* unused pure expression or super */
      null
    );
    if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_7__.s._metricsCache == null) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_7__.s._metricsCache = {};
    }
    var METRICS_CACHE = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_7__.s._metricsCache;
    var send = function send2(type, key, val) {
      var extraData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      try {
        if (METRICS_CACHE.toMput == null) {
          METRICS_CACHE.toMput = [];
        }
        if (METRICS_CACHE.requestId == null) {
          METRICS_CACHE.requestId = 0;
        }
        var messageObj = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_2__.h1)({
          type,
          key,
          value: val != null ? val : null,
          request_id: METRICS_CACHE.requestId
        }, extraData);
        var serialized = JSON.stringify(messageObj);
        utilities_wlog_js__WEBPACK_IMPORTED_MODULE_1__.ct.debug("send metrics", serialized);
        METRICS_CACHE.toMput.push(serialized);
        (0, utilities_timeout_utils_js__WEBPACK_IMPORTED_MODULE_0__.L)("metrics.debounce", function() {
          (0, utilities_elem_js__WEBPACK_IMPORTED_MODULE_3__.Rx)(function() {
            msend.apply(_this, METRICS_CACHE.toMput);
            METRICS_CACHE.toMput = [];
            METRICS_CACHE.requestId += 1;
          });
        }, 500);
      } catch (e) {
        utilities_wlog_js__WEBPACK_IMPORTED_MODULE_1__.ct.error(e);
      }
    };
    var msend = function msend2() {
      if (!(0, utilities_trackingConsentApi_js__WEBPACK_IMPORTED_MODULE_6__.D5)()) {
        return;
      }
      var url = "".concat((0, utilities_url_js__WEBPACK_IMPORTED_MODULE_4__.ff)(), "//").concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_5__.Qz)(), "/mput?topic=metrics");
      for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
        messages[_key] = arguments[_key];
      }
      return fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: messages.join("\n")
      }).then(function(response) {
        if (!response.ok) {
          console.error(response);
        }
      }).catch(function(reason) {
        console.error(reason);
      });
    };
    var count = function count2(key) {
      var val = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
      var extraData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return send("count", key, val, extraData);
    };
    var sample = function sample2(key, val, extraData) {
      return send("sample", key, val, extraData);
    };
  },
  /***/
  731(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Cs: () => (
        /* binding */
        eachLeaf
      ),
      /* harmony export */
      G0: () => (
        /* binding */
        unsetDeep
      ),
      /* harmony export */
      Im: () => (
        /* binding */
        isEmpty
      ),
      /* harmony export */
      Lt: () => (
        /* binding */
        select
      ),
      /* harmony export */
      b$: () => (
        /* binding */
        getDeep
      ),
      /* harmony export */
      cy: () => (
        /* binding */
        isArray2
      ),
      /* harmony export */
      di: () => (
        /* binding */
        sort
      ),
      /* harmony export */
      h1: () => (
        /* binding */
        merge2
      ),
      /* harmony export */
      iu: () => (
        /* binding */
        except
      ),
      /* harmony export */
      j6: () => (
        /* binding */
        only
      ),
      /* harmony export */
      kp: () => (
        /* reexport safe */
        utilities_assign_js__WEBPACK_IMPORTED_MODULE_0__.k
      ),
      /* harmony export */
      mA: () => (
        /* binding */
        setAndPreserveUndefined
      ),
      /* harmony export */
      o8: () => (
        /* binding */
        clone2
      ),
      /* harmony export */
      qh: () => (
        /* binding */
        indexOf
      ),
      /* harmony export */
      vd: () => (
        /* binding */
        setDeep
      ),
      /* harmony export */
      wg: () => (
        /* binding */
        cast2
      )
      /* harmony export */
    });
    var utilities_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9025);
    var _this = (
      /* unused pure expression or super */
      null
    );
    var _objectHasOwn = function(object, property) {
      if (typeof object === "undefined" || object === null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    };
    var aps = Array.prototype.slice;
    var merge2 = function merge3(obj1) {
      if ((arguments.length <= 1 ? 0 : arguments.length - 1) === 0) {
        return obj1;
      }
      for (var i2 = 0; i2 < (arguments.length <= 1 ? 0 : arguments.length - 1); i2++) {
        _mergeOne(obj1, i2 + 1 < 1 || arguments.length <= i2 + 1 ? void 0 : arguments[i2 + 1]);
      }
      return obj1;
    };
    var _mergeOne = function mergeOne(obj1, obj2) {
      var transformerFn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : identityFunc;
      var shouldDeleteFn = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : legacyShouldDeleteFromMerge;
      if (isArray2(obj2)) {
        if (!isArray2(obj1)) {
          obj1 = [];
        }
        for (var i2 = 0; i2 < obj2.length; i2++) {
          var v = obj2[i2];
          if (obj1[i2] == null && v != null) {
            if (isArray2(v)) {
              obj1[i2] = [];
            } else if (isObject2(v)) {
              obj1[i2] = {};
            }
          }
          var result = _mergeOne(obj1[i2], v, transformerFn);
          if (shouldDeleteFn(obj2, i2, result)) {
            delete obj1[i2];
          } else {
            obj1[i2] = result;
          }
        }
        return transformerFn(obj1);
      }
      if (isObject2(obj2)) {
        for (var k in obj2) {
          if (_objectHasOwn(obj2, k) && (_objectHasOwn(obj1, k) || obj1[k] == null)) {
            var _v = obj2[k];
            if (isArray2(_v)) {
              if (!isArray2(obj1[k])) {
                obj1[k] = [];
              }
              _mergeOne(obj1[k], _v, transformerFn);
              obj1[k] = transformerFn(obj1[k]);
            } else if (isObject2(_v)) {
              if (!isObject2(obj1[k])) {
                obj1[k] = {};
              }
              _mergeOne(obj1[k], _v, transformerFn);
              obj1[k] = transformerFn(obj1[k]);
            } else if (obj1 == null) {
              obj1 = {};
              if (!shouldDeleteFn(obj2, k, _v)) {
                obj1[k] = transformerFn(_v);
              }
            } else if (shouldDeleteFn(obj2, k, _v)) {
              delete obj1[k];
            } else {
              obj1[k] = transformerFn(_v);
            }
          }
        }
        return transformerFn(obj1);
      }
      return transformerFn(obj2);
    };
    var identityFunc = function identityFunc2(v) {
      return v;
    };
    var legacyShouldDeleteFromMerge = function legacyShouldDeleteFromMerge2(obj, k, v) {
      return v == null;
    };
    var clone2 = function clone3(obj, transformerFn) {
      if (isArray2(obj)) {
        return _mergeOne([], obj, transformerFn);
      }
      return _mergeOne({}, obj, transformerFn);
    };
    var getDeep = function getDeep2(obj, parts, create) {
      if (typeof parts === "string") {
        parts = parts.split(".");
      } else {
        parts = aps.call(parts);
      }
      var lastObj = obj;
      var lastP;
      while (obj != null && parts.length) {
        var p = parts.shift();
        if ((obj[p] === void 0 || !isObject2(obj[p]) && !isArray2(obj[p])) && create) {
          if (p === 0) {
            obj = lastObj[lastP] = [];
            obj[p] = {};
          } else {
            obj[p] = {};
          }
        }
        lastObj = obj;
        lastP = p;
        if (_objectHasOwn(obj, p)) {
          obj = obj[p];
        } else {
          obj = void 0;
        }
      }
      return obj;
    };
    var setDeep = function setDeep2(obj, parts, value) {
      return setAndMaybeDeleteUndefined(obj, parts, value, true);
    };
    var setAndPreserveUndefined = function setAndPreserveUndefined2(obj, parts, value) {
      return setAndMaybeDeleteUndefined(obj, parts, value, false);
    };
    var setAndMaybeDeleteUndefined = function setAndMaybeDeleteUndefined2(obj, parts, value) {
      var shouldDeleteUndefined = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
      if (typeof parts === "string") {
        parts = parts.split(".");
      } else {
        parts = aps.call(parts);
      }
      var prop = parts.pop();
      obj = getDeep(obj, parts, true);
      if (obj != null && (isObject2(obj) || isArray2(obj)) && prop != null) {
        if (!shouldDeleteUndefined || value != null) {
          obj[prop] = value;
        } else {
          delete obj[prop];
        }
      } else {
        return void 0;
      }
    };
    var unsetDeep = function unsetDeep2(obj, parts) {
      return setDeep(obj, parts);
    };
    var exists = function exists2(obj, name) {
      return getDeep(obj, name) !== void 0;
    };
    var cast2 = function cast3(maybeStr) {
      if (maybeStr == null) {
        return maybeStr;
      }
      if (isObject2(maybeStr) || isArray2(maybeStr)) {
        return castDeep(maybeStr);
      }
      return castStr("".concat(maybeStr), maybeStr);
    };
    var castStr = function castStr2(str) {
      var defaultRet = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : str;
      if (/^-?[1-9]\d*?$/.test(str)) {
        return parseInt(str, 10);
      }
      if (str === "0" || str === "-0") {
        return 0;
      }
      if (/^-?\d*\.\d+$/.test(str)) {
        return parseFloat(str);
      }
      if (/^true$/i.test(str)) {
        return true;
      }
      if (/^false$/i.test(str)) {
        return false;
      }
      return defaultRet;
    };
    var castDeep = function castDeep2(obj) {
      var castTransformer = function castTransformer2(val) {
        if (typeof val === "string") {
          return castStr(val);
        }
        return val;
      };
      var dontDeleteAnything = function dontDeleteAnything2() {
        return false;
      };
      return _mergeOne(obj, obj, castTransformer, dontDeleteAnything);
    };
    var only = function only2(hash2, keys2) {
      var result = {};
      var keyHash = {};
      for (var i2 = 0; i2 < keys2.length; i2++) {
        keyHash[keys2[i2]] = true;
      }
      for (var k in hash2) {
        if (keyHash[k]) {
          result[k] = hash2[k];
        }
      }
      return result;
    };
    var except = function except2(hash2, keys2) {
      var result = {};
      var keyHash = {};
      for (var i2 = 0; i2 < keys2.length; i2++) {
        keyHash[keys2[i2]] = true;
      }
      for (var k in hash2) {
        if (!keyHash[k]) {
          result[k] = hash2[k];
        }
      }
      return result;
    };
    var select = function select2(arr, keyPairs) {
      var result = [];
      var isFn = typeof keyPairs === "function";
      var filterFn = isFn ? keyPairs : null;
      for (var i2 = 0; i2 < arr.length; i2++) {
        var elem = arr[i2];
        if (isFn) {
          if (filterFn(elem)) {
            result.push(elem);
          }
        } else {
          var matching = true;
          for (var k in keyPairs) {
            var v = keyPairs[k];
            if (v instanceof Array) {
              if (!elem[k] || elem[k] < v[0] || elem[k] > v[1]) {
                matching = false;
                break;
              }
            } else if (v instanceof RegExp) {
              if (!v.test(elem[k])) {
                matching = false;
                break;
              }
            } else if (v instanceof MultipleValues) {
              var anyMatch = false;
              for (var j = 0; j < v.values.length; j++) {
                var value = v.values[j];
                if (elem[k] === value) {
                  anyMatch = true;
                  break;
                }
              }
              if (!anyMatch) {
                matching = false;
                break;
              }
            } else if (typeof v === "function") {
              if (elem[k] == null || !v(elem[k])) {
                matching = false;
                break;
              }
            } else if (elem[k] !== v) {
              matching = false;
              break;
            }
          }
          if (matching) {
            result.push(elem);
          }
        }
      }
      return result;
    };
    var MultipleValues = function MultipleValues2(values2) {
      var self2 = this;
      var construct = function construct2() {
        self2.values = values2;
      };
      construct();
      return self2;
    };
    var values = function values2() {
      for (var _len = arguments.length, values3 = new Array(_len), _key = 0; _key < _len; _key++) {
        values3[_key] = arguments[_key];
      }
      return new MultipleValues(values3);
    };
    var sort = function sort2(arr, keys2) {
      var isFn = typeof keys2 === "function";
      var filterFn = isFn ? keys2 : null;
      var result = aps.call(arr);
      if (isFn) {
        result.sort(filterFn);
      } else {
        result.sort(function(a, b) {
          var sortBys;
          if (keys2 instanceof Array) {
            sortBys = clone2(keys2);
          } else {
            sortBys = keys2.split(/\s*,\s*/);
          }
          var ret = 0;
          while (ret === 0 && sortBys.length > 0) {
            var pieces = sortBys.shift().split(/\s+/);
            var sortBy = pieces[0];
            var dir = pieces[1];
            dir = dir === "desc" ? -1 : 1;
            if (a[sortBy] < b[sortBy]) {
              ret = -1 * dir;
              break;
            } else if (a[sortBy] === b[sortBy]) {
              ret = 0;
            } else {
              ret = 1 * dir;
              break;
            }
          }
          return ret;
        });
      }
      return result;
    };
    var filter = function filter2(arr, callback, thisArg) {
      var ctx = thisArg === void 0 ? _this : thisArg;
      var result = [];
      for (var i2 = 0; i2 < arr.length; i2++) {
        if (callback.call(ctx, arr[i2], i2, arr)) {
          result.push(arr[i2]);
        }
      }
      return result;
    };
    var ARR_REGEXP = /^\s*function Array()/;
    var isArray2 = function isArray3(obj) {
      return obj != null && obj.push && ARR_REGEXP.test(obj.constructor);
    };
    var OBJ_REGEXP = /^\s*function Object()/;
    var isObject2 = function isObject3(obj) {
      return obj != null && typeof obj === "object" && OBJ_REGEXP.test(obj.constructor);
    };
    var isFunction = function isFunction2(obj) {
      return obj != null && typeof obj === "function";
    };
    var REGEXP_REGEXP = /^\s*function RegExp()/;
    var isRegExp = function isRegExp2(obj) {
      return obj != null && REGEXP_REGEXP.test(obj.constructor);
    };
    var BASIC_TYPE_REGEXP = /^string|number|boolean|function$/i;
    var isBasicType = function isBasicType2(obj) {
      return obj != null && (BASIC_TYPE_REGEXP.test(typeof obj) || isRegExp(obj));
    };
    var isEmpty = function isEmpty2(obj) {
      if (obj == null) {
        return true;
      }
      if (isArray2(obj) && !obj.length) {
        return true;
      }
      if (isObject2(obj)) {
        if (Object.keys(obj).length) {
          return false;
        }
        return true;
      }
      return false;
    };
    var isSubsetDeep = function isSubsetDeep2(obj1, obj2) {
      if (obj1 === obj2) {
        return true;
      }
      if (obj1 != null && obj2 == null || obj1 == null && obj2 != null) {
        return false;
      }
      var result = true;
      eachLeaf(obj1, function(obj1LeafVal, path) {
        var obj2LeafVal = getDeep(obj2, path);
        if (obj1LeafVal !== obj2LeafVal) {
          result = false;
        }
      });
      return result;
    };
    var equalsDeep = function equalsDeep2(obj1, obj2) {
      return isSubsetDeep(obj1, obj2) && isSubsetDeep(obj2, obj1);
    };
    var _eachDeep = function eachDeep(obj, fn, path, parent2, key) {
      if (path == null) {
        path = [];
      }
      if (isBasicType(obj)) {
        fn(obj, path, parent2, key);
      } else if (isObject2(obj) || isArray2(obj)) {
        fn(obj, path, parent2, key);
        for (var _key2 in obj) {
          if (_objectHasOwn(obj, _key2)) {
            var newPath = aps.call(path);
            newPath.push(_key2);
            _eachDeep(obj[_key2], fn, newPath, obj, _key2);
          }
        }
      } else {
        fn(obj, path, parent2, key);
      }
    };
    var eachLeaf = function eachLeaf2(obj, fn) {
      _eachDeep(obj, function(obj2, path, parent2, key) {
        if (!isArray2(obj2) && !isObject2(obj2)) {
          fn(obj2, path, parent2, key);
        }
      });
    };
    var pick = function pick2(obj, keys2) {
      var result = {};
      for (var i2 = 0; i2 < keys2.length; i2++) {
        var key = keys2[i2];
        if (obj[key] !== void 0) {
          result[key] = obj[key];
        }
      }
      return result;
    };
    var indexOf = function indexOf2(arr, target) {
      for (var i2 = 0; i2 < arr.length; i2++) {
        if (arr[i2] === target) {
          return i2;
        }
      }
      return -1;
    };
    var keys = function keys2(obj) {
      if (Object.keys) {
        return Object.keys(obj);
      }
      var result = [];
      for (var k in obj) {
        if (_objectHasOwn(obj, k)) {
          result.push(k);
        }
      }
      return result;
    };
  },
  /***/
  787(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Ni: () => (
        /* binding */
        appHostname2
      ),
      /* harmony export */
      rY: () => (
        /* binding */
        getSubdomainSuffixHostname
      )
      /* harmony export */
    });
    var REGEX_CLOUD_DEV_BOX = /([a-z0-9-]+)-cde-([a-z0-9-]+)\.([a-z0-9-]+)\.wistia\.io/i;
    var REGEX_DEV_METAL_TUNNEL = /([a-z0-9-]+)-txl-([a-z0-9-]+)\.([a-z0-9-]+)\.mtl\.wistia\.io/i;
    var appHostname2 = function appHostname3() {
      var subdomain = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "app";
      var hostname = "wistia.com";
      var subdomainSuffixHostname = getSubdomainSuffixHostname(subdomain);
      if (subdomainSuffixHostname) {
        return subdomainSuffixHostname;
      }
      return "".concat(subdomain, ".").concat(hostname);
    };
    var getSubdomainSuffixHostname = function getSubdomainSuffixHostname2() {
      var subdomain = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "app";
      if (typeof window !== "undefined" && window.location) {
        var currentHost = window.location.hostname;
        var cloudDevBoxMatches = REGEX_CLOUD_DEV_BOX.exec(currentHost);
        if (cloudDevBoxMatches) {
          return "".concat(subdomain, "-cde-").concat(cloudDevBoxMatches[2], ".").concat(cloudDevBoxMatches[3], ".wistia.io");
        }
        var metalTunnelMatches = REGEX_DEV_METAL_TUNNEL.exec(currentHost);
        if (metalTunnelMatches) {
          return "".concat(subdomain, "-txl-").concat(metalTunnelMatches[2], ".").concat(metalTunnelMatches[3], ".mtl.wistia.io");
        }
      }
      return null;
    };
  },
  /***/
  959(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      V: () => (
        /* binding */
        isMediaDataError
      )
      /* harmony export */
    });
    var _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9814);
    var _objectHasOwn = function(object, property) {
      if (typeof object === "undefined" || object === null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    };
    var isMediaDataError = function isMediaDataError2(mediaData) {
      if (!_objectHasOwn(mediaData, "error") || (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(mediaData.error)) {
        return false;
      }
      if (mediaData.error === "true" || mediaData.error === true) {
        return true;
      }
      return false;
    };
  },
  /***/
  998(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      K6: () => (
        /* binding */
        rgbToHsl
      ),
      /* harmony export */
      bJ: () => (
        /* binding */
        getContrast
      ),
      /* harmony export */
      hu: () => (
        /* binding */
        getVideoPlayerIconColor
      ),
      /* harmony export */
      s1: () => (
        /* binding */
        colorContrastRatiosByShape
      ),
      /* harmony export */
      ui: () => (
        /* binding */
        adjustColorForProperContrast
      )
      /* harmony export */
    });
    var _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9814);
    var _color_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5417);
    var _sentryUtils_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(2621);
    function _toConsumableArray(r) {
      return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray2(r) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return _arrayLikeToArray2(r);
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var colorContrastRatiosByShape = {
      nonText: 3,
      // 3:1 - https://www.w3.org/TR/WCAG21/#non-text-contrast
      largeText: 3,
      // 3:1 - https://www.w3.org/TR/WCAG21/#contrast-minimum
      paragraphText: 4.5,
      // 4.5:1 -  https://www.w3.org/TR/WCAG21/#contrast-minimum
      smallText: 5.5,
      // We're making this up, but it should be more than the paragraph text
      // This one is made up, but we want to offer _some_ visual contrast between the background color and its non-text hit areas with properly contrasting contents.
      // However, the contrast here is for visual interest, not for accessibility (since the contents have proper contrast).
      // In these cases, we'll use a lower contrast ratio than the normal nonText value.
      backgroundColorWhereNonTextHitAreaContentsHaveProperContrast: 2
      // https://www.w3.org/WAI/WCAG21/Understanding/non-text-contrast.html#intent
    };
    var rgbToHsl = function rgbToHsl2(color) {
      var colorArray = color;
      if (color instanceof _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1) {
        if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(color.r) || (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(color.g) || (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(color.b)) {
          throw new Error("Color does not contain required RGB values");
        }
        colorArray = [color.r, color.g, color.b];
      } else if (typeof color === "string") {
        var colorInstance = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(color);
        if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(colorInstance.r) || (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(colorInstance.g) || (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(colorInstance.b)) {
          throw new Error("Color does not contain required RGB values");
        }
        colorArray = [colorInstance.r, colorInstance.g, colorInstance.b];
      }
      var red = colorArray[0] / 255;
      var green = colorArray[1] / 255;
      var blue = colorArray[2] / 255;
      var max = Math.max(red, green, blue);
      var min = Math.min(red, green, blue);
      var hue = 0;
      var saturation = 0;
      var lightness = (max + min) / 2;
      if (max === min) {
        hue = 0;
        saturation = 0;
      }
      var delta = max - min;
      if (delta === 0) {
        return {
          hue,
          saturation,
          lightness: red * 100
        };
      }
      if (lightness > 0.5) {
        saturation = delta / (2 - max - min);
      } else {
        saturation = delta / (max + min);
      }
      if (max === red) {
        hue = (green - blue) / delta + (green < blue ? 6 : 0);
      } else if (max === green) {
        hue = (blue - red) / delta + 2;
      } else {
        hue = (red - green) / delta + 4;
      }
      hue /= 6;
      return {
        hue: hue * 360,
        saturation: saturation * 100,
        lightness: lightness * 100
      };
    };
    var getContrast = function getContrast2(foreground, background) {
      var foregroundColor = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(foreground);
      var backgroundColor = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(background);
      var l1 = foregroundColor.getRelativeLuminance();
      var l2 = backgroundColor.getRelativeLuminance();
      var contrastRatio = l1 > l2 ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
      return Number.parseFloat(contrastRatio.toFixed(3));
    };
    var adjustColorForProperContrast = function adjustColorForProperContrast2(foreground, background) {
      var shape = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "paragraphText";
      var foregroundColor = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(foreground);
      var backgroundColor = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(background);
      if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(foregroundColor.r) || (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(foregroundColor.g) || (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(foregroundColor.b)) {
        throw new Error("Color does not contain required RGB values");
      }
      var initialContrastRatio = getContrast(foregroundColor.toHexWithHash(), backgroundColor.toHexWithHash());
      if (foregroundColor.hasAccessibleContrast(backgroundColor, shape)) {
        return foregroundColor.toHexWithHash();
      }
      var _rgbToHsl = rgbToHsl([foregroundColor.r, foregroundColor.g, foregroundColor.b]), foregroundColorLightness = _rgbToHsl.lightness;
      var slightlyLighterForegroundColor = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(foregroundColor).lighten(1);
      var slightlyDarkerForegroundColor = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(foregroundColor).darken(1);
      var shouldForegroundColorBeLighter = foregroundColorLightness < 15 || slightlyLighterForegroundColor.getContrastRatio(backgroundColor) > slightlyDarkerForegroundColor.getContrastRatio(backgroundColor);
      if (foregroundColorLightness > 75 && initialContrastRatio === 1) {
        shouldForegroundColorBeLighter = false;
      }
      var adjustedForegroundColor = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(foregroundColor);
      var i2 = 0;
      while (!adjustedForegroundColor.hasAccessibleContrast(backgroundColor, shape)) {
        i2 += 1;
        if (i2 > 1e3) {
          (0, _sentryUtils_ts__WEBPACK_IMPORTED_MODULE_2__.N7)("other", new Error("Exceeded ".concat(i2, " attempts to find contrasting color")), {
            key: "adjust-color-for-proper-contrast",
            foregroundColor: foregroundColor.toHexWithHash(),
            backgroundColor: backgroundColor.toHexWithHash()
          });
          return adjustedForegroundColor.toHexWithHash();
        }
        var adjustedForegroundColorLuminance = adjustedForegroundColor.getRelativeLuminance();
        if (i2 > 1 && (adjustedForegroundColorLuminance === 1 || adjustedForegroundColorLuminance === 0)) {
          if (colorContrastRatiosByShape[shape] > 3) {
            return getContrast("#fff", backgroundColor.toHexWithHash()) > getContrast("#000", backgroundColor.toHexWithHash()) ? "#fff" : "#000";
          }
          shouldForegroundColorBeLighter = !shouldForegroundColorBeLighter;
          adjustedForegroundColor = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(foregroundColor);
        }
        if (shouldForegroundColorBeLighter) {
          adjustedForegroundColor.lighten(1);
        } else {
          adjustedForegroundColor.darken(1);
        }
      }
      return adjustedForegroundColor.toHexWithHash();
    };
    var generateColorPalette = function generateColorPalette2(colors) {
      var formattedColors = colors.map(function(color) {
        return new Color(color);
      });
      var uniqueColors = [new Color("#ffffff"), new Color("#000000")].concat(_toConsumableArray(formattedColors)).reduce(function(acc, currentColor) {
        if (acc.find(function(colorObj) {
          return colorObj.toHex() === currentColor.toHex();
        })) {
          return acc;
        }
        acc.push(currentColor);
        return acc;
      }, []);
      return uniqueColors.sort(function(colorOne, colorTwo) {
        return colorOne.getRelativeLuminance() - colorTwo.getRelativeLuminance();
      });
    };
    var getBestColorForShape = function getBestColorForShape2(colors, backgroundColor) {
      var colorsToExclude = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      var shape = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "paragraphText";
      var colorPalette = generateColorPalette(colors);
      var backgroundColorObj = new Color(backgroundColor);
      var formattedExcludedColors = colorsToExclude.map(function(color) {
        return new Color(color);
      });
      formattedExcludedColors.push(new Color(backgroundColor));
      formattedExcludedColors = formattedExcludedColors.filter(function(color) {
        return color.toHex() !== "000000" && color.toHex() !== "FFFFFF";
      });
      var stringifiedExcludedColors = formattedExcludedColors.map(function(formattedColor) {
        return formattedColor.toHex();
      });
      var availableColors = colorPalette.filter(function(color) {
        return !stringifiedExcludedColors.includes(color.toHex());
      });
      if (!backgroundColorObj.isDark(true)) {
        availableColors.reverse();
      }
      var textColor = availableColors.find(function(color) {
        return color.getContrastRatio(backgroundColor) >= colorContrastRatiosByShape[shape];
      });
      if (!textColor) {
        return backgroundColorObj.isDark(true) ? "#ffffff" : "#000000";
      }
      return textColor.toHexWithHash();
    };
    var getHexWithoutHash = function getHexWithoutHash2(hex) {
      if (!isNonEmptyString(hex)) {
        return "";
      }
      if (hex.startsWith("#")) {
        return hex.substring(1);
      }
      return hex;
    };
    var getVideoPlayerIconColor = function getVideoPlayerIconColor2(_playerColor, shouldUseAccessibleIconColor, isGradientEnabled) {
      var _searchParams$get;
      var playerColor = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(_playerColor);
      var _URL = new URL(window.location.toString()), searchParams = _URL.searchParams;
      var hasQueryParamOverride = Boolean((_searchParams$get = searchParams.get("useAccessiblePlayerIconColor")) !== null && _searchParams$get !== void 0 ? _searchParams$get : false);
      if (isGradientEnabled || !hasQueryParamOverride && !shouldUseAccessibleIconColor) {
        return "#ffffff";
      }
      if (new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1("#fff").getContrastRatio(playerColor) >= colorContrastRatiosByShape.paragraphText) {
        return "#ffffff";
      }
      return adjustColorForProperContrast(_playerColor, _playerColor, "paragraphText");
    };
    var getAudioPlayerIconColor = function getAudioPlayerIconColor2(_playerColor, shouldUseAccessibleIconColor, isGradientEnabled) {
      var _searchParams$get2;
      var playerColor = new Color(_playerColor);
      var _URL2 = new URL(window.location.toString()), searchParams = _URL2.searchParams;
      var hasQueryParamOverride = Boolean((_searchParams$get2 = searchParams.get("useAccessiblePlayerIconColor")) !== null && _searchParams$get2 !== void 0 ? _searchParams$get2 : false);
      if (isGradientEnabled || !hasQueryParamOverride && !shouldUseAccessibleIconColor) {
        return "#ffffff";
      }
      if (new Color("#fff").getContrastRatio(playerColor) >= colorContrastRatiosByShape.paragraphText) {
        return "#ffffff";
      }
      return adjustColorForProperContrast(_playerColor, _playerColor, "paragraphText");
    };
  },
  /***/
  1161(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      WO: () => (
        /* binding */
        countMetric
      )
      /* harmony export */
    });
    var utilities_assign_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9025);
    var utilities_pageLoaded_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(9562);
    var utilities_trackingConsentApi_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(4755);
    var _hosts_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(5857);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(5509);
    var _this = void 0;
    if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_4__.s._simpleMetricsCache == null) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_4__.s._simpleMetricsCache = {};
    }
    if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_4__.s._simpleMetricsDebounceInterval == null) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_4__.s._simpleMetricsDebounceInterval = 500;
    }
    var METRICS_CACHE = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_4__.s._simpleMetricsCache;
    var countMetric = function countMetric2(key) {
      var val = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
      var extraData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return sendMetric("count", key, val, extraData);
    };
    var sendMetrics = function sendMetrics2() {
      if (!(0, utilities_trackingConsentApi_js__WEBPACK_IMPORTED_MODULE_2__.D5)()) {
        return;
      }
      var url = "https://".concat((0, _hosts_js__WEBPACK_IMPORTED_MODULE_3__.Qz)(), "/mput?topic=metrics");
      for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
        messages[_key] = arguments[_key];
      }
      return fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: messages.join("\n")
      }).then(function(response) {
        if (!response.ok) {
          console.error(response);
        }
      }).catch(function(reason) {
        console.error(reason);
      });
    };
    var sampleMetric = function sampleMetric2(key, val, extraData) {
      return sendMetric("sample", key, val, extraData);
    };
    var getCircularReplacer = function getCircularReplacer2() {
      var seen = /* @__PURE__ */ new WeakSet();
      return function(key, value) {
        if (typeof value === "object" && value !== null) {
          if (seen.has(value)) {
            return "[Circular]";
          }
          seen.add(value);
        }
        return value;
      };
    };
    var sendMetric = function sendMetric2(type, key, val) {
      var extraData = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
      if (!(0, utilities_trackingConsentApi_js__WEBPACK_IMPORTED_MODULE_2__.D5)()) {
        return;
      }
      try {
        if (METRICS_CACHE.toMput == null) {
          METRICS_CACHE.toMput = [];
        }
        var messageObj = (0, utilities_assign_js__WEBPACK_IMPORTED_MODULE_0__.k)({
          type,
          key,
          value: val != null ? val : null
        }, extraData);
        var serialized = JSON.stringify(messageObj, getCircularReplacer());
        METRICS_CACHE.toMput.push(serialized);
        clearTimeout(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_4__.s._msendTimeout);
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_4__.s._msendTimeout = setTimeout(function() {
          (0, utilities_pageLoaded_js__WEBPACK_IMPORTED_MODULE_1__.R)(function() {
            sendMetrics.apply(_this, METRICS_CACHE.toMput);
            METRICS_CACHE.toMput = [];
          });
        }, _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_4__.s._simpleMetricsDebounceInterval);
      } catch (e) {
        console.error(e.message);
        console.error(e.stack);
      }
    };
    var _clearMetricsCache = function _clearMetricsCache2() {
      METRICS_CACHE.toMput = [];
    };
  },
  /***/
  1224(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      h: () => (
        /* binding */
        seqId
      )
      /* harmony export */
    });
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(5509);
    var seqId = function seqId2() {
      var prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "wistia_";
      var suffix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      var currentVal = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s._sequenceVal || 1;
      var result = "".concat(prefix).concat(currentVal).concat(suffix);
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s._sequenceVal = currentVal + 1;
      return result;
    };
  },
  /***/
  1248(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      j: () => (
        /* binding */
        runScript
      )
      /* harmony export */
    });
    var _hosts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(5857);
    var runScript = function runScript2(src2, timeout) {
      var taggedVersion = _hosts_js__WEBPACK_IMPORTED_MODULE_0__.U4;
      return new Promise(function(resolve, reject) {
        if (timeout == null) {
          timeout = 8e3;
        }
        var s;
        s = document.createElement("script");
        s.src = src2;
        s.async = true;
        s.type = "text/javascript";
        if (/https?:\/\/fast\.wistia\./.test(s.src) && taggedVersion !== "" && taggedVersion.length > 0) {
          s.src = "".concat(s.src, "@").concat(taggedVersion);
        }
        var cleanupTimeoutId = null;
        var done = false;
        var cleanUp = function cleanUp2() {
          s.onerror = s.onreadystatechange = s.onload = null;
          clearTimeout(cleanupTimeoutId);
          clearTimeout(loadingTimeout);
          cleanupTimeoutId = setTimeout(function() {
            if (s && s.parentNode) {
              s.parentNode.removeChild(s);
            }
          }, 500);
        };
        var onSuccess = function onSuccess2() {
          var state = s.readyState;
          if (!done && (!state || /loaded|complete/.test(state))) {
            done = true;
            setTimeout(function() {
              resolve();
              cleanUp();
            }, 1);
          }
        };
        var onTimeout = function onTimeout2() {
          done = true;
          cleanUp();
          reject(new Error("timeout"));
        };
        var onError = function onError2(e) {
          done = true;
          cleanUp();
          reject(e);
        };
        var loadingTimeout = setTimeout(onTimeout, timeout);
        s.onerror = onError;
        s.onreadystatechange = onSuccess;
        s.onload = onSuccess;
        (document.body || document.head).appendChild(s);
      });
    };
  },
  /***/
  1341(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      G5: () => (
        /* binding */
        flexibleDuration
      ),
      /* harmony export */
      ab: () => (
        /* binding */
        secondsConverter
      )
      /* harmony export */
    });
    var iso8601_duration__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(6633);
    var SECONDS_IN_HOUR = 3600;
    var MINUTES_IN_HOUR = 60;
    var SECONDS_IN_MINUTE = 60;
    var padNumber = function padNumber2(num) {
      var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      var result = "".concat(num);
      while (result.length < length) {
        result = "0".concat(result);
      }
      return result;
    };
    var secondsConverter = function secondsConverter2(total, format) {
      var hours = 0;
      var minutes = 0;
      var seconds = 0;
      var remainingDuration = total;
      var useHours = format.includes("h");
      var useMinutes = format.includes("m");
      if (useHours && remainingDuration > 0) {
        hours += Math.floor(remainingDuration / SECONDS_IN_HOUR);
        remainingDuration %= SECONDS_IN_HOUR;
      }
      if (useMinutes && remainingDuration > 0) {
        minutes += Math.floor(remainingDuration / MINUTES_IN_HOUR);
        remainingDuration %= MINUTES_IN_HOUR;
      }
      seconds = Math.round(remainingDuration);
      if (useHours && minutes === MINUTES_IN_HOUR) {
        hours += 1;
        minutes = 0;
      }
      if (useMinutes && seconds === SECONDS_IN_MINUTE) {
        minutes += 1;
        seconds = 0;
      }
      return {
        hours,
        minutes,
        seconds
      };
    };
    var flexibleDuration = function flexibleDuration2(total) {
      var _secondsConverter = secondsConverter(total, "hms"), hours = _secondsConverter.hours, minutes = _secondsConverter.minutes, seconds = _secondsConverter.seconds;
      if (hours === 0) {
        return "".concat(minutes, ":").concat(padNumber(seconds, 2));
      }
      return "".concat(hours, ":").concat(padNumber(minutes, 2), ":").concat(padNumber(seconds, 2));
    };
    var formattedDurationToSeconds = function formattedDurationToSeconds2(dur) {
      if (isNil(dur) || isNumber(dur)) {
        return dur;
      }
      try {
        var parsed = parse(dur.toUpperCase());
        return toSeconds(parsed);
      } catch (_unused) {
      }
      try {
        var _parsed = parse("PT".concat(dur.toUpperCase()));
        return toSeconds(_parsed);
      } catch (_unused2) {
      }
      return dur;
    };
    var accessibilityDuration = function accessibilityDuration2(duration) {
      var _secondsConverter2 = secondsConverter(duration, "hms"), hours = _secondsConverter2.hours, minutes = _secondsConverter2.minutes, seconds = _secondsConverter2.seconds;
      var zeroHours = hours === 0;
      var zeroMinutes = minutes === 0;
      if (zeroHours && zeroMinutes) {
        return "".concat(seconds, " second").concat(seconds === 1 ? "" : "s");
      }
      var hoursText = zeroHours ? "" : "".concat(hours, " hour").concat(hours === 1 ? "" : "s");
      var minText = zeroMinutes ? "" : "".concat(minutes, " minute").concat(hours === 1 ? "" : "s");
      return "".concat(hoursText, " ").concat(minText).trim();
    };
    var humanReadableDuration = function humanReadableDuration2(duration) {
      var _secondsConverter3 = secondsConverter(duration, "hms"), hours = _secondsConverter3.hours, minutes = _secondsConverter3.minutes, seconds = _secondsConverter3.seconds;
      var zeroHours = hours === 0;
      var zeroMinutes = minutes === 0;
      if (zeroHours && zeroMinutes) return "".concat(seconds, " Sec");
      var hoursText = zeroHours ? "" : "".concat(hours, " Hr");
      var minText = zeroMinutes ? "" : "".concat(minutes, " Min");
      return "".concat(hoursText, " ").concat(minText).trim();
    };
    var getSecondsRemaining = function getSecondsRemaining2(start, end) {
      var remaining = end.getTime() - start.getTime();
      return remaining / 1e3;
    };
    var secondsToMilliseconds = function secondsToMilliseconds2(seconds) {
      return seconds * 1e3;
    };
  },
  /***/
  1512(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      E: () => (
        /* binding */
        CONTROL_BAR_HEIGHT
      ),
      /* harmony export */
      R: () => (
        /* binding */
        DEFAULT_ASPECT
      )
      /* harmony export */
    });
    var CONTROL_BAR_HEIGHT = 34;
    var DEFAULT_ASPECT = 16 / 9;
  },
  /***/
  1525(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.r(__webpack_exports__3);
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Children: () => (
        /* binding */
        O
      ),
      /* harmony export */
      Component: () => (
        /* reexport safe */
        preact__WEBPACK_IMPORTED_MODULE_0__2.Component
      ),
      /* harmony export */
      Fragment: () => (
        /* reexport safe */
        preact__WEBPACK_IMPORTED_MODULE_0__2.Fragment
      ),
      /* harmony export */
      PureComponent: () => (
        /* binding */
        N
      ),
      /* harmony export */
      StrictMode: () => (
        /* binding */
        Cn
      ),
      /* harmony export */
      Suspense: () => (
        /* binding */
        P
      ),
      /* harmony export */
      SuspenseList: () => (
        /* binding */
        B
      ),
      /* harmony export */
      __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: () => (
        /* binding */
        hn
      ),
      /* harmony export */
      cloneElement: () => (
        /* binding */
        _n
      ),
      /* harmony export */
      createContext: () => (
        /* reexport safe */
        preact__WEBPACK_IMPORTED_MODULE_0__2.createContext
      ),
      /* harmony export */
      createElement: () => (
        /* reexport safe */
        preact__WEBPACK_IMPORTED_MODULE_0__2.createElement
      ),
      /* harmony export */
      createFactory: () => (
        /* binding */
        dn
      ),
      /* harmony export */
      createPortal: () => (
        /* binding */
        $
      ),
      /* harmony export */
      createRef: () => (
        /* reexport safe */
        preact__WEBPACK_IMPORTED_MODULE_0__2.createRef
      ),
      /* harmony export */
      "default": () => (
        /* binding */
        xn
      ),
      /* harmony export */
      findDOMNode: () => (
        /* binding */
        Sn
      ),
      /* harmony export */
      flushSync: () => (
        /* binding */
        En
      ),
      /* harmony export */
      forwardRef: () => (
        /* binding */
        D
      ),
      /* harmony export */
      hydrate: () => (
        /* binding */
        tn
      ),
      /* harmony export */
      isElement: () => (
        /* binding */
        Rn
      ),
      /* harmony export */
      isFragment: () => (
        /* binding */
        pn
      ),
      /* harmony export */
      isMemo: () => (
        /* binding */
        yn
      ),
      /* harmony export */
      isValidElement: () => (
        /* binding */
        mn
      ),
      /* harmony export */
      lazy: () => (
        /* binding */
        z
      ),
      /* harmony export */
      memo: () => (
        /* binding */
        M
      ),
      /* harmony export */
      render: () => (
        /* binding */
        nn
      ),
      /* harmony export */
      startTransition: () => (
        /* binding */
        x
      ),
      /* harmony export */
      unmountComponentAtNode: () => (
        /* binding */
        bn
      ),
      /* harmony export */
      unstable_batchedUpdates: () => (
        /* binding */
        gn
      ),
      /* harmony export */
      useCallback: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useCallback
      ),
      /* harmony export */
      useContext: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useContext
      ),
      /* harmony export */
      useDebugValue: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useDebugValue
      ),
      /* harmony export */
      useDeferredValue: () => (
        /* binding */
        w
      ),
      /* harmony export */
      useEffect: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useEffect
      ),
      /* harmony export */
      useErrorBoundary: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useErrorBoundary
      ),
      /* harmony export */
      useId: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useId
      ),
      /* harmony export */
      useImperativeHandle: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle
      ),
      /* harmony export */
      useInsertionEffect: () => (
        /* binding */
        I
      ),
      /* harmony export */
      useLayoutEffect: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect
      ),
      /* harmony export */
      useMemo: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useMemo
      ),
      /* harmony export */
      useReducer: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useReducer
      ),
      /* harmony export */
      useRef: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useRef
      ),
      /* harmony export */
      useState: () => (
        /* reexport safe */
        preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useState
      ),
      /* harmony export */
      useSyncExternalStore: () => (
        /* binding */
        C
      ),
      /* harmony export */
      useTransition: () => (
        /* binding */
        k
      ),
      /* harmony export */
      version: () => (
        /* binding */
        vn
      )
      /* harmony export */
    });
    var preact__WEBPACK_IMPORTED_MODULE_0__2 = __webpack_require__3(5181);
    var preact_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(3817);
    function g(n, t) {
      for (var e in t) n[e] = t[e];
      return n;
    }
    function E(n, t) {
      for (var e in n) if ("__source" !== e && !(e in t)) return true;
      for (var r in t) if ("__source" !== r && n[r] !== t[r]) return true;
      return false;
    }
    function C(n, t) {
      var e = t(), r = (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useState)({ t: { __: e, u: t } }), u = r[0].t, o = r[1];
      return (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function() {
        u.__ = e, u.u = t, R(u) && o({ t: u });
      }, [n, e, t]), (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        return R(u) && o({ t: u }), n(function() {
          R(u) && o({ t: u });
        });
      }, [n]), e;
    }
    function R(n) {
      var t, e, r = n.u, u = n.__;
      try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
      } catch (n2) {
        return true;
      }
    }
    function x(n) {
      n();
    }
    function w(n) {
      return n;
    }
    function k() {
      return [false, x];
    }
    var I = preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect;
    function N(n, t) {
      this.props = n, this.context = t;
    }
    function M(n, e) {
      function r(n2) {
        var t = this.props.ref, r2 = t == n2.ref;
        return !r2 && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n2) || !r2 : E(this.props, n2);
      }
      function u(e2) {
        return this.shouldComponentUpdate = r, (0, preact__WEBPACK_IMPORTED_MODULE_0__2.createElement)(n, e2);
      }
      return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = true, u.__f = true, u.type = n, u;
    }
    (N.prototype = new preact__WEBPACK_IMPORTED_MODULE_0__2.Component()).isPureReactComponent = true, N.prototype.shouldComponentUpdate = function(n, t) {
      return E(this.props, n) || E(this.state, t);
    };
    var T = preact__WEBPACK_IMPORTED_MODULE_0__2.options.__b;
    preact__WEBPACK_IMPORTED_MODULE_0__2.options.__b = function(n) {
      n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), T && T(n);
    };
    var A = "undefined" != typeof Symbol && Symbol.for && /* @__PURE__ */ Symbol.for("react.forward_ref") || 3911;
    function D(n) {
      function t(t2) {
        var e = g({}, t2);
        return delete e.ref, n(e, t2.ref || null);
      }
      return t.$$typeof = A, t.render = n, t.prototype.isReactComponent = t.__f = true, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
    }
    var L = function(n, t) {
      return null == n ? null : (0, preact__WEBPACK_IMPORTED_MODULE_0__2.toChildArray)((0, preact__WEBPACK_IMPORTED_MODULE_0__2.toChildArray)(n).map(t));
    }, O = { map: L, forEach: L, count: function(n) {
      return n ? (0, preact__WEBPACK_IMPORTED_MODULE_0__2.toChildArray)(n).length : 0;
    }, only: function(n) {
      var t = (0, preact__WEBPACK_IMPORTED_MODULE_0__2.toChildArray)(n);
      if (1 !== t.length) throw "Children.only";
      return t[0];
    }, toArray: preact__WEBPACK_IMPORTED_MODULE_0__2.toChildArray }, U = preact__WEBPACK_IMPORTED_MODULE_0__2.options.__e;
    preact__WEBPACK_IMPORTED_MODULE_0__2.options.__e = function(n, t, e, r) {
      if (n.then) {
        for (var u, o = t; o = o.__; ) if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
      }
      U(n, t, e, r);
    };
    var F = preact__WEBPACK_IMPORTED_MODULE_0__2.options.unmount;
    function V(n, t, e) {
      return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n2) {
        "function" == typeof n2.__c && n2.__c();
      }), n.__c.__H = null), null != (n = g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c.__e = true, n.__c = null), n.__k = n.__k && n.__k.map(function(n2) {
        return V(n2, t, e);
      })), n;
    }
    function W(n, t, e) {
      return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n2) {
        return W(n2, t, e);
      }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = true, n.__c.__P = e)), n;
    }
    function P() {
      this.__u = 0, this.o = null, this.__b = null;
    }
    function j(n) {
      if (!n.__) return null;
      var t = n.__.__c;
      return t && t.__a && t.__a(n);
    }
    function z(n) {
      var e, r, u, o = null;
      function i2(i3) {
        if (e || (e = n()).then(function(n2) {
          n2 && (o = n2.default || n2), u = true;
        }, function(n2) {
          r = n2, u = true;
        }), r) throw r;
        if (!u) throw e;
        return o ? (0, preact__WEBPACK_IMPORTED_MODULE_0__2.createElement)(o, i3) : null;
      }
      return i2.displayName = "Lazy", i2.__f = true, i2;
    }
    function B() {
      this.i = null, this.l = null;
    }
    preact__WEBPACK_IMPORTED_MODULE_0__2.options.unmount = function(n) {
      var t = n.__c;
      t && (t.__z = true), t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), F && F(n);
    }, (P.prototype = new preact__WEBPACK_IMPORTED_MODULE_0__2.Component()).__c = function(n, t) {
      var e = t.__c, r = this;
      null == r.o && (r.o = []), r.o.push(e);
      var u = j(r.__v), o = false, i2 = function() {
        o || r.__z || (o = true, e.__R = null, u ? u(c) : c());
      };
      e.__R = i2;
      var l = e.__P;
      e.__P = null;
      var c = function() {
        if (!--r.__u) {
          if (r.state.__a) {
            var n2 = r.state.__a;
            r.__v.__k[0] = W(n2, n2.__c.__P, n2.__c.__O);
          }
          var t2;
          for (r.setState({ __a: r.__b = null }); t2 = r.o.pop(); ) t2.__P = l, t2.forceUpdate();
        }
      };
      r.__u++ || 32 & t.__u || r.setState({ __a: r.__b = r.__v.__k[0] }), n.then(i2, i2);
    }, P.prototype.componentWillUnmount = function() {
      this.o = [];
    }, P.prototype.render = function(n, e) {
      if (this.__b) {
        if (this.__v.__k) {
          var r = document.createElement("div"), o = this.__v.__k[0].__c;
          this.__v.__k[0] = V(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
      }
      var i2 = e.__a && (0, preact__WEBPACK_IMPORTED_MODULE_0__2.createElement)(preact__WEBPACK_IMPORTED_MODULE_0__2.Fragment, null, n.fallback);
      return i2 && (i2.__u &= -33), [(0, preact__WEBPACK_IMPORTED_MODULE_0__2.createElement)(preact__WEBPACK_IMPORTED_MODULE_0__2.Fragment, null, e.__a ? null : n.children), i2];
    };
    var H = function(n, t, e) {
      if (++e[1] === e[0] && n.l.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.l.size)) for (e = n.i; e; ) {
        for (; e.length > 3; ) e.pop()();
        if (e[1] < e[0]) break;
        n.i = e = e[2];
      }
    };
    function Z(n) {
      return this.getChildContext = function() {
        return n.context;
      }, n.children;
    }
    function Y(n) {
      var e = this, r = n.h;
      if (e.componentWillUnmount = function() {
        (0, preact__WEBPACK_IMPORTED_MODULE_0__2.render)(null, e.v), e.v = null, e.h = null;
      }, e.h && e.h !== r && e.componentWillUnmount(), !e.v) {
        for (var u = e.__v; null !== u && !u.__m && null !== u.__; ) u = u.__;
        e.h = r, e.v = { nodeType: 1, parentNode: r, childNodes: [], __k: { __m: u.__m }, contains: function() {
          return true;
        }, namespaceURI: r.namespaceURI, insertBefore: function(n2, t) {
          this.childNodes.push(n2), e.h.insertBefore(n2, t);
        }, removeChild: function(n2) {
          this.childNodes.splice(this.childNodes.indexOf(n2) >>> 1, 1), e.h.removeChild(n2);
        } };
      }
      (0, preact__WEBPACK_IMPORTED_MODULE_0__2.render)((0, preact__WEBPACK_IMPORTED_MODULE_0__2.createElement)(Z, { context: e.context }, n.__v), e.v);
    }
    function $(n, e) {
      var r = (0, preact__WEBPACK_IMPORTED_MODULE_0__2.createElement)(Y, { __v: n, h: e });
      return r.containerInfo = e, r;
    }
    (B.prototype = new preact__WEBPACK_IMPORTED_MODULE_0__2.Component()).__a = function(n) {
      var t = this, e = j(t.__v), r = t.l.get(n);
      return r[0]++, function(u) {
        var o = function() {
          t.props.revealOrder ? (r.push(u), H(t, n, r)) : u();
        };
        e ? e(o) : o();
      };
    }, B.prototype.render = function(n) {
      this.i = null, this.l = /* @__PURE__ */ new Map();
      var t = (0, preact__WEBPACK_IMPORTED_MODULE_0__2.toChildArray)(n.children);
      n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
      for (var e = t.length; e--; ) this.l.set(t[e], this.i = [1, 0, this.i]);
      return n.children;
    }, B.prototype.componentDidUpdate = B.prototype.componentDidMount = function() {
      var n = this;
      this.l.forEach(function(t, e) {
        H(n, e, t);
      });
    };
    var q = "undefined" != typeof Symbol && Symbol.for && /* @__PURE__ */ Symbol.for("react.element") || 60103, G = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, J = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, K = /[A-Z0-9]/g, Q = "undefined" != typeof document, X = function(n) {
      return ("undefined" != typeof Symbol && "symbol" == typeof /* @__PURE__ */ Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
    };
    function nn(n, t, e) {
      return null == t.__k && (t.textContent = ""), (0, preact__WEBPACK_IMPORTED_MODULE_0__2.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
    }
    function tn(n, t, e) {
      return (0, preact__WEBPACK_IMPORTED_MODULE_0__2.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
    }
    preact__WEBPACK_IMPORTED_MODULE_0__2.Component.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t) {
      Object.defineProperty(preact__WEBPACK_IMPORTED_MODULE_0__2.Component.prototype, t, { configurable: true, get: function() {
        return this["UNSAFE_" + t];
      }, set: function(n) {
        Object.defineProperty(this, t, { configurable: true, writable: true, value: n });
      } });
    });
    var en = preact__WEBPACK_IMPORTED_MODULE_0__2.options.event;
    function rn() {
    }
    function un() {
      return this.cancelBubble;
    }
    function on() {
      return this.defaultPrevented;
    }
    preact__WEBPACK_IMPORTED_MODULE_0__2.options.event = function(n) {
      return en && (n = en(n)), n.persist = rn, n.isPropagationStopped = un, n.isDefaultPrevented = on, n.nativeEvent = n;
    };
    var ln, cn = { enumerable: false, configurable: true, get: function() {
      return this.class;
    } }, fn = preact__WEBPACK_IMPORTED_MODULE_0__2.options.vnode;
    preact__WEBPACK_IMPORTED_MODULE_0__2.options.vnode = function(n) {
      "string" == typeof n.type && (function(n2) {
        var t = n2.props, e = n2.type, u = {}, o = -1 === e.indexOf("-");
        for (var i2 in t) {
          var l = t[i2];
          if (!("value" === i2 && "defaultValue" in t && null == l || Q && "children" === i2 && "noscript" === e || "class" === i2 || "className" === i2)) {
            var c = i2.toLowerCase();
            "defaultValue" === i2 && "value" in t && null == t.value ? i2 = "value" : "download" === i2 && true === l ? l = "" : "translate" === c && "no" === l ? l = false : "o" === c[0] && "n" === c[1] ? "ondoubleclick" === c ? i2 = "ondblclick" : "onchange" !== c || "input" !== e && "textarea" !== e || X(t.type) ? "onfocus" === c ? i2 = "onfocusin" : "onblur" === c ? i2 = "onfocusout" : J.test(i2) && (i2 = c) : c = i2 = "oninput" : o && G.test(i2) ? i2 = i2.replace(K, "-$&").toLowerCase() : null === l && (l = void 0), "oninput" === c && u[i2 = c] && (i2 = "oninputCapture"), u[i2] = l;
          }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, preact__WEBPACK_IMPORTED_MODULE_0__2.toChildArray)(t.children).forEach(function(n3) {
          n3.props.selected = -1 != u.value.indexOf(n3.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, preact__WEBPACK_IMPORTED_MODULE_0__2.toChildArray)(t.children).forEach(function(n3) {
          n3.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n3.props.value) : u.defaultValue == n3.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", cn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n2.props = u;
      })(n), n.$$typeof = q, fn && fn(n);
    };
    var an = preact__WEBPACK_IMPORTED_MODULE_0__2.options.__r;
    preact__WEBPACK_IMPORTED_MODULE_0__2.options.__r = function(n) {
      an && an(n), ln = n.__c;
    };
    var sn = preact__WEBPACK_IMPORTED_MODULE_0__2.options.diffed;
    preact__WEBPACK_IMPORTED_MODULE_0__2.options.diffed = function(n) {
      sn && sn(n);
      var t = n.props, e = n.__e;
      null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), ln = null;
    };
    var hn = { ReactCurrentDispatcher: { current: { readContext: function(n) {
      return ln.__n[n.__c].props.value;
    }, useCallback: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useCallback, useContext: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useContext, useDebugValue: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useDebugValue, useDeferredValue: w, useEffect: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useEffect, useId: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useId, useImperativeHandle: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle, useInsertionEffect: I, useLayoutEffect: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect, useMemo: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useMemo, useReducer: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useReducer, useRef: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useRef, useState: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useState, useSyncExternalStore: C, useTransition: k } } }, vn = "18.3.1";
    function dn(n) {
      return preact__WEBPACK_IMPORTED_MODULE_0__2.createElement.bind(null, n);
    }
    function mn(n) {
      return !!n && n.$$typeof === q;
    }
    function pn(n) {
      return mn(n) && n.type === preact__WEBPACK_IMPORTED_MODULE_0__2.Fragment;
    }
    function yn(n) {
      return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
    }
    function _n(n) {
      return mn(n) ? preact__WEBPACK_IMPORTED_MODULE_0__2.cloneElement.apply(null, arguments) : n;
    }
    function bn(n) {
      return !!n.__k && ((0, preact__WEBPACK_IMPORTED_MODULE_0__2.render)(null, n), true);
    }
    function Sn(n) {
      return n && (n.base || 1 === n.nodeType && n) || null;
    }
    var gn = function(n, t) {
      return n(t);
    }, En = function(n, t) {
      return n(t);
    }, Cn = preact__WEBPACK_IMPORTED_MODULE_0__2.Fragment, Rn = mn, xn = { useState: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useState, useId: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useId, useReducer: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useReducer, useEffect: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useEffect, useLayoutEffect: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect, useInsertionEffect: I, useTransition: k, useDeferredValue: w, useSyncExternalStore: C, startTransition: x, useRef: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useRef, useImperativeHandle: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle, useMemo: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useMemo, useCallback: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useCallback, useContext: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useContext, useDebugValue: preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useDebugValue, version: "18.3.1", Children: O, render: nn, hydrate: tn, unmountComponentAtNode: bn, createPortal: $, createElement: preact__WEBPACK_IMPORTED_MODULE_0__2.createElement, createContext: preact__WEBPACK_IMPORTED_MODULE_0__2.createContext, createFactory: dn, cloneElement: _n, createRef: preact__WEBPACK_IMPORTED_MODULE_0__2.createRef, Fragment: preact__WEBPACK_IMPORTED_MODULE_0__2.Fragment, isValidElement: mn, isElement: Rn, isFragment: pn, isMemo: yn, findDOMNode: Sn, Component: preact__WEBPACK_IMPORTED_MODULE_0__2.Component, PureComponent: N, memo: M, forwardRef: D, flushSync: En, unstable_batchedUpdates: gn, StrictMode: Cn, Suspense: P, SuspenseList: B, lazy: z, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: hn };
  },
  /***/
  1627(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Uh: () => (
        /* reexport safe */
        utilities_unescape_html_js__WEBPACK_IMPORTED_MODULE_0__.U
      ),
      /* harmony export */
      u: () => (
        /* binding */
        base64Decode
      )
      /* harmony export */
    });
    var utilities_unescape_html_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(2428);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    var unbreakifyText = function unbreakifyText2() {
      var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return text.replace(" ", "&nbsp;");
    };
    var stripHtml = function stripHtml2(htmlStr) {
      var tmp = document.createElement("div");
      tmp.innerHTML = htmlStr;
      return tmp.textContent || tmp.innerText || "";
    };
    var camelCase = function camelCase2(snakeStr) {
      return snakeStr.replace(/[_-]([a-z])/g, function(g) {
        return g.charAt(1).toUpperCase();
      });
    };
    var snakeCase = function snakeCase2(camelStr) {
      return camelStr.replace(/[A-Z]/g, function(g) {
        return "_".concat(g.toLowerCase());
      });
    };
    var shallowCamelizeKeys = function shallowCamelizeKeys2(o) {
      return Object.keys(o).reduce(function(memo, key) {
        memo[camelCase(key)] = o[key];
        return memo;
      }, {});
    };
    var shallowSnakeKeys = function shallowSnakeKeys2(o) {
      return Object.keys(o).reduce(function(memo, key) {
        memo[snakeCase(key)] = o[key];
        return memo;
      }, {});
    };
    var base64Decode = function base64Decode2(input) {
      return decodeURIComponent(atob(input).split("").map(function(c) {
        return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));
      }).join(""));
    };
    var base64Encode = function base64Encode2(input) {
      return btoa(encodeURIComponent(input).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode("0x".concat(p1));
      }));
    };
    var notSetOrTrue = function notSetOrTrue2(val) {
      return val == null || val === true;
    };
    var preventOuterMouseWheel = function preventOuterMouseWheel2(e, container) {
      var topMargin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
      var bottomMargin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
      var scrollTop = container.scrollTop, scrollHeight = container.scrollHeight, offsetHeight = container.offsetHeight;
      var hitTop = function hitTop2() {
        var extra2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return scrollTop + extra2 - topMargin <= 0;
      };
      var hitBottom = function hitBottom2() {
        var extra2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        return scrollTop + extra2 + bottomMargin >= scrollHeight - offsetHeight;
      };
      var delta = e.deltaY || -e.wheelDelta;
      var dir = delta > 0 ? "down" : "up";
      var isModernBrowser = !!e.deltaY;
      if (isModernBrowser) {
        if (dir === "up" && hitTop() || dir === "down" && hitBottom()) {
          e.preventDefault();
        }
      } else {
        var extra = 47.5 * delta / 120;
        if (dir === "up" && hitTop(extra)) {
          e.preventDefault();
          container.scrollTop = 0;
        } else if (dir === "down" && hitBottom(extra)) {
          e.preventDefault();
          container.scrollTop = scrollHeight - offsetHeight;
        }
      }
    };
    var parentFramesLength = function parentFramesLength2() {
      try {
        return parent.frames.length;
      } catch (e) {
        Wistia.warn(e);
        return 1;
      }
    };
  },
  /***/
  1885(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      CC: () => (
        /* binding */
        mediaDataUrl
      ),
      /* harmony export */
      dq: () => (
        /* binding */
        mediaDataScriptRegExp
      )
      /* harmony export */
    });
    var wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(5509);
    var utilities_root_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(8176);
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(731);
    var utilities_script_utils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(159);
    var utilities_remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(3411);
    var utilities_hosts_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(5857);
    var utilities_media_data_transforms_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__3(3917);
    function ownKeys2(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
          return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread2(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
          _defineProperty2(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
          Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
      }
      return e;
    }
    function _defineProperty2(e, r, t) {
      return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    var transformResponse = function transformResponse2(mediaData, options) {
      var _mediaWithOpts$media;
      var mediaWithOpts = _objectSpread2({}, mediaData);
      var transformOpts = merge({}, (_mediaWithOpts$media = mediaWithOpts.media) === null || _mediaWithOpts$media === void 0 ? void 0 : _mediaWithOpts$media.embedOptions, options);
      if (mediaWithOpts.error) {
        return mediaWithOpts;
      }
      delete mediaWithOpts.media.unnamed_assets;
      mediaDataTransforms(mediaWithOpts.media, transformOpts);
      return mediaWithOpts.media;
    };
    var mediaDataUrl = function mediaDataUrl2(hashedId) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var host = (0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_5__.Dd)(options);
      return "".concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_5__.v9)(), "//").concat(host, "/embed/medias/").concat(hashedId, ".json");
    };
    var mediaDataScriptRegExp = function mediaDataScriptRegExp2(hashedId) {
      var protocolMatch = location.protocol === "https:" ? "https" : "https?";
      return new RegExp("^(".concat(protocolMatch, ":)?//((").concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_5__.CX)().replace(".", "\\."), ")|(").concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_5__.kh)().replace(".", "\\."), "))/embed/medias/").concat(hashedId, "\\.jsonp\\??"));
    };
    var cacheMedia = function cacheMedia2(hashedId, data) {
      return cacheMediaData(hashedId, data);
    };
    var uncacheMedia = function uncacheMedia2(hashedId) {
      var _Wistia$uncacheCaptio;
      uncacheMediaData(hashedId);
      (_Wistia$uncacheCaptio = Wistia.uncacheCaptions) === null || _Wistia$uncacheCaptio === void 0 ? void 0 : _Wistia$uncacheCaptio.call(Wistia, hashedId);
      removeSpeedDemonScriptAndData(hashedId);
    };
    var removeSpeedDemonScriptAndData = function removeSpeedDemonScriptAndData2(hashedId) {
      window["wistiajsonp-/embed/medias/".concat(hashedId, ".json")] = null;
      removeScriptsBySrc(mediaDataUrl(hashedId), {
        scriptRegex: mediaDataScriptRegExp(hashedId)
      });
    };
    var mediaFromCache = function mediaFromCache2(hashedId) {
      return dataFromCache(hashedId);
    };
    var dataFromCache = function dataFromCache2(hashedId) {
      var resultFromFetchCache = getMediaDataFromCache(hashedId);
      if (resultFromFetchCache) {
        return resultFromFetchCache;
      }
      var speedDemonData = root["wistiajsonp-/embed/medias/".concat(hashedId, ".json")];
      if (speedDemonData != null && speedDemonData.media) {
        return speedDemonData.media;
      }
      return null;
    };
  },
  /***/
  1919(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      I: () => (
        /* binding */
        standardSvgAttrs
      )
      /* harmony export */
    });
    function ownKeys2(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
          return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread2(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
          _defineProperty2(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
          Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
      }
      return e;
    }
    function _defineProperty2(e, r, t) {
      return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    var standardSvgAttrs = function standardSvgAttrs2(_ref) {
      var _ref$width = _ref.width, width = _ref$width === void 0 ? 40 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 34 : _ref$height, _ref$styleOverride = _ref.styleOverride, styleOverride = _ref$styleOverride === void 0 ? {} : _ref$styleOverride, _ref$ariaHidden = _ref.ariaHidden, ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden, _ref$fillColor = _ref.fillColor, fillColor = _ref$fillColor === void 0 ? "#ffffff" : _ref$fillColor;
      return {
        x: "0px",
        y: "0px",
        viewBox: "0 0 ".concat(width, " ").concat(height),
        "enable-background": "new 0 0 ".concat(width, " ").concat(height),
        "aria-hidden": "".concat(ariaHidden),
        style: _objectSpread2({
          fill: fillColor,
          height: "100%",
          left: 0,
          strokeWidth: 0,
          top: 0,
          width: "100%"
        }, styleOverride)
      };
    };
  },
  /***/
  2147(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Z: () => (
        /* binding */
        removeInjectedJsonLd
      ),
      /* harmony export */
      g: () => (
        /* binding */
        injectJsonLd
      )
      /* harmony export */
    });
    var utilities_keyMoments_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(3441);
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(731);
    var utilities_hosts_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(5857);
    var utilities_assets_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(7209);
    var utilities_url_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(2671);
    var _iso8601Helper_ts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(7229);
    var _normalizeChapters_ts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__3(9128);
    var generateAudioJsonLd = function generateAudioJsonLd2(mediaData) {
      var _embedOptions;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var videoWidth = options.videoWidth, videoHeight = options.videoHeight;
      var embedOptions = options.embedOptions;
      if (!embedOptions) {
        embedOptions = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__.wg)((0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__.o8)(mediaData.embedOptions));
      }
      var obj = {
        "@context": "http://schema.org/",
        "@id": "https://".concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_2__.kh)(), "/embed/iframe/").concat(mediaData.hashedId),
        "@type": "AudioObject",
        duration: "PT".concat((0, _iso8601Helper_ts__WEBPACK_IMPORTED_MODULE_5__.J)(mediaData.duration)),
        name: mediaData.name,
        thumbnailUrl: (0, utilities_assets_js__WEBPACK_IMPORTED_MODULE_3__.Wz)(mediaData.assets, {
          ext: "jpg",
          protocol: "https:",
          videoWidth,
          videoHeight,
          embedHost: (_embedOptions = embedOptions) === null || _embedOptions === void 0 ? void 0 : _embedOptions.embedHost
        }),
        contentUrl: generateContentUrl(mediaData),
        embedUrl: generateEmbedUrl(mediaData, embedOptions),
        uploadDate: new Date(mediaData.createdAt * 1e3).toISOString(),
        description: mediaData.seoDescription
      };
      if (mediaData.captions && mediaData.captions[0]) {
        obj.transcript = mediaData.captions[0].text;
      }
      return obj;
    };
    var generateEmbedUrl = function generateEmbedUrl2(mediaData, embedOptions) {
      var _mediaData$embedOptio;
      var baseUrl = "https://".concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_2__.kh)(), "/embed/iframe/").concat(mediaData.hashedId);
      if ((0, utilities_keyMoments_ts__WEBPACK_IMPORTED_MODULE_0__.Vq)(mediaData, embedOptions) && !(0, utilities_keyMoments_ts__WEBPACK_IMPORTED_MODULE_0__.Qy)(embedOptions) && (_mediaData$embedOptio = mediaData.embedOptions.plugin) !== null && _mediaData$embedOptio !== void 0 && _mediaData$embedOptio.videoThumbnail) {
        return "".concat(baseUrl, "?wseektoaction=true");
      }
      return baseUrl;
    };
    var generateContentUrl = function generateContentUrl2(mediaData) {
      var assets = mediaData.assets;
      if (mediaData.mediaType === "Audio") {
        var _readyPublicMp3s$;
        return (_readyPublicMp3s$ = (0, utilities_assets_js__WEBPACK_IMPORTED_MODULE_3__.o2)(assets)[0]) === null || _readyPublicMp3s$ === void 0 ? void 0 : _readyPublicMp3s$.url;
      }
      var availableMp4s = (0, utilities_assets_js__WEBPACK_IMPORTED_MODULE_3__.Fi)(assets);
      if (availableMp4s.length === 0) {
        return;
      }
      var highestQuality = (0, utilities_assets_js__WEBPACK_IMPORTED_MODULE_3__.tt)(availableMp4s, 1080);
      if (!highestQuality) {
        return;
      }
      var url = new utilities_url_js__WEBPACK_IMPORTED_MODULE_4__.s0(highestQuality.url);
      url.ext("m3u8");
      return url.absolute();
    };
    var generateVideoJsonLd = function generateVideoJsonLd2(mediaData) {
      var _embedOptions2;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var videoWidth = options.videoWidth, videoHeight = options.videoHeight;
      var embedOptions = options.embedOptions;
      if (!embedOptions) {
        var _cast;
        embedOptions = (_cast = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__.wg)((0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__.o8)(mediaData.embedOptions))) !== null && _cast !== void 0 ? _cast : {};
      }
      var obj = {
        "@context": "http://schema.org/",
        "@id": "https://".concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_2__.kh)(), "/embed/iframe/").concat(mediaData.hashedId),
        "@type": "VideoObject",
        duration: "PT".concat((0, _iso8601Helper_ts__WEBPACK_IMPORTED_MODULE_5__.J)(mediaData.duration)),
        name: mediaData.name,
        thumbnailUrl: (0, utilities_assets_js__WEBPACK_IMPORTED_MODULE_3__.Wz)(mediaData.assets, {
          ext: "jpg",
          protocol: "https:",
          videoWidth,
          videoHeight,
          embedHost: (_embedOptions2 = embedOptions) === null || _embedOptions2 === void 0 ? void 0 : _embedOptions2.embedHost
        }),
        embedUrl: generateEmbedUrl(mediaData, embedOptions),
        uploadDate: new Date(mediaData.createdAt * 1e3).toISOString(),
        description: mediaData.seoDescription
      };
      if (mediaData.mediaType === "Video") {
        obj.contentUrl = generateContentUrl(mediaData);
      }
      if (mediaData.captions && mediaData.captions[0]) {
        obj.transcript = mediaData.captions[0].text;
      }
      if ((0, utilities_keyMoments_ts__WEBPACK_IMPORTED_MODULE_0__.Vq)(mediaData, embedOptions)) {
        if ((0, utilities_keyMoments_ts__WEBPACK_IMPORTED_MODULE_0__.Qy)(embedOptions)) {
          var chapters = (0, _normalizeChapters_ts__WEBPACK_IMPORTED_MODULE_6__.a)(embedOptions);
          var chapterList = chapters.chapterList;
          obj.hasPart = (0, utilities_keyMoments_ts__WEBPACK_IMPORTED_MODULE_0__.oG)(chapterList, location.href, mediaData.duration);
        } else {
          obj.potentialAction = (0, utilities_keyMoments_ts__WEBPACK_IMPORTED_MODULE_0__.CR)();
        }
      }
      return obj;
    };
    var injectJsonLd = function injectJsonLd2(id, mediaData) {
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      var jsonLdObj;
      if (mediaData.mediaType === "Audio") {
        jsonLdObj = generateAudioJsonLd(mediaData, options);
      } else {
        jsonLdObj = generateVideoJsonLd(mediaData, options);
      }
      var stringified = JSON.stringify(jsonLdObj);
      var jsonLd = document.createElement("script");
      jsonLd.className = "w-json-ld";
      jsonLd.type = "application/ld+json";
      jsonLd.innerHTML = stringified;
      jsonLd._wistia = true;
      jsonLd.setAttribute("id", id);
      removeInjectedJsonLd(id);
      var existingScripts = document.querySelectorAll("script.w-json-ld");
      var existingScript = existingScripts[existingScripts.length - 1];
      if (existingScript) {
        existingScript.parentNode.insertBefore(jsonLd, existingScript.nextSibling);
      } else {
        document.head.insertBefore(jsonLd, document.head.childNodes[0]);
      }
    };
    var removeInjectedJsonLd = function removeInjectedJsonLd2(id) {
      if (!id) {
        return;
      }
      var el = document.getElementById(id);
      if (!el) {
        return;
      }
      el.remove();
    };
  },
  /***/
  2428(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      U: () => (
        /* binding */
        unescapeHtml
      )
      /* harmony export */
    });
    var unescapedCache = {};
    var unescapeHtml = function unescapeHtml2(encodedHtmlStr) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!encodedHtmlStr) {
        return "";
      }
      if (options.cache) {
        var cachedVal = unescapedCache[encodedHtmlStr];
        if (unescapedCache[encodedHtmlStr]) {
          return cachedVal;
        }
      }
      var e = document.createElement("div");
      e.innerHTML = encodedHtmlStr.toString().replace(/</g, "&lt;").replace(/>/g, "&gt;");
      var result;
      if (e.childNodes.length > 0) {
        result = e.childNodes[0].nodeValue;
      } else {
        result = "";
      }
      if (options.cache) {
        unescapedCache[encodedHtmlStr] = result;
      }
      return result;
    };
  },
  /***/
  2621(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      N7: () => (
        /* binding */
        reportError
      )
      /* harmony export */
    });
    var _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9814);
    var _trackingConsentApi_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(4755);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(5509);
    var _hosts_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(5857);
    var getSampleRatesByProductType = function getSampleRatesByProductType2(productType) {
      if (productType === "mediaPlayback") {
        return 1e-3;
      }
      return 1;
    };
    var IS_DEV_ENV = false;
    var IS_TEST_ENV = false;
    var configureSentry = function configureSentry2() {
      if (isNil(window.Sentry) || isNil(window.Sentry.BrowserClient) || isNil(window.Sentry.makeFetchTransport) || isNil(window.Sentry.defaultStackParser) || isNil(window.Sentry.Scope)) {
        return;
      }
      var client = new window.Sentry.BrowserClient({
        dsn: "https://a3591ba5e949a37083cc6f5a4191e903@o4505518331658240.ingest.us.sentry.io/4505794284290048",
        transport: window.Sentry.makeFetchTransport,
        stackParser: window.Sentry.defaultStackParser,
        integrations: [window.Sentry.httpContextIntegration()],
        // Allow httpContextIntegration so we can collect URL, browser, and OS version information. No PII is included here.
        release: isNonEmptyString(TAGGED_VERSION) ? TAGGED_VERSION : CURRENT_SHA
      });
      var scope = new window.Sentry.Scope();
      scope.setClient(client);
      scope.setTags({
        pillar: "publish"
      });
      Wistia._sentryScope = scope;
      client.init();
      Wistia.isSentryInitialized = true;
      listenForGlobalErrors();
      listenForGlobalUnhandledRejections();
    };
    var initializeSentry = function initializeSentry2() {
      if (isVisitorTrackingEnabled() !== true) {
        return;
      }
      if (!window.Sentry || !Wistia.isSentryInitialized) {
        var sentryLoader = document.createElement("script");
        sentryLoader.src = "https://browser.sentry-cdn.com/9.6.1/bundle.min.js";
        sentryLoader.crossOrigin = "anonymous";
        sentryLoader.integrity = "sha384-kbRmCeIl7Uxr+vT9YhSAdguCdd4L5QPRj7jzQTanorUVVlw/Y5X9vtzVyOEHLfpH";
        sentryLoader.onload = function() {
          return configureSentry();
        };
        document.head.appendChild(sentryLoader);
      }
    };
    var reportError = function reportError2(product, error, details) {
      try {
        if (!_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.isSentryInitialized) {
          return;
        }
        var sampleRate = getSampleRatesByProductType(product);
        if (IS_DEV_ENV) {
          console.error(error);
          return;
        }
        if (IS_TEST_ENV) {
          return;
        }
        var shouldSendToSentry = false;
        var cryptoObj = (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(window.crypto) ? window.msCrypto : window.crypto;
        if (cryptoObj !== void 0) {
          var cryptoRandom = cryptoObj.getRandomValues(new Uint32Array(1));
          shouldSendToSentry = cryptoRandom[0] / (4294967295 + 1) < sampleRate;
        } else {
          var mathRandom = Math.random();
          shouldSendToSentry = mathRandom < sampleRate;
        }
        if (!shouldSendToSentry) {
          console.error(error);
        } else if ((0, _trackingConsentApi_js__WEBPACK_IMPORTED_MODULE_1__.D5)()) {
          _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._sentryScope.clear();
          _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._sentryScope.setTag("pillar", "publish");
          _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._sentryScope.setTag("product", product);
          _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._sentryScope.setTag("url", window.location.href);
          if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.uu)(details)) {
            _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._sentryScope.setTags(details);
          }
          _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._sentryScope.captureException(error);
        }
      } catch (err) {
        console.error(err);
      }
    };
    var globalErrorHandler = function globalErrorHandler2(event) {
      var _event$error$source, _event$error;
      var eventError = event.error;
      if (!(eventError instanceof Error)) {
        return;
      }
      var eventErrorSource = (_event$error$source = (_event$error = event.error) === null || _event$error === void 0 ? void 0 : _event$error.source) !== null && _event$error$source !== void 0 ? _event$error$source : "";
      var fastHostName = appHostname("fast");
      if (eventErrorSource.includes(fastHostName)) {
        reportError("globalListener", eventError);
      }
    };
    var globalUnhandledRejectionHandler = function globalUnhandledRejectionHandler2(event) {
      var _event$reason$stack, _event$reason;
      var eventReason = event.reason;
      if (!(eventReason instanceof Error)) {
        return;
      }
      var eventReasonStack = (_event$reason$stack = (_event$reason = event.reason) === null || _event$reason === void 0 ? void 0 : _event$reason.stack) !== null && _event$reason$stack !== void 0 ? _event$reason$stack : "";
      if (eventReasonStack.includes(appHostname("fast"))) {
        reportError("globalListener", eventReason);
      }
    };
    var listenForGlobalErrors = function listenForGlobalErrors2() {
      if (!Wistia._isListeningForGlobalErrors) {
        window.addEventListener("error", globalErrorHandler);
        Wistia._isListeningForGlobalErrors = true;
      }
    };
    var listenForGlobalUnhandledRejections = function listenForGlobalUnhandledRejections2() {
      if (!Wistia._isListeningForGlobalUnhandledRejections) {
        window.addEventListener("unhandledrejection", globalUnhandledRejectionHandler);
        Wistia._isListeningForGlobalUnhandledRejections = true;
      }
    };
  },
  /***/
  2671(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      ff: () => (
        /* binding */
        proto
      ),
      /* harmony export */
      s0: () => (
        /* binding */
        Url2
      )
      /* harmony export */
    });
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var utilities_wlog_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(6637);
    var proto = function proto2() {
      var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : location.href;
      if (/^http:\/\//.test(url)) {
        return "http:";
      }
      return "https:";
    };
    var queryParamsToObject = function queryParamsToObject2(raw) {
      var result = {};
      if (!raw) {
        return result;
      }
      var parts = raw.split("&");
      var _loop2 = function _loop3() {
        var part = parts[i2];
        var pair = part.split("=");
        var key = pair[0];
        var val = pair[1];
        try {
          key = debrack(decodeURIComponent(key)) || "";
        } catch (e) {
          setTimeout(function() {
            utilities_wlog_js__WEBPACK_IMPORTED_MODULE_1__.ct.notice(e);
          }, 50);
          key = "";
        }
        (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.wg)(key);
        var existing = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.b$)(result, key);
        if (existing != null) {
          if ((0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.cy)(existing)) {
            existing.push(urlComponentToObject(val));
          } else {
            var arr = [existing];
            arr.push(urlComponentToObject(val));
            (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.mA)(result, key, arr);
          }
        } else {
          (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.mA)(result, key, urlComponentToObject(val));
        }
      };
      for (var i2 = 0; i2 < parts.length; i2++) {
        _loop2();
      }
      return result;
    };
    var urlComponentToObject = function urlComponentToObject2(val) {
      if (val == null) {
        return val;
      }
      var result;
      try {
        result = decodeURIComponent(val);
      } catch (e) {
        setTimeout(function() {
          utilities_wlog_js__WEBPACK_IMPORTED_MODULE_1__.ct.notice(e);
        }, 50);
        result = val;
      }
      return result;
    };
    var objectToQueryParams = function objectToQueryParams2(obj) {
      var result = [];
      (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.Cs)(obj, function(leafVal, path) {
        if (leafVal != null) {
          result.push("".concat(encodeURIComponent(brack(path)), "=").concat(encodeURIComponent(leafVal)));
        } else {
          result.push(encodeURIComponent(brack(path)));
        }
      });
      return result.join("&");
    };
    var splitPath = function splitPath2(str) {
      var result = [];
      if (str == null) {
        return result;
      }
      var parts = str.split(/\/+/);
      for (var i2 = 0; i2 < parts.length; i2++) {
        var part = parts[i2];
        if (part != null && part !== "") {
          result.push(part);
        }
      }
      return result;
    };
    var joinPath = function joinPath2(path) {
      if (typeof path === "string") {
        path = path.split("/");
      }
      if (path == null) {
        return "";
      }
      return "/".concat(path.join("/"));
    };
    var brack = function brack2(path) {
      var result = path[0];
      for (var i2 = 1; i2 < path.length; i2++) {
        result += "[".concat(path[i2], "]");
      }
      return result;
    };
    var debrack = function debrack2(str) {
      return str.match(/([\w\-_]+)/g);
    };
    var URL_CONSTRUCTOR_KEYS = ["protocol", "host", "port", "params", "path"];
    var Url2 = function Url3(url) {
      var self2 = this;
      var construct = function construct2() {
        self2.params = {};
        self2.path = [];
        self2.host = "";
        self2.rawPath = "";
        if (typeof url === "object") {
          self2.fromOptions(url);
        } else if (url) {
          self2.fromRaw(url);
        }
      };
      construct();
    };
    var uproto = Url2.prototype;
    uproto.fromOptions = function(options) {
      for (var i2 = 0; i2 < URL_CONSTRUCTOR_KEYS.length; i2++) {
        var opt = URL_CONSTRUCTOR_KEYS[i2];
        if (options[opt] != null) {
          this[opt] = options[opt];
        }
      }
      return this;
    };
    uproto.fromRaw = function(raw) {
      this.rawUrl = raw;
      var match;
      match = raw.match(/^((?:https?:)|(?:file:)|(?:ftp:))?\/\//);
      if (match) {
        this.protocol = match[1] || void 0;
      }
      match = raw.match(/\/\/([^:?#/]*)/);
      if (match) {
        this.host = match[1] || void 0;
      }
      match = raw.match(/\/\/.*?(\/[^?#$]+)/) || raw.match(/(^\/[^/][^?#$]+)/);
      if (match) {
        this.setPath(match[1]);
      }
      match = raw.match(/:(\d+)/);
      if (match) {
        this.port = parseInt(match[1], 10);
      }
      match = raw.match(/\?([^#]+)/);
      if (match) {
        this.rawParams = match[1];
        this.params = queryParamsToObject(this.rawParams);
      }
      match = raw.match(/#(.*)$/);
      if (match) {
        this.anchor = match[1];
      }
      return this;
    };
    uproto.clone = function() {
      return new Url2({
        protocol: this.protocol,
        host: this.host,
        port: this.port,
        path: (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.o8)(this.path),
        params: (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.o8)(this.params),
        anchor: this.anchor
      });
    };
    uproto.ext = function(ext) {
      if (ext != null) {
        var current = this.ext();
        var i2 = this.path.length - 1;
        var regexp = new RegExp("\\.".concat(current), "g");
        if (current) {
          this.path[i2] = "".concat(this.path[i2].replace(regexp, ""));
        }
        return this.path[i2] = "".concat(this.path[i2], ".").concat(ext);
      }
      var match = this.path[this.path.length - 1].match(/\.(.*)$/);
      return match != null && match[1] || null;
    };
    uproto.isRelative = function() {
      var loc = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location;
      var proto2 = this.protocol;
      var host = this.host;
      return (proto2 == null || proto2 === "" || proto2 === loc.protocol) && (!host || host === loc.hostname);
    };
    uproto.toString = function() {
      if (this.isRelative()) {
        return this.relative();
      }
      return this.absolute();
    };
    uproto.absolute = function() {
      var protocolPart = "";
      if (this.protocol != null) {
        protocolPart = this.protocol;
      }
      var portPart = "";
      if (this.port != null) {
        portPart = ":".concat(this.port);
      }
      return "".concat(protocolPart, "//").concat(this.host || location.host).concat(portPart).concat(this.relative());
    };
    uproto.relative = function() {
      var pathPart = "";
      if (this.path.length > 0) {
        pathPart = joinPath(this.path);
        if (this._hasTrailingSlash) {
          pathPart += "/";
        }
      }
      var paramPart = "?".concat(objectToQueryParams(this.params));
      if (paramPart.length === 1) {
        paramPart = "";
      }
      return "".concat(pathPart).concat(paramPart).concat(this.relativeAnchor());
    };
    uproto.authority = function() {
      var portPart = this.port != null ? ":".concat(this.port) : "";
      return "".concat(this.host).concat(portPart);
    };
    uproto.relativeProtocol = function() {
      var portPart = "";
      if (this.port != null) {
        portPart = ":".concat(this.port);
      }
      return "//".concat(this.host).concat(portPart).concat(this.relative());
    };
    uproto.relativeAnchor = function() {
      var anchorPart = "";
      if (this.anchor != null) {
        anchorPart = "#".concat(this.anchor);
      }
      return "".concat(anchorPart);
    };
    uproto.setPath = function(rawPath) {
      this.rawPath = rawPath;
      this._hasTrailingSlash = /\/$/.test(this.rawPath);
      this.path = splitPath(this.rawPath);
    };
    Url2.create = function(options) {
      return new Url2(options);
    };
    var createUrl = Url2.create;
    Url2.parse = function(str) {
      return new Url2(str);
    };
    var parseUrl = Url2.parse;
  },
  /***/
  2694(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      S: () => (
        /* binding */
        EventShepherd
      ),
      /* harmony export */
      h: () => (
        /* binding */
        convertedEventNames
      )
      /* harmony export */
    });
    var _eventConstants_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(2760);
    function _classCallCheck2(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties2(e, r) {
      for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
      }
    }
    function _createClass2(e, r, t) {
      return r && _defineProperties2(e.prototype, r), t && _defineProperties2(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
    }
    function _defineProperty2(e, r, t) {
      return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    var convertedEventNames = {
      mutechange: _eventConstants_ts__WEBPACK_IMPORTED_MODULE_0__.Gd
    };
    var callbackDetailsConversions = {
      mutechange: function mutechange(detail) {
        return detail.isMuted;
      }
    };
    var EventShepherd = /* @__PURE__ */ (function() {
      function EventShepherd2() {
        _classCallCheck2(this, EventShepherd2);
        _defineProperty2(this, "convertedEventsMap", {});
      }
      return _createClass2(EventShepherd2, [{
        key: "addListener",
        value: function addListener(eventName, element, callback) {
          var _convertedEventNames$, _this$convertedEvents, _this$convertedEvents2;
          var normalizedEventName = (_convertedEventNames$ = convertedEventNames[eventName]) !== null && _convertedEventNames$ !== void 0 ? _convertedEventNames$ : eventName;
          (_this$convertedEvents2 = (_this$convertedEvents = this.convertedEventsMap)[normalizedEventName]) !== null && _this$convertedEvents2 !== void 0 ? _this$convertedEvents2 : _this$convertedEvents[normalizedEventName] = [];
          var eventListenerCallback = function eventListenerCallback2(customEvent) {
            if (callbackDetailsConversions[eventName]) {
              var convertedDetail = callbackDetailsConversions[eventName](customEvent.detail);
              callback(convertedDetail);
            } else {
              callback();
            }
          };
          this.convertedEventsMap[normalizedEventName].push({
            givenCallback: callback,
            eventListenerCallback
          });
          element.addEventListener(normalizedEventName, eventListenerCallback);
        }
      }, {
        key: "removeAllListeners",
        value: function removeAllListeners(element) {
          var _this = this;
          Object.keys(this.convertedEventsMap).forEach(function(eventName) {
            var _this$convertedEvents3;
            (_this$convertedEvents3 = _this.convertedEventsMap[eventName]) === null || _this$convertedEvents3 === void 0 ? void 0 : _this$convertedEvents3.forEach(function(storedCallbacks) {
              element.removeEventListener(eventName, storedCallbacks.eventListenerCallback);
            });
            _this.convertedEventsMap[eventName] = [];
          });
        }
      }, {
        key: "removeListener",
        value: function removeListener(eventName, element, callback) {
          var _convertedEventNames$2, _this2 = this;
          var normalizedEventName = (_convertedEventNames$2 = convertedEventNames[eventName]) !== null && _convertedEventNames$2 !== void 0 ? _convertedEventNames$2 : eventName;
          var indexesToRemove = [];
          if (callback) {
            element.removeEventListener(normalizedEventName, callback);
            if (this.convertedEventsMap[normalizedEventName]) {
              this.convertedEventsMap[normalizedEventName].forEach(function(storedCallbacks, index) {
                if (storedCallbacks.givenCallback === callback) {
                  indexesToRemove.push(index);
                  element.removeEventListener(normalizedEventName, storedCallbacks.eventListenerCallback);
                }
              });
              indexesToRemove.forEach(function(index) {
                if (_this2.convertedEventsMap[normalizedEventName]) {
                  _this2.convertedEventsMap[normalizedEventName].splice(index, 1);
                }
              });
            }
          } else {
            this.convertedEventsMap[normalizedEventName] = [];
          }
        }
      }]);
    })();
  },
  /***/
  2721(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      $: () => (
        /* binding */
        usePlayerData
      ),
      /* harmony export */
      z: () => (
        /* binding */
        PlayerDataProvider
      )
      /* harmony export */
    });
    var preact__WEBPACK_IMPORTED_MODULE_0__2 = __webpack_require__3(5181);
    var preact_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(3817);
    var PlayerDataContext = (0, preact__WEBPACK_IMPORTED_MODULE_0__2.createContext)(null);
    var PlayerDataProvider = function PlayerDataProvider2(_ref) {
      var children = _ref.children, embedOptions = _ref.embedOptions, mediaData = _ref.mediaData;
      return (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)(PlayerDataContext.Provider, {
        value: {
          embedOptions,
          mediaData
        }
      }, children);
    };
    var usePlayerData = function usePlayerData2() {
      var context = (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useContext)(PlayerDataContext);
      if (context == null) {
        throw new Error("usePlayerData must be used within a PlayerDataProvider");
      }
      return context;
    };
  },
  /***/
  2760(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      $1: () => (
        /* binding */
        AFTER_REPLACE_EVENT
      ),
      /* harmony export */
      Gd: () => (
        /* binding */
        MUTE_CHANGE_EVENT
      ),
      /* harmony export */
      c5: () => (
        /* binding */
        API_READY_EVENT
      ),
      /* harmony export */
      dp: () => (
        /* binding */
        IMPL_CREATED_EVENT
      ),
      /* harmony export */
      iP: () => (
        /* binding */
        INTERNAL_API_ON_FIND_EVENT
      ),
      /* harmony export */
      kY: () => (
        /* binding */
        BEFORE_REPLACE_EVENT
      ),
      /* harmony export */
      rO: () => (
        /* binding */
        LOADED_MEDIA_DATA_EVENT
      ),
      /* harmony export */
      ve: () => (
        /* binding */
        INPUT_CONTEXT_CHANGE_EVENT
      )
      /* harmony export */
    });
    var AFTER_REPLACE_EVENT = "after-replace";
    var API_READY_EVENT = "api-ready";
    var BEFORE_REPLACE_EVENT = "before-replace";
    var BETWEENTIMES_EVENT_EV1 = "betweentimes";
    var CROSSTIME_EVENT_EV1 = "crosstime";
    var EMBED_OPTIONS_CHANGED_EVENT = "embed-options-changed";
    var IMPL_CREATED_EVENT = "impl-created";
    var INIT_EMBED_EVENT = "initembed";
    var INPUT_CONTEXT_CHANGE_EVENT = "input-context-change";
    var INTERNAL_API_ON_FIND_EVENT = "internal-api-on-find";
    var LOADED_MEDIA_DATA_EVENT = "loaded-media-data";
    var MUTE_CHANGE_EVENT = "mute-change";
    var TIME_UPDATE_EVENT = "time-update";
  },
  /***/
  2917(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Lg: () => (
        /* binding */
        getLocalStorage
      ),
      /* harmony export */
      yo: () => (
        /* binding */
        updateLocalStorage2
      )
      /* harmony export */
    });
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(5509);
    var throwAsync = function throwAsync2(e) {
      setTimeout(function() {
        throw e;
      }, 0);
    };
    var OBJ_PROP = "_namespacedLocalStorage";
    var localStorageWorks = function localStorageWorks2() {
      var ns = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "wistia-test-localstorage";
      if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s._localStorageWorks != null) {
        return _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s._localStorageWorks;
      }
      try {
        var currentVal = localStorage.getItem(ns);
        localStorage.removeItem(ns);
        localStorage.setItem(ns, currentVal);
        localStorage.removeItem(ns);
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s._localStorageWorks = true;
      } catch (e) {
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s._localStorageWorks = false;
      }
      return _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s._localStorageWorks;
    };
    var getMemory = function getMemory2() {
      if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s[OBJ_PROP] == null) {
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s[OBJ_PROP] = {};
      }
      return _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s[OBJ_PROP];
    };
    var getLocalStorage = function getLocalStorage2(ns) {
      if (!localStorageWorks()) {
        return getMemory()[ns] || {};
      }
      if (localStorage[ns]) {
        try {
          if (localStorage[ns] === "null") {
            return {};
          }
          return JSON.parse(localStorage[ns]);
        } catch (e) {
          throwAsync(e);
        }
      }
      return {};
    };
    var removeLocalStorage2 = function removeLocalStorage3(ns) {
      if (!localStorageWorks()) {
        getMemory()[ns] = {};
        return;
      }
      try {
        localStorage.removeItem(ns);
      } catch (e) {
        throwAsync(e);
      }
    };
    var setLocalStorage2 = function setLocalStorage3(ns, obj) {
      if (!localStorageWorks()) {
        if (obj != null && typeof obj === "object") {
          getMemory()[ns] = obj;
        }
        return obj;
      }
      try {
        getMemory()[ns] = obj;
        localStorage[ns] = JSON.stringify(obj);
      } catch (e) {
        throwAsync(e);
      }
      return obj;
    };
    var updateLocalStorage2 = function updateLocalStorage3(ns, fn) {
      var obj = getLocalStorage(ns);
      try {
        fn(obj);
      } catch (e) {
        throwAsync(e);
      }
      return setLocalStorage2(ns, obj);
    };
  },
  /***/
  3065(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      j: () => (
        /* binding */
        fetchMediaData
      )
      /* harmony export */
    });
    var _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9814);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    var _hosts_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(5857);
    var _media_data_transforms_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(3917);
    var _remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(3411);
    var _mediaDataError_ts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(959);
    var _embeds_wistiaPlayer_utilities_getPreferredLanguageIndex_ts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__3(4400);
    var _viewerPreferences_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__3(7438);
    function ownKeys2(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
          return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread2(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
          _defineProperty2(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
          Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
      }
      return e;
    }
    function _defineProperty2(e, r, t) {
      return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    function _toConsumableArray(r) {
      return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray2(r) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return _arrayLikeToArray2(r);
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _regenerator2() {
      var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
      function i2(r2, n2, o2, i3) {
        var c2 = n2 && n2.prototype instanceof Generator ? n2 : Generator, u2 = Object.create(c2.prototype);
        return _regeneratorDefine22(u2, "_invoke", (function(r3, n3, o3) {
          var i4, c3, u3, f2 = 0, p = o3 || [], y = false, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d2(t2, r4) {
            return i4 = t2, c3 = 0, u3 = e, G.n = r4, a;
          } };
          function d(r4, n4) {
            for (c3 = r4, u3 = n4, t = 0; !y && f2 && !o4 && t < p.length; t++) {
              var o4, i5 = p[t], d2 = G.p, l = i5[2];
              r4 > 3 ? (o4 = l === n4) && (u3 = i5[(c3 = i5[4]) ? 5 : (c3 = 3, 3)], i5[4] = i5[5] = e) : i5[0] <= d2 && ((o4 = r4 < 2 && d2 < i5[1]) ? (c3 = 0, G.v = n4, G.n = i5[1]) : d2 < l && (o4 = r4 < 3 || i5[0] > n4 || n4 > l) && (i5[4] = r4, i5[5] = n4, G.n = l, c3 = 0));
            }
            if (o4 || r4 > 1) return a;
            throw y = true, n4;
          }
          return function(o4, p2, l) {
            if (f2 > 1) throw TypeError("Generator is already running");
            for (y && 1 === p2 && d(p2, l), c3 = p2, u3 = l; (t = c3 < 2 ? e : u3) || !y; ) {
              i4 || (c3 ? c3 < 3 ? (c3 > 1 && (G.n = -1), d(c3, u3)) : G.n = u3 : G.v = u3);
              try {
                if (f2 = 2, i4) {
                  if (c3 || (o4 = "next"), t = i4[o4]) {
                    if (!(t = t.call(i4, u3))) throw TypeError("iterator result is not an object");
                    if (!t.done) return t;
                    u3 = t.value, c3 < 2 && (c3 = 0);
                  } else 1 === c3 && (t = i4.return) && t.call(i4), c3 < 2 && (u3 = TypeError("The iterator does not provide a '" + o4 + "' method"), c3 = 1);
                  i4 = e;
                } else if ((t = (y = G.n < 0) ? u3 : r3.call(n3, G)) !== a) break;
              } catch (t2) {
                i4 = e, c3 = 1, u3 = t2;
              } finally {
                f2 = 1;
              }
            }
            return { value: t, done: y };
          };
        })(r2, o2, i3), true), u2;
      }
      var a = {};
      function Generator() {
      }
      function GeneratorFunction() {
      }
      function GeneratorFunctionPrototype() {
      }
      t = Object.getPrototypeOf;
      var c = [][n] ? t(t([][n]())) : (_regeneratorDefine22(t = {}, n, function() {
        return this;
      }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
      function f(e2) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e2, GeneratorFunctionPrototype) : (e2.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine22(e2, o, "GeneratorFunction")), e2.prototype = Object.create(u), e2;
      }
      return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine22(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine22(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine22(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine22(u), _regeneratorDefine22(u, o, "Generator"), _regeneratorDefine22(u, n, function() {
        return this;
      }), _regeneratorDefine22(u, "toString", function() {
        return "[object Generator]";
      }), (_regenerator2 = function _regenerator3() {
        return { w: i2, m: f };
      })();
    }
    function _regeneratorDefine22(e, r, n, t) {
      var i2 = Object.defineProperty;
      try {
        i2({}, "", {});
      } catch (e2) {
        i2 = 0;
      }
      _regeneratorDefine22 = function _regeneratorDefine(e2, r2, n2, t2) {
        function o(r3, n3) {
          _regeneratorDefine22(e2, r3, function(e3) {
            return this._invoke(r3, n3, e3);
          });
        }
        r2 ? i2 ? i2(e2, r2, { value: n2, enumerable: !t2, configurable: !t2, writable: !t2 }) : e2[r2] = n2 : (o("next", 0), o("throw", 1), o("return", 2));
      }, _regeneratorDefine22(e, r, n, t);
    }
    function asyncGeneratorStep2(n, t, e, r, o, a, c) {
      try {
        var i2 = n[a](c), u = i2.value;
      } catch (n2) {
        return void e(n2);
      }
      i2.done ? t(u) : Promise.resolve(u).then(r, o);
    }
    function _asyncToGenerator2(n) {
      return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
          var a = n.apply(t, e);
          function _next(n2) {
            asyncGeneratorStep2(a, r, o, _next, _throw, "next", n2);
          }
          function _throw(n2) {
            asyncGeneratorStep2(a, r, o, _next, _throw, "throw", n2);
          }
          _next(void 0);
        });
      };
    }
    var fetchUnlocalizedMediaData = /* @__PURE__ */ (function() {
      var _ref = _asyncToGenerator2(/* @__PURE__ */ _regenerator2().m(function _callee(hashedId) {
        var _options$channelPassw, _options$plugin, _options$plugin$passw;
        var options, cacheKey, mediaDataFromCache, host, url, channelPasswordParam, promise, _args = arguments;
        return _regenerator2().w(function(_context) {
          while (1) switch (_context.n) {
            case 0:
              options = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
              cacheKey = hashedId;
              mediaDataFromCache = (0, _remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_4__.F2)(cacheKey);
              if (!(mediaDataFromCache && options.skipCache !== true)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, Promise.resolve(mediaDataFromCache));
            case 1:
              if (!((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.n9)(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._mediaDataPromises[cacheKey]) && options.skipCache !== true)) {
                _context.n = 2;
                break;
              }
              return _context.a(2, _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._mediaDataPromises[cacheKey]);
            case 2:
              host = (0, _hosts_js__WEBPACK_IMPORTED_MODULE_2__.Dd)(options);
              url = new window.URL("https://".concat(host, "/embed/medias/").concat(hashedId, ".json"));
              if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.n9)(options.channelId)) {
                url.searchParams.set("channelId", options.channelId.toString());
              }
              channelPasswordParam = (_options$channelPassw = options.channelPassword) !== null && _options$channelPassw !== void 0 ? _options$channelPassw : (_options$plugin = options.plugin) === null || _options$plugin === void 0 ? void 0 : (_options$plugin$passw = _options$plugin.passwordProtectedChannel) === null || _options$plugin$passw === void 0 ? void 0 : _options$plugin$passw.password;
              if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.n9)(channelPasswordParam)) {
                url.searchParams.set("channelPassword", channelPasswordParam);
              }
              if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.n9)(options.password)) {
                url.searchParams.set("password", options.password);
              }
              if (options.deferFetchingToCarousel) {
                url.searchParams.set("defer_fetching_to_carousel", "true");
              }
              if (options.bypassOriginShield) {
                url.searchParams.set("bos", "1");
              }
              promise = fetch(url.href).then(function(resp) {
                return resp.json();
              }).then(function(response) {
                var _mediaData$hashedId;
                if ((0, _mediaDataError_ts__WEBPACK_IMPORTED_MODULE_5__.V)(response)) {
                  return response;
                }
                var _ref2 = response, mediaData = _ref2.media;
                (0, _media_data_transforms_js__WEBPACK_IMPORTED_MODULE_3__.M)(mediaData, options);
                (0, _remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_4__.ry)((_mediaData$hashedId = mediaData.hashedId) !== null && _mediaData$hashedId !== void 0 ? _mediaData$hashedId : "", mediaData);
                return mediaData;
              }).finally(function() {
                Reflect.deleteProperty(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._mediaDataPromises, cacheKey);
              });
              _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._mediaDataPromises[cacheKey] = promise;
              return _context.a(2, promise);
          }
        }, _callee);
      }));
      return function fetchUnlocalizedMediaData2(_x) {
        return _ref.apply(this, arguments);
      };
    })();
    var fetchMediaData = /* @__PURE__ */ (function() {
      var _ref3 = _asyncToGenerator2(/* @__PURE__ */ _regenerator2().m(function _callee2(hashedId) {
        var options, mediaDataOrError, mediaData, typedViewerPreferences, localizationViewerPreferences, preferredLanguages, uniquePreferredLanguages, preferredLanguageIndex, _navigator$languages, preferredLocalization, _args2 = arguments;
        return _regenerator2().w(function(_context2) {
          while (1) switch (_context2.n) {
            case 0:
              options = _args2.length > 1 && _args2[1] !== void 0 ? _args2[1] : {};
              _context2.n = 1;
              return fetchUnlocalizedMediaData(hashedId, options);
            case 1:
              mediaDataOrError = _context2.v;
              if (!(0, _mediaDataError_ts__WEBPACK_IMPORTED_MODULE_5__.V)(mediaDataOrError)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, mediaDataOrError);
            case 2:
              mediaData = mediaDataOrError;
              if (!(mediaData.localizations == null || mediaData.localizations.length === 0)) {
                _context2.n = 3;
                break;
              }
              return _context2.a(2, mediaData);
            case 3:
              typedViewerPreferences = (0, _viewerPreferences_js__WEBPACK_IMPORTED_MODULE_7__.hy)();
              localizationViewerPreferences = typedViewerPreferences.localization;
              preferredLanguages = [];
              if (options.overrideMediaLanguage != null) {
                preferredLanguages.push(options.overrideMediaLanguage);
              }
              if ((localizationViewerPreferences === null || localizationViewerPreferences === void 0 ? void 0 : localizationViewerPreferences.bcp47LanguageTag) != null) {
                preferredLanguages.push(localizationViewerPreferences.bcp47LanguageTag);
              }
              if (options.defaultMediaLanguage != null) {
                preferredLanguages.push(options.defaultMediaLanguage);
              }
              uniquePreferredLanguages = preferredLanguages.filter(function(lang, index) {
                return preferredLanguages.indexOf(lang) === index;
              });
              preferredLanguageIndex = (0, _embeds_wistiaPlayer_utilities_getPreferredLanguageIndex_ts__WEBPACK_IMPORTED_MODULE_6__.J)(mediaData.localizations.map(function(loc) {
                return loc.bcp47LanguageTag;
              }), uniquePreferredLanguages);
              if (preferredLanguageIndex === -1) {
                preferredLanguageIndex = (0, _embeds_wistiaPlayer_utilities_getPreferredLanguageIndex_ts__WEBPACK_IMPORTED_MODULE_6__.J)(mediaData.localizations.map(function(loc) {
                  return loc.wistiaLanguageCode;
                }), uniquePreferredLanguages);
              }
              if (preferredLanguageIndex === -1) {
                preferredLanguageIndex = (0, _embeds_wistiaPlayer_utilities_getPreferredLanguageIndex_ts__WEBPACK_IMPORTED_MODULE_6__.J)(
                  mediaData.localizations.map(function(loc) {
                    return loc.bcp47LanguageTag;
                  }),
                  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                  _toConsumableArray((_navigator$languages = navigator.languages) !== null && _navigator$languages !== void 0 ? _navigator$languages : ["en"])
                );
              }
              if (!(preferredLanguageIndex >= 0)) {
                _context2.n = 6;
                break;
              }
              preferredLocalization = mediaData.localizations[preferredLanguageIndex];
              if (!(mediaData.hashedId === preferredLocalization.hashedId)) {
                _context2.n = 4;
                break;
              }
              return _context2.a(2, mediaData);
            case 4:
              if (!(preferredLocalization.localizationIntent === "alternate_audio")) {
                _context2.n = 5;
                break;
              }
              return _context2.a(2, mediaData);
            case 5:
              return _context2.a(2, fetchUnlocalizedMediaData(preferredLocalization.hashedId, _objectSpread2({}, options)));
            case 6:
              return _context2.a(2, mediaData);
          }
        }, _callee2);
      }));
      return function fetchMediaData2(_x2) {
        return _ref3.apply(this, arguments);
      };
    })();
  },
  /***/
  3123(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      JA: () => (
        /* binding */
        getDefaultPlayerBorderRadius
      ),
      /* harmony export */
      Ru: () => (
        /* binding */
        getDefaultControlBarDistance
      ),
      /* harmony export */
      gl: () => (
        /* binding */
        getDefaultBigPlayButtonBorderRadius
      )
      /* harmony export */
    });
    var BIG_PLAY_BUTTON_RADIUS_RATIO = 0.75;
    var CONTROL_BAR_DISTANCE_RATIO = 0.75;
    var FLOATING_CONTROL_BAR_RADIUS = 18;
    var FLOATING_CONTROL_BAR_DISTANCE = 6;
    var getDefaultPlayerBorderRadius = function getDefaultPlayerBorderRadius2(_ref) {
      var playerBorderRadius = _ref.playerBorderRadius, roundedPlayer = _ref.roundedPlayer;
      if (roundedPlayer !== void 0) {
        return roundedPlayer;
      }
      if (playerBorderRadius !== void 0) {
        return playerBorderRadius;
      }
      return 0;
    };
    var getDefaultBigPlayButtonBorderRadius = function getDefaultBigPlayButtonBorderRadius2(_ref2) {
      var bigPlayButtonBorderRadius = _ref2.bigPlayButtonBorderRadius, roundedPlayer = _ref2.roundedPlayer;
      if (bigPlayButtonBorderRadius !== void 0) {
        return bigPlayButtonBorderRadius;
      }
      if (roundedPlayer !== void 0) {
        return roundedPlayer * BIG_PLAY_BUTTON_RADIUS_RATIO;
      }
      return 0;
    };
    var getDefaultControlBarBorderRadius = function getDefaultControlBarBorderRadius2(_ref3) {
      var controlBarBorderRadius = _ref3.controlBarBorderRadius, floatingControlBar = _ref3.floatingControlBar, roundedPlayer = _ref3.roundedPlayer;
      if (controlBarBorderRadius !== void 0) {
        return controlBarBorderRadius;
      }
      if (roundedPlayer !== void 0) {
        return roundedPlayer * CONTROL_BAR_DISTANCE_RATIO;
      }
      if (floatingControlBar === true) {
        return FLOATING_CONTROL_BAR_RADIUS;
      }
      return 0;
    };
    var getDefaultControlBarDistance = function getDefaultControlBarDistance2(_ref4) {
      var controlBarBorderRadius = _ref4.controlBarBorderRadius, floatingControlBar = _ref4.floatingControlBar, roundedPlayer = _ref4.roundedPlayer;
      if (roundedPlayer !== void 0) {
        return roundedPlayer / 4;
      }
      if (controlBarBorderRadius !== void 0) {
        return controlBarBorderRadius / 2;
      }
      if (floatingControlBar === true) {
        return FLOATING_CONTROL_BAR_DISTANCE;
      }
      return 0;
    };
  },
  /***/
  3164(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      E: () => (
        /* binding */
        ProgressiveThumbnail
      )
      /* harmony export */
    });
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var preact__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5181);
    var utilities_hosts_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(5857);
    var _Thumbnail_jsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(5819);
    function _extends() {
      return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }, _extends.apply(null, arguments);
    }
    function _classCallCheck2(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties2(e, r) {
      for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
      }
    }
    function _createClass2(e, r, t) {
      return r && _defineProperties2(e.prototype, r), t && _defineProperties2(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
    }
    function _callSuper2(t, o, e) {
      return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
    }
    function _possibleConstructorReturn2(t, e) {
      if (e && ("object" == typeof e || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return _assertThisInitialized2(t);
    }
    function _assertThisInitialized2(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function _isNativeReflectConstruct2() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch (t2) {
      }
      return (_isNativeReflectConstruct2 = function _isNativeReflectConstruct3() {
        return !!t;
      })();
    }
    function _getPrototypeOf2(t) {
      return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
        return t2.__proto__ || Object.getPrototypeOf(t2);
      }, _getPrototypeOf2(t);
    }
    function _inherits2(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
    }
    function _setPrototypeOf2(t, e) {
      return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
        return t2.__proto__ = e2, t2;
      }, _setPrototypeOf2(t, e);
    }
    function _defineProperty2(e, r, t) {
      return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    var ProgressiveThumbnail = /* @__PURE__ */ (function(_Component) {
      function ProgressiveThumbnail2(props) {
        var _this;
        _classCallCheck2(this, ProgressiveThumbnail2);
        _this = _callSuper2(this, ProgressiveThumbnail2, [props]);
        _defineProperty2(_this, "afterTwoSeconds", function() {
          if (!_this._displayed && _this.state.normalThumbOpacity === 1) {
            _this.setState({
              normalThumbOpacity: 0
            });
          }
        });
        _defineProperty2(_this, "onDisplayNormalThumb", function() {
          _this.setState({
            normalThumbOpacity: 1
          });
          _this._displayed = true;
          if (_this.onDisplay) {
            _this.onDisplay();
          }
        });
        _this.state = {
          normalThumbOpacity: props.isVisible ? 1 : 0
        };
        _this.onDisplay = props.onDisplay;
        return _this;
      }
      _inherits2(ProgressiveThumbnail2, _Component);
      return _createClass2(ProgressiveThumbnail2, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          if (!this.onDisplay && nextProps.onDisplay) {
            this.onDisplay = nextProps.onDisplay;
          }
        }
      }, {
        key: "render",
        value: function render() {
          if (this.props.isVisible) {
            this._hasRenderedVisible = true;
          }
          var sharedProps = {
            backgroundColor: this.props.backgroundColor,
            fitStrategy: this.props.fitStrategy,
            isVisible: this.props.isVisible,
            stillSnap: this.props.stillSnap,
            stretchLimit: this.props.stretchLimit,
            videoHeight: this.props.videoHeight,
            videoWidth: this.props.videoWidth,
            thumbnailAltText: this.props.thumbnailAltText,
            playerBorderRadius: this.props.playerBorderRadius
          };
          var swatchProps = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.kp)({}, sharedProps, {
            ariaHidden: true,
            images: [{
              url: "".concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_2__.v9)(), "//").concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_2__.bC)(), "/embed/medias/").concat(this.props.hashedId, "/swatch")
            }]
          });
          var normalThumbProps = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.kp)({}, sharedProps, {
            onDisplay: this.onDisplayNormalThumb,
            images: this.props.images
          });
          return (0, preact__WEBPACK_IMPORTED_MODULE_1__.h)("div", {
            ref: this.props.elemRef
          }, this.props.swatchEnabled && this._hasRenderedVisible ? (0, preact__WEBPACK_IMPORTED_MODULE_1__.h)(_Thumbnail_jsx__WEBPACK_IMPORTED_MODULE_3__.V, _extends({}, swatchProps, {
            wrapperStyle: this.swatchWrapperStyle()
          })) : null, this._hasRenderedVisible ? (0, preact__WEBPACK_IMPORTED_MODULE_1__.h)(_Thumbnail_jsx__WEBPACK_IMPORTED_MODULE_3__.V, _extends({}, normalThumbProps, {
            wrapperStyle: this.normalThumbWrapperStyle()
          })) : null);
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          setTimeout(this.afterTwoSeconds, 2e3);
        }
      }, {
        key: "normalThumbWrapperStyle",
        value: function normalThumbWrapperStyle() {
          var transition = this.props.swatchEnabled && this.props.uiHasRendered && this.state.normalThumbOpacity === 1 ? "opacity 3s" : "";
          return {
            height: "100%",
            left: 0,
            opacity: this.state.normalThumbOpacity,
            position: this.props.fitStrategy === "naturalHeight" ? "relative" : "absolute",
            top: 0,
            transition,
            width: "100%"
          };
        }
      }, {
        key: "swatchWrapperStyle",
        value: function swatchWrapperStyle() {
          return {
            filter: "blur(5px)",
            height: "100%",
            left: 0,
            position: this.props.fitStrategy === "naturalHeight" ? "relative" : "absolute",
            top: 0,
            width: "100%"
          };
        }
      }]);
    })(preact__WEBPACK_IMPORTED_MODULE_1__.Component);
  },
  /***/
  3280(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      gY: () => (
        /* binding */
        setEmbedOptionStore
      ),
      /* harmony export */
      iU: () => (
        /* binding */
        removeEmbedOptionStore
      )
      /* harmony export */
    });
    var _obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var _wistiaData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(3997);
    var _getApiHandles_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(5510);
    var OPTION_PREFIX = "wistia_embed_options_";
    var GLOBAL_ID_KEY = "__global__";
    var getEmbedOptionStore = function getEmbedOptionStore2(id) {
      var matcherFn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getOneApiHandle;
      if (wData([OPTION_PREFIX, id]) !== void 0) {
        return wData([OPTION_PREFIX, id]);
      }
      var apiHandleFromKey = matcherFn(id);
      if (apiHandleFromKey === null || apiHandleFromKey === "removed") {
        return {};
      }
      if (wData(OPTION_PREFIX) !== void 0) {
        var matchedKey = Object.keys(wData(OPTION_PREFIX)).find(function(key) {
          return matcherFn(key) === apiHandleFromKey;
        });
        if (wData([OPTION_PREFIX, matchedKey]) !== void 0) {
          return wData([OPTION_PREFIX, matchedKey]);
        }
      }
      return {};
    };
    var setEmbedOptionStore = function setEmbedOptionStore2(id, options) {
      if (options !== null) {
        return (0, _wistiaData_js__WEBPACK_IMPORTED_MODULE_1__.m)([OPTION_PREFIX, id], (0, _obj_js__WEBPACK_IMPORTED_MODULE_0__.wg)((0, _obj_js__WEBPACK_IMPORTED_MODULE_0__.o8)(options)));
      }
      return {};
    };
    var removeEmbedOptionStore = function removeEmbedOptionStore2(id) {
      (0, _wistiaData_js__WEBPACK_IMPORTED_MODULE_1__.S)([OPTION_PREFIX, id]);
    };
    var getOrSetEmbedOptionStore = function getOrSetEmbedOptionStore2(id, options) {
      var optionsKey = id;
      var embedOptions = options;
      if (isObject(optionsKey) && typeof optionsKey === "object") {
        embedOptions = optionsKey;
        optionsKey = GLOBAL_ID_KEY;
      }
      if (embedOptions !== void 0 && embedOptions !== null) {
        return wData([OPTION_PREFIX, optionsKey], cast(clone(embedOptions)));
      }
      if (optionsKey !== void 0) {
        if (wData([OPTION_PREFIX, id]) !== void 0) {
          return wData([OPTION_PREFIX, id]);
        }
        var apiHandleFromKey = getOneApiHandle(optionsKey);
        if (apiHandleFromKey === null || apiHandleFromKey === "removed") {
          return {};
        }
        if (wData(OPTION_PREFIX) !== void 0) {
          var matchedKey = Object.keys(wData(OPTION_PREFIX)).find(function(key) {
            return getOneApiHandle(key) === apiHandleFromKey;
          });
          if (wData([OPTION_PREFIX, matchedKey]) !== void 0) {
            return wData([OPTION_PREFIX, matchedKey]);
          }
        }
        return {};
      }
      return wData(OPTION_PREFIX);
    };
  },
  /***/
  3411(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      F2: () => (
        /* binding */
        getMediaDataFromCache2
      ),
      /* harmony export */
      ry: () => (
        /* binding */
        cacheMediaData2
      ),
      /* harmony export */
      s3: () => (
        /* binding */
        uncacheMediaData2
      )
      /* harmony export */
    });
    var _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9814);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    var _wlog_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(6637);
    var _objectHasOwn = function(object, property) {
      if (typeof object === "undefined" || object === null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    };
    var getMediaDataFromCache2 = function getMediaDataFromCache3(hashedId) {
      var mediaData = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._remoteData.get("media_".concat(hashedId));
      if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.gD)(mediaData)) return null;
      if (_objectHasOwn(mediaData, "error")) {
        _wlog_js__WEBPACK_IMPORTED_MODULE_2__.ct.error("Received cached error response instead of MediaData when retrieving cached mediaData for ".concat(hashedId));
      }
      return mediaData;
    };
    var cacheMediaData2 = function cacheMediaData3(hashedId, data) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._remoteData.set("media_".concat(hashedId), data);
    };
    var uncacheMediaData2 = function uncacheMediaData3(hashedId) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._remoteData.delete("media_".concat(hashedId));
      Reflect.deleteProperty(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._mediaDataPromises, hashedId);
    };
    var cacheLiveStreamEventData = function cacheLiveStreamEventData2(hashedId, data) {
      Wistia._remoteData.set("live_stream_event_".concat(hashedId), data);
    };
    var uncacheLiveStreamEventData = function uncacheLiveStreamEventData2(hashedId) {
      Wistia._remoteData.delete("live_stream_event_".concat(hashedId));
    };
    var getLiveStreamEventDataFromCache = function getLiveStreamEventDataFromCache2(hashedId) {
      var liveStreamEventData = Wistia._remoteData.get("live_stream_event_".concat(hashedId));
      if (isNil(liveStreamEventData)) return null;
      if (_objectHasOwn(liveStreamEventData, "error")) {
        wlog.error("Received cached error response instead of LiveStreamEventData when retrieving cached liveStreamEventData for ".concat(hashedId));
        uncacheLiveStreamEventData(hashedId);
      }
      return liveStreamEventData;
    };
    var getCarouselDataFromCache = function getCarouselDataFromCache2(hashedId) {
      var carouselData = Wistia._remoteData.get("carousel_".concat(hashedId));
      if (isNil(carouselData)) return null;
      return carouselData;
    };
    var cacheCarouselData = function cacheCarouselData2(hashedId, data) {
      Wistia._remoteData.set("carousel_".concat(hashedId), data);
    };
    var uncacheCarouselData = function uncacheCarouselData2(hashedId) {
      Wistia._remoteData.delete("carousel_".concat(hashedId));
    };
  },
  /***/
  3441(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      CR: () => (
        /* binding */
        seekToAction
      ),
      /* harmony export */
      Qy: () => (
        /* binding */
        shouldAddClipsFromChapters
      ),
      /* harmony export */
      Vq: () => (
        /* binding */
        shouldAddKeyMoments
      ),
      /* harmony export */
      oG: () => (
        /* binding */
        clipsFromChapters
      )
      /* harmony export */
    });
    var _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9814);
    var _normalizeChapters_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(9128);
    function _toConsumableArray(r) {
      return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray2(r) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return _arrayLikeToArray2(r);
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var DEFAULT_CHAPTER_TITLE = "Chapter Title";
    var MINIMUM_DURATION = 30;
    var shouldAddClipsFromChapters = function shouldAddClipsFromChapters2(embedOptions) {
      var chapters = (0, _normalizeChapters_ts__WEBPACK_IMPORTED_MODULE_1__.a)(embedOptions);
      if (!chapters) {
        return false;
      }
      var chapterList = chapters.chapterList;
      return chapters.on !== false && chapters.on !== "false" && Array.isArray(chapterList) && chapterList.length > 0;
    };
    var shouldAddKeyMoments = function shouldAddKeyMoments2(mediaData, embedOptions) {
      var _embedOptions$plugin;
      if (embedOptions.keyMoments === false) {
        return false;
      }
      var duration = mediaData.duration, type = mediaData.type;
      var _ref = (_embedOptions$plugin = embedOptions.plugin) !== null && _embedOptions$plugin !== void 0 ? _embedOptions$plugin : {}, passwordProtectedVideo = _ref.passwordProtectedVideo, turnstilePlugin = _ref["requireEmail-v1"], form = _ref.form;
      var isLiveStream = type === "LiveStream";
      var passwordEnabled = (passwordProtectedVideo === null || passwordProtectedVideo === void 0 ? void 0 : passwordProtectedVideo.on) === true || (passwordProtectedVideo === null || passwordProtectedVideo === void 0 ? void 0 : passwordProtectedVideo.on) === "true";
      var turnstileBlocksContent = turnstilePlugin && turnstilePlugin.on !== false && turnstilePlugin.time !== "end" && !turnstilePlugin.persistentTurnstile;
      var formBlocksContent = (form === null || form === void 0 ? void 0 : form.on) !== false && (form === null || form === void 0 ? void 0 : form.time) !== "end" && (form === null || form === void 0 ? void 0 : form.displayMode) === "pause";
      return !passwordEnabled && !turnstileBlocksContent && !formBlocksContent && !isLiveStream && typeof duration === "number" && duration >= MINIMUM_DURATION;
    };
    var sortedFilteredChapters = function sortedFilteredChapters2(chapterList) {
      var chapterExistsAtTime = {};
      return _toConsumableArray(chapterList).sort(function(firstChapter, secondChapter) {
        return firstChapter.time - secondChapter.time;
      }).filter(function(_ref2) {
        var time = _ref2.time, title = _ref2.title, deleted = _ref2.deleted;
        if (Boolean(chapterExistsAtTime[time]) || deleted || title === DEFAULT_CHAPTER_TITLE) {
          return false;
        }
        chapterExistsAtTime[time] = true;
        return true;
      });
    };
    var clipsFromChapters = function clipsFromChapters2(chapterList, baseUrl, mediaDuration) {
      if (!Array.isArray(chapterList) || chapterList.length === 0) {
        return [];
      }
      var clips = sortedFilteredChapters(chapterList).map(function(chapter, index, chapters) {
        var time = chapter.time, title = chapter.title;
        var url = new window.URL(baseUrl);
        var floorTime = Math.floor(time);
        var nextChapter = chapters[index + 1];
        var endOffsetTime = (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.n9)(nextChapter) ? nextChapter.time : mediaDuration;
        url.searchParams.set("wtime", "".concat(floorTime, "s"));
        return {
          "@type": "Clip",
          endOffset: Math.floor(endOffsetTime),
          name: title,
          startOffset: floorTime,
          url: url.toString()
        };
      });
      return clips;
    };
    var seekToAction = function seekToAction2() {
      var url = new window.URL(window.location.href);
      url.searchParams.set("wtime", "{seek_to_second_number}");
      return {
        "@type": "SeekToAction",
        target: url.toString().replace("%7Bseek_to_second_number%7D", "{seek_to_second_number}"),
        // we need to replace the encoded uri with the direct string
        "startOffset-input": "required name=seek_to_second_number"
      };
    };
  },
  /***/
  3695(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Qy: () => (
        /* binding */
        setOrGet
      )
      /* harmony export */
    });
    var utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(4997);
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(731);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(5509);
    if (!_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._localStorage) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._localStorage = (0, utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_0__.y1)();
    }
    var uncache = function uncache2() {
      Wistia._localStorage = {};
    };
    var setOrGet = function setOrGet2(key, val) {
      var unset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      if (val != null) {
        var fn = unset ? utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__.G0 : utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__.vd;
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._localStorage = (0, utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_0__.$B)(function(ls) {
          return fn(ls, key, val);
        });
        return val;
      }
      if (key != null) {
        return (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_1__.b$)(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._localStorage, key);
      }
      return _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._localStorage;
    };
    var removeLocalStorage2 = function removeLocalStorage3(key) {
      return setOrGet(key, "nada", true);
    };
    var dumpLocalStorage = (
      /* unused pure expression or super */
      null
    );
  },
  /***/
  3737(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      L: () => (
        /* binding */
        doTimeout2
      )
      /* harmony export */
    });
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    var W = (
      /* unused pure expression or super */
      null
    );
    if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts == null) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts = {};
    }
    var doTimeout2 = function doTimeout3(key, fn) {
      var time = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
      if ((0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.cy)(key)) {
        key = key.join(".");
      }
      var namespace = timeoutNamespace(key);
      clearTimeouts(key, namespace);
      if (fn) {
        var timeouts = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts[namespace];
        if (timeouts == null) {
          timeouts = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts[namespace] = {};
        }
        var timeoutId = setTimeout(function() {
          delete timeouts[key];
          fn();
        }, time);
        timeouts[key] = timeoutId;
        return timeoutId;
      }
      return _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts[namespace][key];
    };
    var clearTimeouts = function clearTimeouts2(key) {
      var namespace = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
      if ((0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.cy)(key)) {
        key = key.join(".");
      }
      namespace = namespace || timeoutNamespace(key);
      var timeouts;
      if (namespace === "__global__") {
        timeouts = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts[key];
        if (timeouts) {
          for (var k in timeouts) {
            var v = timeouts[k];
            clearTimeout(v);
            delete timeouts[k];
          }
        }
      }
      timeouts = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts[namespace];
      if (timeouts) {
        for (var _k in timeouts) {
          var _v = timeouts[_k];
          if (_k.indexOf && _k.indexOf(key) === 0 && (_k.length === key.length || _k.charAt(key.length) === ".")) {
            clearTimeout(_v);
            delete timeouts[_k];
          }
        }
      }
      if (!_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.blockSweepTimeouts) {
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.blockSweepTimeouts = true;
        setTimeout(sweepTimeouts, 0);
        setTimeout(function() {
          _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.blockSweepTimeouts = false;
        }, 5e3);
      }
    };
    var sweepTimeouts = function sweepTimeouts2() {
      for (var namespace in _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts) {
        var timeouts = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts[namespace];
        if ((0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.Im)(timeouts)) {
          delete _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._timeouts[namespace];
        }
      }
    };
    var timeoutNamespace = function timeoutNamespace2(key) {
      var dotIndex = key.indexOf(".");
      if (dotIndex > 0) {
        return key.substring(0, dotIndex);
      }
      return "__global__";
    };
  },
  /***/
  3817(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.r(__webpack_exports__3);
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      useCallback: () => (
        /* binding */
        q
      ),
      /* harmony export */
      useContext: () => (
        /* binding */
        x
      ),
      /* harmony export */
      useDebugValue: () => (
        /* binding */
        P
      ),
      /* harmony export */
      useEffect: () => (
        /* binding */
        y
      ),
      /* harmony export */
      useErrorBoundary: () => (
        /* binding */
        b
      ),
      /* harmony export */
      useId: () => (
        /* binding */
        g
      ),
      /* harmony export */
      useImperativeHandle: () => (
        /* binding */
        F
      ),
      /* harmony export */
      useLayoutEffect: () => (
        /* binding */
        _
      ),
      /* harmony export */
      useMemo: () => (
        /* binding */
        T
      ),
      /* harmony export */
      useReducer: () => (
        /* binding */
        h
      ),
      /* harmony export */
      useRef: () => (
        /* binding */
        A
      ),
      /* harmony export */
      useState: () => (
        /* binding */
        d
      )
      /* harmony export */
    });
    var preact__WEBPACK_IMPORTED_MODULE_0__2 = __webpack_require__3(5181);
    var t, r, u, i2, o = 0, f = [], c = preact__WEBPACK_IMPORTED_MODULE_0__2.options, e = c.__b, a = c.__r, v = c.diffed, l = c.__c, m = c.unmount, s = c.__;
    function p(n, t2) {
      c.__h && c.__h(r, n, o || t2), o = 0;
      var u2 = r.__H || (r.__H = { __: [], __h: [] });
      return n >= u2.__.length && u2.__.push({}), u2.__[n];
    }
    function d(n) {
      return o = 1, h(D, n);
    }
    function h(n, u2, i3) {
      var o2 = p(t++, 2);
      if (o2.t = n, !o2.__c && (o2.__ = [i3 ? i3(u2) : D(void 0, u2), function(n2) {
        var t2 = o2.__N ? o2.__N[0] : o2.__[0], r2 = o2.t(t2, n2);
        t2 !== r2 && (o2.__N = [r2, o2.__[1]], o2.__c.setState({}));
      }], o2.__c = r, !r.__f)) {
        var f2 = function(n2, t2, r2) {
          if (!o2.__c.__H) return true;
          var u3 = o2.__c.__H.__.filter(function(n3) {
            return !!n3.__c;
          });
          if (u3.every(function(n3) {
            return !n3.__N;
          })) return !c2 || c2.call(this, n2, t2, r2);
          var i4 = o2.__c.props !== n2;
          return u3.forEach(function(n3) {
            if (n3.__N) {
              var t3 = n3.__[0];
              n3.__ = n3.__N, n3.__N = void 0, t3 !== n3.__[0] && (i4 = true);
            }
          }), c2 && c2.call(this, n2, t2, r2) || i4;
        };
        r.__f = true;
        var c2 = r.shouldComponentUpdate, e2 = r.componentWillUpdate;
        r.componentWillUpdate = function(n2, t2, r2) {
          if (this.__e) {
            var u3 = c2;
            c2 = void 0, f2(n2, t2, r2), c2 = u3;
          }
          e2 && e2.call(this, n2, t2, r2);
        }, r.shouldComponentUpdate = f2;
      }
      return o2.__N || o2.__;
    }
    function y(n, u2) {
      var i3 = p(t++, 3);
      !c.__s && C(i3.__H, u2) && (i3.__ = n, i3.u = u2, r.__H.__h.push(i3));
    }
    function _(n, u2) {
      var i3 = p(t++, 4);
      !c.__s && C(i3.__H, u2) && (i3.__ = n, i3.u = u2, r.__h.push(i3));
    }
    function A(n) {
      return o = 5, T(function() {
        return { current: n };
      }, []);
    }
    function F(n, t2, r2) {
      o = 6, _(function() {
        if ("function" == typeof n) {
          var r3 = n(t2());
          return function() {
            n(null), r3 && "function" == typeof r3 && r3();
          };
        }
        if (n) return n.current = t2(), function() {
          return n.current = null;
        };
      }, null == r2 ? r2 : r2.concat(n));
    }
    function T(n, r2) {
      var u2 = p(t++, 7);
      return C(u2.__H, r2) && (u2.__ = n(), u2.__H = r2, u2.__h = n), u2.__;
    }
    function q(n, t2) {
      return o = 8, T(function() {
        return n;
      }, t2);
    }
    function x(n) {
      var u2 = r.context[n.__c], i3 = p(t++, 9);
      return i3.c = n, u2 ? (null == i3.__ && (i3.__ = true, u2.sub(r)), u2.props.value) : n.__;
    }
    function P(n, t2) {
      c.useDebugValue && c.useDebugValue(t2 ? t2(n) : n);
    }
    function b(n) {
      var u2 = p(t++, 10), i3 = d();
      return u2.__ = n, r.componentDidCatch || (r.componentDidCatch = function(n2, t2) {
        u2.__ && u2.__(n2, t2), i3[1](n2);
      }), [i3[0], function() {
        i3[1](void 0);
      }];
    }
    function g() {
      var n = p(t++, 11);
      if (!n.__) {
        for (var u2 = r.__v; null !== u2 && !u2.__m && null !== u2.__; ) u2 = u2.__;
        var i3 = u2.__m || (u2.__m = [0, 0]);
        n.__ = "P" + i3[0] + "-" + i3[1]++;
      }
      return n.__;
    }
    function j() {
      for (var n; n = f.shift(); ) if (n.__P && n.__H) try {
        n.__H.__h.forEach(z), n.__H.__h.forEach(B), n.__H.__h = [];
      } catch (t2) {
        n.__H.__h = [], c.__e(t2, n.__v);
      }
    }
    c.__b = function(n) {
      r = null, e && e(n);
    }, c.__ = function(n, t2) {
      n && t2.__k && t2.__k.__m && (n.__m = t2.__k.__m), s && s(n, t2);
    }, c.__r = function(n) {
      a && a(n), t = 0;
      var i3 = (r = n.__c).__H;
      i3 && (u === r ? (i3.__h = [], r.__h = [], i3.__.forEach(function(n2) {
        n2.__N && (n2.__ = n2.__N), n2.u = n2.__N = void 0;
      })) : (i3.__h.forEach(z), i3.__h.forEach(B), i3.__h = [], t = 0)), u = r;
    }, c.diffed = function(n) {
      v && v(n);
      var t2 = n.__c;
      t2 && t2.__H && (t2.__H.__h.length && (1 !== f.push(t2) && i2 === c.requestAnimationFrame || ((i2 = c.requestAnimationFrame) || w)(j)), t2.__H.__.forEach(function(n2) {
        n2.u && (n2.__H = n2.u), n2.u = void 0;
      })), u = r = null;
    }, c.__c = function(n, t2) {
      t2.some(function(n2) {
        try {
          n2.__h.forEach(z), n2.__h = n2.__h.filter(function(n3) {
            return !n3.__ || B(n3);
          });
        } catch (r2) {
          t2.some(function(n3) {
            n3.__h && (n3.__h = []);
          }), t2 = [], c.__e(r2, n2.__v);
        }
      }), l && l(n, t2);
    }, c.unmount = function(n) {
      m && m(n);
      var t2, r2 = n.__c;
      r2 && r2.__H && (r2.__H.__.forEach(function(n2) {
        try {
          z(n2);
        } catch (n3) {
          t2 = n3;
        }
      }), r2.__H = void 0, t2 && c.__e(t2, r2.__v));
    };
    var k = "function" == typeof requestAnimationFrame;
    function w(n) {
      var t2, r2 = function() {
        clearTimeout(u2), k && cancelAnimationFrame(t2), setTimeout(n);
      }, u2 = setTimeout(r2, 35);
      k && (t2 = requestAnimationFrame(r2));
    }
    function z(n) {
      var t2 = r, u2 = n.__c;
      "function" == typeof u2 && (n.__c = void 0, u2()), r = t2;
    }
    function B(n) {
      var t2 = r;
      n.__c = n.__(), r = t2;
    }
    function C(n, t2) {
      return !n || n.length !== t2.length || t2.some(function(t3, r2) {
        return t3 !== n[r2];
      });
    }
    function D(n, t2) {
      return "function" == typeof t2 ? t2(n) : t2;
    }
  },
  /***/
  3832(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      i: () => (
        /* binding */
        extractEmailFromParams
      )
      /* harmony export */
    });
    var _core_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(1627);
    var _wlog_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(6637);
    var extractEmailFromParams = function extractEmailFromParams2(pageUrl) {
      var _exec, _exec2;
      var wemail = (_exec = /wemail=([^&#]+)/.exec(pageUrl)) !== null && _exec !== void 0 ? _exec : null;
      if (wemail) {
        return wemail[1];
      }
      var wkey = (_exec2 = /wkey=([^&#]+)/.exec(pageUrl)) !== null && _exec2 !== void 0 ? _exec2 : null;
      if (wkey) {
        var base64Email = wkey[1];
        try {
          var decodedEmail = (0, _core_js__WEBPACK_IMPORTED_MODULE_0__.u)(base64Email);
          return decodedEmail;
        } catch (error) {
          _wlog_js__WEBPACK_IMPORTED_MODULE_1__.ct.info("Failed to decode email from wkey", error);
        }
      }
      return null;
    };
  },
  /***/
  3917(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      M: () => (
        /* binding */
        mediaDataTransforms2
      )
      /* harmony export */
    });
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var utilities_url_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(2671);
    var utilities_detect_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(7231);
    var _wistia_type_guards__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(9814);
    var _assets_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(7209);
    function _createForOfIteratorHelper(r, e) {
      var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray2(r)) || e && r && "number" == typeof r.length) {
          t && (r = t);
          var _n = 0, F = function F2() {
          };
          return { s: F, n: function n() {
            return _n >= r.length ? { done: true } : { done: false, value: r[_n++] };
          }, e: function e2(r2) {
            throw r2;
          }, f: F };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var o, a = true, u = false;
      return { s: function s() {
        t = t.call(r);
      }, n: function n() {
        var r2 = t.next();
        return a = r2.done, r2;
      }, e: function e2(r2) {
        u = true, o = r2;
      }, f: function f() {
        try {
          a || null == t.return || t.return();
        } finally {
          if (u) throw o;
        }
      } };
    }
    function _toConsumableArray(r) {
      return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray2(r) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return _arrayLikeToArray2(r);
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var detect = (0, utilities_detect_js__WEBPACK_IMPORTED_MODULE_2__.o1)();
    var convertStillImageToWebp = function convertStillImageToWebp2(media) {
      if (media.assets && detect.webp) {
        media.assets = media.assets.map(function(asset) {
          if (asset.type === "still_image" && Object(asset).url) {
            var url = new utilities_url_js__WEBPACK_IMPORTED_MODULE_1__.s0(asset.url);
            url.ext("webp");
            asset.url = url.absolute();
          }
          return asset;
        });
      }
    };
    var maybeCloneOriginalAsMp4 = function maybeCloneOriginalAsMp42(media) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (options.allowOriginalAsMp4 !== true) {
        return;
      }
      var original = media.assets.filter(function(a) {
        return a.type === "original";
      })[0];
      if ((0, _assets_js__WEBPACK_IMPORTED_MODULE_4__.n9)(media.assets).length > 0) {
        return;
      }
      media.assets = [].concat(_toConsumableArray(media.assets), [(0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.kp)({}, original, {
        display_name: "".concat(original.display_name, " copy"),
        container: "mp4",
        codec: "h264",
        type: "mp4_video"
      })]);
    };
    var maybeAddChannelIdToEmbedOptions = function maybeAddChannelIdToEmbedOptions2(media) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_3__.n9)(options.channelId) && media.embedOptions) {
        media.embedOptions.channelId = options.channelId;
      }
    };
    var maybeAddChannelPasswordToEmbedOptions = function maybeAddChannelPasswordToEmbedOptions2(media) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_3__.n9)(options.channelPassword) && media.embedOptions) {
        media.embedOptions.channelPassword = options.channelPassword;
      }
    };
    var mergeFormCustomizations = function mergeFormCustomizations2(formCustomizations, embedOptions) {
      if (!formCustomizations || !embedOptions) return;
      if (!embedOptions.plugin) embedOptions.plugin = {};
      if (!embedOptions.plugin.form) embedOptions.plugin.form = {};
      var form = embedOptions.plugin.form;
      if (formCustomizations.form_button_text) form.formButtonText = formCustomizations.form_button_text;
      if (formCustomizations.form_lower_text) form.formLowerText = formCustomizations.form_lower_text;
      if (formCustomizations.title) form.title = formCustomizations.title;
    };
    var mergeFormCustomizationsIntoEmbedOptions = function mergeFormCustomizationsIntoEmbedOptions2(media) {
      mergeFormCustomizations(media.formCustomizations, media.embedOptions);
      if (Array.isArray(media.translatedMediaData)) {
        var _iterator = _createForOfIteratorHelper(media.translatedMediaData), _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done; ) {
            var entry = _step.value;
            mergeFormCustomizations(entry.formCustomizations, entry.embedOptions);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    };
    var mediaDataTransforms2 = function mediaDataTransforms3(media) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      maybeCloneOriginalAsMp4(media, options);
      convertStillImageToWebp(media);
      maybeAddChannelIdToEmbedOptions(media, options);
      maybeAddChannelPasswordToEmbedOptions(media, options);
      mergeFormCustomizationsIntoEmbedOptions(media);
      return media;
    };
  },
  /***/
  3997(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      S: () => (
        /* binding */
        wRemoveData
      ),
      /* harmony export */
      m: () => (
        /* binding */
        wData2
      )
      /* harmony export */
    });
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    var wData2 = function wData3(key, val) {
      if (!(0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.cy)(key)) {
        key = key.split(".");
      }
      if (val != null) {
        (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.vd)(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s, ["_data"].concat(key), val);
      }
      return (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.b$)(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s, ["_data"].concat(key));
    };
    var wRemoveData = function wRemoveData2(key) {
      if (!(0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.cy)(key)) {
        key = key.split(".");
      }
      return (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.G0)(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s, ["_data"].concat(key));
    };
  },
  /***/
  4271(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      mj: () => (
        /* binding */
        globalTrigger
      )
      /* harmony export */
    });
    var utilities_wbindable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9376);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    (0, utilities_wbindable_js__WEBPACK_IMPORTED_MODULE_0__.R)(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s);
    var globalBind = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.bind.bind(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s);
    var globalOn = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.on.bind(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s);
    var globalOff = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.off.bind(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s);
    var globalRebind = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.rebind.bind(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s);
    var globalTrigger = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.trigger.bind(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s);
    var globalUnbind = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.unbind.bind(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s);
  },
  /***/
  4309(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      wt: () => (
        /* binding */
        controlMultiplierEstimatedByWidth
      )
      /* harmony export */
    });
    var utilities_elem_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(7715);
    var utilities_timeout_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(3737);
    var utilities_detect_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(7231);
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(731);
    function _slicedToArray2(r, e) {
      return _arrayWithHoles2(r) || _iterableToArrayLimit2(r, e) || _unsupportedIterableToArray2(r, e) || _nonIterableRest2();
    }
    function _nonIterableRest2() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _iterableToArrayLimit2(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i2, u, a = [], f = true, o = false;
        try {
          if (i2 = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = false;
          } else for (; !(f = (e = i2.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles2(r) {
      if (Array.isArray(r)) return r;
    }
    var detect = (0, utilities_detect_js__WEBPACK_IMPORTED_MODULE_2__.o1)();
    var scalingOptionsFromVideo = function scalingOptionsFromVideo2(video, options) {
      return merge({
        videoWidth: video.videoWidth(),
        videoHeight: video.videoHeight(),
        isInFullscreen: video.inFullscreen(),
        controlScaling: video.controlScaling()
      }, options);
    };
    var controlDimensions = function controlDimensions2() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var baseWidth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40;
      var baseHeight = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 34;
      options = merge({
        videoWidth: 640,
        videoHeight: 360,
        isInFullscreen: false,
        baseWidth: baseWidth != null ? baseWidth : 40,
        baseHeight: baseHeight != null ? baseHeight : 34
      }, options);
      var multiplier = controlMultiplier(options);
      return {
        width: multiplier * options.baseWidth,
        height: multiplier * options.baseHeight
      };
    };
    var bigPlayButtonDimensions = function bigPlayButtonDimensions2(options, baseWidth, baseHeight) {
      return controlDimensions(options, baseWidth, baseHeight);
    };
    var fontSizeMultiplier = function fontSizeMultiplier2(options) {
      return controlMultiplier(options);
    };
    var allowBigControls = function allowBigControls2() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var screenHeight = options.screenHeight || window.screen.height;
      var screenWidth = options.screenWidth || window.screen.width;
      return options.controlScaling != "auto" || detect.iphone || detect.android || screenWidth < screenHeight;
    };
    var maxMultiplierForVideo = function maxMultiplierForVideo2(options) {
      if (options.controlScaling != "auto") {
        return options.controlScaling;
      }
      if (allowBigControls(options)) {
        return 3.5;
      }
      return 1.4;
    };
    var minMultiplierForVideo = function minMultiplierForVideo2(options) {
      if (options.controlScaling != "auto") {
        return options.controlScaling;
      }
      if (allowBigControls(options)) {
        return 1;
      }
      return 0.75;
    };
    var getZoomMultiplier = function getZoomMultiplier2(options) {
      if (!options.isInFullscreen) {
        return 1;
      }
      var result = Math.max(1, window.innerWidth / Math.max(screen.width, screen.height));
      return result;
    };
    var getDeviceMultiplier = function getDeviceMultiplier2(options) {
      if (allowBigControls(options)) {
        return 1.4;
      }
      return 1;
    };
    var controlMultiplierForVideo = function controlMultiplierForVideo2(video, options) {
      return controlMultiplier(scalingOptionsFromVideo(video, options));
    };
    var controlMultiplier = function controlMultiplier2(options) {
      if (options.controlScaling != "auto") {
        return options.controlScaling;
      }
      var videoWidth = options.videoWidth, videoHeight = options.videoHeight;
      var zoomMultiplier = getZoomMultiplier(options);
      var largestDimension = Math.max(videoWidth, videoHeight);
      if (largestDimension > 960) {
        var percentOverThreshold = largestDimension / 960;
        var scaleFactor = percentOverThreshold * getDeviceMultiplier(options);
        return Math.min(maxMultiplierForVideo(options) * zoomMultiplier, scaleFactor * zoomMultiplier);
      }
      if (largestDimension < 640) {
        var percentUnderThreshold = largestDimension / 640;
        var _scaleFactor = percentUnderThreshold * getDeviceMultiplier(options);
        return Math.max(minMultiplierForVideo(options) * zoomMultiplier, _scaleFactor * zoomMultiplier);
      }
      return 1 * getDeviceMultiplier(options);
    };
    var menuMultiplier = function menuMultiplier2(options) {
      return Math.max(0.75, controlMultiplier(options));
    };
    var fitControl = function fitControl2(options) {
      var _options = options, controlId = _options.controlId, video = _options.video, controlElem = _options.controlElem;
      options = merge({
        videoWidth: video.videoWidth(),
        videoHeight: video.videoHeight(),
        controlScaling: video.controlScaling(),
        isInFullscreen: video.inFullscreen()
      }, options);
      var _controlDimensions = controlDimensions(options), width = _controlDimensions.width, height = _controlDimensions.height;
      elemStyle(controlElem, {
        height: "".concat(height, "px"),
        width: "".concat(width, "px")
      });
      tapIcon("".concat(video.uuid, ".").concat(controlId), controlElem);
      return {
        width,
        height
      };
    };
    var tapIcon = function tapIcon2(timeoutPrefix, controlElem) {
      var svgs = controlElem.getElementsByTagName("svg");
      for (var i2 = 0; i2 < svgs.length; i2++) {
        (function(svg) {
          doTimeout("".concat(timeoutPrefix, ".tap_icon"), function() {
            elemStyle(svg, {
              position: "relative"
            });
            doTimeout("#{timeoutPrefix}.tap_icon", function() {
              elemStyle(svg, {
                position: ""
              });
            }, 30);
          }, 30);
        })(svgs[i2]);
      }
    };
    var parseMetaViewport = function parseMetaViewport2() {
      var metaTag = document.querySelector("meta[name=viewport]");
      var content = metaTag && metaTag.getAttribute("content");
      var result = {};
      if (content) {
        var pairs = content.split(/[\s,]+/);
        pairs.forEach(function(pair) {
          var keyAndVal = pair.split("=");
          if (keyAndVal.length === 2) {
            result[keyAndVal[0]] = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_3__.wg)(keyAndVal[1]);
          }
        });
      }
      return result;
    };
    var normalScaleWidthRange = function normalScaleWidthRange2(media) {
      var onMobile = detect.iphone || detect.ipad || detect.android;
      if (!onMobile) {
        return [640, 960];
      }
      if (media !== null && media !== void 0 && media.isAudio()) {
        return [500, 960];
      }
      var viewport = parseMetaViewport();
      var screenWidth;
      if (viewport.width) {
        if (typeof viewport.width === "number") {
          screenWidth = 0 + viewport.width;
        } else {
          screenWidth = screen.width || window.innerWidth;
        }
        var scale = Math.max(viewport["minimum-scale"] || 0, Math.min(viewport["maximum-scale"] || 10, viewport["initial-scale"] || 1));
        if (scale < 1) {
          screenWidth /= scale;
        }
      } else {
        screenWidth = window.innerWidth;
      }
      return [screenWidth, screenWidth * 2 / 3];
    };
    var normalScaleHeightRange = function normalScaleHeightRange2(media) {
      var onMobile = detect.iphone || detect.ipad || detect.android;
      if (!onMobile) {
        return [340, 860];
      }
      if (media !== null && media !== void 0 && media.isAudio()) {
        return [500, 960];
      }
      var viewport = parseMetaViewport();
      var screenHeight;
      if (viewport.height) {
        if (typeof viewport.height === "number") {
          screenHeight = 0 + viewport.height;
        } else {
          screenHeight = screen.height || window.innerHeight;
        }
        var scale = Math.max(viewport["minimum-scale"] || 0, Math.min(viewport["maximum-scale"] || 10, viewport["initial-scale"] || 1));
        if (scale < 1) {
          screenHeight /= scale;
        }
      } else {
        screenHeight = window.innerWidth;
      }
      return [screenHeight, screenHeight * 2 / 1.3];
    };
    var controlMultiplierBasedOnVideo = function controlMultiplierBasedOnVideo2(video, normalRange) {
      var vidWidth = video.videoWidth();
      var vidHeight = video.videoHeight();
      var aspect = vidWidth / vidHeight;
      if (aspect < 1) {
        var _normalScaleHeightRan = normalScaleHeightRange(video), _normalScaleHeightRan2 = _slicedToArray2(_normalScaleHeightRan, 2), lowerCutoff = _normalScaleHeightRan2[0], upperCutoff = _normalScaleHeightRan2[1];
        if (vidHeight <= lowerCutoff) {
          return vidHeight / lowerCutoff;
        }
        if (vidHeight > upperCutoff) {
          return vidHeight / upperCutoff;
        }
      } else {
        var _ref = normalRange || normalScaleWidthRange(video), _ref2 = _slicedToArray2(_ref, 2), _lowerCutoff = _ref2[0], _upperCutoff = _ref2[1];
        if (vidWidth <= _lowerCutoff) {
          return vidWidth / _lowerCutoff;
        }
        if (vidWidth > _upperCutoff) {
          return vidWidth / _upperCutoff;
        }
      }
      return 1;
    };
    var controlMultiplierEstimatedByWidth = function controlMultiplierEstimatedByWidth2(width, normalRange) {
      var _ref3 = normalRange || normalScaleWidthRange(), _ref4 = _slicedToArray2(_ref3, 2), lowerCutoff = _ref4[0], upperCutoff = _ref4[1];
      if (width <= lowerCutoff) {
        return width / lowerCutoff;
      }
      if (width > upperCutoff) {
        return width / upperCutoff;
      }
      return 1;
    };
  },
  /***/
  4372(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      qN: () => (
        /* binding */
        getCssGradient
      ),
      /* harmony export */
      yz: () => (
        /* binding */
        getGradientColor
      )
      /* harmony export */
    });
    var _types_gradient_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(7350);
    var _color_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5417);
    var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(731);
    function _slicedToArray2(r, e) {
      return _arrayWithHoles2(r) || _iterableToArrayLimit2(r, e) || _unsupportedIterableToArray2(r, e) || _nonIterableRest2();
    }
    function _nonIterableRest2() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _iterableToArrayLimit2(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i2, u, a = [], f = true, o = false;
        try {
          if (i2 = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = false;
          } else for (; !(f = (e = i2.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles2(r) {
      if (Array.isArray(r)) return r;
    }
    var DEFAULT_ALPHA = 0.9;
    var GRADIENT_COLOR_INDEX = 0;
    var GRADIENT_PERCENTAGE_INDEX = 1;
    var DEFAULT_GRADIENT = {
      colors: [["#2949E5", 0], ["#6A84FF", 1]],
      on: true
    };
    var hexToRGBA = function hexToRGBA2(hex) {
      var alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_ALPHA;
      var color = new _color_js__WEBPACK_IMPORTED_MODULE_1__.Q1(hex);
      var colorWithAlpha = color.alpha(alpha);
      return colorWithAlpha.toRgba();
    };
    var decimalToPercentage = function decimalToPercentage2(decimal) {
      return decimal * 100;
    };
    var getCssGradient = function getCssGradient2(gradient) {
      var alpha = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DEFAULT_ALPHA;
      if (gradient.colors.length === 0) {
        return null;
      }
      var areAllColorsValid = gradient.colors.every(function(gradientColor) {
        return Boolean(gradientColor[GRADIENT_COLOR_INDEX] && gradientColor[GRADIENT_PERCENTAGE_INDEX] >= 0 && gradientColor[GRADIENT_PERCENTAGE_INDEX] <= 1);
      });
      if (!areAllColorsValid) {
        return null;
      }
      return "linear-gradient(90deg, ".concat(gradient.colors.map(function(gradientColor) {
        return "".concat(hexToRGBA(gradientColor[0], alpha), " ").concat(decimalToPercentage(gradientColor[1]), "%");
      }).join(", "), ")");
    };
    var getGradientColor = function getGradientColor2(gradient) {
      var index = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (!(0, _types_gradient_ts__WEBPACK_IMPORTED_MODULE_0__.b)(gradient)) {
        return null;
      }
      return gradient.colors[index][GRADIENT_COLOR_INDEX];
    };
    var cleanGradient = function cleanGradient2(gradient) {
      var casted = cast(clone(gradient));
      var result = {
        colors: casted.colors.map(function(_ref) {
          var _ref2 = _slicedToArray2(_ref, 2), color = _ref2[0], percentage = _ref2[1];
          return [color.toString(), percentage];
        }),
        on: casted.on
      };
      return result;
    };
  },
  /***/
  4400(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      J: () => (
        /* binding */
        getPreferredAvailableLanguageIndex
      )
      /* harmony export */
    });
    function _createForOfIteratorHelper(r, e) {
      var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (!t) {
        if (Array.isArray(r) || (t = _unsupportedIterableToArray2(r)) || e && r && "number" == typeof r.length) {
          t && (r = t);
          var _n = 0, F = function F2() {
          };
          return { s: F, n: function n() {
            return _n >= r.length ? { done: true } : { done: false, value: r[_n++] };
          }, e: function e2(r2) {
            throw r2;
          }, f: F };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }
      var o, a = true, u = false;
      return { s: function s() {
        t = t.call(r);
      }, n: function n() {
        var r2 = t.next();
        return a = r2.done, r2;
      }, e: function e2(r2) {
        u = true, o = r2;
      }, f: function f() {
        try {
          a || null == t.return || t.return();
        } finally {
          if (u) throw o;
        }
      } };
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var getAlpha2Code = function getAlpha2Code2(iso6392Code) {
      return iso6392Code.split("-")[0];
    };
    var getStack = function getStack2() {
      var _err$stack;
      var err = new Error();
      return (_err$stack = err.stack) === null || _err$stack === void 0 ? void 0 : _err$stack.split("\n").slice(2).join("\n");
    };
    var getPreferredAvailableLanguageIndex = function getPreferredAvailableLanguageIndex2(availableLanguages, preferredLanguages) {
      if (availableLanguages.some(function(lang) {
        return typeof lang !== "string";
      })) {
        console.error("availableLanguages has non-string values", availableLanguages, getStack());
        availableLanguages = availableLanguages.filter(function(lang) {
          return typeof lang === "string";
        });
      }
      if (preferredLanguages.some(function(lang) {
        return typeof lang !== "string";
      })) {
        console.error("preferredLanguages has non-string values", preferredLanguages, getStack());
        preferredLanguages = preferredLanguages.filter(function(lang) {
          return typeof lang === "string";
        });
      }
      var _iterator = _createForOfIteratorHelper(preferredLanguages), _step;
      try {
        var _loop2 = function _loop3() {
          var preferredLanguage = _step.value;
          if (availableLanguages.includes(preferredLanguage)) {
            return {
              v: availableLanguages.indexOf(preferredLanguage)
            };
          }
          var preferredAlpha2 = getAlpha2Code(preferredLanguage);
          var hasRegionMatch = availableLanguages.some(function(lang) {
            return getAlpha2Code(lang) === preferredAlpha2;
          });
          if (hasRegionMatch) {
            return {
              v: availableLanguages.findIndex(function(lang) {
                return getAlpha2Code(lang) === preferredAlpha2;
              })
            };
          }
        }, _ret;
        for (_iterator.s(); !(_step = _iterator.n()).done; ) {
          _ret = _loop2();
          if (_ret) return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return -1;
    };
  },
  /***/
  4635(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      YG: () => (
        /* binding */
        blankImage
      ),
      /* harmony export */
      cd: () => (
        /* binding */
        bestImage
      ),
      /* harmony export */
      eZ: () => (
        /* binding */
        sortedImages
      )
      /* harmony export */
    });
    var utilities_hosts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(5857);
    var bestImage = function bestImage2(images) {
      var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var _sortedImages = sortedImages(images);
      if (_sortedImages.length === 0) {
        return blankImage(opts.videoWith, opts.videoHeight);
      }
      var currentWidth = opts.videoWidth;
      var desiredWidth = (window.devicePixelRatio || 1) * currentWidth;
      if (desiredWidth <= _sortedImages[0].width) {
        return _sortedImages[0];
      }
      for (var i2 = 0; i2 < _sortedImages.length; i2++) {
        var image = _sortedImages[i2];
        if (image.width >= desiredWidth) {
          return image;
        }
      }
      return _sortedImages[_sortedImages.length - 1];
    };
    var blankImage = function blankImage2(videoWidth, videoHeight) {
      return {
        height: videoHeight,
        url: "https://".concat((0, utilities_hosts_js__WEBPACK_IMPORTED_MODULE_0__.aY)(), "/assets/images/blank.gif"),
        width: videoWidth
      };
    };
    var sortedImages = function sortedImages2(images) {
      return images.map(function(image) {
        image.aspect = image.width / image.height;
        return image;
      });
    };
  },
  /***/
  4719(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      e: () => (
        /* binding */
        BigPlayButtonLoadingAnim
      )
      /* harmony export */
    });
    var preact__WEBPACK_IMPORTED_MODULE_0__2 = __webpack_require__3(5181);
    var preact_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(3817);
    var _utilities_elem_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(7715);
    function _slicedToArray2(r, e) {
      return _arrayWithHoles2(r) || _iterableToArrayLimit2(r, e) || _unsupportedIterableToArray2(r, e) || _nonIterableRest2();
    }
    function _nonIterableRest2() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _iterableToArrayLimit2(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i2, u, a = [], f = true, o = false;
        try {
          if (i2 = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = false;
          } else for (; !(f = (e = i2.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles2(r) {
      if (Array.isArray(r)) return r;
    }
    var BigPlayButtonLoadingAnim = function BigPlayButtonLoadingAnim2() {
      var svgEl = (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
      var _useState = (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useState)(false), _useState2 = _slicedToArray2(_useState, 2), isAnimating = _useState2[0], setIsAnimating = _useState2[1];
      (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0, _utilities_elem_js__WEBPACK_IMPORTED_MODULE_2__.Ev)(svgEl.current, "\n        @keyframes w-loading-pulse {\n          from {\n            stroke-dashoffset: 55;\n          }\n          to {\n            stroke-dashoffset: -175;\n          }\n        }\n        .w-big-play-button-loading-anim {\n          stroke-dasharray: 50 260;\n          stroke-dashoffset: 55;\n          animation: w-loading-pulse 1.2s infinite cubic-bezier(0.65, 0, 0, 1);\n        }\n      ");
        setIsAnimating(true);
      }, []);
      return (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("line", {
        ref: svgEl,
        class: "w-big-play-button-loading-anim",
        x1: "0",
        y1: "78",
        x2: "125",
        y2: "78",
        style: {
          stroke: "currentcolor",
          strokeWidth: 4,
          strokeLinecap: "round",
          opacity: isAnimating ? 1 : 0
        }
      });
    };
  },
  /***/
  4730(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Oj: () => (
        /* binding */
        defineTranslations
      ),
      /* harmony export */
      Z0: () => (
        /* binding */
        getLanguage
      ),
      /* harmony export */
      sC: () => (
        /* binding */
        getTranslation
      )
      /* harmony export */
    });
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var utilities_dynamicImport_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(7157);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(5509);
    var languages = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.languages = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.languages || {};
    var translations = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.translations = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.translations || {};
    if (!_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._translationPromises) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s._translationPromises = {};
    }
    var supportedLanguages = ["ar", "de", "es", "en-US", "fr", "it", "ja", "ko", "pt", "ru", "zh-CN"];
    var ietfLanguageTagToCode = {
      ara: "ar",
      ger: "de",
      spa: "es",
      eng: "en-US",
      fre: "fr",
      ita: "it",
      jpn: "ja",
      kor: "ko",
      por: "pt",
      rus: "ru",
      chi: "zh-CN"
    };
    var normalizeLanguageCode = function normalizeLanguageCode2(code) {
      if (code == null) {
        return "en-US";
      }
      code = ietfLanguageTagToCode[code] || code;
      if (!supportedLanguages.includes(code)) {
        var match = matchingLanguages(function() {
          return [code];
        })[0];
        if (match) {
          code = match;
        }
      }
      if (code === "en" || /^en-/.test(code)) {
        code = "en-US";
      }
      if (code === "zh" || /^zh-/.test(code)) {
        code = "zh-CN";
      }
      return code;
    };
    var defineLanguage = function defineLanguage2(code, text, translations2) {
      languages[code] = {
        code,
        text: decodeEntities(text)
      };
      if (translations2) {
        defineTranslations(code, translations2);
      }
    };
    var getLanguage = function getLanguage2(code) {
      return languages[normalizeLanguageCode(code)];
    };
    var isSupportedPlayerLanguage = function isSupportedPlayerLanguage2(code) {
      return supportedLanguages.includes(normalizeLanguageCode(code));
    };
    var defineTranslations = function defineTranslations2(code, keyValPairs) {
      if (languages[code] == null) {
        throw new Error("Must define a language with code ".concat(code, " before defining its translations."));
      }
      var translation = translations[code];
      if (translation) {
        (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.h1)(translation, keyValPairs);
      } else {
        translations[code] = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.o8)(keyValPairs);
      }
    };
    var withFallbackText = function withFallbackText2(text) {
      if (text == null) {
        return "?";
      }
      return text;
    };
    var dummyTextArea;
    var cachedDecodings = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.cachedDecodings = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.cachedDecodings || {};
    var decodeEntities = function decodeEntities2(text) {
      if (!dummyTextArea) {
        dummyTextArea = document.createElement("textarea");
      }
      if (cachedDecodings[text] != null) {
        return cachedDecodings[text];
      }
      dummyTextArea.innerHTML = text;
      cachedDecodings[text] = dummyTextArea.value;
      return dummyTextArea.value;
    };
    var getTranslation = function getTranslation2(code, key) {
      code = normalizeLanguageCode(code);
      var text;
      if (translations[code] && translations[code][key]) {
        text = translations[code][key];
      } else {
        text = translations["en-US"][key];
      }
      return decodeEntities(withFallbackText(text));
    };
    var getTranslations = function getTranslations2(code) {
      var keys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
      var translations2 = {};
      keys.forEach(function(key) {
        translations2[key] = getTranslation(code, key);
      });
      return translations2;
    };
    var getLanguagePreference = function getLanguagePreference2() {
      if (navigator.languages || navigator.language) {
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.languagePreference = navigator.languages || [navigator.language];
      } else {
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.languagePreference = ["en-US"];
      }
      return _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_2__.s.languagePreference;
    };
    var defaultPromise = Promise.resolve({
      code: "en-US",
      translations: translations["en-US"]
    });
    var loadAndDefineTranslation = function loadAndDefineTranslation2(code) {
      code = normalizeLanguageCode(code);
      if (!supportedLanguages.includes(code)) {
        return defaultPromise;
      }
      if (Wistia._translationPromises[code]) {
        return Wistia._translationPromises[code];
      }
      if (code === "en-US") {
        return defaultPromise;
      }
      var result = new Promise(function(resolve, reject) {
        dynamicImport(["assets/external/translations/".concat(code, ".js")]).then(function(moduleClass) {
          var languageCode = moduleClass.languageCode, languageLabel = moduleClass.languageLabel, translations2 = moduleClass.translations;
          defineLanguage(languageCode, languageLabel, translations2);
          resolve({
            code,
            translations: translations2[code]
          });
        }).catch(reject);
      });
      Wistia._translationPromises[code] = result;
      return result;
    };
    var matchingLanguages = function matchingLanguages2() {
      var languagePrefs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getLanguagePreference;
      return languagePrefs().reduce(function(matches2, langCode) {
        var isFullMatch = supportedLanguages.indexOf(langCode) !== -1;
        var partialLangCode = langCode.split("-")[0];
        var isPartialMatch = supportedLanguages.indexOf(partialLangCode) !== -1;
        if (isFullMatch) {
          matches2.push(langCode);
        } else if (isPartialMatch) {
          matches2.push(partialLangCode);
        }
        return matches2;
      }, []);
    };
    var getDefaultTranslation = function getDefaultTranslation2() {
      var matchingLanguage = matchingLanguages()[0];
      if (!matchingLanguage || matchingLanguage === "en") {
        matchingLanguage = "en-US";
      }
      if (translations[matchingLanguage]) {
        return Promise.resolve({
          code: matchingLanguage,
          translations: translations[matchingLanguage]
        });
      }
      return loadAndDefineTranslation(matchingLanguage);
    };
    defineLanguage("en-US", "English");
    defineTranslations("en-US", {
      PLAY: "Play",
      PLAY_BUTTON_LIVE_NOT_STARTED: "Livestream has not started",
      PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: "Play Video",
      PLAY_BUTTON_TITLE_WHEN_PLAYING: "Pause",
      REWATCH: "Rewatch",
      SKIP: "Skip"
    });
  },
  /***/
  4755(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      D5: () => (
        /* binding */
        isVisitorTrackingEnabled2
      )
      /* harmony export */
    });
    var utilities_globalBindAndTrigger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(4271);
    var utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(4997);
    var utilities_getApiHandles_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(5510);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2 = __webpack_require__3(5509);
    function _toConsumableArray(r) {
      return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray2(r) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return _arrayLikeToArray2(r);
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var migrateLegacyVisitorTracking = function migrateLegacyVisitorTracking2() {
      var legacyIsEnabled = (0, utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_1__.y1)().visitorTrackingEnabled;
      if (legacyIsEnabled != null) {
        (0, utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_1__.$B)(function(ls) {
          return delete ls.visitorTrackingEnabled;
        });
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking = {};
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking[_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTrackingDomain] = {
          isEnabled: legacyIsEnabled,
          updatedAt: Date.now()
        };
        (0, utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_1__.$B)(function(ls) {
          return ls.visitorTracking = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking;
        });
      }
    };
    if (!_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTrackingDomain) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTrackingDomain = location.hostname || "";
    }
    if (!_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking) {
      migrateLegacyVisitorTracking();
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking = (0, utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_1__.y1)().visitorTracking || {};
    }
    var consent = function consent2(val) {
      if (val == null) {
        return isVisitorTrackingEnabled2();
      }
      return setVisitorTrackingEnabled(val);
    };
    _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s.consent = consent;
    var setVisitorTrackingEnabled = function setVisitorTrackingEnabled2(val) {
      var domain = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTrackingDomain;
      if (val === "default") {
        delete _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking[domain];
      } else {
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking[domain] = {
          isEnabled: "".concat(val) === "true",
          updatedAt: Date.now()
        };
      }
      (0, utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_1__.$B)(function(obj) {
        return obj.visitorTracking = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking;
      });
      (0, utilities_globalBindAndTrigger_js__WEBPACK_IMPORTED_MODULE_0__.mj)("visitortrackingchange", val);
      var allWistiaPlayers = _toConsumableArray(document.getElementsByTagName("wistia-player"));
      allWistiaPlayers.forEach(function(player) {
        player.dispatchEvent(new CustomEvent("visitor-tracking-change", {
          detail: {
            isTrackingEnabled: val
          }
        }));
      });
    };
    var isCurrentDomainOrAnyParentDomainsEnabled = function isCurrentDomainOrAnyParentDomainsEnabled2() {
      if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTrackingDomain) {
        var domainParts = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTrackingDomain.split(".");
        while (domainParts.length > 0) {
          var entry = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking[domainParts.join(".")];
          var enabledVal = entry && entry.isEnabled;
          if (enabledVal != null) {
            return enabledVal;
          }
          domainParts.shift();
        }
      }
    };
    var isVisitorTrackingEnabled2 = function isVisitorTrackingEnabled3() {
      if (typeof _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking === "boolean") {
        return _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking;
      }
      if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s._visitorTracking) {
        var isEnabledVal = isCurrentDomainOrAnyParentDomainsEnabled();
        if (isEnabledVal != null) {
          return Boolean(isEnabledVal);
        }
      }
      var apis = (0, utilities_getApiHandles_ts__WEBPACK_IMPORTED_MODULE_2__.bp)();
      if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s.channel && _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s.channel.all) {
        try {
          apis.push.apply(apis, _toConsumableArray(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__2.s.channel.all()));
        } catch (e) {
        }
      }
      var isPrivacyModeEnabled = apis.some(function(api) {
        var data = api._mediaData || api._galleryData || {};
        return data.privacyMode === true;
      });
      return !isPrivacyModeEnabled;
    };
  },
  /***/
  4989(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      $: () => (
        /* binding */
        camelCaseToKebabCase
      ),
      /* harmony export */
      b: () => (
        /* binding */
        kebabCaseToCamelCase
      )
      /* harmony export */
    });
    var camelCaseToKebabCase = function camelCaseToKebabCase2(camelCaseString) {
      return camelCaseString.replace(/[A-Z]+(?![a-z])|[A-Z]/g, function(letter, idx) {
        return (idx !== void 0 ? "-" : "") + letter.toLowerCase();
      });
    };
    var kebabCaseToCamelCase = function kebabCaseToCamelCase2(kebabCaseString) {
      return kebabCaseString.replace(/-./g, function(word) {
        return word[1].toUpperCase();
      });
    };
  },
  /***/
  4997(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      $B: () => (
        /* binding */
        updateWistiaLocalStorage
      ),
      /* harmony export */
      y1: () => (
        /* binding */
        getWistiaLocalStorage
      )
      /* harmony export */
    });
    var utilities_namespacedLocalStorage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(2917);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    var WISTIA_NAMESPACE = "wistia";
    var getWistiaLocalStorage = function getWistiaLocalStorage2() {
      return (0, utilities_namespacedLocalStorage_js__WEBPACK_IMPORTED_MODULE_0__.Lg)(WISTIA_NAMESPACE);
    };
    var removeWistiaLocalStorage2 = function removeWistiaLocalStorage3() {
      Wistia._localStorage = removeLocalStorage(WISTIA_NAMESPACE);
      return Wistia._localStorage;
    };
    var setWistiaLocalStorage = function setWistiaLocalStorage2(obj) {
      Wistia._localStorage = setLocalStorage(WISTIA_NAMESPACE, obj);
      return Wistia._localStorage;
    };
    var updateWistiaLocalStorage = function updateWistiaLocalStorage2(fn) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._localStorage = (0, utilities_namespacedLocalStorage_js__WEBPACK_IMPORTED_MODULE_0__.yo)(WISTIA_NAMESPACE, fn);
      return _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._localStorage;
    };
  },
  /***/
  5181(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.r(__webpack_exports__3);
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Component: () => (
        /* binding */
        x
      ),
      /* harmony export */
      Fragment: () => (
        /* binding */
        k
      ),
      /* harmony export */
      cloneElement: () => (
        /* binding */
        K
      ),
      /* harmony export */
      createContext: () => (
        /* binding */
        Q
      ),
      /* harmony export */
      createElement: () => (
        /* binding */
        _
      ),
      /* harmony export */
      createRef: () => (
        /* binding */
        b
      ),
      /* harmony export */
      h: () => (
        /* binding */
        _
      ),
      /* harmony export */
      hydrate: () => (
        /* binding */
        J
      ),
      /* harmony export */
      isValidElement: () => (
        /* binding */
        t
      ),
      /* harmony export */
      options: () => (
        /* binding */
        l
      ),
      /* harmony export */
      render: () => (
        /* binding */
        G
      ),
      /* harmony export */
      toChildArray: () => (
        /* binding */
        H
      )
      /* harmony export */
    });
    var n, l, u, t, i2, o, r, e, f, c, s, a, h, p = {}, v = [], y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, d = Array.isArray;
    function w(n2, l2) {
      for (var u2 in l2) n2[u2] = l2[u2];
      return n2;
    }
    function g(n2) {
      n2 && n2.parentNode && n2.parentNode.removeChild(n2);
    }
    function _(l2, u2, t2) {
      var i3, o2, r2, e2 = {};
      for (r2 in u2) "key" == r2 ? i3 = u2[r2] : "ref" == r2 ? o2 = u2[r2] : e2[r2] = u2[r2];
      if (arguments.length > 2 && (e2.children = arguments.length > 3 ? n.call(arguments, 2) : t2), "function" == typeof l2 && null != l2.defaultProps) for (r2 in l2.defaultProps) void 0 === e2[r2] && (e2[r2] = l2.defaultProps[r2]);
      return m(l2, e2, i3, o2, null);
    }
    function m(n2, t2, i3, o2, r2) {
      var e2 = { type: n2, props: t2, key: i3, ref: o2, __k: null, __: null, __b: 0, __e: null, __c: null, constructor: void 0, __v: null == r2 ? ++u : r2, __i: -1, __u: 0 };
      return null == r2 && null != l.vnode && l.vnode(e2), e2;
    }
    function b() {
      return { current: null };
    }
    function k(n2) {
      return n2.children;
    }
    function x(n2, l2) {
      this.props = n2, this.context = l2;
    }
    function S(n2, l2) {
      if (null == l2) return n2.__ ? S(n2.__, n2.__i + 1) : null;
      for (var u2; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) return u2.__e;
      return "function" == typeof n2.type ? S(n2) : null;
    }
    function C(n2) {
      var l2, u2;
      if (null != (n2 = n2.__) && null != n2.__c) {
        for (n2.__e = n2.__c.base = null, l2 = 0; l2 < n2.__k.length; l2++) if (null != (u2 = n2.__k[l2]) && null != u2.__e) {
          n2.__e = n2.__c.base = u2.__e;
          break;
        }
        return C(n2);
      }
    }
    function M(n2) {
      (!n2.__d && (n2.__d = true) && i2.push(n2) && !$.__r++ || o != l.debounceRendering) && ((o = l.debounceRendering) || r)($);
    }
    function $() {
      for (var n2, u2, t2, o2, r2, f2, c2, s2 = 1; i2.length; ) i2.length > s2 && i2.sort(e), n2 = i2.shift(), s2 = i2.length, n2.__d && (t2 = void 0, o2 = void 0, r2 = (o2 = (u2 = n2).__v).__e, f2 = [], c2 = [], u2.__P && ((t2 = w({}, o2)).__v = o2.__v + 1, l.vnode && l.vnode(t2), O(u2.__P, t2, o2, u2.__n, u2.__P.namespaceURI, 32 & o2.__u ? [r2] : null, f2, null == r2 ? S(o2) : r2, !!(32 & o2.__u), c2), t2.__v = o2.__v, t2.__.__k[t2.__i] = t2, N(f2, t2, c2), o2.__e = o2.__ = null, t2.__e != r2 && C(t2)));
      $.__r = 0;
    }
    function I(n2, l2, u2, t2, i3, o2, r2, e2, f2, c2, s2) {
      var a2, h2, y2, d2, w2, g2, _2, m2 = t2 && t2.__k || v, b2 = l2.length;
      for (f2 = P(u2, l2, m2, f2, b2), a2 = 0; a2 < b2; a2++) null != (y2 = u2.__k[a2]) && (h2 = -1 == y2.__i ? p : m2[y2.__i] || p, y2.__i = a2, g2 = O(n2, y2, h2, i3, o2, r2, e2, f2, c2, s2), d2 = y2.__e, y2.ref && h2.ref != y2.ref && (h2.ref && B(h2.ref, null, y2), s2.push(y2.ref, y2.__c || d2, y2)), null == w2 && null != d2 && (w2 = d2), (_2 = !!(4 & y2.__u)) || h2.__k === y2.__k ? f2 = A(y2, f2, n2, _2) : "function" == typeof y2.type && void 0 !== g2 ? f2 = g2 : d2 && (f2 = d2.nextSibling), y2.__u &= -7);
      return u2.__e = w2, f2;
    }
    function P(n2, l2, u2, t2, i3) {
      var o2, r2, e2, f2, c2, s2 = u2.length, a2 = s2, h2 = 0;
      for (n2.__k = new Array(i3), o2 = 0; o2 < i3; o2++) null != (r2 = l2[o2]) && "boolean" != typeof r2 && "function" != typeof r2 ? ("string" == typeof r2 || "number" == typeof r2 || "bigint" == typeof r2 || r2.constructor == String ? r2 = n2.__k[o2] = m(null, r2, null, null, null) : d(r2) ? r2 = n2.__k[o2] = m(k, { children: r2 }, null, null, null) : void 0 === r2.constructor && r2.__b > 0 ? r2 = n2.__k[o2] = m(r2.type, r2.props, r2.key, r2.ref ? r2.ref : null, r2.__v) : n2.__k[o2] = r2, f2 = o2 + h2, r2.__ = n2, r2.__b = n2.__b + 1, e2 = null, -1 != (c2 = r2.__i = L(r2, u2, f2, a2)) && (a2--, (e2 = u2[c2]) && (e2.__u |= 2)), null == e2 || null == e2.__v ? (-1 == c2 && (i3 > s2 ? h2-- : i3 < s2 && h2++), "function" != typeof r2.type && (r2.__u |= 4)) : c2 != f2 && (c2 == f2 - 1 ? h2-- : c2 == f2 + 1 ? h2++ : (c2 > f2 ? h2-- : h2++, r2.__u |= 4))) : n2.__k[o2] = null;
      if (a2) for (o2 = 0; o2 < s2; o2++) null != (e2 = u2[o2]) && 0 == (2 & e2.__u) && (e2.__e == t2 && (t2 = S(e2)), D(e2, e2));
      return t2;
    }
    function A(n2, l2, u2, t2) {
      var i3, o2;
      if ("function" == typeof n2.type) {
        for (i3 = n2.__k, o2 = 0; i3 && o2 < i3.length; o2++) i3[o2] && (i3[o2].__ = n2, l2 = A(i3[o2], l2, u2, t2));
        return l2;
      }
      n2.__e != l2 && (t2 && (l2 && n2.type && !l2.parentNode && (l2 = S(n2)), u2.insertBefore(n2.__e, l2 || null)), l2 = n2.__e);
      do {
        l2 = l2 && l2.nextSibling;
      } while (null != l2 && 8 == l2.nodeType);
      return l2;
    }
    function H(n2, l2) {
      return l2 = l2 || [], null == n2 || "boolean" == typeof n2 || (d(n2) ? n2.some(function(n3) {
        H(n3, l2);
      }) : l2.push(n2)), l2;
    }
    function L(n2, l2, u2, t2) {
      var i3, o2, r2, e2 = n2.key, f2 = n2.type, c2 = l2[u2], s2 = null != c2 && 0 == (2 & c2.__u);
      if (null === c2 && null == e2 || s2 && e2 == c2.key && f2 == c2.type) return u2;
      if (t2 > (s2 ? 1 : 0)) {
        for (i3 = u2 - 1, o2 = u2 + 1; i3 >= 0 || o2 < l2.length; ) if (null != (c2 = l2[r2 = i3 >= 0 ? i3-- : o2++]) && 0 == (2 & c2.__u) && e2 == c2.key && f2 == c2.type) return r2;
      }
      return -1;
    }
    function T(n2, l2, u2) {
      "-" == l2[0] ? n2.setProperty(l2, null == u2 ? "" : u2) : n2[l2] = null == u2 ? "" : "number" != typeof u2 || y.test(l2) ? u2 : u2 + "px";
    }
    function j(n2, l2, u2, t2, i3) {
      var o2, r2;
      n: if ("style" == l2) if ("string" == typeof u2) n2.style.cssText = u2;
      else {
        if ("string" == typeof t2 && (n2.style.cssText = t2 = ""), t2) for (l2 in t2) u2 && l2 in u2 || T(n2.style, l2, "");
        if (u2) for (l2 in u2) t2 && u2[l2] == t2[l2] || T(n2.style, l2, u2[l2]);
      }
      else if ("o" == l2[0] && "n" == l2[1]) o2 = l2 != (l2 = l2.replace(f, "$1")), r2 = l2.toLowerCase(), l2 = r2 in n2 || "onFocusOut" == l2 || "onFocusIn" == l2 ? r2.slice(2) : l2.slice(2), n2.l || (n2.l = {}), n2.l[l2 + o2] = u2, u2 ? t2 ? u2.u = t2.u : (u2.u = c, n2.addEventListener(l2, o2 ? a : s, o2)) : n2.removeEventListener(l2, o2 ? a : s, o2);
      else {
        if ("http://www.w3.org/2000/svg" == i3) l2 = l2.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l2 && "height" != l2 && "href" != l2 && "list" != l2 && "form" != l2 && "tabIndex" != l2 && "download" != l2 && "rowSpan" != l2 && "colSpan" != l2 && "role" != l2 && "popover" != l2 && l2 in n2) try {
          n2[l2] = null == u2 ? "" : u2;
          break n;
        } catch (n3) {
        }
        "function" == typeof u2 || (null == u2 || false === u2 && "-" != l2[4] ? n2.removeAttribute(l2) : n2.setAttribute(l2, "popover" == l2 && 1 == u2 ? "" : u2));
      }
    }
    function F(n2) {
      return function(u2) {
        if (this.l) {
          var t2 = this.l[u2.type + n2];
          if (null == u2.t) u2.t = c++;
          else if (u2.t < t2.u) return;
          return t2(l.event ? l.event(u2) : u2);
        }
      };
    }
    function O(n2, u2, t2, i3, o2, r2, e2, f2, c2, s2) {
      var a2, h2, p2, v2, y2, _2, m2, b2, S2, C2, M2, $2, P2, A2, H2, L2, T2, j2 = u2.type;
      if (void 0 !== u2.constructor) return null;
      128 & t2.__u && (c2 = !!(32 & t2.__u), r2 = [f2 = u2.__e = t2.__e]), (a2 = l.__b) && a2(u2);
      n: if ("function" == typeof j2) try {
        if (b2 = u2.props, S2 = "prototype" in j2 && j2.prototype.render, C2 = (a2 = j2.contextType) && i3[a2.__c], M2 = a2 ? C2 ? C2.props.value : a2.__ : i3, t2.__c ? m2 = (h2 = u2.__c = t2.__c).__ = h2.__E : (S2 ? u2.__c = h2 = new j2(b2, M2) : (u2.__c = h2 = new x(b2, M2), h2.constructor = j2, h2.render = E), C2 && C2.sub(h2), h2.state || (h2.state = {}), h2.__n = i3, p2 = h2.__d = true, h2.__h = [], h2._sb = []), S2 && null == h2.__s && (h2.__s = h2.state), S2 && null != j2.getDerivedStateFromProps && (h2.__s == h2.state && (h2.__s = w({}, h2.__s)), w(h2.__s, j2.getDerivedStateFromProps(b2, h2.__s))), v2 = h2.props, y2 = h2.state, h2.__v = u2, p2) S2 && null == j2.getDerivedStateFromProps && null != h2.componentWillMount && h2.componentWillMount(), S2 && null != h2.componentDidMount && h2.__h.push(h2.componentDidMount);
        else {
          if (S2 && null == j2.getDerivedStateFromProps && b2 !== v2 && null != h2.componentWillReceiveProps && h2.componentWillReceiveProps(b2, M2), u2.__v == t2.__v || !h2.__e && null != h2.shouldComponentUpdate && false === h2.shouldComponentUpdate(b2, h2.__s, M2)) {
            for (u2.__v != t2.__v && (h2.props = b2, h2.state = h2.__s, h2.__d = false), u2.__e = t2.__e, u2.__k = t2.__k, u2.__k.some(function(n3) {
              n3 && (n3.__ = u2);
            }), $2 = 0; $2 < h2._sb.length; $2++) h2.__h.push(h2._sb[$2]);
            h2._sb = [], h2.__h.length && e2.push(h2);
            break n;
          }
          null != h2.componentWillUpdate && h2.componentWillUpdate(b2, h2.__s, M2), S2 && null != h2.componentDidUpdate && h2.__h.push(function() {
            h2.componentDidUpdate(v2, y2, _2);
          });
        }
        if (h2.context = M2, h2.props = b2, h2.__P = n2, h2.__e = false, P2 = l.__r, A2 = 0, S2) {
          for (h2.state = h2.__s, h2.__d = false, P2 && P2(u2), a2 = h2.render(h2.props, h2.state, h2.context), H2 = 0; H2 < h2._sb.length; H2++) h2.__h.push(h2._sb[H2]);
          h2._sb = [];
        } else do {
          h2.__d = false, P2 && P2(u2), a2 = h2.render(h2.props, h2.state, h2.context), h2.state = h2.__s;
        } while (h2.__d && ++A2 < 25);
        h2.state = h2.__s, null != h2.getChildContext && (i3 = w(w({}, i3), h2.getChildContext())), S2 && !p2 && null != h2.getSnapshotBeforeUpdate && (_2 = h2.getSnapshotBeforeUpdate(v2, y2)), L2 = a2, null != a2 && a2.type === k && null == a2.key && (L2 = V(a2.props.children)), f2 = I(n2, d(L2) ? L2 : [L2], u2, t2, i3, o2, r2, e2, f2, c2, s2), h2.base = u2.__e, u2.__u &= -161, h2.__h.length && e2.push(h2), m2 && (h2.__E = h2.__ = null);
      } catch (n3) {
        if (u2.__v = null, c2 || null != r2) if (n3.then) {
          for (u2.__u |= c2 ? 160 : 128; f2 && 8 == f2.nodeType && f2.nextSibling; ) f2 = f2.nextSibling;
          r2[r2.indexOf(f2)] = null, u2.__e = f2;
        } else {
          for (T2 = r2.length; T2--; ) g(r2[T2]);
          z(u2);
        }
        else u2.__e = t2.__e, u2.__k = t2.__k, n3.then || z(u2);
        l.__e(n3, u2, t2);
      }
      else null == r2 && u2.__v == t2.__v ? (u2.__k = t2.__k, u2.__e = t2.__e) : f2 = u2.__e = q(t2.__e, u2, t2, i3, o2, r2, e2, c2, s2);
      return (a2 = l.diffed) && a2(u2), 128 & u2.__u ? void 0 : f2;
    }
    function z(n2) {
      n2 && n2.__c && (n2.__c.__e = true), n2 && n2.__k && n2.__k.forEach(z);
    }
    function N(n2, u2, t2) {
      for (var i3 = 0; i3 < t2.length; i3++) B(t2[i3], t2[++i3], t2[++i3]);
      l.__c && l.__c(u2, n2), n2.some(function(u3) {
        try {
          n2 = u3.__h, u3.__h = [], n2.some(function(n3) {
            n3.call(u3);
          });
        } catch (n3) {
          l.__e(n3, u3.__v);
        }
      });
    }
    function V(n2) {
      return "object" != typeof n2 || null == n2 || n2.__b && n2.__b > 0 ? n2 : d(n2) ? n2.map(V) : w({}, n2);
    }
    function q(u2, t2, i3, o2, r2, e2, f2, c2, s2) {
      var a2, h2, v2, y2, w2, _2, m2, b2 = i3.props || p, k2 = t2.props, x2 = t2.type;
      if ("svg" == x2 ? r2 = "http://www.w3.org/2000/svg" : "math" == x2 ? r2 = "http://www.w3.org/1998/Math/MathML" : r2 || (r2 = "http://www.w3.org/1999/xhtml"), null != e2) {
        for (a2 = 0; a2 < e2.length; a2++) if ((w2 = e2[a2]) && "setAttribute" in w2 == !!x2 && (x2 ? w2.localName == x2 : 3 == w2.nodeType)) {
          u2 = w2, e2[a2] = null;
          break;
        }
      }
      if (null == u2) {
        if (null == x2) return document.createTextNode(k2);
        u2 = document.createElementNS(r2, x2, k2.is && k2), c2 && (l.__m && l.__m(t2, e2), c2 = false), e2 = null;
      }
      if (null == x2) b2 === k2 || c2 && u2.data == k2 || (u2.data = k2);
      else {
        if (e2 = e2 && n.call(u2.childNodes), !c2 && null != e2) for (b2 = {}, a2 = 0; a2 < u2.attributes.length; a2++) b2[(w2 = u2.attributes[a2]).name] = w2.value;
        for (a2 in b2) if (w2 = b2[a2], "children" == a2) ;
        else if ("dangerouslySetInnerHTML" == a2) v2 = w2;
        else if (!(a2 in k2)) {
          if ("value" == a2 && "defaultValue" in k2 || "checked" == a2 && "defaultChecked" in k2) continue;
          j(u2, a2, null, w2, r2);
        }
        for (a2 in k2) w2 = k2[a2], "children" == a2 ? y2 = w2 : "dangerouslySetInnerHTML" == a2 ? h2 = w2 : "value" == a2 ? _2 = w2 : "checked" == a2 ? m2 = w2 : c2 && "function" != typeof w2 || b2[a2] === w2 || j(u2, a2, w2, b2[a2], r2);
        if (h2) c2 || v2 && (h2.__html == v2.__html || h2.__html == u2.innerHTML) || (u2.innerHTML = h2.__html), t2.__k = [];
        else if (v2 && (u2.innerHTML = ""), I("template" == t2.type ? u2.content : u2, d(y2) ? y2 : [y2], t2, i3, o2, "foreignObject" == x2 ? "http://www.w3.org/1999/xhtml" : r2, e2, f2, e2 ? e2[0] : i3.__k && S(i3, 0), c2, s2), null != e2) for (a2 = e2.length; a2--; ) g(e2[a2]);
        c2 || (a2 = "value", "progress" == x2 && null == _2 ? u2.removeAttribute("value") : null != _2 && (_2 !== u2[a2] || "progress" == x2 && !_2 || "option" == x2 && _2 != b2[a2]) && j(u2, a2, _2, b2[a2], r2), a2 = "checked", null != m2 && m2 != u2[a2] && j(u2, a2, m2, b2[a2], r2));
      }
      return u2;
    }
    function B(n2, u2, t2) {
      try {
        if ("function" == typeof n2) {
          var i3 = "function" == typeof n2.__u;
          i3 && n2.__u(), i3 && null == u2 || (n2.__u = n2(u2));
        } else n2.current = u2;
      } catch (n3) {
        l.__e(n3, t2);
      }
    }
    function D(n2, u2, t2) {
      var i3, o2;
      if (l.unmount && l.unmount(n2), (i3 = n2.ref) && (i3.current && i3.current != n2.__e || B(i3, null, u2)), null != (i3 = n2.__c)) {
        if (i3.componentWillUnmount) try {
          i3.componentWillUnmount();
        } catch (n3) {
          l.__e(n3, u2);
        }
        i3.base = i3.__P = null;
      }
      if (i3 = n2.__k) for (o2 = 0; o2 < i3.length; o2++) i3[o2] && D(i3[o2], u2, t2 || "function" != typeof n2.type);
      t2 || g(n2.__e), n2.__c = n2.__ = n2.__e = void 0;
    }
    function E(n2, l2, u2) {
      return this.constructor(n2, u2);
    }
    function G(u2, t2, i3) {
      var o2, r2, e2, f2;
      t2 == document && (t2 = document.documentElement), l.__ && l.__(u2, t2), r2 = (o2 = "function" == typeof i3) ? null : i3 && i3.__k || t2.__k, e2 = [], f2 = [], O(t2, u2 = (!o2 && i3 || t2).__k = _(k, null, [u2]), r2 || p, p, t2.namespaceURI, !o2 && i3 ? [i3] : r2 ? null : t2.firstChild ? n.call(t2.childNodes) : null, e2, !o2 && i3 ? i3 : r2 ? r2.__e : t2.firstChild, o2, f2), N(e2, u2, f2);
    }
    function J(n2, l2) {
      G(n2, l2, J);
    }
    function K(l2, u2, t2) {
      var i3, o2, r2, e2, f2 = w({}, l2.props);
      for (r2 in l2.type && l2.type.defaultProps && (e2 = l2.type.defaultProps), u2) "key" == r2 ? i3 = u2[r2] : "ref" == r2 ? o2 = u2[r2] : f2[r2] = void 0 === u2[r2] && null != e2 ? e2[r2] : u2[r2];
      return arguments.length > 2 && (f2.children = arguments.length > 3 ? n.call(arguments, 2) : t2), m(l2.type, f2, i3 || l2.key, o2 || l2.ref, null);
    }
    function Q(n2) {
      function l2(n3) {
        var u2, t2;
        return this.getChildContext || (u2 = /* @__PURE__ */ new Set(), (t2 = {})[l2.__c] = this, this.getChildContext = function() {
          return t2;
        }, this.componentWillUnmount = function() {
          u2 = null;
        }, this.shouldComponentUpdate = function(n4) {
          this.props.value != n4.value && u2.forEach(function(n5) {
            n5.__e = true, M(n5);
          });
        }, this.sub = function(n4) {
          u2.add(n4);
          var l3 = n4.componentWillUnmount;
          n4.componentWillUnmount = function() {
            u2 && u2.delete(n4), l3 && l3.call(n4);
          };
        }), n3.children;
      }
      return l2.__c = "__cC" + h++, l2.__ = n2, l2.Provider = l2.__l = (l2.Consumer = function(n3, l3) {
        return n3.children(l3);
      }).contextType = l2, l2;
    }
    n = v.slice, l = { __e: function(n2, l2, u2, t2) {
      for (var i3, o2, r2; l2 = l2.__; ) if ((i3 = l2.__c) && !i3.__) try {
        if ((o2 = i3.constructor) && null != o2.getDerivedStateFromError && (i3.setState(o2.getDerivedStateFromError(n2)), r2 = i3.__d), null != i3.componentDidCatch && (i3.componentDidCatch(n2, t2 || {}), r2 = i3.__d), r2) return i3.__E = i3;
      } catch (l3) {
        n2 = l3;
      }
      throw n2;
    } }, u = 0, t = function(n2) {
      return null != n2 && void 0 === n2.constructor;
    }, x.prototype.setState = function(n2, l2) {
      var u2;
      u2 = null != this.__s && this.__s != this.state ? this.__s : this.__s = w({}, this.state), "function" == typeof n2 && (n2 = n2(w({}, u2), this.props)), n2 && w(u2, n2), null != n2 && this.__v && (l2 && this._sb.push(l2), M(this));
    }, x.prototype.forceUpdate = function(n2) {
      this.__v && (this.__e = true, n2 && this.__h.push(n2), M(this));
    }, x.prototype.render = k, i2 = [], r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, e = function(n2, l2) {
      return n2.__v.__b - l2.__v.__b;
    }, $.__r = 0, f = /(PointerCapture)$|Capture$/i, c = 0, s = F(false), a = F(true), h = 0;
  },
  /***/
  5393(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      H: () => (
        /* binding */
        inferPageUrl
      )
      /* harmony export */
    });
    var inferPageUrl = function inferPageUrl2() {
      var _window$FreshUrl;
      if (((_window$FreshUrl = window.FreshUrl) === null || _window$FreshUrl === void 0 ? void 0 : _window$FreshUrl.originalUrl) != null) {
        return window.FreshUrl.originalUrl;
      }
      if (window.top === window.self) {
        return window.location.href || "";
      }
      return document.referrer || "";
    };
  },
  /***/
  5417(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Q1: () => (
        /* binding */
        Color2
      )
      /* harmony export */
    });
    var _color_utils_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(998);
    function _classCallCheck2(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties2(e, r) {
      for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
      }
    }
    function _createClass2(e, r, t) {
      return r && _defineProperties2(e.prototype, r), t && _defineProperties2(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    var rHex = /^#?([0-9a-f]{3,4}|[0-9a-f]{6,8})$/i;
    var rRgb = /^rgba?\((\d{1,3}(?:\.\d+)?%?),\s*(\d{1,3}(?:\.\d+)?%?),\s*(\d{1,3}(?:\.\d+)?%?)(?:,\s*([01]?\.?\d*))?\)$/;
    var rPercent = /^\d+(\.\d+)*%$/;
    var hexBit = /([0-9a-f])/gi;
    var p2v = function p2v2(p) {
      if (rPercent.test(p)) {
        return parseFloat(p) * 2.55;
      }
      return p;
    };
    var hue2rgb = function hue2rgb2(a, b, c) {
      if (c < 0) {
        c += 1;
      }
      if (c > 1) {
        c -= 1;
      }
      if (c < 1 / 6) {
        return a + (b - a) * 6 * c;
      }
      if (c < 1 / 2) {
        return b;
      }
      if (c < 2 / 3) {
        return a + (b - a) * (2 / 3 - c) * 6;
      }
      return a;
    };
    var Color2 = /* @__PURE__ */ (function() {
      function Color3(input) {
        _classCallCheck2(this, Color3);
        if (input instanceof Color3) {
          this.r = input.r;
          this.g = input.g;
          this.b = input.b;
          this.a = input.a;
        } else if (input) {
          this.parse(input);
        } else {
          this.r = this.g = this.b = 0;
          this.a = 1;
        }
      }
      return _createClass2(Color3, [{
        key: "parse",
        value: function parse2(input) {
          var parsed = false;
          if (Array.isArray(input)) {
            var _input$;
            this.r = input[0];
            this.g = input[1];
            this.b = input[2];
            this.a = (_input$ = input[3]) !== null && _input$ !== void 0 ? _input$ : 1;
            parsed = true;
          } else {
            var sanitized = String(input).replace(/\s+/g, "");
            if (rHex.test(sanitized)) {
              var stripped = sanitized.replace(/^#/, "");
              if (stripped.length === 3 || stripped.length === 4) {
                stripped = stripped.replace(hexBit, "$1$1");
              }
              this.r = parseInt(stripped.substr(0, 2), 16);
              this.g = parseInt(stripped.substr(2, 2), 16);
              this.b = parseInt(stripped.substr(4, 2), 16);
              if (stripped.length === 8) {
                this.a = parseInt(stripped.substr(6, 2), 16) / 255;
              } else {
                this.a = 1;
              }
              parsed = true;
            } else if (rRgb.test(sanitized)) {
              var parts = sanitized.match(rRgb);
              this.r = parseFloat(p2v(parts[1]));
              this.g = parseFloat(p2v(parts[2]));
              this.b = parseFloat(p2v(parts[3]));
              if (parts[4]) {
                this.a = parseFloat(parts[4]);
              } else {
                this.a = 1;
              }
              parsed = true;
            }
          }
          if (!parsed || isNaN(this.r) || isNaN(this.g) || isNaN(this.b) || isNaN(this.a) || this.r < 0 || this.g < 0 || this.b < 0 || this.a < 0) {
            this.r = 41;
            this.g = 73;
            this.b = 229;
            this.a = 1;
            console.error("An invalid color was provided, ".concat(input.toString(), ", using default color instead."));
          }
          return this;
        }
      }, {
        key: "clone",
        value: function clone2() {
          return new Color3(this);
        }
        // Compute internal HSL values based on internal RGB values.
      }, {
        key: "_hslFromRgb",
        value: function _hslFromRgb() {
          var _rgbToHsl = (0, _color_utils_ts__WEBPACK_IMPORTED_MODULE_0__.K6)([this.r, this.g, this.b]), hue = _rgbToHsl.hue, saturation = _rgbToHsl.saturation, lightness = _rgbToHsl.lightness;
          this._h = hue;
          this._s = saturation;
          this._l = lightness;
          return this;
        }
        // Compute internal RGB values based on internal HSL values.
      }, {
        key: "_rgbFromHsl",
        value: function _rgbFromHsl() {
          var h = this._h / 360;
          var s = this._s / 100;
          var l = this._l / 100;
          var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
          var p = 2 * l - q;
          this.r = hue2rgb(p, q, h + 1 / 3) * 255;
          this.g = hue2rgb(p, q, h) * 255;
          this.b = hue2rgb(p, q, h - 1 / 3) * 255;
          return this;
        }
        // Do math to blend a channel with a different value. Alpha is
        // the strength of the blend.
      }, {
        key: "blendChannel",
        value: function blendChannel(channel, value, alpha, shouldUseLrgb) {
          if (shouldUseLrgb) {
            this[channel] = Math.sqrt(Math.pow(this[channel], 2) * (1 - alpha) + Math.pow(value, 2) * alpha);
            return this;
          }
          this[channel] = alpha * value + (1 - alpha) * this[channel];
          return this;
        }
        // Blend this color with another color by blending each RGB
        // channel individually.
      }, {
        key: "blend",
        value: function blend(color, alpha, shouldUseLrgb) {
          color = new Color3(color);
          this.blendChannel("r", color.r, alpha, shouldUseLrgb);
          this.blendChannel("g", color.g, alpha, shouldUseLrgb);
          this.blendChannel("b", color.b, alpha, shouldUseLrgb);
          return this;
        }
        // background color can be a string or a Color
      }, {
        key: "getContrastRatio",
        value: function getContrastRatio(backgroundColor) {
          return Number.parseFloat((0, _color_utils_ts__WEBPACK_IMPORTED_MODULE_0__.bJ)(this.toHexWithHash(), new Color3(backgroundColor).toHexWithHash()).toFixed(3));
        }
        // background color can be a string or a Color
        // shape will be a key of colorContrastRatiosByShape
      }, {
        key: "hasAccessibleContrast",
        value: function hasAccessibleContrast(backgroundColor, shape) {
          return this.getContrastRatio(backgroundColor) >= _color_utils_ts__WEBPACK_IMPORTED_MODULE_0__.s1[shape];
        }
      }, {
        key: "hue",
        value: function hue() {
          this._hslFromRgb();
          return this._h;
        }
        // Increase a channel by a fixed value, but within the [0,255] range.
      }, {
        key: "lightenChannel",
        value: function lightenChannel(channel, steps) {
          this[channel] += steps;
          if (this[channel] < 0) {
            this[channel] = 0;
          } else if (this[channel] > 255) {
            this[channel] = 255;
          }
          return this;
        }
        // Lighten this color by increasing each channel by a fixed value.
      }, {
        key: "lighten",
        value: function lighten(steps) {
          if (this.looksLikePercent(steps)) {
            this.lightness(this.lightness() + parseFloat(steps));
          } else {
            this.lightenChannel("r", steps);
            this.lightenChannel("g", steps);
            this.lightenChannel("b", steps);
          }
          return this;
        }
      }, {
        key: "darken",
        value: function darken(steps) {
          if (typeof steps === "string") {
            return this.lighten("-".concat(steps));
          }
          return this.lighten(-steps);
        }
      }, {
        key: "looksLikePercent",
        value: function looksLikePercent(str) {
          return /^-?\d+(\.\d+)?%$/.test(str);
        }
        // Set the lightness of this color by modifying the L value in
        // HSL, then recomputing the RGB.
        //
        // No args gets the current lightness.
      }, {
        key: "lightness",
        value: function lightness(l) {
          this._hslFromRgb();
          if (l != null) {
            this._l = Math.max(0, Math.min(100, l));
            this._rgbFromHsl();
            return this;
          }
          return this._l;
        }
        // Set the saturation of this color by modifying the S value in
        // HSL, then recomputing the RGB.
        //
        // No args gets the current saturation.
      }, {
        key: "saturation",
        value: function saturation(s) {
          this._hslFromRgb();
          if (s != null) {
            this._s = Math.max(0, Math.min(100, s));
            this._rgbFromHsl();
            return this;
          }
          return this._s;
        }
      }, {
        key: "setHue",
        value: function setHue(hueValue) {
          this._hslFromRgb();
          if (hueValue != null) {
            this._h = Math.max(0, Math.min(360, hueValue));
            this._rgbFromHsl();
            return this;
          }
        }
      }, {
        key: "shade",
        value: function shade(percentage, shouldUseLrgb) {
          return this.blend("#000000", percentage, shouldUseLrgb);
        }
        // Gray level accounts for the strength of each individual channel.
        // This is more visually accurate than just averaging all the channels.
      }, {
        key: "grayLevel",
        value: function grayLevel() {
          return (0.299 * this.r + 0.587 * this.g + 0.114 * this.b) / 255;
        }
      }, {
        key: "tint",
        value: function tint(percentage, shouldUseLrgb) {
          return this.blend("#ffffff", percentage, shouldUseLrgb);
        }
        // The white level is basically paleness, and is determined by the
        // minimum of all the RGB channels.
      }, {
        key: "whiteLevel",
        value: function whiteLevel() {
          return Math.min(Math.min(this.r, this.g), this.b);
        }
      }, {
        key: "getRelativeLuminance",
        value: function getRelativeLuminance() {
          var adjustChannel = function adjustChannel2(givenVal) {
            var val = givenVal * 3921569e-9;
            if (val <= 0.03928) {
              return val / 12.92;
            }
            return Math.pow((val + 0.055) / 1.055, 2.4);
          };
          var rAdjusted = adjustChannel(this.r);
          var gAdjusted = adjustChannel(this.g);
          var bAdjusted = adjustChannel(this.b);
          return Math.min(0.2126 * rAdjusted + 0.7152 * gAdjusted + 0.0722 * bAdjusted, 1);
        }
      }, {
        key: "isDark",
        value: function isDark(shouldUseRL) {
          if (shouldUseRL) {
            return this.getRelativeLuminance() < 0.15;
          }
          return this.grayLevel() <= 0.4;
        }
      }, {
        key: "isLight",
        value: function isLight(shouldUseRL) {
          if (shouldUseRL) {
            return this.getRelativeLuminance() >= 0.8;
          }
          return this.grayLevel() > 0.4;
        }
      }, {
        key: "isGrayscale",
        value: function isGrayscale() {
          return this.r === this.g && this.g === this.b;
        }
      }, {
        key: "distanceFrom",
        value: function distanceFrom(color) {
          return Math.sqrt(Math.pow(this.r - color.r, 2) + Math.pow(this.g - color.g, 2) + Math.pow(this.b - color.b, 2));
        }
      }, {
        key: "channelDominance",
        value: function channelDominance() {
          var _this = this;
          return ["r", "g", "b"].sort(function(a, b) {
            return _this[b] - _this[a];
          });
        }
      }, {
        key: "alpha",
        value: function alpha(a) {
          if (a != null) {
            this.a = a;
            return this;
          }
          return this.a;
        }
      }, {
        key: "red",
        value: function red(r) {
          if (r != null) {
            this.r = r;
            return this;
          }
          return this.r;
        }
      }, {
        key: "green",
        value: function green(g) {
          if (g != null) {
            this.g = g;
            return this;
          }
          return this.g;
        }
      }, {
        key: "blue",
        value: function blue(b) {
          if (b != null) {
            this.b = b;
            return this;
          }
          return this.b;
        }
      }, {
        key: "toHex",
        value: function toHex() {
          var r = Math.round(this.r).toString(16);
          var g = Math.round(this.g).toString(16);
          var b = Math.round(this.b).toString(16);
          if (r.length === 1) {
            r = "0".concat(r);
          }
          if (g.length === 1) {
            g = "0".concat(g);
          }
          if (b.length === 1) {
            b = "0".concat(b);
          }
          return "".concat(r).concat(g).concat(b);
        }
      }, {
        key: "toHexWithAlpha",
        value: function toHexWithAlpha() {
          var a = Math.round(this.a * 255).toString(16);
          if (a.length === 1) {
            a = "0".concat(a);
          }
          return "".concat(a).concat(this.toHex());
        }
      }, {
        key: "toHexWithHash",
        value: function toHexWithHash() {
          return "#".concat(this.toHex());
        }
      }, {
        key: "toRgb",
        value: function toRgb() {
          return "rgb(".concat(Math.round(this.r), ",").concat(Math.round(this.g), ",").concat(Math.round(this.b), ")");
        }
      }, {
        key: "toRgba",
        value: function toRgba() {
          return "rgba(".concat(Math.round(this.r), ",").concat(Math.round(this.g), ",").concat(Math.round(this.b), ",").concat(this.a, ")");
        }
      }, {
        key: "toRgbaOrHex",
        value: function toRgbaOrHex() {
          return this.toRgba();
        }
      }, {
        key: "toPercent",
        value: function toPercent() {
          return "rgba(".concat(this.r / 255 * 100, "%,").concat(this.g / 255 * 100, "%,").concat(this.b / 255 * 100, "%,").concat(this.a, ")");
        }
        // IE8 and below don't support RGBA, but we can use this gradient hack to
        // do the same thing. The catch is that it functions as a background image
        // instead of a color, and therefore overrides other background images in IE.
        //
        // This should go after a `filter` CSS property.
      }, {
        key: "toIeGradient",
        value: function toIeGradient() {
          return "progid:DXImageTransform.Microsoft.gradient(startColorStr='#".concat(this.toHexWithAlpha(), "', endColorStr='#").concat(this.toHexWithAlpha(), "')");
        }
      }, {
        key: "toString",
        value: function toString() {
          return this.toPercent();
        }
      }]);
    })();
    var addHashToHex = function addHashToHex2(hex) {
      if (isNil(hex)) {
        return;
      }
      if (hex.charAt(0) === "#") {
        return hex;
      }
      return "#".concat(hex);
    };
    var colorWithAlpha = function colorWithAlpha2(color, alpha) {
      return new Color2(color).alpha(alpha).toRgba();
    };
  },
  /***/
  5509(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      s: () => (
        /* binding */
        Wistia2
      )
      /* harmony export */
    });
    var preact__WEBPACK_IMPORTED_MODULE_0__2 = __webpack_require__3(5181);
    var preact_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(3817);
    var preact_compat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(1525);
    var _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(8176);
    var _root$Wistia, _root$Wistia2, _root$Wistia2$Preact, _root$Wistia3, _root$Wistia3$_destru, _root$Wistia4, _root$Wistia4$_initia, _root$Wistia5, _root$Wistia5$_remote, _root$Wistia6, _root$Wistia6$api, _root$Wistia7, _root$Wistia7$defineC, _root$Wistia8, _root$Wistia8$EventSh, _root$Wistia9, _root$Wistia9$mixin, _root$Wistia0, _root$Wistia0$playlis, _root$Wistia1, _root$Wistia1$PublicA, _root$Wistia10, _root$Wistia10$uncach, _root$Wistia11, _root$Wistia11$Visito, _root$Wistia12, _root$Wistia12$visito, _root$Wistia13, _root$Wistia13$wistia, _root$Wistia14, _root$Wistia14$_liveS, _root$Wistia15, _root$Wistia15$_media, _root$Wistia16, _root$Wistia16$_liveS, _root$Wistia17, _root$Wistia17$first;
    var _objectHasOwn = function(object, property) {
      if (typeof object === "undefined" || object === null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    };
    function ownKeys2(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
          return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread2(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
          _defineProperty2(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
          Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
      }
      return e;
    }
    function _defineProperty2(e, r, t) {
      return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    (_root$Wistia = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia) !== null && _root$Wistia !== void 0 ? _root$Wistia : _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia = {};
    (_root$Wistia2$Preact = (_root$Wistia2 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).Preact) !== null && _root$Wistia2$Preact !== void 0 ? _root$Wistia2$Preact : _root$Wistia2.Preact = _objectSpread2(_objectSpread2({}, preact__WEBPACK_IMPORTED_MODULE_0__2), {}, {
      hooks: preact_hooks__WEBPACK_IMPORTED_MODULE_1__,
      compat: preact_compat__WEBPACK_IMPORTED_MODULE_2__
    });
    (_root$Wistia3$_destru = (_root$Wistia3 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia)._destructors) !== null && _root$Wistia3$_destru !== void 0 ? _root$Wistia3$_destru : _root$Wistia3._destructors = {};
    (_root$Wistia4$_initia = (_root$Wistia4 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia)._initializers) !== null && _root$Wistia4$_initia !== void 0 ? _root$Wistia4$_initia : _root$Wistia4._initializers = {};
    (_root$Wistia5$_remote = (_root$Wistia5 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia)._remoteData) !== null && _root$Wistia5$_remote !== void 0 ? _root$Wistia5$_remote : _root$Wistia5._remoteData = /* @__PURE__ */ new Map();
    (_root$Wistia6$api = (_root$Wistia6 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).api) !== null && _root$Wistia6$api !== void 0 ? _root$Wistia6$api : _root$Wistia6.api = function() {
      console.error("Accessed Wistia.api() before it was initialized");
      return null;
    };
    (_root$Wistia7$defineC = (_root$Wistia7 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).defineControl) !== null && _root$Wistia7$defineC !== void 0 ? _root$Wistia7$defineC : _root$Wistia7.defineControl = function() {
      console.error("Accessed Wistia.defineControl() before it was initialized");
      return null;
    };
    (_root$Wistia8$EventSh = (_root$Wistia8 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).EventShepherdManager) !== null && _root$Wistia8$EventSh !== void 0 ? _root$Wistia8$EventSh : _root$Wistia8.EventShepherdManager = {};
    (_root$Wistia9$mixin = (_root$Wistia9 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).mixin) !== null && _root$Wistia9$mixin !== void 0 ? _root$Wistia9$mixin : _root$Wistia9.mixin = function(klass) {
      var obj = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      Object.keys(obj).forEach(function(key) {
        if (_objectHasOwn(obj, key)) {
          klass[key] = obj[key];
        }
      });
    };
    (_root$Wistia0$playlis = (_root$Wistia0 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).playlistMethods) !== null && _root$Wistia0$playlis !== void 0 ? _root$Wistia0$playlis : _root$Wistia0.playlistMethods = /* @__PURE__ */ new Map();
    (_root$Wistia1$PublicA = (_root$Wistia1 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).PublicApi) !== null && _root$Wistia1$PublicA !== void 0 ? _root$Wistia1$PublicA : _root$Wistia1.PublicApi = null;
    (_root$Wistia10$uncach = (_root$Wistia10 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).uncacheMedia) !== null && _root$Wistia10$uncach !== void 0 ? _root$Wistia10$uncach : _root$Wistia10.uncacheMedia = function() {
      console.error("Accessed Wistia.uncacheMedia() before it was initialized");
      return null;
    };
    (_root$Wistia11$Visito = (_root$Wistia11 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).VisitorKey) !== null && _root$Wistia11$Visito !== void 0 ? _root$Wistia11$Visito : _root$Wistia11.VisitorKey = null;
    (_root$Wistia12$visito = (_root$Wistia12 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).visitorKey) !== null && _root$Wistia12$visito !== void 0 ? _root$Wistia12$visito : _root$Wistia12.visitorKey = null;
    (_root$Wistia13$wistia = (_root$Wistia13 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).wistia) !== null && _root$Wistia13$wistia !== void 0 ? _root$Wistia13$wistia : _root$Wistia13.wistia = void 0;
    (_root$Wistia14$_liveS = (_root$Wistia14 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia)._liveStreamEventDataPromises) !== null && _root$Wistia14$_liveS !== void 0 ? _root$Wistia14$_liveS : _root$Wistia14._liveStreamEventDataPromises = {};
    (_root$Wistia15$_media = (_root$Wistia15 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia)._mediaDataPromises) !== null && _root$Wistia15$_media !== void 0 ? _root$Wistia15$_media : _root$Wistia15._mediaDataPromises = {};
    (_root$Wistia16$_liveS = (_root$Wistia16 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia)._liveStreamPollingPromises) !== null && _root$Wistia16$_liveS !== void 0 ? _root$Wistia16$_liveS : _root$Wistia16._liveStreamPollingPromises = {};
    (_root$Wistia17$first = (_root$Wistia17 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia).first) !== null && _root$Wistia17$first !== void 0 ? _root$Wistia17$first : _root$Wistia17.first = function() {
      var _root$Wistia$api;
      return (_root$Wistia$api = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia.api()) !== null && _root$Wistia$api !== void 0 ? _root$Wistia$api : document.querySelector("wistia-player");
    };
    var Wistia2 = _utilities_root_js__WEBPACK_IMPORTED_MODULE_3__.z.Wistia;
  },
  /***/
  5510(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      bp: () => (
        /* binding */
        getAllApiHandles
      )
      /* harmony export */
    });
    var _wlog_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(6637);
    var _wistiaData_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(3997);
    function _toConsumableArray(r) {
      return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray2(r) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return _arrayLikeToArray2(r);
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var getAllInitializedEmbedApiHandles = function getAllInitializedEmbedApiHandles2() {
      if ((0, _wistiaData_js__WEBPACK_IMPORTED_MODULE_1__.m)("video") === void 0) {
        return [];
      }
      return Object.values((0, _wistiaData_js__WEBPACK_IMPORTED_MODULE_1__.m)("video"));
    };
    var getAllIframeApiHandles = function getAllIframeApiHandles2() {
      if ((0, _wistiaData_js__WEBPACK_IMPORTED_MODULE_1__.m)("iframe_api") === void 0) {
        return [];
      }
      return Object.values((0, _wistiaData_js__WEBPACK_IMPORTED_MODULE_1__.m)("iframe_api"));
    };
    var getAllApiHandles = function getAllApiHandles2() {
      return getAllInitializedEmbedApiHandles().concat(getAllIframeApiHandles());
    };
    var getOneApiHandle2 = function getOneApiHandle3(matcher) {
      var _container, _container2;
      if (matcher === void 0) {
        var _getAllApiHandles$;
        return (_getAllApiHandles$ = getAllApiHandles()[0]) !== null && _getAllApiHandles$ !== void 0 ? _getAllApiHandles$ : null;
      }
      var container = null;
      if (typeof matcher === "string") {
        var _document$querySelect;
        var query = matcher;
        container = (_document$querySelect = document.querySelector("[unique-id='".concat(query, "']"))) !== null && _document$querySelect !== void 0 ? _document$querySelect : document.getElementById(query);
        if (container === null) {
          var apiHandles = getAllApiHandles();
          var matchedHandle = apiHandles.find(function(handle) {
            var _handle$hashedId, _handle$container;
            if ((_handle$hashedId = handle.hashedId()) !== null && _handle$hashedId !== void 0 && _handle$hashedId.startsWith(query) || (_handle$container = handle.container) !== null && _handle$container !== void 0 && _handle$container.id.startsWith(query)) {
              return handle;
            }
            if ("mediaLanguages" in handle && "languageToLocalization" in handle) {
              var _handle$_mediaData;
              var queryMatchesLocalization = handle.mediaLanguages().some(function(language) {
                var localization = handle.languageToLocalization(language);
                return localization != null && ensureString(localization.hashedId).startsWith(query);
              });
              if (queryMatchesLocalization) {
                return handle;
              }
              var queryMatchesSourceMediaId = ensureString((_handle$_mediaData = handle._mediaData) === null || _handle$_mediaData === void 0 ? void 0 : _handle$_mediaData.sourceHashedId).startsWith(query);
              if (queryMatchesSourceMediaId) {
                return handle;
              }
            }
            return null;
          });
          if (matchedHandle !== "removed") {
            var _ref;
            container = (_ref = matchedHandle === null || matchedHandle === void 0 ? void 0 : matchedHandle.container) !== null && _ref !== void 0 ? _ref : null;
          }
        }
      } else if (typeof matcher === "number") {
        var index = matcher;
        var _apiHandles = getAllApiHandles();
        if (index < 0) {
          index = _apiHandles.length + index;
        }
        var apiHandle = _apiHandles[index];
        if (apiHandle !== void 0 && apiHandle !== "removed") {
          var _apiHandle$container;
          container = (_apiHandle$container = apiHandle.container) !== null && _apiHandle$container !== void 0 ? _apiHandle$container : null;
        }
      } else if (matcher instanceof HTMLElement) {
        container = matcher;
      } else {
        wlog.error("Unrecognized matcher", matcher);
      }
      if (((_container = container) === null || _container === void 0 ? void 0 : _container.tagName) === "WISTIA-PLAYER") {
        return container.deprecatedApiDoNotUse;
      }
      if (((_container2 = container) === null || _container2 === void 0 ? void 0 : _container2.wistiaApi) !== void 0 && container.wistiaApi !== "removed") {
        return container.wistiaApi;
      }
      return null;
    };
    var getOneApiHandleFromHashedId = function getOneApiHandleFromHashedId2(hashedId) {
      var _container3, _container4;
      var container = null;
      var query = hashedId;
      var apiHandles = getAllApiHandles();
      var matchedHandle = apiHandles.find(function(handle) {
        var _handle$hashedId2;
        if ((_handle$hashedId2 = handle.hashedId()) !== null && _handle$hashedId2 !== void 0 && _handle$hashedId2.startsWith(query)) {
          return handle;
        }
        return null;
      });
      if (matchedHandle !== "removed") {
        var _ref2;
        container = (_ref2 = matchedHandle === null || matchedHandle === void 0 ? void 0 : matchedHandle.container) !== null && _ref2 !== void 0 ? _ref2 : null;
      }
      if (((_container3 = container) === null || _container3 === void 0 ? void 0 : _container3.tagName) === "WISTIA-PLAYER") {
        return container.deprecatedApiDoNotUse;
      }
      if (((_container4 = container) === null || _container4 === void 0 ? void 0 : _container4.wistiaApi) !== void 0 && container.wistiaApi !== "removed") {
        return container.wistiaApi;
      }
      return null;
    };
    var getAllApiHandlesByDomOrder = function getAllApiHandlesByDomOrder2() {
      var legacyHandles = Array.from(getAllApiEmbedElements("wistia_embed_initialized")).reduce(function(accumulator, legacyContainer) {
        if (legacyContainer.wistiaApi !== void 0 && legacyContainer.wistiaApi !== "removed" && legacyContainer.wistiaApi !== null) {
          accumulator.push(legacyContainer.wistiaApi);
        }
        return accumulator;
      }, []);
      var wistiaPlayerHandles = Array.from(document.querySelectorAll("wistia-player")).reduce(function(accumulator, container) {
        if (container.deprecatedApiDoNotUse !== void 0 && container.deprecatedApiDoNotUse !== "removed" && container.deprecatedApiDoNotUse !== null) {
          accumulator.push(container.deprecatedApiDoNotUse);
        }
        return accumulator;
      }, []);
      return [].concat(_toConsumableArray(legacyHandles), _toConsumableArray(wistiaPlayerHandles));
    };
  },
  /***/
  5819(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      V: () => (
        /* binding */
        Thumbnail
      )
      /* harmony export */
    });
    var utilities_image_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(4635);
    var preact__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5181);
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(731);
    var utilities_elem_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(7715);
    var _translations_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(4730);
    function _readOnlyError(r) {
      throw new TypeError('"' + r + '" is read-only');
    }
    function _classCallCheck2(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties2(e, r) {
      for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
      }
    }
    function _createClass2(e, r, t) {
      return r && _defineProperties2(e.prototype, r), t && _defineProperties2(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    function _callSuper2(t, o, e) {
      return o = _getPrototypeOf2(o), _possibleConstructorReturn2(t, _isNativeReflectConstruct2() ? Reflect.construct(o, e || [], _getPrototypeOf2(t).constructor) : o.apply(t, e));
    }
    function _possibleConstructorReturn2(t, e) {
      if (e && ("object" == typeof e || "function" == typeof e)) return e;
      if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
      return _assertThisInitialized2(t);
    }
    function _assertThisInitialized2(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function _isNativeReflectConstruct2() {
      try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
      } catch (t2) {
      }
      return (_isNativeReflectConstruct2 = function _isNativeReflectConstruct3() {
        return !!t;
      })();
    }
    function _getPrototypeOf2(t) {
      return _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
        return t2.__proto__ || Object.getPrototypeOf(t2);
      }, _getPrototypeOf2(t);
    }
    function _inherits2(t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf2(t, e);
    }
    function _setPrototypeOf2(t, e) {
      return _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
        return t2.__proto__ = e2, t2;
      }, _setPrototypeOf2(t, e);
    }
    (0, _translations_js__WEBPACK_IMPORTED_MODULE_4__.Oj)("en-US", {
      THUMBNAIL_VIDEO_THUMBNAIL: "Video Thumbnail"
    });
    var Thumbnail = /* @__PURE__ */ (function(_Component) {
      function Thumbnail2(props) {
        var _this;
        _classCallCheck2(this, Thumbnail2);
        _this = _callSuper2(this, Thumbnail2, [props]);
        _this.initialState = _this.state = {
          isLoaded: false,
          isDisplaying: false
        };
        _this.onDisplay = _this.props.onDisplay;
        return _this;
      }
      _inherits2(Thumbnail2, _Component);
      return _createClass2(Thumbnail2, [{
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
          if (nextProps.images !== this.props.images) {
            this._sortedImages = null;
            this.setState({
              isLoaded: false,
              isDisplaying: false
            });
          }
          if (!this.onDisplay && nextProps.onDisplay) {
            this.onDisplay = nextProps.onDisplay;
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;
          var altText = this.props.thumbnailAltText !== void 0 ? this.props.thumbnailAltText : this.translate("VIDEO_THUMBNAIL");
          return (0, preact__WEBPACK_IMPORTED_MODULE_1__.h)("div", {
            style: this.wrapperStyle(),
            class: "w-css-reset"
          }, (0, preact__WEBPACK_IMPORTED_MODULE_1__.h)("img", {
            class: "w-css-reset",
            srcset: this.props.images.length > 1 ? this.srcSet() : null,
            src: this.bestSrc(),
            style: this.imgStyle(),
            alt: altText,
            ref: function ref(e) {
              return _this2.imgElem = e;
            },
            "aria-hidden": this.props.ariaHidden ? "true" : null
          }));
        }
      }, {
        key: "translate",
        value: function translate(key) {
          return (0, _translations_js__WEBPACK_IMPORTED_MODULE_4__.sC)(this.props.playerLanguage, "THUMBNAIL_".concat(key));
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          this.setStateBasedOnImgStatus();
          this.maybeCallOnDisplay(this.initialState);
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
          this.setStateBasedOnImgStatus();
          this.maybeCallOnDisplay(prevState);
        }
      }, {
        key: "maybeCallOnDisplay",
        value: function maybeCallOnDisplay() {
          if (this.onDisplay && this.state.isDisplaying && !this.calledOnDisplay) {
            this.calledOnDisplay = true;
            this.onDisplay();
          }
        }
      }, {
        key: "setStateBasedOnImgStatus",
        value: function setStateBasedOnImgStatus() {
          var _this3 = this;
          var state = this.state;
          var imgElem = this.imgElem;
          if (state.isLoaded) {
            return;
          }
          if (!imgElem.onload) {
            imgElem.onload = function() {
              if ((0, utilities_elem_js__WEBPACK_IMPORTED_MODULE_3__.lj)(imgElem)) {
                _this3.setState({
                  isLoaded: true,
                  isDisplaying: true
                });
              }
            };
          }
          if (imgElem.complete) {
            this.setState({
              isLoaded: true,
              isDisplaying: true
            });
          }
        }
      }, {
        key: "wrapperStyle",
        value: function wrapperStyle() {
          var shouldShow = this.state.isDisplaying && this.props.isVisible;
          return (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_2__.kp)({}, this.props.wrapperStyle, {
            display: this.state.isLoaded && !shouldShow ? "none" : "block"
          });
        }
      }, {
        key: "baseStyle",
        value: function baseStyle() {
          var fitStrategy = this.props.fitStrategy;
          if (fitStrategy === "cover") {
            return this.coverStyle();
          }
          if (fitStrategy === "contain") {
            return this.containStyle();
          }
          if (fitStrategy === "fill") {
            return this.fillStyle();
          }
          if (fitStrategy === "naturalHeight") {
            return this.naturalHeightStyle();
          }
          return this.containStyle();
        }
      }, {
        key: "imgStyle",
        value: function imgStyle() {
          var shouldShow = this.state.isDisplaying && this.props.isVisible;
          return (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_2__.kp)(this.baseStyle(), {
            // We use position/clip to hide/show the thumbnail until it has loaded
            // because the img may not try to load if it's not visible. But after
            // it's loaded, we use display: none/block to defeat over-aggressive css
            // that might do something like position: static !important.
            clip: shouldShow ? "auto" : "rect(0,0,0,0)",
            display: this.state.isLoaded && !shouldShow ? "none" : "block",
            borderRadius: "".concat(this.props.playerBorderRadius, "px")
          });
        }
      }, {
        key: "containStyle",
        value: function containStyle() {
          return {
            backgroundColor: this.props.backgroundColor || "#000",
            height: "100%",
            objectFit: "contain",
            position: "absolute",
            width: "100%",
            top: 0,
            left: 0
          };
        }
      }, {
        key: "coverStyle",
        value: function coverStyle() {
          return {
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            width: "100%"
          };
        }
      }, {
        key: "fillStyle",
        value: function fillStyle() {
          return {
            height: "100%",
            objectFit: "fill",
            position: "absolute",
            width: "100%"
          };
        }
      }, {
        key: "naturalHeightStyle",
        value: function naturalHeightStyle() {
          return {
            width: "100%",
            position: "relative"
          };
        }
      }, {
        key: "bestSrc",
        value: function bestSrc() {
          return (0, utilities_image_js__WEBPACK_IMPORTED_MODULE_0__.cd)(this.props.images, {
            videoWidth: this.props.videoWidth,
            videoHeight: this.props.videoHeight
          }).url;
        }
      }, {
        key: "srcSet",
        value: function srcSet() {
          var sortedImages = this.sortedImages();
          if (sortedImages.length === 0) {
            sortedImages = [(0, utilities_image_js__WEBPACK_IMPORTED_MODULE_0__.YG)(this.props.videoWidth, this.props.videoHeight)];
          }
          return sortedImages.map(function(image) {
            return "".concat(image.url, " ").concat(image.width, "w");
          }).join(", ");
        }
      }, {
        key: "sortedImages",
        value: function sortedImages() {
          if (this._sortedImages) {
            return this._sortedImages;
          }
          this._sortedImages = (0, utilities_image_js__WEBPACK_IMPORTED_MODULE_0__.eZ)(this.props.images);
          return this._sortedImages;
        }
      }, {
        key: "stretchLimit",
        value: function stretchLimit() {
          var stretchLimit2 = this.props.stretchLimit;
          if (stretchLimit2 != null) {
            return stretchLimit2;
          }
          return 10;
        }
      }]);
    })(preact__WEBPACK_IMPORTED_MODULE_1__.Component);
  },
  /***/
  5833(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      n: () => (
        /* binding */
        getInitialMediaData
      )
      /* harmony export */
    });
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(5509);
    var _utilities_script_utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(159);
    var _utilities_media_data_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(1885);
    var _utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(5857);
    var _utilities_media_data_transforms_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(3917);
    var _utilities_remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(3411);
    var _utilities_mediaDataError_ts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__3(959);
    var _utilities_obj_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__3(731);
    var _utilities_fetchMediaData_ts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__3(3065);
    function _slicedToArray2(r, e) {
      return _arrayWithHoles2(r) || _iterableToArrayLimit2(r, e) || _unsupportedIterableToArray2(r, e) || _nonIterableRest2();
    }
    function _nonIterableRest2() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _iterableToArrayLimit2(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i2, u, a = [], f = true, o = false;
        try {
          if (i2 = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = false;
          } else for (; !(f = (e = i2.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles2(r) {
      if (Array.isArray(r)) return r;
    }
    function _regenerator2() {
      var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
      function i2(r2, n2, o2, i3) {
        var c2 = n2 && n2.prototype instanceof Generator ? n2 : Generator, u2 = Object.create(c2.prototype);
        return _regeneratorDefine22(u2, "_invoke", (function(r3, n3, o3) {
          var i4, c3, u3, f2 = 0, p = o3 || [], y = false, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d2(t2, r4) {
            return i4 = t2, c3 = 0, u3 = e, G.n = r4, a;
          } };
          function d(r4, n4) {
            for (c3 = r4, u3 = n4, t = 0; !y && f2 && !o4 && t < p.length; t++) {
              var o4, i5 = p[t], d2 = G.p, l = i5[2];
              r4 > 3 ? (o4 = l === n4) && (u3 = i5[(c3 = i5[4]) ? 5 : (c3 = 3, 3)], i5[4] = i5[5] = e) : i5[0] <= d2 && ((o4 = r4 < 2 && d2 < i5[1]) ? (c3 = 0, G.v = n4, G.n = i5[1]) : d2 < l && (o4 = r4 < 3 || i5[0] > n4 || n4 > l) && (i5[4] = r4, i5[5] = n4, G.n = l, c3 = 0));
            }
            if (o4 || r4 > 1) return a;
            throw y = true, n4;
          }
          return function(o4, p2, l) {
            if (f2 > 1) throw TypeError("Generator is already running");
            for (y && 1 === p2 && d(p2, l), c3 = p2, u3 = l; (t = c3 < 2 ? e : u3) || !y; ) {
              i4 || (c3 ? c3 < 3 ? (c3 > 1 && (G.n = -1), d(c3, u3)) : G.n = u3 : G.v = u3);
              try {
                if (f2 = 2, i4) {
                  if (c3 || (o4 = "next"), t = i4[o4]) {
                    if (!(t = t.call(i4, u3))) throw TypeError("iterator result is not an object");
                    if (!t.done) return t;
                    u3 = t.value, c3 < 2 && (c3 = 0);
                  } else 1 === c3 && (t = i4.return) && t.call(i4), c3 < 2 && (u3 = TypeError("The iterator does not provide a '" + o4 + "' method"), c3 = 1);
                  i4 = e;
                } else if ((t = (y = G.n < 0) ? u3 : r3.call(n3, G)) !== a) break;
              } catch (t2) {
                i4 = e, c3 = 1, u3 = t2;
              } finally {
                f2 = 1;
              }
            }
            return { value: t, done: y };
          };
        })(r2, o2, i3), true), u2;
      }
      var a = {};
      function Generator() {
      }
      function GeneratorFunction() {
      }
      function GeneratorFunctionPrototype() {
      }
      t = Object.getPrototypeOf;
      var c = [][n] ? t(t([][n]())) : (_regeneratorDefine22(t = {}, n, function() {
        return this;
      }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
      function f(e2) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e2, GeneratorFunctionPrototype) : (e2.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine22(e2, o, "GeneratorFunction")), e2.prototype = Object.create(u), e2;
      }
      return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine22(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine22(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine22(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine22(u), _regeneratorDefine22(u, o, "Generator"), _regeneratorDefine22(u, n, function() {
        return this;
      }), _regeneratorDefine22(u, "toString", function() {
        return "[object Generator]";
      }), (_regenerator2 = function _regenerator3() {
        return { w: i2, m: f };
      })();
    }
    function _regeneratorDefine22(e, r, n, t) {
      var i2 = Object.defineProperty;
      try {
        i2({}, "", {});
      } catch (e2) {
        i2 = 0;
      }
      _regeneratorDefine22 = function _regeneratorDefine(e2, r2, n2, t2) {
        function o(r3, n3) {
          _regeneratorDefine22(e2, r3, function(e3) {
            return this._invoke(r3, n3, e3);
          });
        }
        r2 ? i2 ? i2(e2, r2, { value: n2, enumerable: !t2, configurable: !t2, writable: !t2 }) : e2[r2] = n2 : (o("next", 0), o("throw", 1), o("return", 2));
      }, _regeneratorDefine22(e, r, n, t);
    }
    function asyncGeneratorStep2(n, t, e, r, o, a, c) {
      try {
        var i2 = n[a](c), u = i2.value;
      } catch (n2) {
        return void e(n2);
      }
      i2.done ? t(u) : Promise.resolve(u).then(r, o);
    }
    function _asyncToGenerator2(n) {
      return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
          var a = n.apply(t, e);
          function _next(n2) {
            asyncGeneratorStep2(a, r, o, _next, _throw, "next", n2);
          }
          function _throw(n2) {
            asyncGeneratorStep2(a, r, o, _next, _throw, "throw", n2);
          }
          _next(void 0);
        });
      };
    }
    var INTERVAL_TIME = 15;
    var JS_LOAD_TIMEOUT = 3e4;
    var SERVER_FETCH_FALLBACK_TIMEOUT = 15e3;
    var doesJsonpExist = function doesJsonpExist2(mediaId) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var url = (0, _utilities_media_data_js__WEBPACK_IMPORTED_MODULE_2__.CC)(mediaId, options);
      var matchUrl = url.replace(/\.json(?!p)/, ".jsonp").replace(/&$/, "");
      var isJsonpScriptInDom = (0, _utilities_script_utils_js__WEBPACK_IMPORTED_MODULE_1__.Rb)(matchUrl, {
        ignoreProtocol: true,
        scriptRegex: (0, _utilities_media_data_js__WEBPACK_IMPORTED_MODULE_2__.dq)(mediaId)
      });
      return Boolean(isJsonpScriptInDom);
    };
    var jsScriptUrl = function jsScriptUrl2(mediaId) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var host = (0, _utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.Dd)(options);
      return "".concat((0, _utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.v9)(), "//").concat(host, "/embed/").concat(mediaId, ".js");
    };
    var doesJsMediaDataScriptExist = function doesJsMediaDataScriptExist2(mediaId) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var url = jsScriptUrl(mediaId, options);
      var isJsScriptInDom = (0, _utilities_script_utils_js__WEBPACK_IMPORTED_MODULE_1__.Rb)(url, {
        ignoreProtocol: true
      });
      return Boolean(isJsScriptInDom);
    };
    var pollForJsonp = /* @__PURE__ */ (function() {
      var _ref = _asyncToGenerator2(/* @__PURE__ */ _regenerator2().m(function _callee(mediaId, options) {
        return _regenerator2().w(function(_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2, new Promise(function(resolve, reject) {
                var poll = -1;
                var checkForJsonp = function checkForJsonp2() {
                  var jsonp = window["wistiajsonp-/embed/medias/".concat(mediaId, ".jsonp")];
                  if (jsonp) {
                    if (jsonp.media) {
                      clearInterval(poll);
                      (0, _utilities_remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_5__.ry)(mediaId, jsonp.media);
                      (0, _utilities_fetchMediaData_ts__WEBPACK_IMPORTED_MODULE_8__.j)(mediaId, options).then(resolve).catch(function() {
                        reject(new Error("Failed to fetch media data via jsonp"));
                      });
                      return;
                    }
                    if ((0, _utilities_mediaDataError_ts__WEBPACK_IMPORTED_MODULE_6__.V)(jsonp)) {
                      clearInterval(poll);
                      resolve(jsonp);
                    }
                  }
                };
                checkForJsonp();
                poll = window.setInterval(checkForJsonp, INTERVAL_TIME);
                setTimeout(function() {
                  clearInterval(poll);
                  reject(new Error("Timeout loading jsonp media data"));
                }, JS_LOAD_TIMEOUT);
              }));
          }
        }, _callee);
      }));
      return function pollForJsonp2(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    })();
    var getJsScript = /* @__PURE__ */ (function() {
      var _ref2 = _asyncToGenerator2(/* @__PURE__ */ _regenerator2().m(function _callee3(mediaId) {
        var options, url, _args3 = arguments;
        return _regenerator2().w(function(_context3) {
          while (1) switch (_context3.n) {
            case 0:
              options = _args3.length > 1 && _args3[1] !== void 0 ? _args3[1] : {};
              url = jsScriptUrl(mediaId, options);
              return _context3.a(2, new Promise(function(resolve, reject) {
                setTimeout(function() {
                  reject(new Error("Timeout loading js media data"));
                }, JS_LOAD_TIMEOUT);
                void import(
                  /* webpackIgnore: true */
                  url
                ).then(function(module) {
                  var mediaData = module.mediaData;
                  (0, _utilities_remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_5__.ry)(mediaId, mediaData);
                }).then(/* @__PURE__ */ _asyncToGenerator2(/* @__PURE__ */ _regenerator2().m(function _callee2() {
                  return _regenerator2().w(function(_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        return _context2.a(2, (0, _utilities_fetchMediaData_ts__WEBPACK_IMPORTED_MODULE_8__.j)(mediaId, options));
                    }
                  }, _callee2);
                }))).then(resolve).catch(function(err) {
                  reject(err instanceof Error ? err : new Error(String(err)));
                });
              }));
          }
        }, _callee3);
      }));
      return function getJsScript2(_x3) {
        return _ref2.apply(this, arguments);
      };
    })();
    var fetchMediaDataDelayed = function fetchMediaDataDelayed2(mediaId) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var timeoutRef = {
        current: -1
      };
      var promise = new Promise(function(resolve, reject) {
        timeoutRef.current = window.setTimeout(function() {
          void (0, _utilities_fetchMediaData_ts__WEBPACK_IMPORTED_MODULE_8__.j)(mediaId, options).then(resolve).catch(function(err) {
            reject(err instanceof Error ? err : new Error(String(err)));
          });
        }, SERVER_FETCH_FALLBACK_TIMEOUT);
      });
      return [promise, timeoutRef];
    };
    var getInitialMediaData = /* @__PURE__ */ (function() {
      var _ref4 = _asyncToGenerator2(/* @__PURE__ */ _regenerator2().m(function _callee4(mediaId) {
        var _Wistia$_inlineMediaD;
        var options, mediaDataFromCache, inlineMediaData, clonedInlineMediaData, speedDemonPromises, mediaData, _fetchMediaDataDelaye, _fetchMediaDataDelaye2, delayedMediaDataPromise, delayedFetchTimeoutRef, _args4 = arguments;
        return _regenerator2().w(function(_context4) {
          while (1) switch (_context4.n) {
            case 0:
              options = _args4.length > 1 && _args4[1] !== void 0 ? _args4[1] : {};
              mediaDataFromCache = (0, _utilities_remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_5__.F2)(mediaId);
              if (!(mediaDataFromCache != null && options.skipCache !== true)) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2, (0, _utilities_fetchMediaData_ts__WEBPACK_IMPORTED_MODULE_8__.j)(mediaId, options));
            case 1:
              inlineMediaData = (_Wistia$_inlineMediaD = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s._inlineMediaData) === null || _Wistia$_inlineMediaD === void 0 ? void 0 : _Wistia$_inlineMediaD[mediaId];
              if (!(inlineMediaData != null)) {
                _context4.n = 2;
                break;
              }
              clonedInlineMediaData = (0, _utilities_obj_js__WEBPACK_IMPORTED_MODULE_7__.o8)(inlineMediaData);
              (0, _utilities_media_data_transforms_js__WEBPACK_IMPORTED_MODULE_4__.M)(clonedInlineMediaData, options);
              (0, _utilities_remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_5__.ry)(mediaId, clonedInlineMediaData);
              return _context4.a(2, (0, _utilities_fetchMediaData_ts__WEBPACK_IMPORTED_MODULE_8__.j)(mediaId, options));
            case 2:
              speedDemonPromises = [];
              if (doesJsonpExist(mediaId, options)) {
                speedDemonPromises.push(pollForJsonp(mediaId, options));
              }
              if (doesJsMediaDataScriptExist(mediaId, options)) {
                speedDemonPromises.push(getJsScript(mediaId, options));
              }
              if (!(speedDemonPromises.length === 0)) {
                _context4.n = 4;
                break;
              }
              _context4.n = 3;
              return (0, _utilities_fetchMediaData_ts__WEBPACK_IMPORTED_MODULE_8__.j)(mediaId, options);
            case 3:
              mediaData = _context4.v;
              _context4.n = 6;
              break;
            case 4:
              _fetchMediaDataDelaye = fetchMediaDataDelayed(mediaId, options), _fetchMediaDataDelaye2 = _slicedToArray2(_fetchMediaDataDelaye, 2), delayedMediaDataPromise = _fetchMediaDataDelaye2[0], delayedFetchTimeoutRef = _fetchMediaDataDelaye2[1];
              _context4.n = 5;
              return Promise.any([].concat(speedDemonPromises, [delayedMediaDataPromise]));
            case 5:
              mediaData = _context4.v;
              clearTimeout(delayedFetchTimeoutRef.current);
            case 6:
              return _context4.a(2, mediaData);
          }
        }, _callee4);
      }));
      return function getInitialMediaData2(_x4) {
        return _ref4.apply(this, arguments);
      };
    })();
  },
  /***/
  5857(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      CX: () => (
        /* binding */
        cdnFastWistiaComHost
      ),
      /* harmony export */
      Dd: () => (
        /* binding */
        mediaDataHost
      ),
      /* harmony export */
      KG: () => (
        /* binding */
        PROD_FASTLY_SSL_HOST
      ),
      /* harmony export */
      Qz: () => (
        /* binding */
        metricsHost
      ),
      /* harmony export */
      U4: () => (
        /* binding */
        TAGGED_VERSION2
      ),
      /* harmony export */
      aY: () => (
        /* binding */
        eV1HostWithPort
      ),
      /* harmony export */
      bC: () => (
        /* binding */
        eV1Host
      ),
      /* harmony export */
      bF: () => (
        /* binding */
        PROD_FAST_HOSTNAME_NET
      ),
      /* harmony export */
      cu: () => (
        /* binding */
        SSL_EMBED_HOST
      ),
      /* harmony export */
      hk: () => (
        /* binding */
        PROD_EMBED_HOST
      ),
      /* harmony export */
      iD: () => (
        /* binding */
        PROD_SSL_EMBED_HOST
      ),
      /* harmony export */
      kh: () => (
        /* binding */
        cdnFastWistiaNetHost
      ),
      /* harmony export */
      lR: () => (
        /* binding */
        CURRENT_SHA2
      ),
      /* harmony export */
      pK: () => (
        /* binding */
        EMBED_HOST
      ),
      /* harmony export */
      pb: () => (
        /* binding */
        PROD_FAST_HOSTNAME_COM
      ),
      /* harmony export */
      v9: () => (
        /* binding */
        eV1Protocol
      )
      /* harmony export */
    });
    var utilities_root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(8176);
    var utilities_url_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(2671);
    var _appHostname_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(787);
    var APP_WISTIA_COM = (0, _appHostname_js__WEBPACK_IMPORTED_MODULE_2__.Ni)("app");
    var CDN_FAST_PROTECTED_WISTIA_COM = (0, _appHostname_js__WEBPACK_IMPORTED_MODULE_2__.Ni)("fast-protected");
    var CDN_FAST_WISTIA_COM = (0, _appHostname_js__WEBPACK_IMPORTED_MODULE_2__.Ni)("fast");
    var CDN_FAST_WISTIA_CANARY = "fast-canary.wistia.net";
    var EMBED_HOST = "embed.wistia.com";
    var PROD_FAST_HOSTNAME_NET = "fast.wistia.net";
    var PROD_FAST_HOSTNAME_COM = "fast.wistia.com";
    var PROD_EMBED_HOST = "embed.wistia.com";
    var PROD_SSL_EMBED_HOST = "embed-ssl.wistia.com";
    var PROD_FASTLY_SSL_HOST = "embed-fastly.wistia.com";
    var SSL_EMBED_HOST = "embed-ssl.wistia.com";
    var TAGGED_VERSION2 = "0.6.10";
    var CURRENT_SHA2 = "f5c129aec7dc3d346d1afe4998baf044c7fe6147";
    var DEFAULT_PROTOCOL = (function() {
      if (typeof window !== "undefined" && utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z === window && utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z.location) {
        return utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z.location.protocol;
      }
      return "https:";
    })();
    var sslOrNonSsl = function sslOrNonSsl2(protocol, sslHost, nonSslHost) {
      return protocol === "https:" ? sslHost : nonSslHost;
    };
    var deliveryHost = function deliveryHost2() {
      var protocol = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_PROTOCOL;
      return sslOrNonSsl(protocol, SSL_EMBED_HOST, EMBED_HOST);
    };
    var appHost = function appHost2() {
      return APP_WISTIA_COM;
    };
    var getDevFastHostname = function getDevFastHostname2() {
      var fastDevHostname = (0, _appHostname_js__WEBPACK_IMPORTED_MODULE_2__.rY)("fast");
      if (fastDevHostname) {
        return fastDevHostname;
      }
      return null;
    };
    var cdnFastWistiaComHost = function cdnFastWistiaComHost2() {
      var embedHost = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      if (embedHost) {
        return embedHost;
      }
      var devFastHostname = getDevFastHostname();
      if (devFastHostname) {
        return devFastHostname;
      }
      return CDN_FAST_WISTIA_COM;
    };
    var cdnFastProtectedWistiaComHost = function cdnFastProtectedWistiaComHost2(assetHost) {
      if (assetHost) {
        return assetHost;
      }
      return CDN_FAST_PROTECTED_WISTIA_COM;
    };
    var cdnFastWistiaNetHost = function cdnFastWistiaNetHost2() {
      var devFastHostname = getDevFastHostname();
      if (devFastHostname) {
        return devFastHostname;
      }
      var hostName = "wistia.net";
      return "fast.".concat(hostName);
    };
    var cdnFastWistiaCanaryHost = function cdnFastWistiaCanaryHost2() {
      return CDN_FAST_WISTIA_CANARY;
    };
    var eV1Url = (function() {
      var scripts = document.getElementsByTagName("script");
      for (var i2 = 0; i2 < scripts.length; i2++) {
        var s = scripts[i2];
        if (s.src) {
          var url = new utilities_url_js__WEBPACK_IMPORTED_MODULE_1__.s0(s.src);
          var pathIsEv1 = /\/assets\/external\/E-v1?\.js$/.test(url.rawPath);
          var hasKnownHost = url.host === cdnFastWistiaComHost() || url.host === cdnFastWistiaNetHost() || url.host === cdnFastWistiaCanaryHost();
          var usesHttpsIfRequired = location.protocol === "https:" && url.protocol === "https:";
          var isProtocolRelative = url.protocol === "" || url.protocol == null;
          var protoIsSane = usesHttpsIfRequired || isProtocolRelative || location.protocol === "http:";
          var scriptHasLoaded = !s.readyState || /loaded|complete/.test(s.readyState);
          if (pathIsEv1 && hasKnownHost && protoIsSane && scriptHasLoaded) {
            return url;
          }
        }
      }
      return new utilities_url_js__WEBPACK_IMPORTED_MODULE_1__.s0("".concat((0, utilities_url_js__WEBPACK_IMPORTED_MODULE_1__.ff)(), "//").concat(cdnFastWistiaNetHost(), "/E-v1.js"));
    })();
    var eV1Host = function eV1Host2() {
      return eV1Url.host;
    };
    var eV1HostWithPort = function eV1HostWithPort2() {
      if (eV1Url.port) {
        return "".concat(eV1Host(), ":").concat(eV1Url.port);
      }
      return eV1Host();
    };
    var eV1Protocol = function eV1Protocol2() {
      return eV1Url.protocol;
    };
    var mediaDataHost = function mediaDataHost2() {
      var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      if (options.embedHost) {
        return forceValidFastWistiaHost(options.embedHost);
      }
      return eV1HostWithPort();
    };
    var metricsHost = function metricsHost2() {
      var hostname = false ? 0 : "wistia.com";
      return "pipedream.".concat(hostname);
    };
    var VALID_PRODUCTION_HOSTS = ["wistia.net", "wistia.com"];
    var VALID_FASTLY_HOSTS = [].concat(VALID_PRODUCTION_HOSTS, [
      "wistia.mx",
      // ngrok hosts
      "wistia.dev",
      "wistia.tech",
      "wistia.am",
      "wistia.se",
      "wistia.io",
      // development
      "wistia.st"
      // staging
    ]);
    var VALID_FASTLY_HOSTS_R = new RegExp("(".concat(VALID_FASTLY_HOSTS.map(function(h) {
      return "\\.".concat(h.replace(".", "\\."));
    }).join("|"), ")$"));
    var forceValidFastWistiaHost = function forceValidFastWistiaHost2(host) {
      if (host && VALID_FASTLY_HOSTS_R.test(host)) {
        return host;
      }
      return eV1HostWithPort();
    };
    var isEmbedOnACustomerPage = function isEmbedOnACustomerPage2() {
      return window.location.href.match(/^http(s)?:\/\/(\S)*.wistia.(io|test|st|com)/gi) === null;
    };
  },
  /***/
  6461(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {
    var utilities_script_utils_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(159);
    var getScriptTags = function getScriptTags2(htmlStr) {
      return htmlStr.match(/<script.*?src[^>]*>\s*<\/script>|<script.*?>[\s\S]+?<\/script>/gi) || [];
    };
    var scriptTagsToRunScriptsInput = function scriptTagsToRunScriptsInput(scriptTags) {
      if (!scriptTags) {
        return [];
      }
      if (!(scriptTags instanceof Array)) {
        scriptTags = getScriptTags(scriptTags);
      }
      var hashes = [];
      var _loop = function _loop() {
        var scriptTag = scriptTags[i];
        var hash = {};
        var matches = scriptTag.match(/<script.*?>/i);
        if (matches) {
          matches = matches[0].match(/src="([^"]+)"/i);
          if (matches) {
            hash.src = matches[1];
            hash.async = /async/i.test(scriptTag.replace(hash.src, ""));
          }
        }
        if (!matches) {
          matches = scriptTag.match(/<script>([\s\S]+?)<\/script>/i);
          if (matches) {
            var src = matches[1];
            hash.fn = function() {
              return eval(src);
            };
          }
        }
        hashes.push(hash);
      };
      for (var i = 0; i < scriptTags.length; i++) {
        _loop();
      }
      return hashes;
    };
    var execScriptTags = function execScriptTags2(scriptTags2, callback) {
      if (!scriptTags2) {
        return null;
      }
      var hashes2 = scriptTagsToRunScriptsInput(scriptTags2);
      return runScripts(hashes2).then(callback);
    };
    var removeScriptTags = function removeScriptTags2(htmlStr) {
      return htmlStr.replace(/<script.*?src[^>]*>\s*<\/script>|<script>[\s\S]+?<\/script>/g, "");
    };
  },
  /***/
  6462(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      I: () => (
        /* binding */
        PlayerDataHandler
      )
      /* harmony export */
    });
    var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(8089);
    var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__3.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
    var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(8290);
    var lodash_clonedeep__WEBPACK_IMPORTED_MODULE_1___default = /* @__PURE__ */ __webpack_require__3.n(lodash_clonedeep__WEBPACK_IMPORTED_MODULE_1__);
    var _utilities_obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(731);
    function _classCallCheck2(a, n) {
      if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties2(e, r) {
      for (var t = 0; t < r.length; t++) {
        var o = r[t];
        o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey2(o.key), o);
      }
    }
    function _createClass2(e, r, t) {
      return r && _defineProperties2(e.prototype, r), t && _defineProperties2(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    function _classPrivateMethodInitSpec2(e, a) {
      _checkPrivateRedeclaration2(e, a), a.add(e);
    }
    function _classPrivateFieldInitSpec2(e, t, a) {
      _checkPrivateRedeclaration2(e, t), t.set(e, a);
    }
    function _checkPrivateRedeclaration2(e, t) {
      if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldSet2(s, a, r) {
      return s.set(_assertClassBrand2(s, a), r), r;
    }
    function _classPrivateFieldGet2(s, a) {
      return s.get(_assertClassBrand2(s, a));
    }
    function _assertClassBrand2(e, t, n) {
      if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
      throw new TypeError("Private element is not present on this object");
    }
    var _embedOptionOverrides = /* @__PURE__ */ new WeakMap();
    var _embedOptions = /* @__PURE__ */ new WeakMap();
    var _mediaData = /* @__PURE__ */ new WeakMap();
    var _sourceEmbedOptions = /* @__PURE__ */ new WeakMap();
    var _sourceMediaData = /* @__PURE__ */ new WeakMap();
    var _PlayerDataHandler_brand = /* @__PURE__ */ new WeakSet();
    var PlayerDataHandler = /* @__PURE__ */ (function() {
      function PlayerDataHandler2() {
        _classCallCheck2(this, PlayerDataHandler2);
        _classPrivateMethodInitSpec2(this, _PlayerDataHandler_brand);
        _classPrivateFieldInitSpec2(this, _embedOptionOverrides, {});
        _classPrivateFieldInitSpec2(this, _embedOptions, {});
        _classPrivateFieldInitSpec2(this, _mediaData, {});
        _classPrivateFieldInitSpec2(this, _sourceEmbedOptions, {
          domOptions: {},
          iframeOptions: {},
          mediaDataOptions: {},
          wistiaWindowOptions: {}
        });
        _classPrivateFieldInitSpec2(this, _sourceMediaData, {});
      }
      return _createClass2(PlayerDataHandler2, [{
        key: "embedOptions",
        get: (
          /**
           * Returns the final embed options which are a merge of all the source data and the overrides
           * @returns {EmbedOptions}
           * @readonly
           */
          function get() {
            return _classPrivateFieldGet2(_embedOptions, this);
          }
        )
        /**
         * Returns the final media data which is a merge of all the source data
         * @returns {MediaData}
         * @readonly
         */
      }, {
        key: "mediaData",
        get: function get() {
          _classPrivateFieldGet2(_mediaData, this).embedOptions = _classPrivateFieldGet2(_embedOptions, this);
          return _classPrivateFieldGet2(_mediaData, this);
        }
        /**
         * Sets the source data for the embed options set on the <wistia-player> DOM element
         * @param {EmbedOptions} data
         * @returns {void}
         */
      }, {
        key: "setDomEmbedOptionSource",
        value: function setDomEmbedOptionSource(data) {
          _classPrivateFieldGet2(_sourceEmbedOptions, this).domOptions = data;
          _assertClassBrand2(_PlayerDataHandler_brand, this, _updatePlayerEmbedOptions).call(this);
        }
        /**
         * Sets the source data for the embed options from an iframe's url search params
         * @returns {void}
         */
      }, {
        key: "setIframeEmbedOptionSource",
        value: function setIframeEmbedOptionSource(data) {
          _classPrivateFieldGet2(_sourceEmbedOptions, this).iframeOptions = data;
          _assertClassBrand2(_PlayerDataHandler_brand, this, _updatePlayerEmbedOptions).call(this);
        }
        /**
         * Sets the source data for the media data
         * @param {MediaData} data
         * @returns {void}
         */
      }, {
        key: "setMediaDataSource",
        value: function setMediaDataSource(data) {
          var _cloneDeep;
          _classPrivateFieldSet2(_sourceMediaData, this, data);
          _classPrivateFieldSet2(_mediaData, this, (0, _utilities_obj_js__WEBPACK_IMPORTED_MODULE_2__.wg)(lodash_clonedeep__WEBPACK_IMPORTED_MODULE_1___default()(_classPrivateFieldGet2(_sourceMediaData, this))));
          if (_classPrivateFieldGet2(_mediaData, this).hashedId !== void 0) {
            _classPrivateFieldGet2(_mediaData, this).hashedId = _classPrivateFieldGet2(_mediaData, this).hashedId.toString();
          }
          _classPrivateFieldGet2(_sourceEmbedOptions, this).mediaDataOptions = (_cloneDeep = lodash_clonedeep__WEBPACK_IMPORTED_MODULE_1___default()(_classPrivateFieldGet2(_mediaData, this).embedOptions)) !== null && _cloneDeep !== void 0 ? _cloneDeep : {};
          _assertClassBrand2(_PlayerDataHandler_brand, this, _updatePlayerEmbedOptions).call(this);
        }
        /**
         * Sets the source data for the embed options set on the window via wistiaOptions
         * @param {EmbedOptions} data
         * @returns {void}
         */
      }, {
        key: "setWistiaWindowEmbedOptionSource",
        value: function setWistiaWindowEmbedOptionSource(data) {
          _classPrivateFieldGet2(_sourceEmbedOptions, this).wistiaWindowOptions = data;
          _assertClassBrand2(_PlayerDataHandler_brand, this, _updatePlayerEmbedOptions).call(this);
        }
        /**
         * Updates the embed option overrides which will be merged with the source embed option data
         * This merge can happen more frequently than our finite source data sets, which is why it's separate.
         * That way we don't have to re-merge the source data every time we update the overrides.
         * @param {EmbedOptions} data
         * @returns {void}
         */
      }, {
        key: "updateEmbedOptionOverrides",
        value: function updateEmbedOptionOverrides(data) {
          _classPrivateFieldSet2(_embedOptionOverrides, this, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(_classPrivateFieldGet2(_embedOptionOverrides, this), data));
          _classPrivateFieldSet2(_embedOptions, this, lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(_classPrivateFieldGet2(_embedOptions, this), _classPrivateFieldGet2(_embedOptionOverrides, this)));
        }
      }]);
    })();
    function _updatePlayerEmbedOptions() {
      var _classPrivateFieldGet22 = _classPrivateFieldGet2(_sourceEmbedOptions, this), mediaDataOptions = _classPrivateFieldGet22.mediaDataOptions, wistiaWindowOptions = _classPrivateFieldGet22.wistiaWindowOptions, domOptions = _classPrivateFieldGet22.domOptions, iframeOptions = _classPrivateFieldGet22.iframeOptions;
      _classPrivateFieldSet2(_embedOptions, this, (0, _utilities_obj_js__WEBPACK_IMPORTED_MODULE_2__.wg)(lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({}, mediaDataOptions !== null && mediaDataOptions !== void 0 ? mediaDataOptions : {}, wistiaWindowOptions !== null && wistiaWindowOptions !== void 0 ? wistiaWindowOptions : {}, domOptions !== null && domOptions !== void 0 ? domOptions : {}, iframeOptions !== null && iframeOptions !== void 0 ? iframeOptions : {}, _classPrivateFieldGet2(_embedOptionOverrides, this))));
      _classPrivateFieldGet2(_mediaData, this).embedOptions = _classPrivateFieldGet2(_embedOptions, this);
    }
  },
  /***/
  6633(__unused_webpack_module, exports) {
    var __webpack_unused_export__;
    __webpack_unused_export__ = { value: true };
    exports.fP = exports._N = exports.qg = exports.T1 = void 0;
    var numbers = "\\d+";
    var fractionalNumbers = "".concat(numbers, "(?:[\\.,]").concat(numbers, ")?");
    var datePattern = "(".concat(numbers, "Y)?(").concat(numbers, "M)?(").concat(numbers, "W)?(").concat(numbers, "D)?");
    var timePattern = "T(".concat(fractionalNumbers, "H)?(").concat(fractionalNumbers, "M)?(").concat(fractionalNumbers, "S)?");
    var iso8601 = "P(?:".concat(datePattern, "(?:").concat(timePattern, ")?)");
    var objMap = [
      "years",
      "months",
      "weeks",
      "days",
      "hours",
      "minutes",
      "seconds"
    ];
    var defaultDuration = Object.freeze({
      years: 0,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    });
    exports.T1 = new RegExp(iso8601);
    var parse2 = function(durationString) {
      var matches2 = durationString.replace(/,/g, ".").match(exports.T1);
      if (!matches2) {
        throw new RangeError("invalid duration: ".concat(durationString));
      }
      var slicedMatches = matches2.slice(1);
      if (slicedMatches.filter(function(v) {
        return v != null;
      }).length === 0) {
        throw new RangeError("invalid duration: ".concat(durationString));
      }
      if (slicedMatches.filter(function(v) {
        return /\./.test(v || "");
      }).length > 1) {
        throw new RangeError("only the smallest unit can be fractional");
      }
      return slicedMatches.reduce(function(prev, next, idx) {
        prev[objMap[idx]] = parseFloat(next || "0") || 0;
        return prev;
      }, {});
    };
    exports.qg = parse2;
    var end = function(durationInput, startDate) {
      if (startDate === void 0) {
        startDate = /* @__PURE__ */ new Date();
      }
      var duration = Object.assign({}, defaultDuration, durationInput);
      var timestamp = startDate.getTime();
      var then = new Date(timestamp);
      then.setFullYear(then.getFullYear() + duration.years);
      then.setMonth(then.getMonth() + duration.months);
      then.setDate(then.getDate() + duration.days);
      var hoursInMs = duration.hours * 3600 * 1e3;
      var minutesInMs = duration.minutes * 60 * 1e3;
      then.setMilliseconds(then.getMilliseconds() + duration.seconds * 1e3 + hoursInMs + minutesInMs);
      then.setDate(then.getDate() + duration.weeks * 7);
      return then;
    };
    exports._N = end;
    var toSeconds2 = function(durationInput, startDate) {
      if (startDate === void 0) {
        startDate = /* @__PURE__ */ new Date();
      }
      var duration = Object.assign({}, defaultDuration, durationInput);
      var timestamp = startDate.getTime();
      var now = new Date(timestamp);
      var then = (0, exports._N)(duration, now);
      var tzStart = startDate.getTimezoneOffset();
      var tzEnd = then.getTimezoneOffset();
      var tzOffsetSeconds = (tzStart - tzEnd) * 60;
      var seconds = (then.getTime() - now.getTime()) / 1e3;
      return seconds + tzOffsetSeconds;
    };
    exports.fP = toSeconds2;
    __webpack_unused_export__ = {
      end: exports._N,
      toSeconds: exports.fP,
      pattern: exports.T1,
      parse: exports.qg
    };
  },
  /***/
  6637(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      ct: () => (
        /* binding */
        wlog2
      )
      /* harmony export */
    });
    var utilities_globalBindAndTrigger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(4271);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    function _toConsumableArray(r) {
      return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray2(r) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return _arrayLikeToArray2(r);
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var ERROR = 0;
    var WARNING = 1;
    var NOTICE = 2;
    var INFO = 3;
    var DEBUG = 4;
    var LOG_LEVELS = {
      ERROR,
      WARNING,
      NOTICE,
      INFO,
      DEBUG,
      error: ERROR,
      warning: WARNING,
      notice: NOTICE,
      info: INFO,
      debug: DEBUG
    };
    var NOOP = function NOOP2() {
    };
    var Logger = function Logger2(ctx) {
      var self2 = this;
      if (ctx == null) {
        ctx = {};
      }
      var construct = function construct2() {
        self2.ctx = ctx;
        if (!self2.ctx.initializedAt) {
          self2.reset();
        }
      };
      self2.error = function() {
        for (var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++) {
          messages[_key] = arguments[_key];
        }
        return self2.log(ERROR, messages);
      };
      self2.warn = function() {
        for (var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          messages[_key2] = arguments[_key2];
        }
        return self2.log(WARNING, messages);
      };
      self2.notice = function() {
        for (var _len3 = arguments.length, messages = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          messages[_key3] = arguments[_key3];
        }
        return self2.log(WARNING, messages);
      };
      self2.info = function() {
        for (var _len4 = arguments.length, messages = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          messages[_key4] = arguments[_key4];
        }
        return self2.log(INFO, messages);
      };
      self2.debug = function() {
        for (var _len5 = arguments.length, messages = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          messages[_key5] = arguments[_key5];
        }
        return self2.log(DEBUG, messages);
      };
      construct();
      return self2;
    };
    var lproto = Logger.prototype;
    lproto.reset = function() {
      this.ctx.level = ERROR;
      this.ctx.grep = null;
      this.ctx.grepv = null;
      this.ctx.first1000LogLines = [];
      this.ctx.last1000LogLines = [];
      this.ctx.initializedAt = (/* @__PURE__ */ new Date()).getTime();
    };
    lproto.setLevel = function(level) {
      var logFunc = this.logFunc(INFO);
      if (LOG_LEVELS[level] != null) {
        this.ctx.level = LOG_LEVELS[level];
        logFunc('Log level set to "'.concat(level, '" (').concat(LOG_LEVELS[level], ")"));
      } else {
        logFunc('Unknown log level "'.concat(level, '"'));
      }
    };
    lproto.setGrep = function(grep) {
      this.ctx.grep = grep;
    };
    lproto.setGrepv = function(grepv) {
      this.ctx.grepv = grepv;
    };
    lproto.first1000LogLines = function() {
      return this.ctx.first1000LogLines;
    };
    lproto.last1000LogLines = function() {
      return this.ctx.last1000LogLines;
    };
    lproto.matchedGrep = function(messages) {
      var matched = false;
      if (this.ctx.grep || this.ctx.grepv) {
        var messageStrings = [];
        for (var i2 = 0; i2 < messages.length; i2++) {
          try {
            var message = messages[i2];
            messageStrings.push(message.toString && message.toString());
          } catch (e) {
            messageStrings.push("");
          }
        }
        var fullLine = messageStrings.join(" ");
        var matchesGrep = !this.ctx.grep || fullLine.match(this.ctx.grep);
        var matchesGrepv = !this.ctx.grepv || !fullLine.match(this.ctx.grepv);
        matched = matchesGrep && matchesGrepv;
      } else {
        matched = true;
      }
      return matched;
    };
    lproto.now = function() {
      if (typeof performance !== "undefined" && typeof performance.now === "function") {
        return performance.now().toFixed(3);
      }
      if (Date.now) {
        return Date.now() - this.ctx.initializedAt;
      }
      return (/* @__PURE__ */ new Date()).getTime() - this.ctx.initializedAt;
    };
    lproto.messagesToLogLine = function(level, time, messages) {
      var logLine = [level, time];
      logLine = logLine.concat(messages);
      var cappedLine;
      try {
        cappedLine = logLine.join(" ") || "";
        if (cappedLine.length > 200) {
          cappedLine = cappedLine.slice(0, 200);
        }
      } catch (e1) {
        cappedLine = "could not serialize";
      }
      return cappedLine;
    };
    lproto.persistLine = function(logLine) {
      if (this.ctx.first1000LogLines.length < 1e3) {
        this.ctx.first1000LogLines.push(logLine);
      } else {
        if (this.ctx.last1000LogLines.length >= 1e3) {
          this.ctx.last1000LogLines.shift();
        }
        this.ctx.last1000LogLines.push(logLine);
      }
    };
    lproto.log = function(level, messages) {
      var withinLevel = level <= this.ctx.level;
      var notDebug = level < DEBUG;
      var matched = (withinLevel || notDebug) && this.matchedGrep(messages);
      if (level === ERROR) {
        (0, utilities_globalBindAndTrigger_js__WEBPACK_IMPORTED_MODULE_0__.mj)("problem", {
          type: "error-logged",
          data: {
            messages
          }
        });
      }
      var now;
      if (matched && (withinLevel || notDebug)) {
        now = this.now();
      }
      if (notDebug && matched) {
        var logLine = this.messagesToLogLine(level, now, messages);
        this.persistLine(logLine);
      }
      if (withinLevel && matched) {
        var logFunc = this.logFunc(level);
        var e;
        if (messages.length === 1 && (e = messages[0]) instanceof Error) {
          logFunc(e.message);
          if (e.stack) {
            logFunc(e.stack);
          }
        } else {
          logFunc.apply(void 0, _toConsumableArray(messages));
        }
      }
    };
    var logError = function logError2() {
      for (var _len6 = arguments.length, messages = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        messages[_key6] = arguments[_key6];
      }
      console.error.apply(console, messages);
    };
    var logWarn = function logWarn2() {
      for (var _len7 = arguments.length, messages = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        messages[_key7] = arguments[_key7];
      }
      console.warn.apply(console, messages);
    };
    var logInfo = function logInfo2() {
      for (var _len8 = arguments.length, messages = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        messages[_key8] = arguments[_key8];
      }
      console.info.apply(console, messages);
    };
    var logDebug = function logDebug2() {
      for (var _len9 = arguments.length, messages = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
        messages[_key9] = arguments[_key9];
      }
      console.debug.apply(console, messages);
    };
    var logLog = function logLog2(messages) {
      console.log.apply(console, messages);
    };
    lproto.logFunc = function(level) {
      if (level == null) {
        level = this.level;
      }
      if (!console) {
        return NOOP;
      }
      var func;
      if (level === ERROR) {
        func = logError;
      } else if (level === WARNING) {
        func = logWarn;
      } else if (level === INFO) {
        func = logInfo;
      } else if (level === DEBUG) {
        func = logDebug;
      }
      if (!func) {
        func = logLog;
      }
      if (typeof func !== "function") {
        this.noConsoleLog = true;
        func = NOOP;
      }
      return func;
    };
    lproto.maybePrefix = function(prefix, messages) {
      if (prefix) {
        if (typeof prefix === "function") {
          try {
            prefix = prefix();
          } catch (e) {
            prefix = 'prefix err "'.concat(e.message, '"');
          }
        }
        if (prefix instanceof Array) {
          return prefix.concat(messages);
        }
        return [prefix].concat(messages);
      }
      return messages;
    };
    lproto.getPrefixedFunctions = function(prefix) {
      var _this = this;
      return {
        log: function log() {
          for (var _len0 = arguments.length, messages = new Array(_len0), _key0 = 0; _key0 < _len0; _key0++) {
            messages[_key0] = arguments[_key0];
          }
          return _this.log(ERROR, _this.maybePrefix(prefix, messages));
        },
        error: function error() {
          for (var _len1 = arguments.length, messages = new Array(_len1), _key1 = 0; _key1 < _len1; _key1++) {
            messages[_key1] = arguments[_key1];
          }
          return _this.log(ERROR, _this.maybePrefix(prefix, messages));
        },
        warn: function warn() {
          for (var _len10 = arguments.length, messages = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
            messages[_key10] = arguments[_key10];
          }
          return _this.log(WARNING, _this.maybePrefix(prefix, messages));
        },
        notice: function notice() {
          for (var _len11 = arguments.length, messages = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
            messages[_key11] = arguments[_key11];
          }
          return _this.log(WARNING, _this.maybePrefix(prefix, messages));
        },
        info: function info() {
          for (var _len12 = arguments.length, messages = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
            messages[_key12] = arguments[_key12];
          }
          return _this.log(INFO, _this.maybePrefix(prefix, messages));
        },
        debug: function debug() {
          for (var _len13 = arguments.length, messages = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
            messages[_key13] = arguments[_key13];
          }
          return _this.log(DEBUG, _this.maybePrefix(prefix, messages));
        }
      };
    };
    if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s && _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.wlogCtx == null) {
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.wlogCtx = {};
    }
    var wlog2 = new Logger(_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.wlogCtx);
  },
  /***/
  6906(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Fn: () => (
        /* binding */
        BigPlayButton
      )
      /* harmony export */
    });
    var preact__WEBPACK_IMPORTED_MODULE_0__2 = __webpack_require__3(5181);
    var preact_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(3817);
    var _svgs_BigPlayButtonSVG_tsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(7880);
    var _shared_translations_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(4730);
    var _utilities_color_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(5417);
    var _utilities_core_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(1627);
    var _utilities_detect_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__3(7231);
    var _utilities_duration_ts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__3(1341);
    var _utilities_interFontFamily_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__3(8213);
    var _utilities_color_utils_ts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__3(998);
    function ownKeys2(e, r) {
      var t = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r2) {
          return Object.getOwnPropertyDescriptor(e, r2).enumerable;
        })), t.push.apply(t, o);
      }
      return t;
    }
    function _objectSpread2(e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
          _defineProperty2(e, r2, t[r2]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
          Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
        });
      }
      return e;
    }
    function _defineProperty2(e, r, t) {
      return (r = _toPropertyKey2(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
    }
    function _toPropertyKey2(t) {
      var i2 = _toPrimitive2(t, "string");
      return "symbol" == typeof i2 ? i2 : i2 + "";
    }
    function _toPrimitive2(t, r) {
      if ("object" != typeof t || !t) return t;
      var e = t[Symbol.toPrimitive];
      if (void 0 !== e) {
        var i2 = e.call(t, r || "default");
        if ("object" != typeof i2) return i2;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === r ? String : Number)(t);
    }
    function _slicedToArray2(r, e) {
      return _arrayWithHoles2(r) || _iterableToArrayLimit2(r, e) || _unsupportedIterableToArray2(r, e) || _nonIterableRest2();
    }
    function _nonIterableRest2() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _iterableToArrayLimit2(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i2, u, a = [], f = true, o = false;
        try {
          if (i2 = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = false;
          } else for (; !(f = (e = i2.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles2(r) {
      if (Array.isArray(r)) return r;
    }
    var detect = (0, _utilities_detect_js__WEBPACK_IMPORTED_MODULE_6__.o1)();
    var BASE_BUTTON_WIDTH = 125;
    var BASE_BUTTON_HEIGHT = 80;
    var BASE_FONT_SIZE = 18;
    var BASE_LINE_HEIGHT = 30;
    var ALPHA_MIX_BLEND_MODE = 0.7;
    var ALPHA_NO_MIX_BLEND_MODE = 0.85;
    var BigPlayButton = function BigPlayButton2(_ref) {
      var backgroundGradientCss = _ref.backgroundGradientCss, _ref$baseHeight = _ref.baseHeight, baseHeight = _ref$baseHeight === void 0 ? BASE_BUTTON_HEIGHT : _ref$baseHeight, _ref$baseWidth = _ref.baseWidth, baseWidth = _ref$baseWidth === void 0 ? BASE_BUTTON_WIDTH : _ref$baseWidth, borderRadius = _ref.borderRadius, buttonTabIndex = _ref.buttonTabIndex, color = _ref.color, _ref$controlBarDistan = _ref.controlBarDistance, controlBarDistance = _ref$controlBarDistan === void 0 ? 0 : _ref$controlBarDistan, duration = _ref.duration, elemRef = _ref.elemRef, hasContrastIcons = _ref.hasContrastIcons, isLiveMedia = _ref.isLiveMedia, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$isOpaque = _ref.isOpaque, isOpaque = _ref$isOpaque === void 0 ? false : _ref$isOpaque, isVisible = _ref.isVisible, _ref$leftNudgeFractio = _ref.leftNudgeFraction, leftNudgeFraction = _ref$leftNudgeFractio === void 0 ? 0 : _ref$leftNudgeFractio, _ref$noMixBlendMode = _ref.noMixBlendMode, noMixBlendMode = _ref$noMixBlendMode === void 0 ? false : _ref$noMixBlendMode, onClick = _ref.onClick, playerLanguage = _ref.playerLanguage, scale = _ref.scale, showBpbTime = _ref.showBpbTime, _ref$topNudgeFraction = _ref.topNudgeFraction, topNudgeFraction = _ref$topNudgeFraction === void 0 ? 0 : _ref$topNudgeFraction, videoName = _ref.videoName, videoWidth = _ref.videoWidth;
      var _useState = (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useState)(false), _useState2 = _slicedToArray2(_useState, 2), isFocused = _useState2[0], setIsFocused = _useState2[1];
      var scaledWidth = baseWidth * scale;
      var scaledHeight = baseHeight * scale;
      var translate = function translate2(key) {
        return (0, _shared_translations_js__WEBPACK_IMPORTED_MODULE_3__.sC)(playerLanguage.code, "PLAY_BUTTON_".concat(key));
      };
      var unescapedVideoName = (0, _utilities_core_js__WEBPACK_IMPORTED_MODULE_5__.Uh)(videoName);
      var ariaLabel = "".concat(translate("TITLE_WHEN_NOT_PLAYING"), ": ").concat(unescapedVideoName);
      var wrapperStyle = {
        borderRadius: "".concat(borderRadius, "px"),
        display: isVisible ? "block" : "none",
        left: "calc(50% + ".concat((leftNudgeFraction || 0) * 100, "%)"),
        marginLeft: "-".concat(scaledWidth / 2, "px"),
        marginTop: "-".concat(scaledHeight / 2, "px"),
        overflow: "hidden",
        position: "absolute",
        top: "calc(50% + ".concat((topNudgeFraction || 0) * 100, "% - ").concat(controlBarDistance, "px)"),
        boxShadow: isOpaque ? "0 3px 5px rgba(0,0,0,0.3)" : void 0
      };
      var shouldMixBlendMode = !detect.edge && !noMixBlendMode;
      var blendColor = new _utilities_color_js__WEBPACK_IMPORTED_MODULE_4__.Q1(color !== null && color !== void 0 ? color : "#000").alpha(1);
      var blendStyle = {
        background: blendColor.toRgba(),
        display: shouldMixBlendMode ? "block" : "none",
        left: 0,
        height: "".concat(scaledHeight, "px"),
        mixBlendMode: "darken",
        position: "absolute",
        top: 0,
        width: "".concat(scaledWidth, "px")
      };
      var shouldUseGradient = backgroundGradientCss != null;
      var playerColorObj = new _utilities_color_js__WEBPACK_IMPORTED_MODULE_4__.Q1(color !== null && color !== void 0 ? color : "#000000");
      var hoverButtonColor = (0, _utilities_color_utils_ts__WEBPACK_IMPORTED_MODULE_9__.ui)(playerColorObj, playerColorObj, "nonText");
      var overlayColor = isFocused ? hoverButtonColor : playerColorObj;
      var overlayAlphaValue = shouldMixBlendMode ? ALPHA_MIX_BLEND_MODE : ALPHA_NO_MIX_BLEND_MODE;
      var overlayColorObj = new _utilities_color_js__WEBPACK_IMPORTED_MODULE_4__.Q1(overlayColor);
      var playerIconColor = (0, _utilities_color_utils_ts__WEBPACK_IMPORTED_MODULE_9__.hu)(playerColorObj, hasContrastIcons, shouldUseGradient);
      var hoverIconColor = hasContrastIcons ? (0, _utilities_color_utils_ts__WEBPACK_IMPORTED_MODULE_9__.ui)(playerIconColor, hoverButtonColor, "paragraphText") : "#fff";
      overlayColorObj.alpha(isOpaque ? 1 : overlayAlphaValue);
      var gradientStyles = shouldUseGradient ? {
        background: backgroundGradientCss,
        backgroundSize: "".concat(videoWidth, "px 100%"),
        backgroundPositionX: "center"
      } : {};
      if (shouldUseGradient) {
        hoverIconColor = "#ffffff";
        hoverButtonColor = "rgba(0,0,0,0.4)";
      }
      var overlayStyle = _objectSpread2(_objectSpread2({
        backgroundColor: overlayColorObj.toRgba()
      }, gradientStyles), {}, {
        height: "".concat(scaledHeight, "px"),
        left: 0,
        position: "absolute",
        top: 0,
        transition: "background-color 150ms",
        width: "".concat(scaledWidth, "px")
      });
      var buttonStyle = {
        backgroundColor: "transparent",
        border: 0,
        color: isFocused ? hoverIconColor : playerIconColor,
        cursor: "pointer",
        height: "".concat(scaledHeight, "px"),
        boxShadow: "none",
        width: "".concat(scaledWidth, "px")
      };
      var shouldDisplayDuration = showBpbTime && !isLiveMedia;
      var timeStyle = {
        background: "rgba(0,0,0,.4)",
        color: "#fff",
        fontFamily: _utilities_interFontFamily_js__WEBPACK_IMPORTED_MODULE_8__.w5,
        fontSize: "".concat(BASE_FONT_SIZE * scale, "px"),
        lineHeight: "".concat(BASE_LINE_HEIGHT * scale, "px"),
        pointerEvents: "none",
        textAlign: "center"
      };
      var handleIsFocused = function handleIsFocused2() {
        setIsFocused(true);
      };
      var handleNotFocused = function handleNotFocused2() {
        setIsFocused(false);
      };
      return (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("div", {
        class: "w-bpb-wrapper w-css-reset w-css-reset-tree",
        ref: elemRef,
        style: wrapperStyle
      }, (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("button", {
        class: "w-big-play-button w-css-reset-button-important w-vulcan-v2-button",
        style: buttonStyle,
        onMouseEnter: handleIsFocused,
        onMouseLeave: handleNotFocused,
        onFocusIn: handleIsFocused,
        onFocusOut: handleNotFocused,
        onClick,
        "aria-label": ariaLabel,
        tabIndex: buttonTabIndex,
        type: "button"
      }, (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("div", {
        style: blendStyle
      }), (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("div", {
        style: overlayStyle
      }), (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)(_svgs_BigPlayButtonSVG_tsx__WEBPACK_IMPORTED_MODULE_2__.R, {
        width: baseWidth,
        height: baseHeight,
        scale,
        isLoading,
        overrideFillColor: isFocused ? hoverIconColor : playerIconColor
      })), shouldDisplayDuration ? (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("div", {
        class: "w-bpb-time",
        style: timeStyle
      }, (0, _utilities_duration_ts__WEBPACK_IMPORTED_MODULE_7__.G5)(duration)) : null);
    };
  },
  /***/
  7157(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      $: () => (
        /* binding */
        dynamicImport2
      )
      /* harmony export */
    });
    var _hosts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(5857);
    var _objectHasOwn = function(object, property) {
      if (typeof object === "undefined" || object === null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    };
    function _regenerator2() {
      var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
      function i2(r2, n2, o2, i3) {
        var c2 = n2 && n2.prototype instanceof Generator ? n2 : Generator, u2 = Object.create(c2.prototype);
        return _regeneratorDefine22(u2, "_invoke", (function(r3, n3, o3) {
          var i4, c3, u3, f2 = 0, p = o3 || [], y = false, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d2(t2, r4) {
            return i4 = t2, c3 = 0, u3 = e, G.n = r4, a;
          } };
          function d(r4, n4) {
            for (c3 = r4, u3 = n4, t = 0; !y && f2 && !o4 && t < p.length; t++) {
              var o4, i5 = p[t], d2 = G.p, l = i5[2];
              r4 > 3 ? (o4 = l === n4) && (u3 = i5[(c3 = i5[4]) ? 5 : (c3 = 3, 3)], i5[4] = i5[5] = e) : i5[0] <= d2 && ((o4 = r4 < 2 && d2 < i5[1]) ? (c3 = 0, G.v = n4, G.n = i5[1]) : d2 < l && (o4 = r4 < 3 || i5[0] > n4 || n4 > l) && (i5[4] = r4, i5[5] = n4, G.n = l, c3 = 0));
            }
            if (o4 || r4 > 1) return a;
            throw y = true, n4;
          }
          return function(o4, p2, l) {
            if (f2 > 1) throw TypeError("Generator is already running");
            for (y && 1 === p2 && d(p2, l), c3 = p2, u3 = l; (t = c3 < 2 ? e : u3) || !y; ) {
              i4 || (c3 ? c3 < 3 ? (c3 > 1 && (G.n = -1), d(c3, u3)) : G.n = u3 : G.v = u3);
              try {
                if (f2 = 2, i4) {
                  if (c3 || (o4 = "next"), t = i4[o4]) {
                    if (!(t = t.call(i4, u3))) throw TypeError("iterator result is not an object");
                    if (!t.done) return t;
                    u3 = t.value, c3 < 2 && (c3 = 0);
                  } else 1 === c3 && (t = i4.return) && t.call(i4), c3 < 2 && (u3 = TypeError("The iterator does not provide a '" + o4 + "' method"), c3 = 1);
                  i4 = e;
                } else if ((t = (y = G.n < 0) ? u3 : r3.call(n3, G)) !== a) break;
              } catch (t2) {
                i4 = e, c3 = 1, u3 = t2;
              } finally {
                f2 = 1;
              }
            }
            return { value: t, done: y };
          };
        })(r2, o2, i3), true), u2;
      }
      var a = {};
      function Generator() {
      }
      function GeneratorFunction() {
      }
      function GeneratorFunctionPrototype() {
      }
      t = Object.getPrototypeOf;
      var c = [][n] ? t(t([][n]())) : (_regeneratorDefine22(t = {}, n, function() {
        return this;
      }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
      function f(e2) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e2, GeneratorFunctionPrototype) : (e2.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine22(e2, o, "GeneratorFunction")), e2.prototype = Object.create(u), e2;
      }
      return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine22(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine22(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine22(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine22(u), _regeneratorDefine22(u, o, "Generator"), _regeneratorDefine22(u, n, function() {
        return this;
      }), _regeneratorDefine22(u, "toString", function() {
        return "[object Generator]";
      }), (_regenerator2 = function _regenerator3() {
        return { w: i2, m: f };
      })();
    }
    function _regeneratorDefine22(e, r, n, t) {
      var i2 = Object.defineProperty;
      try {
        i2({}, "", {});
      } catch (e2) {
        i2 = 0;
      }
      _regeneratorDefine22 = function _regeneratorDefine(e2, r2, n2, t2) {
        function o(r3, n3) {
          _regeneratorDefine22(e2, r3, function(e3) {
            return this._invoke(r3, n3, e3);
          });
        }
        r2 ? i2 ? i2(e2, r2, { value: n2, enumerable: !t2, configurable: !t2, writable: !t2 }) : e2[r2] = n2 : (o("next", 0), o("throw", 1), o("return", 2));
      }, _regeneratorDefine22(e, r, n, t);
    }
    function asyncGeneratorStep2(n, t, e, r, o, a, c) {
      try {
        var i2 = n[a](c), u = i2.value;
      } catch (n2) {
        return void e(n2);
      }
      i2.done ? t(u) : Promise.resolve(u).then(r, o);
    }
    function _asyncToGenerator2(n) {
      return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
          var a = n.apply(t, e);
          function _next(n2) {
            asyncGeneratorStep2(a, r, o, _next, _throw, "next", n2);
          }
          function _throw(n2) {
            asyncGeneratorStep2(a, r, o, _next, _throw, "throw", n2);
          }
          _next(void 0);
        });
      };
    }
    var dynamicImport2 = /* @__PURE__ */ (function() {
      var _ref = _asyncToGenerator2(/* @__PURE__ */ _regenerator2().m(function _callee(filePath) {
        var options, host, taggedVersion, currentSha, _args = arguments;
        return _regenerator2().w(function(_context) {
          while (1) switch (_context.n) {
            case 0:
              options = _args.length > 1 && _args[1] !== void 0 ? _args[1] : {};
              host = _objectHasOwn(options, "host") && options.host != null ? options.host : (0, _hosts_js__WEBPACK_IMPORTED_MODULE_0__.aY)();
              taggedVersion = _hosts_js__WEBPACK_IMPORTED_MODULE_0__.U4;
              currentSha = _hosts_js__WEBPACK_IMPORTED_MODULE_0__.lR;
              if (!(taggedVersion !== "" && taggedVersion.length > 0 && options.mediaData !== true)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, import(
                /* webpackIgnore: true */
                "".concat((0, _hosts_js__WEBPACK_IMPORTED_MODULE_0__.v9)(), "//").concat(host, "/").concat(filePath, "@").concat(taggedVersion)
              ));
            case 1:
              if (!(currentSha !== "" && currentSha.length > 0 && options.mediaData !== true)) {
                _context.n = 2;
                break;
              }
              return _context.a(2, import(
                /* webpackIgnore: true */
                "".concat((0, _hosts_js__WEBPACK_IMPORTED_MODULE_0__.v9)(), "//").concat(host, "/").concat(filePath, "@").concat(currentSha)
              ));
            case 2:
              return _context.a(2, import(
                /* webpackIgnore: true */
                "".concat((0, _hosts_js__WEBPACK_IMPORTED_MODULE_0__.v9)(), "//").concat(host, "/").concat(filePath)
              ));
          }
        }, _callee);
      }));
      return function dynamicImport3(_x) {
        return _ref.apply(this, arguments);
      };
    })();
  },
  /***/
  7209(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Fi: () => (
        /* binding */
        readyPublicMp4s
      ),
      /* harmony export */
      Q0: () => (
        /* binding */
        thumbnailAssets
      ),
      /* harmony export */
      Wz: () => (
        /* binding */
        stillUrl
      ),
      /* harmony export */
      aF: () => (
        /* binding */
        nonfailedPublicOver400
      ),
      /* harmony export */
      n9: () => (
        /* binding */
        readyPublicOver400
      ),
      /* harmony export */
      o2: () => (
        /* binding */
        readyPublicMp3s
      ),
      /* harmony export */
      pb: () => (
        /* binding */
        filter
      ),
      /* harmony export */
      tt: () => (
        /* binding */
        findClosestAssetByQuality
      ),
      /* harmony export */
      x4: () => (
        /* binding */
        readyPublicM3u8s
      ),
      /* harmony export */
      yE: () => (
        /* binding */
        READY
      )
      /* harmony export */
    });
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var utilities_url_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(2671);
    var utilities_detect_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(7231);
    var utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(5857);
    var utilities_wlog_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(6637);
    var _appHostname_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(787);
    function _slicedToArray2(r, e) {
      return _arrayWithHoles2(r) || _iterableToArrayLimit2(r, e) || _unsupportedIterableToArray2(r, e) || _nonIterableRest2();
    }
    function _nonIterableRest2() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _iterableToArrayLimit2(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i2, u, a = [], f = true, o = false;
        try {
          if (i2 = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = false;
          } else for (; !(f = (e = i2.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles2(r) {
      if (Array.isArray(r)) return r;
    }
    var aps = Array.prototype.slice;
    var FAILED = -1;
    var QUEUED = 0;
    var PROCESSING = 1;
    var READY = 2;
    var FILTER_KEYS = ["select", "sortFn", "sortBy", "unique"];
    var filter = function filter2(assets) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (!assets) {
        return [];
      }
      if (assets.assets) {
        assets = assets.assets;
      }
      if (options.qualityMin != null || options.qualityMax != null) {
        assets = withinQualityRange(assets, options.qualityMin, options.qualityMax);
        options = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.iu)(options, ["qualityMin", "qualityMax"]);
      }
      var filterOptions = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.j6)(options, FILTER_KEYS);
      var selectFn = filterOptions.select || (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.iu)(options, FILTER_KEYS);
      if (selectFn) {
        filterOptions.select = selectFn;
      }
      var result = filterOptions.select ? (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.Lt)(assets, filterOptions.select) : (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.o8)(assets);
      if (filterOptions.sortFn || filterOptions.sortBy) {
        result = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.di)(result, filterOptions.sortFn || filterOptions.sortBy);
      }
      if (filterOptions.unique) {
        var uniqHash = {};
        for (var i2 = 0; i2 < result.length; i2++) {
          var asset = result[i2];
          var bucket = asset["".concat(filterOptions.unique)] || "__undefined__";
          if (!uniqHash[bucket]) {
            uniqHash[bucket] = asset;
          }
        }
        result = [];
        for (var k in uniqHash) {
          result.push(uniqHash[k]);
        }
      }
      return result;
    };
    var one = function one2(assets, options) {
      return filter(assets, options)[0] || null;
    };
    var readyPublicMp3s = function readyPublicMp3s2(assets) {
      return filter(assets, {
        ext: "mp3",
        status: READY,
        public: true
      });
    };
    var readyPublicMp4s = function readyPublicMp4s2(assets) {
      return filter(assets, {
        container: "mp4",
        status: READY,
        public: true
      });
    };
    var readyPublicM3u8s = function readyPublicM3u8s2(assets) {
      return filter(assets, {
        container: "m3u8",
        status: READY,
        public: true
      });
    };
    var filterOver400 = function filterOver4002(assets) {
      var result = [];
      for (var i2 = 0; i2 < assets.length; i2++) {
        var a = assets[i2];
        var vbitrateInRange = a.opt_vbitrate != null && a.opt_vbitrate >= 500 && a.opt_vbitrate <= 1e5;
        var widthInRange = a.width != null && a.width > 400;
        if (vbitrateInRange || widthInRange) {
          result.push(a);
        }
      }
      return result;
    };
    var readyPublicOver400 = function readyPublicOver4002(assets) {
      return filterOver400(filter(assets, {
        container: /mp4/,
        public: true,
        status: READY
      }));
    };
    var nonfailedPublicOver400 = function nonfailedPublicOver4002(assets) {
      return filterOver400(filter(assets, {
        container: /mp4/,
        public: true,
        status: function status(s) {
          return s !== FAILED;
        }
      }));
    };
    var withinQualityRange = function withinQualityRange2(assets) {
      var qualityMin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
      var qualityMax = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e4;
      return filter(assets, {
        select: function select(asset) {
          var quality = numericSizeSnapped(asset.width, asset.height);
          return qualityMin <= quality && quality <= qualityMax;
        }
      });
    };
    var numericSizeSnapped = function numericSizeSnapped2(width, height) {
      if (height > width) {
        var tmpWidth = width;
        width = height;
        height = tmpWidth;
      }
      var aspectRatio = width / height;
      if (aspectRatio < 1.05) {
        width = height * (16 / 9);
      }
      if (width >= 3740) {
        return 2160;
      }
      if (width >= 3100) {
        return 1800;
      }
      if (width >= 2460) {
        return 1440;
      }
      if (width >= 1820) {
        return 1080;
      }
      if (width >= 1180) {
        return 720;
      }
      if (width >= 860) {
        return 540;
      }
      if (width >= 540) {
        return 360;
      }
      return height;
    };
    var findClosestAssetByQuality = function findClosestAssetByQuality2(assets, quality) {
      var height;
      if (quality === "4k") {
        height = 2160;
      } else {
        height = parseInt(quality, 10);
      }
      var exactMatch = withinQualityRange(assets, height, height)[0];
      if (exactMatch) {
        return exactMatch;
      }
      var surroundingAssets = nearestOutsideRange(assets, height, height);
      if (surroundingAssets.length === 1) {
        return surroundingAssets[0];
      }
      var aspect = videoAspect(assets);
      var width = Math.round(aspect * height);
      var _surroundingAssets = _slicedToArray2(surroundingAssets, 2), lowerAsset = _surroundingAssets[0], upperAsset = _surroundingAssets[1];
      var lowerDiff = Math.abs(lowerAsset.width - width);
      var upperDiff = Math.abs(upperAsset.width - width);
      if (lowerDiff < upperDiff) {
        return lowerAsset;
      }
      return upperAsset;
    };
    var still = function still2(assets) {
      var stillAsset = one(assets, {
        type: /^still_image$/,
        sortBy: "created_at desc"
      });
      if (!stillAsset) {
        stillAsset = channelArtworkStill(assets);
      }
      if (!stillAsset) {
        stillAsset = one(assets, {
          container: /mp4/,
          sortBy: "width desc"
        });
      }
      return stillAsset;
    };
    var channelArtworkStill = function channelArtworkStill2(assets) {
      return one(assets, {
        type: /^channel_still_image$/,
        sortBy: "created_at desc"
      });
    };
    var thumbnailAssets = function thumbnailAssets2(assets, options) {
      if (options.stillUrl) {
        return [{
          height: null,
          url: options.stillUrl,
          width: null
        }];
      }
      var stillAsset = still(assets);
      if (options.instantHlsStillAsset != null && (!stillAsset || /mp4/.test(stillAsset.container))) {
        return [options.instantHlsStillAsset];
      }
      if (options.originalFileStillAsset != null && (!stillAsset || /mp4/.test(stillAsset.container))) {
        return [options.originalFileStillAsset];
      }
      if (!stillAsset) {
        return [];
      }
      var stillAspect = stillAsset.width / stillAsset.height;
      return [320, 640, 960, 1280, 1920, 3840].map(function(width) {
        var height = Math.round(width / stillAspect);
        var url = stillUrl(assets, {
          videoWidth: width,
          videoHeight: height,
          playButton: false
        });
        return {
          height,
          url,
          width
        };
      });
    };
    var FAST_HOSTNAME = (0, _appHostname_js__WEBPACK_IMPORTED_MODULE_5__.Ni)("fast");
    var stillUrl = function stillUrl2(assets) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var stillAsset = still(assets);
      if (!stillAsset) return;
      if (stillAsset.status !== READY) {
        var channelArtwork = channelArtworkStill();
        if (channelArtwork && channelArtwork.status === READY) {
          return channelArtwork.url;
        }
        return "//".concat(FAST_HOSTNAME, "/assets/images/blank.gif");
      }
      options = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.h1)({
        aspect: stillAsset.width / stillAsset.height || 1,
        // default to square if we can't determine the aspect
        stillUrl: stillAsset.url,
        playButton: false,
        playerColor: options.playerColor || "636155",
        videoWidth: stillAsset.width || 640,
        videoHeight: stillAsset.height || 360,
        stillSnap: true
      }, options);
      var stillWidth = options.videoWidth;
      var stillHeight = options.videoHeight;
      var result = new utilities_url_js__WEBPACK_IMPORTED_MODULE_1__.s0(options.stillUrl);
      if (options.retina) {
        result.params.image_play_button_size = "2x";
        stillWidth *= 2;
        stillHeight *= 2;
      }
      if (options.stillSnap) {
        stillWidth = getStillWidth({
          videoWidth: stillWidth,
          stillAssetWidth: stillAsset.width || 640
          // there have been times where we fail to have proper width returned
        });
        stillHeight = Math.round(stillWidth / options.aspect);
      }
      if (!isBakeryUrl(options.stillUrl)) {
        return options.stillUrl;
      }
      if (options.protocol === "https:") {
        result.protocol = "https:";
        result.host = options.embedHost === utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.pb || options.embedHost === utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.bF ? utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.iD : utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.cu;
      }
      result.params.image_crop_resized = "".concat(stillWidth, "x").concat(stillHeight);
      if (options.playButton == null || options.playButton) {
        result.params.image_play_button_rounded = 1;
        result.params.image_play_button_color = "".concat("".concat(options.playerColor).replace(/^#+/, ""), "e0");
      }
      if (options.ext) {
        result.ext(options.ext);
      }
      if (result.ext() === "bin") {
        result.ext("jpg");
      }
      return result.absolute();
    };
    var getStillWidth = function getStillWidth2(options) {
      var potentialStillWidths = [640, 960, 1280, 1920, 3840];
      if (options.stillAssetWidth < 3840) {
        potentialStillWidths.push(options.stillAssetWidth);
      }
      var availableStillWidths = [];
      for (var i2 = 0; i2 < potentialStillWidths.length; i2++) {
        var width = potentialStillWidths[i2];
        if (width <= options.stillAssetWidth) {
          availableStillWidths.push(width);
        }
      }
      availableStillWidths.sort(function(a, b) {
        return a - b;
      });
      for (var _i = 0; _i < availableStillWidths.length; _i++) {
        var _width = availableStillWidths[_i];
        if (options.videoWidth <= _width) {
          return _width;
        }
      }
      return Math.max.apply(Math, availableStillWidths);
    };
    var BAKERY_HOSTS = [
      utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.pK,
      utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.cu,
      (0, _appHostname_js__WEBPACK_IMPORTED_MODULE_5__.Ni)("embed"),
      (0, _appHostname_js__WEBPACK_IMPORTED_MODULE_5__.Ni)("prime"),
      (0, _appHostname_js__WEBPACK_IMPORTED_MODULE_5__.Ni)("mixergy-cdn"),
      (0, _appHostname_js__WEBPACK_IMPORTED_MODULE_5__.Ni)("embed-fastly"),
      // XXX: akamai test
      utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.hk,
      utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.iD,
      utilities_hosts_js__WEBPACK_IMPORTED_MODULE_3__.KG
    ];
    var isBakeryUrl = function isBakeryUrl2(rawUrl) {
      if (rawUrl == null) {
        return false;
      }
      var url = new utilities_url_js__WEBPACK_IMPORTED_MODULE_1__.s0(rawUrl);
      if (!url.host) {
        return false;
      }
      return BAKERY_HOSTS.join(",").indexOf(url.host) >= 0;
    };
    var onePublicReadyWithContainer = function onePublicReadyWithContainer2(assets, type, options) {
      options = (0, utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__.h1)({
        container: type,
        public: true,
        status: READY
      }, options);
      return one(assets, options);
    };
    var hasAnyReadyHdrAssets = function hasAnyReadyHdrAssets2(assets) {
      return assets.some(function(asset) {
        return asset.type === "hdr_video" && asset.status === READY && asset.public && asset.container === "mp4";
      });
    };
    var mp4 = function mp42(assets, options) {
      return onePublicReadyWithContainer(assets, "mp4", options);
    };
    var webm = function webm2(assets, options) {
      return onePublicReadyWithContainer(assets, "webm", options);
    };
    var m3u8 = function m3u82(assets, options) {
      return onePublicReadyWithContainer(assets, "m3u8", options);
    };
    var original = function original2(assets) {
      return one(assets, {
        type: "original"
      });
    };
    var playable = function playable2(assets, options) {
      var detect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : cachedDetect();
      if (detect.video.webm) {
        return webm(assets, options) || mp4(assets, options);
      }
      return mp4(assets, options);
    };
    var videoAspect = function videoAspect2(assets) {
      var asset = mp4(assets) || m3u8(assets) || webm(assets) || original(assets);
      if (asset && asset.height) {
        return asset.width / asset.height;
      }
      return 640 / 360;
    };
    var originalAspect = function originalAspect2(assets) {
      var derivativeAspect = videoAspect(assets);
      var asset = original(assets);
      if (asset && asset.width && asset.height) {
        var candidateAspect = asset.width / asset.height;
        if (candidateAspect > 1 && derivativeAspect < 1 || candidateAspect < 1 && derivativeAspect > 1) {
          return 1 / candidateAspect;
        }
        return candidateAspect;
      }
      return derivativeAspect;
    };
    var iphone = function iphone2(assets, options) {
      var aspect = videoAspect(assets);
      if (aspect > 1) {
        options = merge({
          width: 640
        }, options);
        return mp4(assets, options) || smallestNormalMp4(assets, options);
      }
      var opt1 = merge({
        width: 320
      }, options);
      var opt2 = merge({
        width: 640
      }, options);
      return mp4(assets, opt1) || mp4(assets, opt2) || smallestNormalMp4(assets, options);
    };
    var smallestNormalMp4 = function smallestNormalMp42(assets, options) {
      options = merge({
        sortBy: "width asc",
        width: [640, 1920]
      }, options);
      return mp4(assets, options);
    };
    var urlWithCorrectHost = function urlWithCorrectHost2(assetUrl) {
      var proto = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Hosts.eV1Protocol();
      var parsedUrl = new Url(assetUrl);
      if (isBakeryUrl(assetUrl)) {
        if (proto === "https:") {
          parsedUrl.host = Hosts.deliveryHost(location.protocol);
          parsedUrl.protocol = "https:";
        } else {
          parsedUrl.host = Hosts.deliveryHost(location.protocol);
          parsedUrl.protocol = "http:";
        }
      }
      return parsedUrl.absolute();
    };
    var nearestOutsideRange = function nearestOutsideRange2(assets, lower, upper) {
      if (assets.length === 0) {
        return [];
      }
      var sortedAssets = aps.call(assets).sort(function(a, b) {
        return numericSizeSnapped(a.width, a.height) - numericSizeSnapped(b.width, b.height);
      });
      var lowerAsset;
      var upperAsset;
      for (var i2 = 0; i2 < sortedAssets.length; i2++) {
        var asset = sortedAssets[i2];
        var assetSize = numericSizeSnapped(asset.width, asset.height);
        if (assetSize < lower) {
          lowerAsset = asset;
        }
        if (assetSize >= upper) {
          upperAsset = asset;
          break;
        }
      }
      var result = [];
      if (lowerAsset) {
        result.push(lowerAsset);
      }
      if (upperAsset) {
        result.push(upperAsset);
      }
      if (result.length === 0) {
        utilities_wlog_js__WEBPACK_IMPORTED_MODULE_4__.ct.error("nearestOutsideRange: no nearby assets found, using first in list", sortedAssets[0]);
        result.push(sortedAssets[0]);
      }
      return result;
    };
    var moveToFront = function moveToFront2(assets, toFront) {
      if (!toFront) {
        return assets;
      }
      var index = -1;
      for (var i2 = 0; i2 < assets.length; i2++) {
        var asset = assets[i2];
        if (asset.url === toFront.url) {
          index = i2;
          break;
        }
      }
      if (index > 0) {
        assets.splice(index, 1);
        assets.unshift(toFront);
      }
      return assets;
    };
  },
  /***/
  7211(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      J: () => (
        /* binding */
        shouldEnableMux
      ),
      /* harmony export */
      _: () => (
        /* binding */
        MUX_PERCENTAGE_TO_ENABLE
      )
      /* harmony export */
    });
    var MUX_PERCENTAGE_TO_ENABLE = 0.1;
    var shouldEnableMux = function shouldEnableMux2(video, didWinCoinFlip) {
      var _video$_opts, _video$_mediaData;
      var isMuxEnabledOnWindow = window.wistiaDisableMux !== true;
      var isMuxEnabledFromOpts = ((_video$_opts = video._opts) === null || _video$_opts === void 0 ? void 0 : _video$_opts.mux) !== false;
      var isMuxEnabledFromStandardEmbed = video.iframe == null;
      var isMuxEnabledFromCoinFlip = didWinCoinFlip;
      var isMuxEnabledFromLiveStream = ((_video$_mediaData = video._mediaData) === null || _video$_mediaData === void 0 ? void 0 : _video$_mediaData.type) === "LiveStream";
      return isMuxEnabledOnWindow && isMuxEnabledFromOpts && isMuxEnabledFromStandardEmbed && (isMuxEnabledFromCoinFlip || isMuxEnabledFromLiveStream);
    };
  },
  /***/
  7229(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      J: () => (
        /* binding */
        secondsToIso8601Duration
      )
      /* harmony export */
    });
    var _duration_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(1341);
    var SECONDS_IN_MINUTE = 60;
    var secondsToIso8601Duration = function secondsToIso8601Duration2(totalSeconds) {
      var _secondsConverter = (0, _duration_ts__WEBPACK_IMPORTED_MODULE_0__.ab)(totalSeconds, "hms"), hours = _secondsConverter.hours, minutes = _secondsConverter.minutes, seconds = _secondsConverter.seconds;
      var result = "";
      if (hours) {
        result += "".concat(hours, "H");
      }
      if (minutes || totalSeconds > SECONDS_IN_MINUTE && seconds !== 0) {
        result += "".concat(minutes, "M");
      }
      if (seconds || totalSeconds === 0) {
        result += "".concat(seconds, "S");
      }
      return result;
    };
  },
  /***/
  7231(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      GS: () => (
        /* binding */
        detectIsMobile
      ),
      /* harmony export */
      o1: () => (
        /* binding */
        cachedDetect2
      )
      /* harmony export */
    });
    var utilities_root_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(8176);
    var _performance_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(267);
    var na = navigator.userAgent;
    var _playerDetectCache = null;
    var rwebkit = /(webkit)[ /]([^\s]+)/i;
    var ropera = /OPR\/([^\s]+)/i;
    var redge = /(edge)\/(\d+(?:\.\d+)?)/i;
    var rmozilla = /(mozilla)(?:.*? rv:([^\s)]+))?/i;
    var randroid = /(android) ([^;]+)/i;
    var riphone = /(iphone)/i;
    var rwinphone = /(Windows Phone OS (\d+(?:\.\d+)?))/;
    var rios = /OS (\d+)_(\d+)/i;
    var rfirefox = /(firefox)/i;
    var rgearvr = /Mobile VR/i;
    var riosVersion = /Version\/([^\s]+)/i;
    var browser = function browser2() {
      return (browserMatch()[1] || "webkit").toLowerCase();
    };
    var browserVersion = function browserVersion2() {
      return browserMatch()[2];
    };
    var browserMatch = function browserMatch2() {
      var match;
      match = na.match(redge);
      if (match) {
        return match;
      }
      match = na.match(rwebkit);
      if (match) {
        return match;
      }
      match = na.match(ropera);
      if (match) {
        return match;
      }
      if (match) {
        if (document.documentMode != null) {
          match[2] = document.documentMode;
        }
        return match;
      }
      match = na.match(rmozilla);
      if (match) {
        return match;
      }
      return [];
    };
    var android = function android2() {
      var matches2 = na.match(randroid);
      if (matches2 == null) {
        return false;
      }
      return {
        version: matches2[2]
      };
    };
    var oldandroid = function oldandroid2() {
      return android() && parseFloat(android().version) < 4.1;
    };
    var iphone = function iphone2() {
      return riphone.test(na);
    };
    var touchScreen = function touchScreen2() {
      return iosVersion() > 0 || android() || ipad();
    };
    var HDRCodecSupport = function HDRCodecSupport2() {
      var _window$MediaSource$i, _window$MediaSource, _window$MediaSource$i2, _window$MediaSource$i3, _window$MediaSource2, _window$MediaSource2$, _window$MediaSource$i4, _window$MediaSource3, _window$MediaSource3$;
      return {
        hevc: (_window$MediaSource$i = (_window$MediaSource = window.MediaSource) === null || _window$MediaSource === void 0 ? void 0 : (_window$MediaSource$i2 = _window$MediaSource.isTypeSupported) === null || _window$MediaSource$i2 === void 0 ? void 0 : _window$MediaSource$i2.call(_window$MediaSource, 'video/mp4; codecs="hvc1.2.4.L153.B0"')) !== null && _window$MediaSource$i !== void 0 ? _window$MediaSource$i : false,
        // // HEVC Main10
        av1: (_window$MediaSource$i3 = (_window$MediaSource2 = window.MediaSource) === null || _window$MediaSource2 === void 0 ? void 0 : (_window$MediaSource2$ = _window$MediaSource2.isTypeSupported) === null || _window$MediaSource2$ === void 0 ? void 0 : _window$MediaSource2$.call(_window$MediaSource2, 'video/mp4; codecs="av01.0.08M.10.0.110.09.16.09"')) !== null && _window$MediaSource$i3 !== void 0 ? _window$MediaSource$i3 : false,
        // AV1 10-bit Main, PQ (HDR10)
        vp92: (_window$MediaSource$i4 = (_window$MediaSource3 = window.MediaSource) === null || _window$MediaSource3 === void 0 ? void 0 : (_window$MediaSource3$ = _window$MediaSource3.isTypeSupported) === null || _window$MediaSource3$ === void 0 ? void 0 : _window$MediaSource3$.call(_window$MediaSource3, 'video/mp4; codecs="vp09.02.10.10.01.09.16.09"')) !== null && _window$MediaSource$i4 !== void 0 ? _window$MediaSource$i4 : false
        // // VP9 Profile 2 (10-bit)
      };
    };
    var HDRSupported = function HDRSupported2() {
      var _window$matchMedia, _window;
      if ((_window$matchMedia = (_window = window).matchMedia) !== null && _window$matchMedia !== void 0 && _window$matchMedia.call(_window, "(dynamic-range: high)").matches) {
        return true;
      }
      if (screen.colorDepth && screen.colorDepth >= 30) {
        return true;
      }
      return false;
    };
    var hoverIsNatural = function hoverIsNatural2() {
      try {
        var mediaQueryList = matchMedia("(hover:hover)");
        if (mediaQueryList.media !== "not all") {
          return mediaQueryList.matches;
        }
      } catch (err) {
      }
      return !touchScreen();
    };
    var retina = function retina2() {
      return utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z.devicePixelRatio != null && utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z.devicePixelRatio > 1;
    };
    var ipad = function ipad2() {
      return /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
    };
    var safari = function safari2() {
      return rwebkit.test(na) && !/chrome/i.test(na) && !ipad() && !iphone();
    };
    var chrome = function chrome2() {
      if (/Chrome/.test(na) && /Google Inc/.test(navigator.vendor)) {
        return {
          version: chromeVersion()
        };
      }
      return false;
    };
    var silkVersion = function silkVersion2() {
      var match = na.match(/\bSilk\/([^\s]+)/);
      return match && match[1];
    };
    var chromeVersion = function chromeVersion2() {
      var match = na.match(/\bChrome\/([^\s]+)/);
      return match && match[1];
    };
    var opera = function opera2() {
      return ropera.test(na);
    };
    var iosVersion = function iosVersion2() {
      var iosMatch = na.match(rios);
      var versionMatch = na.match(riosVersion);
      if (iosMatch != null) {
        return parseFloat("".concat(iosMatch[1], ".").concat(iosMatch[2]));
      }
      if (versionMatch != null && versionMatch[1] && ipad()) {
        return parseFloat(versionMatch[1]);
      }
      return 0;
    };
    var windowsPhone = function windowsPhone2() {
      return rwinphone.test(na);
    };
    var edge = function edge2() {
      return redge.test(na);
    };
    var firefox = function firefox2() {
      return rfirefox.test(na);
    };
    var gearvr = function gearvr2() {
      return rgearvr.test(na);
    };
    var windows = function windows2() {
      return /win/i.test(navigator.platform);
    };
    var mac = function mac2() {
      return /mac/i.test(navigator.platform);
    };
    var html5Video = function html5Video2() {
      var elem = document.createElement("video");
      var result = false;
      try {
        if (elem.canPlayType) {
          result = {};
          var h264 = 'video/mp4; codecs="avc1.42E01E';
          result.h264 = !!elem.canPlayType("".concat(h264, '"')) || !!elem.canPlayType("".concat(h264, ', mp4a.40.2"'));
          result.webm = !!elem.canPlayType('video/webm; codecs="vp9, vorbis"');
          result.nativeHls = !!elem.canPlayType("application/vnd.apple.mpegURL");
        }
      } catch (e) {
        result = {
          ogg: false,
          h264: false,
          webm: false,
          nativeHls: false
        };
      }
      return result;
    };
    var mediaSource = function mediaSource2() {
      var h264 = 'video/mp4; codecs="avc1.42E01E';
      return utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z.MediaSource && utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z.MediaSource.isTypeSupported("".concat(h264, ', mp4a.40.2"'));
    };
    var nativeHls = function nativeHls2() {
      return (iphone() || ipad() || safari()) && html5Video().nativeHls;
    };
    var localStorage2 = function localStorage3() {
      try {
        return "localStorage" in utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z && utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z.localStorage != null;
      } catch (e) {
        return false;
      }
    };
    var fullscreenEnabled = function fullscreenEnabled2() {
      return document.fullscreenEnabled || document.mozFullScreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled;
    };
    var managedMediaSource = function managedMediaSource2() {
      var _window$ManagedMediaS;
      return "ManagedMediaSource" in window && typeof ((_window$ManagedMediaS = window.ManagedMediaSource) === null || _window$ManagedMediaS === void 0 ? void 0 : _window$ManagedMediaS.isTypeSupported) === "function";
    };
    var browserPrefixes = ["WebKit", "Moz", "O", "Ms", ""];
    var mutationObserver = function mutationObserver2() {
      for (var i2 = 0; i2 < browserPrefixes.length; i2++) {
        var prefix = browserPrefixes[i2];
        var prop = "".concat(prefix, "MutationObserver");
        if (utilities_root_js__WEBPACK_IMPORTED_MODULE_0__.z[prop]) {
          return prop;
        }
      }
      return null;
    };
    var vulcanV2Support = function vulcanV2Support2() {
      var modernBrowser = /webkit|mozilla|edge/.test(browser());
      if (iphone() || ipad() || android()) {
        return true;
      }
      return Boolean(modernBrowser && html5Video().h264 && Object.defineProperties);
    };
    var isPassiveSupported;
    var passiveSupported = function passiveSupported2() {
      if (isPassiveSupported != null) {
        return isPassiveSupported;
      }
      try {
        var options = Object.defineProperty({}, "passive", {
          /* eslint-disable-next-line getter-return */
          get: function get() {
            isPassiveSupported = true;
          }
        });
        window.addEventListener("test", null, options);
      } catch (err) {
        isPassiveSupported = false;
      }
      return isPassiveSupported;
    };
    var callingPlayRequiresEventContext = function callingPlayRequiresEventContext2() {
      return iosVersion() > 0 || android() || safari();
    };
    var webp = function webp2() {
      var chromeBrowser = chrome();
      var firefoxBrowser = firefox();
      var edgeBrowser = edge();
      var operaBrowser = opera();
      var isChromeDesktopSupported = chromeBrowser && browserVersion() >= 32;
      var isChromeAndroidSupported = chromeBrowser && browserVersion() >= 75 && android();
      var isFirefoxDesktopSupported = firefoxBrowser && browserVersion() >= 65;
      var isFirefoxAndroidSupported = firefoxBrowser && browserVersion() >= 67 && android();
      var isEdgeSupported = edgeBrowser && browserVersion() >= 18;
      var isOperaSupported = operaBrowser && browserVersion() >= 19;
      return isChromeDesktopSupported || isChromeAndroidSupported || isFirefoxDesktopSupported || isFirefoxAndroidSupported || isEdgeSupported || isOperaSupported;
    };
    var cachedDetect2 = function cachedDetect3() {
      if (_playerDetectCache) {
        return _playerDetectCache;
      }
      _playerDetectCache = uncachedDetect();
      return _playerDetectCache;
    };
    var uncachedDetect = function uncachedDetect2() {
      var result = {
        browser: {
          version: browserVersion()
        },
        edge: edge(),
        firefox: firefox(),
        gearvr: gearvr(),
        hdr: HDRSupported(),
        hdrCodecs: HDRCodecSupport(),
        android: android(),
        oldandroid: oldandroid(),
        iphone: iphone(),
        ipad: ipad(),
        safari: safari(),
        chrome: chrome(),
        winphone: {
          version: windowsPhone()[2]
        },
        ios: {
          version: iosVersion()
        },
        windows: windows(),
        mac: mac(),
        retina: retina(),
        hoverIsNatural: hoverIsNatural(),
        touchScreen: touchScreen(),
        video: html5Video(),
        managedMediaSource: managedMediaSource(),
        mediaSource: mediaSource(),
        nativeHls: nativeHls(),
        localstorage: localStorage2(),
        fullscreenEnabled: fullscreenEnabled(),
        vulcanV2Support: vulcanV2Support(),
        mutationObserver: mutationObserver(),
        callingPlayRequiresEventContext: callingPlayRequiresEventContext(),
        passiveSupported: passiveSupported(),
        webp: webp(),
        performanceMeasure: (0, _performance_ts__WEBPACK_IMPORTED_MODULE_1__.O)()
      };
      result.browser[browser()] = true;
      return result;
    };
    var clearDetectCache = function clearDetectCache2() {
      _playerDetectCache = null;
    };
    var detectIsMobile = function detectIsMobile2() {
      var isAndroid = android();
      var isIPad = ipad();
      var isIPhone = iphone();
      return isAndroid || isIPad || isIPhone;
    };
  },
  /***/
  7323(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      k: () => (
        /* binding */
        didWinCoinFlip
      )
      /* harmony export */
    });
    var MAX_RANDOM_VALUE = 4294967295;
    var didWinCoinFlip = function didWinCoinFlip2(percentToWinCoinFlip) {
      var cryptoObj = window.crypto;
      if (typeof cryptoObj !== "undefined") {
        var cryptoRandom = cryptoObj.getRandomValues(new Uint32Array(1));
        return cryptoRandom[0] / (MAX_RANDOM_VALUE + 1) < percentToWinCoinFlip;
      }
      var mathRandom = Math.random();
      return mathRandom >= percentToWinCoinFlip;
    };
  },
  /***/
  7350(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      b: () => (
        /* binding */
        isGradient
      )
      /* harmony export */
    });
    var isGradient = function isGradient2(value) {
      if (typeof value !== "object" || value === null) {
        return false;
      }
      var _ref = value, colors = _ref.colors, on = _ref.on;
      if (!on) {
        return true;
      }
      if (!Array.isArray(colors) || typeof on !== "boolean") {
        return false;
      }
      if (colors.length === 0) {
        return false;
      }
      return colors.every(function(color) {
        return typeof color[0] === "string" && typeof color[1] === "number";
      });
    };
  },
  /***/
  7438(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      hy: () => (
        /* binding */
        getViewerPreferences
      )
      /* harmony export */
    });
    var utilities_namespacedLocalStorage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(2917);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    var deleteViewerPreferences = function deleteViewerPreferences2() {
      removeLocalStorage(getLocalStorageKey());
    };
    var getLocalStorageKey = function getLocalStorageKey2() {
      return "wistia-viewer-preferences";
    };
    var getViewerPreferences = function getViewerPreferences2() {
      if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s._viewerPreferencesEnabled === false) {
        return {};
      }
      return (0, utilities_namespacedLocalStorage_js__WEBPACK_IMPORTED_MODULE_0__.Lg)(getLocalStorageKey());
    };
    var getViewerPreference = function getViewerPreference2(preference) {
      var preferences = getViewerPreferences();
      if (!preferences) {
        return null;
      }
      return preferences[preference];
    };
    var setViewerPreference = function setViewerPreference2(preference, value) {
      updateLocalStorage(getLocalStorageKey(), function(obj) {
        if (obj.plugin) {
          delete obj.plugin;
        }
        obj[preference] = value;
      });
    };
  },
  /***/
  7715(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      Ev: () => (
        /* binding */
        addInlineCss
      ),
      /* harmony export */
      Rx: () => (
        /* reexport safe */
        utilities_pageLoaded_js__WEBPACK_IMPORTED_MODULE_1__.R
      ),
      /* harmony export */
      cG: () => (
        /* binding */
        elemWidth
      ),
      /* harmony export */
      lj: () => (
        /* binding */
        elemInDom
      )
      /* harmony export */
    });
    var utilities_obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(731);
    var utilities_pageLoaded_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(9562);
    var utilities_detect_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(7231);
    var utilities_wlog_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(6637);
    var utilities_script_tags_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(6461);
    var utilities_seqid_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(1224);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__3(5509);
    var _objectHasOwn = function(object, property) {
      if (typeof object === "undefined" || object === null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    };
    var W = (
      /* unused pure expression or super */
      null
    );
    var detect = (0, utilities_detect_js__WEBPACK_IMPORTED_MODULE_2__.o1)();
    var elemHtml = function elemHtml2(elem, content) {
      var cssTags = getCssTags(content);
      var scriptTags2 = getScriptTags(content);
      content = removeCssTags(content);
      content = removeScriptTags(content);
      elem.innerHTML = content;
      execCssTags(cssTags, elem);
      return execScriptTags(scriptTags2);
    };
    var getCssTags = function getCssTags2(htmlStr) {
      return htmlStr.match(/<link.*?rel=['"]stylesheet['"][^>]*>|<style>[\s\S]+?<\/style>/gi) || [];
    };
    var execCssTags = function execCssTags2(cssTags, parentElem) {
      if (!cssTags) {
        return null;
      }
      if (!isArray(cssTags)) {
        cssTags = getCssTags(cssTags);
      }
      var inserted = [];
      for (var i2 = 0; i2 < cssTags.length; i2++) {
        var cssTag = cssTags[i2];
        if (/<link.*?rel=['"]stylesheet['"][^>]*>/.test(cssTag)) {
          var matches2 = cssTag.match(/href=['"](.*?)['"]/i);
          if (matches2) {
            var link = document.createElement("link");
            link.setAttribute("rel", "stylesheet");
            link.setAttribute("href", matches2[1]);
            link.className = "wistia_injected_style";
            (parentElem || document.body || document.head).appendChild(link);
            inserted.push(link);
          }
        } else if (/<style>[\s\S]+?<\/style>/gi.test(cssTag)) {
          var _matches = cssTag.match(/<style>([\s\S]+?)<\/style>/i);
          if (_matches) {
            var style = addInlineCss(parentElem || document.body || document.head, _matches[1]);
            inserted.push(style);
          }
        }
      }
      return inserted;
    };
    var removeCssTags = function removeCssTags2(htmlStr) {
      return htmlStr.replace(/<link.*?rel=['"]stylesheet['"][^>]*>|<style>[\s\S]+?<\/style>/gi, "");
    };
    var addInlineCss = function addInlineCss2(domTarget, css) {
      var target = domTarget || document.body || document.head;
      var styleElem = document.createElement("style");
      styleElem.id = (0, utilities_seqid_js__WEBPACK_IMPORTED_MODULE_5__.h)("wistia_", "_style");
      styleElem.setAttribute("type", "text/css");
      styleElem.className = "wistia_injected_style";
      target.appendChild(styleElem, target.nextSibling);
      if (styleElem.styleSheet) {
        styleElem.styleSheet.cssText = css;
      } else {
        styleElem.appendChild(document.createTextNode(css));
      }
      return styleElem;
    };
    var _elemFromObject = function elemFromObject(obj) {
      if (isArray(obj)) {
        var result = [];
        for (var i2 = 0; i2 < obj.length; i2++) {
          result.push(_elemFromObject(obj[i2]));
        }
        return result;
      }
      var tagName = obj.tagName || "div";
      var childNodes = obj.childNodes || [];
      if (!isArray(childNodes)) {
        childNodes = [childNodes];
      }
      var elem = document.createElement(tagName);
      for (var key in obj) {
        if (_objectHasOwn(obj, key)) {
          var val = obj[key];
          if (key !== "childNodes" && key !== "tagName" && key !== "ref") {
            var dashedKey = key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
            if (key === "style") {
              if (isObject(val)) {
                for (var p in val) {
                  elem.style[p] = val[p];
                }
              } else {
                var styles = val.split(";");
                for (var _i = 0; _i < styles.length; _i++) {
                  var pair = styles[_i].split(/\s*:\s*/);
                  var _p = pair[0];
                  var v = pair[1];
                  if (_p && v) {
                    elem.style[_p] = v;
                  }
                }
              }
            } else if (key === "events") {
              for (var evt in val) {
                var callback = val[evt];
                elemBind(elem, evt, callback);
              }
            } else if (key === "className" || key === "class") {
              elem.className = val;
            } else if (key === "innerHTML") {
              elem.innerHTML = val;
            } else if (key === "innerText") {
              elem.innerText = val;
            } else if (val != null && typeof val.toString === "function") {
              elem.setAttribute(dashedKey, val.toString());
            }
          }
        }
      }
      for (var _i2 = 0; _i2 < childNodes.length; _i2++) {
        var childObj = childNodes[_i2];
        if (isObject(childObj)) {
          var child = _elemFromObject(childObj);
          _elemAppend(elem, child);
        } else {
          var _child = document.createTextNode(childObj.toString());
          _elemAppend(elem, _child);
        }
      }
      if (typeof obj.ref === "function") {
        obj.ref(elem);
      }
      return elem;
    };
    var _elemToObject = function elemToObject(elem) {
      if (isArray(elem)) {
        var _result = [];
        for (var i2 = 0; i2 < elem.length; i2++) {
          _result.push(_elemToObject(elem[i2]));
        }
      }
      var result = {};
      result.tagName = elem.tagName.toLowerCase();
      var elemKeys = Object.keys(elem);
      for (var _i3 = 0; _i3 < elemKeys.length; _i3++) {
        var attr = elemKeys[_i3];
        if (attr !== "tagName" && attr !== "childNodes" && attr !== "nodeType" && attr !== "nodeValue") {
          if (attr === "style") {
            result.style = {};
            var styleKeys = Object.keys(elem.style);
            for (var j = 0; j < styleKeys.length; j++) {
              var prop = styleKeys[j];
              var val = elem.style[prop];
              if (val && !/^\d/.test(prop) && prop !== "length") {
                result.style[prop] = val;
              }
            }
          } else {
            var value = elem.getAttribute(attr);
            if (value != null) {
              result[attr] = value;
            }
          }
        }
      }
      var children = [];
      for (var _i4 = 0; _i4 < elem.childNodes.length; _i4++) {
        var child = elem.childNodes[_i4];
        if (child.nodeType === 1) {
          children.push(_elemToObject(child));
        } else if (child.nodeType === 3) {
          children.push(child.nodeValue);
        }
      }
      if (children.length > 0) {
        result.childNodes = children;
      }
      return result;
    };
    var elemClone = function elemClone2(elem) {
      var obj = _elemToObject(elem);
      return _elemFromObject(obj);
    };
    var _elemAppend = function elemAppend(par, elem) {
      if (isArray(elem)) {
        for (var i2 = 0; i2 < elem.length; i2++) {
          _elemAppend(par, elem[i2]);
        }
        return;
      }
      if (par.tagName.includes("-")) {
        par.shadowRoot.appendChild(elem, {
          wistiaGridCaller: true
        });
      } else {
        par.appendChild(elem, {
          wistiaGridCaller: true
        });
      }
    };
    var _elemPrepend = function elemPrepend(par, elem) {
      if (isArray(elem)) {
        for (var i2 = 0; i2 < elem.length; i2++) {
          _elemPrepend(par, elem[i2]);
        }
        return;
      }
      if (par.childNodes.length === 0) {
        return _elemAppend(par, elem);
      }
      return par.insertBefore(elem, par.childNodes[0]);
    };
    var _elemBefore = function elemBefore(sibling, elem) {
      if (isArray(elem)) {
        elem = elem.reverse();
        for (var i2 = 0; i2 < elem.length; i2++) {
          _elemBefore(sibling, elem[i2]);
        }
        return;
      }
      return sibling.parentNode.insertBefore(elem, sibling);
    };
    var _elemAfter = function elemAfter(sibling, elem) {
      if (isArray(elem)) {
        elem = elem.reverse();
        for (var i2 = 0; i2 < elem.length; i2++) {
          _elemAfter(sibling, elem[i2]);
        }
        return;
      }
      return sibling.parentNode.insertBefore(elem, sibling.nextSibling);
    };
    var _elemRemove = function elemRemove(elem) {
      if (isArray(elem) || window.NodeList && elem instanceof NodeList) {
        for (var i2 = 0; i2 < elem.length; i2++) {
          _elemRemove(elem[i2]);
        }
        return;
      }
      var par;
      if (elem != null && (elem.nodeType === 1 || elem.nodeType === 3) && (par = elem.parentNode)) {
        par.removeChild(elem);
        elem = null;
      }
    };
    var _elemRemoveClass = function elemRemoveClass(elem, klass) {
      if (isArray(elem) || window.NodeList && elem instanceof NodeList) {
        for (var i2 = 0; i2 < elem.length; i2++) {
          _elemRemoveClass(elem[i2], klass);
        }
        return;
      }
      if (!elemHasClass(elem, klass)) {
        return;
      }
      var className = elem.getAttribute("class");
      if (className) {
        var regexp = new RegExp("\\b".concat(klass, "\\b"), "g");
        var newClassString = normalizeClassName(className.replace(regexp, ""));
        elem.setAttribute("class", newClassString);
      }
    };
    var _elemAddClass = function elemAddClass(elem, klass) {
      if (isArray(elem) || window.NodeList && elem instanceof NodeList) {
        for (var i2 = 0; i2 < elem.length; i2++) {
          _elemAddClass(elem[i2], klass);
        }
        return;
      }
      if (elemHasClass(elem, klass)) {
        return;
      }
      var className = elem.getAttribute("class");
      var newClassString;
      if (className) {
        _elemRemoveClass(elem, klass);
        newClassString = normalizeClassName("".concat(className, " ").concat(klass));
      } else {
        newClassString = klass;
      }
      elem.setAttribute("class", newClassString);
    };
    var elemHasClass = function elemHasClass2(elem, klass) {
      var className = elem != null && typeof elem.getAttribute === "function" && elem.getAttribute("class");
      if (!className && elem && typeof elem.className === "string") {
        className = elem.className;
      }
      if (!className) {
        return false;
      }
      var returnValue = false;
      eachIndexOf(className, klass, function(index) {
        var classBeginningFound = index === 0 || className.charAt(index - 1) === " ";
        var endsWidthClass = index + klass.length === className.length;
        var classInMiddle = className.charAt(index + klass.length) === " ";
        if (classBeginningFound && (endsWidthClass || classInMiddle)) {
          returnValue = true;
          return BREAK_IDENTIFIER;
        }
      });
      return returnValue;
    };
    var BREAK_IDENTIFIER = {};
    var eachIndexOf = function eachIndexOf2(str, needle, fn) {
      var i2 = -1;
      while ((i2 = str.indexOf(needle, i2 + 1)) != -1) {
        if (fn(i2) === BREAK_IDENTIFIER) {
          break;
        }
      }
    };
    var elemClasses = function elemClasses2(elem) {
      if (elem && typeof elem.className !== "string") {
        return [""];
      }
      return (elem && elem.className || "").split(/\s+/);
    };
    var normalizeClassName = function normalizeClassName2(className) {
      return className.replace(/^\s+/g, "").replace(/\s+$/g, "").replace(/\s+/g, " ");
    };
    var _elemStyle = function elemStyle2(elem) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (isArray(elem) || window.NodeList && elem instanceof NodeList) {
        var result = [];
        for (var i2 = 0; i2 < elem.length; i2++) {
          var node = elem[i2];
          if (node.nodeType === 1) {
            result.push(_elemStyle.apply(void 0, [node].concat(args)));
          }
        }
        return result;
      }
      if (args.length === 2) {
        var prop = args[0];
        var val = args[1];
        elem.style[prop] = val;
      } else if (args.length === 1) {
        if (typeof args[0] === "string") {
          var _prop = args[0];
          try {
            if (elem.currentStyle) {
              return elem.currentStyle[_prop];
            }
            if (window.getComputedStyle) {
              return window.getComputedStyle(elem, null).getPropertyValue(_prop);
            }
            return null;
          } catch (e) {
            wlog.notice(e);
          }
        } else {
          var props = propsWithVendorPrefixes(args[0]);
          for (var _prop2 in props) {
            var _val = props[_prop2];
            elem.style[_prop2] = _val;
          }
        }
      } else {
        wlog.apply(void 0, ["Unexpected args", elem].concat(args));
      }
    };
    var VENDORED_PROPERTIES = {
      borderImage: true,
      mixBlendMode: true,
      transform: true,
      transition: true,
      transitionDuration: true
    };
    var VENDOR_PREFIXES = (
      /* unused pure expression or super */
      null
    );
    var propsWithVendorPrefixes = function propsWithVendorPrefixes2(props) {
      if (detect.chrome) {
        return props;
      }
      var result = {};
      for (var prop in props) {
        var val = props[prop];
        result[prop] = val;
        if (VENDORED_PROPERTIES[prop]) {
          var prefixes = VENDOR_PREFIXES;
          for (var i2 = 0; i2 < prefixes.length; i2++) {
            var prefix = prefixes[i2];
            var prefixedProp = prefix + prop.charAt(0).toUpperCase() + prop.slice(1);
            if (!prop[prefixedProp]) {
              result[prefixedProp] = val;
            }
          }
        }
      }
      return result;
    };
    var getComputedStyle2 = function getComputedStyle3(elem, prop) {
      if (!window.getComputedStyle) {
        return null;
      }
      var computed = window.getComputedStyle(elem, null);
      if (computed == null) {
        return null;
      }
      if (prop != null) {
        return computed[prop];
      }
      return computed;
    };
    var elemWidth = function elemWidth2(elem) {
      if (elem === window) {
        if (window.innerWidth) {
          return window.innerWidth;
        }
        if (document.documentElement) {
          return document.documentElement.offsetWidth;
        }
        return document.body.offsetWidth;
      }
      if (elem === document) {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
      }
      var val;
      if ((val = getComputedStyle2(elem, "width")) && val != null) {
        return parseFloat(val);
      }
      if (elem.currentStyle) {
        return elem.offsetWidth;
      }
      return -1;
    };
    var elemHeight = function elemHeight2(elem) {
      if (elem === window) {
        if (window.innerHeight) {
          return window.innerHeight;
        }
        if (document.documentElement) {
          return document.documentElement.offsetHeight;
        }
        return document.body.offsetHeight;
      }
      if (elem === document) {
        var body = document.body;
        var html = document.documentElement;
        return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
      }
      var val;
      if ((val = getComputedStyle2(elem, "height")) && val != null) {
        return parseFloat(val);
      }
      if (elem.currentStyle) {
        return elem.offsetHeight;
      }
      return -1;
    };
    var elemContainsOffset = function elemContainsOffset2(elem, left, top2) {
      var offset = elemOffset(elem);
      offset.right = offset.left + elemWidth(elem);
      offset.bottom = offset.top + elemHeight(elem);
      return offset.left <= left && left < offset.right && offset.top <= top2 && top2 < offset.bottom;
    };
    var elemScrollOffset = function elemScrollOffset2(elem) {
      var curLeft = 0;
      var curTop = 0;
      if (elem.parentNode) {
        while (elem && elem.offsetParent) {
          curTop += elem.scrollTop;
          curLeft += elem.scrollLeft;
          elem = elem.parentNode;
        }
      }
      return {
        left: curLeft,
        top: curTop
      };
    };
    var elemIsHidden = function elemIsHidden2(elem) {
      while (elem && elem.nodeType === 1) {
        if (_elemStyle(elem, "display") === "none") {
          return true;
        }
        elem = elem.parentNode;
      }
      return false;
    };
    var elemInDom = function elemInDom2(elem) {
      while (elem) {
        if (elem === document) {
          return true;
        }
        elem = elem.parentNode || elem.getRootNode().host;
      }
      return false;
    };
    var elemIsDescendantOf = function elemIsDescendantOf2(elem, target) {
      var ancestors = elemAncestors(elem);
      for (var i2 = 0; i2 < ancestors.length; i2++) {
        if (ancestors[i2] === target) {
          return true;
        }
      }
      return false;
    };
    var elemAncestorWithClass = function elemAncestorWithClass2(elem, klass) {
      var ancestors = elemAncestors(elem);
      for (var i2 = 0; i2 < ancestors.length; i2++) {
        if (elemHasClass(ancestors[i2], klass)) {
          return ancestors[i2];
        }
      }
      return null;
    };
    var elemAncestorHasClass = function elemAncestorHasClass2(elem, klass) {
      var ancestor = elemAncestorWithClass(elem, klass);
      return !!ancestor;
    };
    var elemAncestors = function elemAncestors2(elem) {
      var current = elem;
      var result = [];
      while (current = current.parentNode) {
        result.push(current);
      }
      return result;
    };
    var elemIsInside = function elemIsInside2(elem, ancestor) {
      return elem === ancestor || elemIsDescendantOf(elem, ancestor);
    };
    var getTransitionProp = function getTransitionProp2(props, time, easing) {
      var result = [];
      for (var prop in props) {
        result.push("".concat(prop, " ").concat(time, "ms ").concat(easing));
      }
      return result.join(",");
    };
    var elemAnimate = function elemAnimate2(elem) {
      var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      options = merge({
        time: 400,
        easing: "ease"
      }, options);
      var transitions = getTransitionProp(props, options.time, options.easing);
      _elemStyle(elem, {
        transition: transitions
      });
      safeRequestAnimationFrame(function() {
        _elemStyle(elem, props);
        setTimeout(function() {
          _elemStyle(elem, {
            transition: ""
          });
          if (typeof options.callback === "function") {
            options.callback();
          }
        }, options.time);
      });
    };
    var elemBind = function elemBind2(elem, event, fn) {
      var useCapture = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
      var eventShim = function eventShim2(e) {
        e = e || window.event;
        if (!e.pageX && !e.pageY && (e.clientX || e.clientY)) {
          e.pageX = e.clientX + docScrollLeft();
          e.pageY = e.clientY + docScrollTop();
        }
        if (!e.preventDefault) {
          e.preventDefault = function() {
            e.returnValue = false;
          };
        }
        if (!e.stopPropagation) {
          e.stopPropagation = function() {
            e.cancelBubble = true;
          };
        }
        if (e.which == null) {
          e.which = e.charCode != null ? e.charCode : e.keyCode;
        }
        if (e.which == null && e.button != null) {
          if (e.button & 1) {
            e.which = 1;
          } else if (e.button & 2) {
            e.which = 3;
          } else if (e.button & 4) {
            e.which = 2;
          } else {
            e.which = 0;
          }
        }
        if (e.target) {
        } else if (e.srcElement) {
          e.target = e.srcElement;
        }
        if (e.target && e.target.nodeType === 3) {
          e.target = e.target.parentNode;
        }
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        var result = fn.apply(e.target, [e].concat(args));
        if (result === elemUnbind) {
          elemUnbind(elem, event, fn);
        }
        return result;
      };
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_6__.s._elemBind = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_6__.s._elemBind || {};
      var key = elemBindKey(elem, event, fn);
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_6__.s._elemBind[key] = eventShim;
      eventShim.elem = elem;
      eventShim.event = event;
      elem.addEventListener(event, eventShim, useCapture);
      return function() {
        elemUnbind(elem, event, fn, useCapture);
      };
    };
    var elemUnbind = function elemUnbind2(elem, event, fn) {
      var useCapture = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
      if (!(elem != null && elem._wistiaElemId != null && fn != null && fn._wistiaBindId)) {
        return;
      }
      var key = elemBindKey(elem, event, fn);
      var eventShim = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_6__.s._elemBind[key];
      if (eventShim) {
        elem.removeEventListener(event, eventShim, useCapture);
        eventShim.elem = null;
        eventShim.event = null;
      }
      return delete _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_6__.s._elemBind[key];
    };
    var elemUnbindAll = function elemUnbindAll2(elem) {
      for (var key in Wistia._elemBind) {
        var eventShim = Wistia._elemBind[key];
        if (eventShim && elem === eventShim.elem) {
          var event = eventShim.event;
          eventShim.elem.removeEventListener(event, eventShim, false);
          eventShim.elem = null;
          eventShim.event = null;
          delete Wistia._elemBind[key];
        }
      }
    };
    var elemUnbindAllInside = function elemUnbindAllInside2(container) {
      var count = 0;
      for (var key in Wistia._elemBind) {
        var eventShim = Wistia._elemBind[key];
        if (eventShim && elemIsInside(eventShim.elem, container)) {
          var event = eventShim.event;
          eventShim.elem.removeEventListener(event, eventShim, false);
          eventShim.elem = null;
          eventShim.event = null;
          delete Wistia._elemBind[key];
          count += 1;
        }
      }
      return count;
    };
    var elemBindKey = function elemBindKey2(elem, event, fn) {
      elem._wistiaElemId = elem._wistiaElemId || (0, utilities_seqid_js__WEBPACK_IMPORTED_MODULE_5__.h)("wistia_elem_");
      fn._wistiaBindId = fn._wistiaBindId || (0, utilities_seqid_js__WEBPACK_IMPORTED_MODULE_5__.h)("wistia_bind_");
      return "".concat(elem._wistiaElemId, ".").concat(event, ".").concat(fn._wistiaBindId);
    };
    var elemRebind = function elemRebind2(elem, event, fn) {
      if (fn) {
        elemUnbind(elem, event, fn);
        return elemBind(elem, event, fn);
      }
    };
    var elemBindOnce = function elemBindOnce2(elem, event, fn) {
      var wrap = function wrap2() {
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        fn.apply(this, args);
        return elemUnbind;
      };
      return elemBind(elem, event, wrap);
    };
    var elemTrigger = function elemTrigger2(elem, event) {
      for (var _len4 = arguments.length, customArguments = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        customArguments[_key4 - 2] = arguments[_key4];
      }
      if (elem.dispatchEvent) {
        var eventObj = document.createEvent("Events");
        eventObj.initEvent(event, true, false);
        if (event === "click" || event === "doubleclick") {
          eventObj.which = 1;
        } else if (event === "rightclick") {
          eventObj.which = 2;
        }
        eventObj.customArguments = customArguments;
        return elem.dispatchEvent(eventObj);
      }
      if (elem.fireEvent) {
        var _eventObj = {
          customArguments
        };
        return elem.fireEvent("on".concat(event), _eventObj);
      }
      wlog.error("neither dispatchEvent nor fireEvent is defined for", elem, event);
    };
    var fullscreenElement = function fullscreenElement2() {
      return document.fullscreenElement || document.webkitFullscreenElement;
    };
    var elemRequestFullscreen = function elemRequestFullscreen2(elem) {
      try {
        if (elem.requestFullscreen && document.fullscreenEnabled) {
          return elem.requestFullscreen().catch(function(error) {
            wlog.notice("requestFullscreen failed", error);
            return Promise.reject(error);
          });
        }
        if (elem.webkitEnterFullscreen) {
          elem.webkitEnterFullscreen();
          return Promise.resolve();
        }
      } catch (error) {
        wlog.notice("requestFullscreen failed", error);
        return Promise.reject(error);
      }
      wlog.notice("no requestFullscreen functionality detected");
      return Promise.resolve();
    };
    var elemCancelFullscreen = function elemCancelFullscreen2(elem) {
      if (document.exitFullscreen) {
        return document.exitFullscreen();
      }
      if (elem && elem.webkitExitFullscreen) {
        return new Promise(function(resolve) {
          elem.webkitExitFullscreen();
          resolve();
        });
      }
      wlog.notice("no cancelFullscreen functionality detected");
      return Promise.resolve();
    };
    var _elemStripEventAttributes = function elemStripEventAttributes(elem) {
      var attributes = elem && elem.attributes || [];
      try {
        for (var i2 = 0; i2 < attributes.length; i2++) {
          var attr = attributes[i2];
          if (/^on.+/i.test(attr.name)) {
            elem[attr.name] = null;
            elem.removeAttribute(attr.name);
          }
        }
      } catch (e) {
        wlog.error(e);
      }
      if (elem.childNodes) {
        for (var _i5 = 0; _i5 < elem.childNodes.length; _i5++) {
          var child = elem.childNodes[_i5];
          if (child.nodeType === 1) {
            _elemStripEventAttributes(child);
          }
        }
      }
    };
    var elemMutationObserver = function elemMutationObserver2(fn) {
      var klass = detect.mutationObserver;
      if (klass) {
        return new window[klass](fn);
      }
      return null;
    };
    var docScrollTop = function docScrollTop2(t) {
      var docBody = document.body;
      var docElem = document.documentElement;
      if (t != null) {
        if (docBody) {
          docBody.scrollTop = t;
        }
        if (docElem) {
          docElem.scrollTop = t;
        }
      } else {
        return docElem && docElem.scrollTop || docBody && docBody.scrollTop || 0;
      }
    };
    var docScrollLeft = function docScrollLeft2(t) {
      var docBody = document.body;
      var docElem = document.documentElement;
      if (t != null) {
        if (docBody) {
          docBody.scrollLeft = t;
        }
        if (docElem) {
          docElem.scrollLeft = t;
        }
      } else {
        return docElem && docElem.scrollLeft || docBody && docBody.scrollLeft || 0;
      }
    };
    var safeRequestAnimationFrame = function safeRequestAnimationFrame2(fn) {
      var requestAnimFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function(callback) {
        return setTimeout(callback, 1e3 / 60);
      };
      return requestAnimFrame(fn);
    };
    var formInputIsFocused = function formInputIsFocused2() {
      var activeElement = document.activeElement;
      if (document.activeElement.tagName === "WISTIA-PLAYER") {
        activeElement = document.activeElement.shadowRoot.activeElement;
      }
      if (activeElement.tagName === "WISTIA-FORM-EMBED") {
        activeElement = activeElement.shadowRoot.activeElement;
      }
      return /^textarea|input|select$/i.test(activeElement.tagName) || activeElement.isContentEditable;
    };
    var currentEventSource = function currentEventSource2() {
      return inUserEventContext() ? "user-event" : "non-user-event";
    };
    var inUserEventContext = function inUserEventContext2() {
      return !!activeDOMEvent;
    };
    var getLastActiveEventAt = function getLastActiveEventAt2() {
      return lastActiveEventAt;
    };
    var activeDOMEvent;
    var lastActiveEventAt = (
      /* unused pure expression or super */
      null
    );
    var userEventsThatShowIntent = ["auxclick", "click", "contextmenu", "dblclick", "focus", "keydown", "keypress", "keyup", "mousedown", "mouseup", "reset", "submit", "touchend", "touchstart"];
    userEventsThatShowIntent.forEach(function(type) {
      var onEvent = function onEvent2(e) {
        activeDOMEvent = e;
        lastActiveEventAt = Date.now();
        setTimeout(function() {
          if (activeDOMEvent === e) {
            activeDOMEvent = void 0;
          }
        }, 0);
      };
      elemBind(document, type, onEvent, detect.passiveSupported ? {
        capture: true,
        passive: true
      } : true);
    });
  },
  /***/
  7880(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      R: () => (
        /* binding */
        BigPlayButtonSVG
      )
      /* harmony export */
    });
    var preact__WEBPACK_IMPORTED_MODULE_0__2 = __webpack_require__3(5181);
    var _BigPlayButtonLoadingAnim_tsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(4719);
    var _utilities_svg_boilerplate_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(1919);
    function _extends() {
      return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for (var e = 1; e < arguments.length; e++) {
          var t = arguments[e];
          for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
      }, _extends.apply(null, arguments);
    }
    var ICON_WIDTH = 37;
    var ICON_HEIGHT = 36;
    var LOADING_ALPHA = 0.5;
    var BigPlayButtonSVG = function BigPlayButtonSVG2(_ref) {
      var width = _ref.width, height = _ref.height, scale = _ref.scale, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, overrideFillColor = _ref.overrideFillColor;
      var scaledHeight = height * scale;
      var svgAttrs = (0, _utilities_svg_boilerplate_ts__WEBPACK_IMPORTED_MODULE_2__.I)({
        width,
        height,
        styleOverride: {
          position: "absolute",
          height: "".concat(scaledHeight, "px"),
          color: overrideFillColor
        },
        ariaHidden: true
      });
      var iconXOffset = -(ICON_WIDTH / 2) + width / 2;
      var iconYOffset = -(ICON_HEIGHT / 2) + height / 2;
      return (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("svg", _extends({}, svgAttrs, {
        "aria-hidden": "true"
      }), (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        fill: "currentcolor",
        opacity: isLoading ? LOADING_ALPHA : 1,
        transform: "translate(".concat(iconXOffset, ", ").concat(iconYOffset, ")"),
        d: "M12.138 2.173C10.812 1.254 9 2.203 9 3.817v28.366c0 1.613 1.812 2.563 3.138 1.644l20.487-14.183a2 2 0 0 0 0-3.288L12.138 2.173Z"
      }), isLoading && (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)(_BigPlayButtonLoadingAnim_tsx__WEBPACK_IMPORTED_MODULE_1__.e, null));
    };
  },
  /***/
  8089(module, exports, __webpack_require__3) {
    module = __webpack_require__3.nmd(module);
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var HOT_COUNT = 800, HOT_SPAN = 16;
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var freeGlobal = typeof __webpack_require__3.g == "object" && __webpack_require__3.g && __webpack_require__3.g.Object === Object && __webpack_require__3.g;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = (function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    })();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
    var coreJsData = root2["__core-js_shared__"];
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    })();
    var nativeObjectToString = objectProto.toString;
    var objectCtorString = funcToString.call(Object);
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Buffer = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array = root2.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    var defineProperty = (function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {
      }
    })();
    var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0, nativeMax = Math.max, nativeNow = Date.now;
    var Map2 = getNative(root2, "Map"), nativeCreate = getNative(Object, "create");
    var baseCreate = /* @__PURE__ */ (function() {
      function object() {
      }
      return function(proto) {
        if (!isObject2(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = void 0;
        return result;
      };
    })();
    function Hash(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray2(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assignMergeValue(object, key, value) {
      if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    function baseAssignValue(object, key, value) {
      if (key == "__proto__" && defineProperty) {
        defineProperty(object, key, {
          "configurable": true,
          "enumerable": true,
          "value": value,
          "writable": true
        });
      } else {
        object[key] = value;
      }
    }
    var baseFor = createBaseFor();
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    function baseIsNative(value) {
      if (!isObject2(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    function baseKeysIn(object) {
      if (!isObject2(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object), result = [];
      for (var key in object) {
        if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack());
        if (isObject2(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
          if (newValue === void 0) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
      var isCommon = newValue === void 0;
      if (isCommon) {
        var isArr = isArray2(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray2(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject2(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }
      if (isCommon) {
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + "");
    }
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    function copyArray(source, array) {
      var index = -1, length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1, length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
        if (newValue === void 0) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? void 0 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    function initCloneObject(object) {
      return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    function isIterateeCall(value, index, object) {
      if (!isObject2(object)) {
        return false;
      }
      var type = typeof index;
      if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
        return eq(object[index], value);
      }
      return false;
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    function overRest(func, start, transform) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    function safeGet(object, key) {
      if (key === "constructor" && typeof object[key] === "function") {
        return;
      }
      if (key == "__proto__") {
        return;
      }
      return object[key];
    }
    var setToString = shortOut(baseSetToString);
    function shortOut(func) {
      var count = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    var isArguments = baseIsArguments(/* @__PURE__ */ (function() {
      return arguments;
    })()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    var isArray2 = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isFunction(value) {
      if (!isObject2(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject2(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
      return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }
    var merge2 = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });
    function constant(value) {
      return function() {
        return value;
      };
    }
    function identity(value) {
      return value;
    }
    function stubFalse() {
      return false;
    }
    module.exports = merge2;
  },
  /***/
  8176(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      z: () => (
        /* binding */
        root2
      )
      /* harmony export */
    });
    var rootTest;
    try {
      rootTest = self;
      if (rootTest.self !== rootTest && typeof rootTest.self !== "undefined" && typeof window !== "undefined") {
        rootTest = window;
      }
    } catch (err) {
      if (typeof globalThis !== "undefined") {
        rootTest = globalThis;
      } else {
        rootTest = window;
      }
    }
    var root2 = rootTest;
  },
  /***/
  8213(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      w5: () => (
        /* binding */
        interNumbersSemiBold
      )
      /* harmony export */
    });
    var interBoldItalicFontFamily = "WistiaPlayerInterBoldItalic, Helvetica, Sans-Serif";
    var interFontFamily = "WistiaPlayerInter, Helvetica, Sans-Serif";
    var interSemiBoldFontFamily = "WistiaPlayerInterSemiBold, Helvetica, Sans-Serif";
    var interNumbersSemiBold = "WistiaPlayerInterNumbersSemiBold, Helvetica, Sans-Serif";
  },
  /***/
  8290(module, exports, __webpack_require__3) {
    module = __webpack_require__3.nmd(module);
    var LARGE_ARRAY_SIZE = 200;
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var MAX_SAFE_INTEGER = 9007199254740991;
    var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reFlags = /\w*$/;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var freeGlobal = typeof __webpack_require__3.g == "object" && __webpack_require__3.g && __webpack_require__3.g.Object === Object && __webpack_require__3.g;
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root2 = freeGlobal || freeSelf || Function("return this")();
    var freeExports = exports && !exports.nodeType && exports;
    var freeModule = freeExports && true && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    function addMapEntry(map, pair) {
      map.set(pair[0], pair[1]);
      return map;
    }
    function addSetEntry(set, value) {
      set.add(value);
      return set;
    }
    function arrayEach(array, iteratee) {
      var index = -1, length = array ? array.length : 0;
      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayPush(array, values) {
      var index = -1, length = values.length, offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1, length = array ? array.length : 0;
      if (initAccum && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    function isHostObject(value) {
      var result = false;
      if (value != null && typeof value.toString != "function") {
        try {
          result = !!(value + "");
        } catch (e) {
        }
      }
      return result;
    }
    function mapToArray(map) {
      var index = -1, result = Array(map.size);
      map.forEach(function(value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    function setToArray(set) {
      var index = -1, result = Array(set.size);
      set.forEach(function(value) {
        result[++index] = value;
      });
      return result;
    }
    var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
    var coreJsData = root2["__core-js_shared__"];
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    })();
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var objectToString = objectProto.toString;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    var Buffer = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array = root2.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
    var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0, nativeKeys = overArg(Object.keys, Object);
    var DataView = getNative(root2, "DataView"), Map2 = getNative(root2, "Map"), Promise2 = getNative(root2, "Promise"), Set2 = getNative(root2, "Set"), WeakMap2 = getNative(root2, "WeakMap"), nativeCreate = getNative(Object, "create");
    var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function Hash(entries) {
      var index = -1, length = entries ? entries.length : 0;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
    }
    function hashDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    function hashSet(key, value) {
      var data = this.__data__;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    function ListCache(entries) {
      var index = -1, length = entries ? entries.length : 0;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function listCacheClear() {
      this.__data__ = [];
    }
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      return true;
    }
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    function MapCache(entries) {
      var index = -1, length = entries ? entries.length : 0;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    function mapCacheClear() {
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    function mapCacheDelete(key) {
      return getMapData(this, key)["delete"](key);
    }
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    function mapCacheSet(key, value) {
      getMapData(this, key).set(key, value);
      return this;
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    function Stack(entries) {
      this.__data__ = new ListCache(entries);
    }
    function stackClear() {
      this.__data__ = new ListCache();
    }
    function stackDelete(key) {
      return this.__data__["delete"](key);
    }
    function stackGet(key) {
      return this.__data__.get(key);
    }
    function stackHas(key) {
      return this.__data__.has(key);
    }
    function stackSet(key, value) {
      var cache = this.__data__;
      if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          return this;
        }
        cache = this.__data__ = new MapCache(pairs);
      }
      cache.set(key, value);
      return this;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    function arrayLikeKeys(value, inherited) {
      var result = isArray2(value) || isArguments(value) ? baseTimes(value.length, String) : [];
      var length = result.length, skipIndexes = !!length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
        object[key] = value;
      }
    }
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }
    function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== void 0) {
        return result;
      }
      if (!isObject2(value)) {
        return value;
      }
      var isArr = isArray2(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
          if (isHostObject(value)) {
            return object ? value : {};
          }
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      stack || (stack = new Stack());
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);
      if (!isArr) {
        var props = isFull ? getAllKeys(value) : keys(value);
      }
      arrayEach(props || value, function(subValue, key2) {
        if (props) {
          key2 = subValue;
          subValue = value[key2];
        }
        assignValue(result, key2, baseClone(subValue, isDeep, isFull, customizer, key2, value, stack));
      });
      return result;
    }
    function baseCreate(proto) {
      return isObject2(proto) ? objectCreate(proto) : {};
    }
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray2(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    function baseGetTag(value) {
      return objectToString.call(value);
    }
    function baseIsNative(value) {
      if (!isObject2(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var result = new buffer.constructor(buffer.length);
      buffer.copy(result);
      return result;
    }
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor());
    }
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor());
    }
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    function copyArray(source, array) {
      var index = -1, length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }
    function copyObject(source, props, object, customizer) {
      object || (object = {});
      var index = -1, length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
        assignValue(object, key, newValue === void 0 ? source[key] : newValue);
      }
      return object;
    }
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
    var getTag = baseGetTag;
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
      getTag = function(value) {
        var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : void 0;
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    function initCloneArray(array) {
      var length = array.length, result = array.constructor(length);
      if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }
    function initCloneObject(object) {
      return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
          return new Ctor(+object);
        case dataViewTag:
          return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
          return cloneTypedArray(object, isDeep);
        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
          return new Ctor(object);
        case regexpTag:
          return cloneRegExp(object);
        case setTag:
          return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
          return cloneSymbol(object);
      }
    }
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    function cloneDeep(value) {
      return baseClone(value, true, true);
    }
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    function isArguments(value) {
      return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
    }
    var isArray2 = Array.isArray;
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    var isBuffer = nativeIsBuffer || stubFalse;
    function isFunction(value) {
      var tag = isObject2(value) ? objectToString.call(value) : "";
      return tag == funcTag || tag == genTag;
    }
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    function isObject2(value) {
      var type = typeof value;
      return !!value && (type == "object" || type == "function");
    }
    function isObjectLike(value) {
      return !!value && typeof value == "object";
    }
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    function stubArray() {
      return [];
    }
    function stubFalse() {
      return false;
    }
    module.exports = cloneDeep;
  },
  /***/
  9025(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      k: () => (
        /* binding */
        assign
      )
      /* harmony export */
    });
    var _objectHasOwn = function(object, property) {
      if (typeof object === "undefined" || object === null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    };
    var assign = function assign2(obj1) {
      for (var _len = arguments.length, objs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        objs[_key - 1] = arguments[_key];
      }
      if (Object.assign) {
        return Object.assign.apply(Object, [obj1].concat(objs));
      }
      for (var i2 = 0; i2 < objs.length; i2++) {
        assignOne(obj1, objs[i2]);
      }
      return obj1;
    };
    var assignOne = function assignOne2(obj1, obj2) {
      for (var k in obj2) {
        if (_objectHasOwn(obj2, k)) {
          obj1[k] = obj2[k];
        }
      }
      return obj1;
    };
  },
  /***/
  9061(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      E0: () => (
        /* binding */
        unbindAllInNamespace
      ),
      /* harmony export */
      Nw: () => (
        /* binding */
        unbind
      ),
      /* harmony export */
      RX: () => (
        /* binding */
        bindNamed
      ),
      /* harmony export */
      _Z: () => (
        /* binding */
        unbindNamed
      ),
      /* harmony export */
      hZ: () => (
        /* binding */
        trigger
      ),
      /* harmony export */
      oI: () => (
        /* binding */
        bind
      )
      /* harmony export */
    });
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(5509);
    var _objectHasOwn = function(object, property) {
      if (typeof object === "undefined" || object === null) {
        throw new TypeError("Cannot convert undefined or null to object");
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    };
    function _toConsumableArray(r) {
      return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray2(r) || _nonIterableSpread();
    }
    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _iterableToArray(r) {
      if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _arrayWithoutHoles(r) {
      if (Array.isArray(r)) return _arrayLikeToArray2(r);
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    var aps = Array.prototype.slice;
    var bind = function bind2(event, fn) {
      var self2 = this;
      if (!self2._bindings) {
        self2._bindings = {};
      }
      if (!self2._bindings[event]) {
        self2._bindings[event] = [];
      }
      self2._bindings[event].push(fn);
      return function() {
        self2.unbind(event, fn);
      };
    };
    var unbind = function unbind2(event, fn) {
      if (!this._bindings) {
        return this;
      }
      if (!this._bindings[event]) {
        return this;
      }
      var bindings = [];
      for (var i2 = 0; i2 < this._bindings[event].length; i2++) {
        var boundFn = this._bindings[event][i2];
        if (boundFn !== fn) {
          bindings.push(boundFn);
        }
      }
      this._bindings[event] = bindings;
    };
    var rebind = function rebind2(event, fn) {
      this.unbind(event, fn);
      this.bind(event, fn);
      return {
        event,
        fn
      };
    };
    var trigger = function trigger2(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this._bindings && this._bindings.all != null) {
        triggerImpl.apply(this, ["all", event].concat(args));
      }
      return triggerImpl.apply(this, [event].concat(args));
    };
    var triggerImpl = function triggerImpl2(event) {
      if (!this._bindings) {
        return this;
      }
      if (!this._bindings[event]) {
        return this;
      }
      var args = aps.call(arguments, 1);
      var unbinds;
      var bindings = _toConsumableArray(this._bindings[event]);
      for (var i2 = 0; i2 < bindings.length; i2++) {
        var fn = bindings[i2];
        try {
          var ret = fn.apply(this, args);
          if (ret === this.unbind) {
            if (unbinds == null) {
              unbinds = [];
            }
            unbinds.push({
              event,
              fn
            });
          }
        } catch (e) {
          if (this._throwTriggerErrors) {
            throw e;
          } else if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s.error) {
            _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_0__.s.error(e);
          }
        }
      }
      if (unbinds) {
        for (var _i = 0; _i < unbinds.length; _i++) {
          var _unbind = unbinds[_i];
          this.unbind(_unbind.event, _unbind.fn);
        }
      }
      return this;
    };
    var once = function once2(event, fn) {
      var wrappedFn = function wrappedFn2() {
        fn.apply(this, aps.call(arguments, 0));
        return unbind;
      };
      return bind(event, wrappedFn);
    };
    var initNamespace = function initNamespace2(ctx, namespace) {
      if (ctx._namedBindings == null) {
        ctx._namedBindings = {};
      }
      if (ctx._namedBindings[namespace] == null) {
        ctx._namedBindings[namespace] = {};
      }
    };
    var getNamedBinding = function getNamedBinding2(ctx, namespace, fnKey) {
      initNamespace(ctx, namespace);
      return ctx._namedBindings[namespace][fnKey];
    };
    var setNamedBinding = function setNamedBinding2(ctx, namespace, fnKey, event, fn) {
      initNamespace(ctx, namespace);
      ctx._namedBindings[namespace][fnKey] = {
        event,
        fn
      };
    };
    var bindNamed = function bindNamed2(namespace, fnKey, event, fn) {
      this.unbindNamed(namespace, fnKey);
      setNamedBinding(this, namespace, fnKey, event, fn);
      this.bind(event, fn);
      return function() {
        this.unbindNamed(namespace, fnKey);
      };
    };
    var unbindNamed = function unbindNamed2(namespace, fnKey) {
      initNamespace(this, namespace);
      var entry = getNamedBinding(this, namespace, fnKey);
      if (entry) {
        var event = entry.event, fn = entry.fn;
        this.unbind(event, fn);
      }
      var namedBindings = this._namedBindings;
      delete namedBindings[namespace][fnKey];
      if (isEmpty(namedBindings[namespace])) {
        delete namedBindings[namespace];
      }
      return this;
    };
    var unbindAllInNamespace = function unbindAllInNamespace2(namespace) {
      var bindings = this._namedBindings && this._namedBindings[namespace];
      if (bindings == null) {
        return this;
      }
      for (var fnKey in bindings) {
        if (_objectHasOwn(bindings, fnKey)) {
          this.unbindNamed(namespace, fnKey);
        }
      }
    };
    var isEmpty = function isEmpty2(obj) {
      for (var k in obj) {
        if (_objectHasOwn(obj, k)) {
          return false;
        }
      }
      return true;
    };
    var bindify = function bindify2(prototype) {
      prototype.bind = bind;
      prototype.unbind = unbind;
      prototype.on = bind;
      prototype.off = unbind;
      prototype.rebind = rebind;
      prototype.trigger = trigger;
      prototype.bindNamed = bindNamed;
      prototype.unbindNamed = unbindNamed;
      prototype.unbindAllInNamespace = unbindAllInNamespace;
      return prototype;
    };
    var Bindings = function Bindings2() {
    };
    bindify(Bindings.prototype);
  },
  /***/
  9128(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      a: () => (
        /* binding */
        normalizeChapters
      )
      /* harmony export */
    });
    var _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9814);
    var normalizeChapters = function normalizeChapters2(embedOptions) {
      var plugin = embedOptions.plugin, chaptersOn = embedOptions.chaptersOn, chapterList = embedOptions.chapterList;
      if (plugin !== null && plugin !== void 0 && plugin.chapters) {
        return plugin.chapters;
      }
      var areChaptersOn = chaptersOn === true || chaptersOn === "true";
      if ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.n9)(chapterList) || areChaptersOn) {
        var hasChapters = (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_0__.n9)(chapterList) && chapterList.length > 0;
        var list = hasChapters ? chapterList : [];
        return {
          on: chaptersOn,
          chapterList: list
        };
      }
      return void 0;
    };
  },
  /***/
  9376(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      R: () => (
        /* binding */
        makeWbindable
      )
      /* harmony export */
    });
    var utilities_bindify_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(9061);
    var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(5509);
    var _eventShepherd_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(2694);
    if (!_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.bindable) {
      if (!_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager) {
        _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager = {};
      }
      _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.bindable = {
        bind: function bind(event, callback) {
          if (event === "crosstime" && this.crossTime) {
            this.crossTime.addBinding(arguments[1], arguments[2]);
            return this;
          }
          if (event === "betweentimes" && this.betweenTimes) {
            this.betweenTimes.addBinding(arguments[1], arguments[2], arguments[3]);
            return this;
          }
          var embedElement = this.embedElement || this.container;
          if (Object.keys(_eventShepherd_ts__WEBPACK_IMPORTED_MODULE_2__.h).includes(event) && embedElement) {
            var id = identifierFromEmbedElement(embedElement);
            if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id] === void 0) {
              _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id] = new _eventShepherd_ts__WEBPACK_IMPORTED_MODULE_2__.S();
            }
            _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id].addListener(event, embedElement, callback);
            return this;
          }
          if (callback) {
            utilities_bindify_js__WEBPACK_IMPORTED_MODULE_0__.oI.call(this, event, callback);
            return this;
          }
          if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.warn) {
            _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.warn(this.constructor.name, "bind", "falsey value passed in as callback:", callback);
          }
        },
        // unbind the matching callback and event for this video
        unbind: function unbind(event, callback) {
          if (event === "crosstime" && this.crossTime) {
            if (!callback) {
              this.crossTime.removeAllBindings();
            } else {
              this.crossTime.removeBinding(arguments[1], arguments[2]);
            }
            return this;
          }
          if (event === "betweentimes" && this.betweenTimes) {
            if (!callback) {
              this.betweenTimes.removeAllBindings();
            } else {
              this.betweenTimes.removeBinding(arguments[1], arguments[2], arguments[3]);
            }
            return this;
          }
          var embedElement = this.embedElement || this.container;
          if (Object.keys(_eventShepherd_ts__WEBPACK_IMPORTED_MODULE_2__.h).includes(event) && embedElement) {
            var id = identifierFromEmbedElement(embedElement);
            if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id] === void 0) {
              return this;
            }
            _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id].removeListener(event, embedElement, callback);
            return this;
          }
          if (callback) {
            utilities_bindify_js__WEBPACK_IMPORTED_MODULE_0__.Nw.call(this, event, callback);
          } else if (this._bindings) {
            this._bindings[event] = [];
          }
          if (this._bindings && this._bindings[event] && !this._bindings[event].length) {
            this._bindings[event] = null;
            delete this._bindings[event];
          }
          return this;
        },
        on: function on(event, fn) {
          var _arguments = arguments, _this = this;
          if (event === "crosstime" && this.crossTime) {
            this.crossTime.addBinding(arguments[1], arguments[2]);
            return function() {
              _this.crossTime.removeBinding(_arguments[1], _arguments[2]);
            };
          }
          if (event === "betweentimes" && this.betweenTimes) {
            this.betweenTimes.addBinding(arguments[1], arguments[2], arguments[3]);
            return function() {
              _this.betweenTimes.removeBinding(_arguments[1], _arguments[2], _arguments[3]);
            };
          }
          var embedElement = this.embedElement || this.container;
          if (Object.keys(_eventShepherd_ts__WEBPACK_IMPORTED_MODULE_2__.h).includes(event) && embedElement) {
            var id = identifierFromEmbedElement(embedElement);
            if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id] === void 0) {
              _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id] = new _eventShepherd_ts__WEBPACK_IMPORTED_MODULE_2__.S(embedElement);
            }
            _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id].addListener(event, embedElement, fn);
            return function() {
              _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id].removeListener(event, embedElement, fn);
            };
          }
          return utilities_bindify_js__WEBPACK_IMPORTED_MODULE_0__.oI.call(this, event, fn);
        },
        off: function off(event, fn) {
          if (event === "crosstime" && this.crossTime) {
            return this.crossTime.removeBinding(arguments[1], arguments[2]);
          }
          if (event === "betweentimes" && this.betweenTimes) {
            return this.betweenTimes.removeBinding(arguments[1], arguments[2], arguments[3]);
          }
          var embedElement = this.embedElement || this.container;
          if (Object.keys(_eventShepherd_ts__WEBPACK_IMPORTED_MODULE_2__.h).includes(event) && embedElement) {
            var id = identifierFromEmbedElement(embedElement);
            if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id] === void 0) {
              return function() {
              };
            }
            return _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.EventShepherdManager[id].removeListener(event, embedElement, fn);
          }
          return utilities_bindify_js__WEBPACK_IMPORTED_MODULE_0__.Nw.call(this, event, fn);
        },
        rebind: function rebind(event, callback) {
          this.unbind(event, callback);
          this.bind(event, callback);
          return this;
        },
        // fire an event trigger on the video. for play/pause/ended callbacks.
        trigger: function trigger(event) {
          var _bindify$trigger;
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          (_bindify$trigger = utilities_bindify_js__WEBPACK_IMPORTED_MODULE_0__.hZ).call.apply(_bindify$trigger, [this, event].concat(args));
          return this;
        },
        bindNamed: function bindNamed() {
          return utilities_bindify_js__WEBPACK_IMPORTED_MODULE_0__.RX.apply(this, arguments);
        },
        unbindNamed: function unbindNamed() {
          return utilities_bindify_js__WEBPACK_IMPORTED_MODULE_0__._Z.apply(this, arguments);
        },
        unbindAllInNamespace: function unbindAllInNamespace() {
          return utilities_bindify_js__WEBPACK_IMPORTED_MODULE_0__.E0.apply(this, arguments);
        }
      };
    }
    var makeWbindable = function makeWbindable2(obj) {
      for (var k in _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.bindable) {
        var v = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_1__.s.bindable[k];
        if (!obj[k]) {
          obj[k] = v;
        }
      }
    };
    var identifierFromEmbedElement = function identifierFromEmbedElement2(embedElement) {
      if (embedElement !== null && embedElement !== void 0 && embedElement.mediaId) {
        return embedElement.mediaId;
      }
      if (embedElement !== null && embedElement !== void 0 && embedElement.id) {
        return embedElement.id;
      }
    };
  },
  /***/
  9392(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      C: () => (
        /* binding */
        getWistiaOptions
      )
      /* harmony export */
    });
    var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__3(8089);
    var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /* @__PURE__ */ __webpack_require__3.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
    var getWistiaOptions = function getWistiaOptions2(mediaId) {
      var _window$wistiaOptions, _window$wistiaOptions2;
      if (!window.wistiaOptions) {
        return {};
      }
      var globalOptions = (_window$wistiaOptions = window.wistiaOptions._all) !== null && _window$wistiaOptions !== void 0 ? _window$wistiaOptions : {};
      var mediaOptions = (_window$wistiaOptions2 = window.wistiaOptions[mediaId]) !== null && _window$wistiaOptions2 !== void 0 ? _window$wistiaOptions2 : {};
      return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(globalOptions, mediaOptions);
    };
  },
  /***/
  9562(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      R: () => (
        /* binding */
        pageLoaded
      )
      /* harmony export */
    });
    var pageLoaded = function pageLoaded2(fn) {
      var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4e3;
      var doc = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
      var win = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : window;
      if (/loaded|complete/.test(doc.readyState)) {
        setTimeout(fn, 0);
      } else {
        var unbind = function unbind2() {
          win.removeEventListener("load", onPageLoad, false);
        };
        var onPageLoad = function onPageLoad2() {
          clearTimeout(onLoadTimeout);
          unbind();
          fn();
        };
        win.addEventListener("load", onPageLoad, false);
        var onLoadTimeout = setTimeout(function() {
          unbind();
          fn();
        }, timeout);
      }
    };
  },
  /***/
  9804(__unused_webpack_module, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      u: () => (
        /* binding */
        PreloadThumbnail
      )
      /* harmony export */
    });
    var preact__WEBPACK_IMPORTED_MODULE_0__2 = __webpack_require__3(5181);
    var preact_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__3(3817);
    var _hooks_usePlayerData_tsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__3(2721);
    var _utilities_constants_ts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__3(1512);
    var _media_players_vulcanV2Player_shared_ui_components_BigPlayButton_tsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__3(6906);
    var _shared_ProgressiveThumbnail_jsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__3(3164);
    var _shared_translations_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__3(4730);
    var _utilities_assets_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__3(7209);
    var _utilities_fit_control_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__3(4309);
    var _utilities_roundedPlayerDefaults_ts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__3(3123);
    var _utilities_gradients_ts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__3(4372);
    var _types_gradient_ts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__3(7350);
    var _utilities_color_utils_ts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__3(998);
    function _slicedToArray2(r, e) {
      return _arrayWithHoles2(r) || _iterableToArrayLimit2(r, e) || _unsupportedIterableToArray2(r, e) || _nonIterableRest2();
    }
    function _nonIterableRest2() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _unsupportedIterableToArray2(r, a) {
      if (r) {
        if ("string" == typeof r) return _arrayLikeToArray2(r, a);
        var t = {}.toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray2(r, a) : void 0;
      }
    }
    function _arrayLikeToArray2(r, a) {
      (null == a || a > r.length) && (a = r.length);
      for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
      return n;
    }
    function _iterableToArrayLimit2(r, l) {
      var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
      if (null != t) {
        var e, n, i2, u, a = [], f = true, o = false;
        try {
          if (i2 = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t) return;
            f = false;
          } else for (; !(f = (e = i2.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
        } catch (r2) {
          o = true, n = r2;
        } finally {
          try {
            if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
          } finally {
            if (o) throw n;
          }
        }
        return a;
      }
    }
    function _arrayWithHoles2(r) {
      if (Array.isArray(r)) return r;
    }
    var MAX_SCALE = 1.3;
    var MIN_SCALE = 0.3;
    var DEFAULT_LOWER_CUTOFF_WIDTH = 640;
    var DEFAULT_UPPER_CUTOFF_WIDTH = 960;
    var PreloadThumbnail = function PreloadThumbnail2(_ref) {
      var _ref2, _ref3, _getGradientColor;
      var isPlayPending = _ref.isPlayPending, mediaId = _ref.mediaId, playerType = _ref.playerType, playerWidth = _ref.playerWidth;
      var _useState = (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useState)(false), _useState2 = _slicedToArray2(_useState, 2), isLoading = _useState2[0], setIsLoading = _useState2[1];
      (0, preact_hooks__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isPlayPending) {
          setIsLoading(true);
        }
      }, [isPlayPending]);
      var _usePlayerData = (0, _hooks_usePlayerData_tsx__WEBPACK_IMPORTED_MODULE_2__.$)(), embedOptions = _usePlayerData.embedOptions, mediaData = _usePlayerData.mediaData;
      var aspect = embedOptions.aspect, bigPlayButton = embedOptions.bigPlayButton, bpbTime = embedOptions.bpbTime, bigPlayButtonBorderRadius = embedOptions.bigPlayButtonBorderRadius, contrastIcons = embedOptions.contrastIcons, controlBarBorderRadius = embedOptions.controlBarBorderRadius, controlsVisibleOnLoad = embedOptions.controlsVisibleOnLoad, floatingControlBar = embedOptions.floatingControlBar, noMixBlendMode = embedOptions.noMixBlendMode, opaqueControls = embedOptions.opaqueControls, playButton = embedOptions.playButton, playerBorderRadius = embedOptions.playerBorderRadius, playerColor = embedOptions.playerColor, playerColorGradient = embedOptions.playerColorGradient, playerLanguage = embedOptions.playerLanguage, roundedPlayer = embedOptions.roundedPlayer, thumbnailAltText = embedOptions.thumbnailAltText, transparentLetterbox = embedOptions.transparentLetterbox;
      var aspectRatio = mediaData.aspectRatio, assets = mediaData.assets, duration = mediaData.duration, mediaType = mediaData.mediaType, name = mediaData.name;
      var height = playerWidth / ((_ref2 = aspect !== null && aspect !== void 0 ? aspect : aspectRatio) !== null && _ref2 !== void 0 ? _ref2 : _utilities_constants_ts__WEBPACK_IMPORTED_MODULE_3__.R);
      var scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, (0, _utilities_fit_control_js__WEBPACK_IMPORTED_MODULE_8__.wt)(playerWidth, [DEFAULT_LOWER_CUTOFF_WIDTH, DEFAULT_UPPER_CUTOFF_WIDTH])));
      var calculatedControlsVisibleOnLoad = controlsVisibleOnLoad && playerType === "vulcan-v2";
      var defaultControlBarDistance = (0, _utilities_roundedPlayerDefaults_ts__WEBPACK_IMPORTED_MODULE_9__.Ru)({
        controlBarBorderRadius,
        floatingControlBar,
        roundedPlayer
      });
      var calculatedControlBarDistance = calculatedControlsVisibleOnLoad ? (_utilities_constants_ts__WEBPACK_IMPORTED_MODULE_3__.E / 2 + defaultControlBarDistance) * scale : defaultControlBarDistance * scale;
      var calculatedBigPlayButtonBorderRadius = (0, _utilities_roundedPlayerDefaults_ts__WEBPACK_IMPORTED_MODULE_9__.gl)({
        bigPlayButtonBorderRadius,
        roundedPlayer
      }) * scale;
      var calculatedPlayerBorderRadius = (0, _utilities_roundedPlayerDefaults_ts__WEBPACK_IMPORTED_MODULE_9__.JA)({
        playerBorderRadius,
        roundedPlayer
      }) * scale;
      var backgroundColor = transparentLetterbox === true || calculatedPlayerBorderRadius > 0 ? "transparent" : void 0;
      var thumbnailAssets = (0, _utilities_assets_js__WEBPACK_IMPORTED_MODULE_7__.Q0)(assets, {});
      var calculatedPlayerLanguage = (_ref3 = (0, _shared_translations_js__WEBPACK_IMPORTED_MODULE_6__.Z0)(playerLanguage)) !== null && _ref3 !== void 0 ? _ref3 : (0, _shared_translations_js__WEBPACK_IMPORTED_MODULE_6__.Z0)("en-US");
      var shouldShowBigPlayButton = bigPlayButton !== false && playButton !== false;
      var shouldShowBpbTime = bpbTime === true || bpbTime === "true";
      var backgroundGradientCss = playerColorGradient !== null && playerColorGradient !== void 0 && playerColorGradient.on ? (0, _utilities_gradients_ts__WEBPACK_IMPORTED_MODULE_10__.qN)(playerColorGradient) : void 0;
      var playerColorOrGradientColor = playerColorGradient !== null && playerColorGradient !== void 0 && playerColorGradient.on && (0, _types_gradient_ts__WEBPACK_IMPORTED_MODULE_11__.b)(playerColorGradient) ? (_getGradientColor = (0, _utilities_gradients_ts__WEBPACK_IMPORTED_MODULE_10__.yz)(playerColorGradient)) !== null && _getGradientColor !== void 0 ? _getGradientColor : playerColor : playerColor;
      var handleClick = function handleClick2() {
        setIsLoading(true);
      };
      return (
        // Provide the icon color for the BigPlayButton
        (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("div", {
          style: {
            "--wistia-player-icon-color": (0, _utilities_color_utils_ts__WEBPACK_IMPORTED_MODULE_12__.hu)(playerColor !== null && playerColor !== void 0 ? playerColor : "#636155", contrastIcons !== null && contrastIcons !== void 0 ? contrastIcons : false, (playerColorGradient === null || playerColorGradient === void 0 ? void 0 : playerColorGradient.on) === true)
          }
        }, (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)("div", {
          class: "w-css-reset",
          style: {
            cursor: "pointer",
            width: "100%",
            height: "".concat(height, "px")
          },
          onClick: handleClick,
          tabIndex: shouldShowBigPlayButton ? -1 : 0
        }, (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)(_shared_ProgressiveThumbnail_jsx__WEBPACK_IMPORTED_MODULE_5__.E, {
          backgroundColor,
          images: thumbnailAssets,
          isVisible: true,
          hashedId: mediaId,
          playerBorderRadius: calculatedPlayerBorderRadius,
          swatchEnabled: false,
          uiHasRendered: false,
          thumbnailAltText: thumbnailAltText !== null && thumbnailAltText !== void 0 ? thumbnailAltText : "",
          height: "".concat(height, "px")
        })), shouldShowBigPlayButton && (0, preact__WEBPACK_IMPORTED_MODULE_0__2.h)(_media_players_vulcanV2Player_shared_ui_components_BigPlayButton_tsx__WEBPACK_IMPORTED_MODULE_4__.Fn, {
          borderRadius: calculatedBigPlayButtonBorderRadius,
          buttonTabIndex: 0,
          color: playerColorOrGradientColor,
          controlBarDistance: calculatedControlBarDistance,
          duration: duration !== null && duration !== void 0 ? duration : 0,
          hasContrastIcons: contrastIcons !== null && contrastIcons !== void 0 ? contrastIcons : false,
          isLiveMedia: mediaType === "LiveStream",
          isLoading,
          isOpaque: opaqueControls,
          isVisible: true,
          noMixBlendMode,
          onClick: handleClick,
          playerLanguage: calculatedPlayerLanguage,
          scale,
          showBpbTime: shouldShowBpbTime,
          videoName: name !== null && name !== void 0 ? name : "",
          videoWidth: playerWidth,
          backgroundGradientCss
        }))
      );
    };
  },
  /***/
  9814(__unused_webpack___webpack_module__2, __webpack_exports__3, __webpack_require__3) {
    __webpack_require__3.d(__webpack_exports__3, {
      /* harmony export */
      gD: () => (
        /* binding */
        isNil2
      ),
      /* harmony export */
      jw: () => (
        /* binding */
        isEmptyString
      ),
      /* harmony export */
      n9: () => (
        /* binding */
        isNotNil
      ),
      /* harmony export */
      uu: () => (
        /* binding */
        isNonEmptyRecord
      )
      /* harmony export */
    });
    var FALSY_VALUES = [false, 0, -0, 0n, "", null, void 0, Number.NaN];
    var isNull = (value) => value === null;
    var isNotNull = (value) => !isNull(value);
    var isUndefined = (value) => value === void 0;
    var isNotUndefined = (value) => !isUndefined(value);
    var isNil2 = (value) => isNull(value) || isUndefined(value);
    var isNotNil = (value) => !isNil2(value);
    var isString = (value) => typeof value === "string";
    var isNotString = (value) => !isString(value);
    var isEmptyString = (value) => isString(value) && value === "";
    var isNonEmptyString2 = (value) => isString(value) && !isEmptyString(value);
    var isNumber2 = (value) => typeof value === "number";
    var isNotNumber = (value) => !isNumber2(value);
    var isNaN2 = (value) => Number.isNaN(value);
    var isInteger = (value) => Number.isInteger(value);
    var isRecord = (value) => isNotNil(value) && typeof value === "object" && !(value instanceof Array);
    var isNotRecord = (value) => !isRecord(value);
    var isEmptyRecord = (value) => isRecord(value) && Object.keys(value).length === 0;
    var isNonEmptyRecord = (value) => isRecord(value) && Object.keys(value).length > 0;
    var isArray2 = (value) => isNotNil(value) && typeof value === "object" && value instanceof Array;
    var isNotArray = (value) => !isArray2(value);
    var isEmptyArray = (value) => isArray2(value) && value.length === 0;
    var isNonEmptyArray = (value) => isArray2(value) && value.length > 0;
    var isFunction = (value) => isNotNil(value) && typeof value === "function";
    var isNotFunction = (value) => !isFunction(value);
    var isBoolean = (value) => isNotNil(value) && typeof value === "boolean";
    var isNotBoolean = (value) => !isBoolean(value);
    var isVoid = (value) => value === void 0;
    var isNotVoid = (value) => !isVoid(value);
    var isError = (value) => {
      return isNotNil(value) && value instanceof Error;
    };
    var isFalsy = (value) => (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      FALSY_VALUES.includes(value) || Number.isNaN(value)
    );
    var isTruthy = (value) => (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      !FALSY_VALUES.includes(value) && !Number.isNaN(value)
    );
    var hasKey = (value, key) => isNonEmptyRecord(value) && key in value;
  }
  /******/
};
var __webpack_module_cache__ = {};
function __webpack_require__2(moduleId) {
  var cachedModule = __webpack_module_cache__[moduleId];
  if (cachedModule !== void 0) {
    return cachedModule.exports;
  }
  var module = __webpack_module_cache__[moduleId] = {
    /******/
    id: moduleId,
    /******/
    loaded: false,
    /******/
    exports: {}
    /******/
  };
  __webpack_modules__[moduleId](module, module.exports, __webpack_require__2);
  module.loaded = true;
  return module.exports;
}
(() => {
  __webpack_require__2.n = (module) => {
    var getter = module && module.__esModule ? (
      /******/
      () => module["default"]
    ) : (
      /******/
      () => module
    );
    __webpack_require__2.d(getter, { a: getter });
    return getter;
  };
})();
(() => {
  __webpack_require__2.d = (exports, definition) => {
    for (var key in definition) {
      if (__webpack_require__2.o(definition, key) && !__webpack_require__2.o(exports, key)) {
        Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
      }
    }
  };
})();
(() => {
  __webpack_require__2.g = (function() {
    if (typeof globalThis === "object") return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if (typeof window === "object") return window;
    }
  })();
})();
(() => {
  __webpack_require__2.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
})();
(() => {
  __webpack_require__2.r = (exports) => {
    if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
      Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
    }
    Object.defineProperty(exports, "__esModule", { value: true });
  };
})();
(() => {
  __webpack_require__2.nmd = (module) => {
    module.paths = [];
    if (!module.children) module.children = [];
    return module;
  };
})();
var __webpack_exports__2 = {};
__webpack_require__2.d(__webpack_exports__2, {
  /* harmony export */
  $: () => (
    /* binding */
    WistiaPlayer
  ),
  /* harmony export */
  A: () => (
    /* binding */
    wistiaSwatchElement
  )
  /* harmony export */
});
var preact__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__2(5181);
var _wistia_type_guards__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__2(9814);
var _utilities_gradients_ts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__2(4372);
var _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__2(5509);
var _components_PreloadThumbnail_tsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__2(9804);
var _hooks_usePlayerData_tsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__2(2721);
var _utilities_constants_ts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__2(1512);
var _utilities_PlayerDataHandler_ts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__2(6462);
var _appHostname_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__2(787);
var _utilities_assets_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__2(7209);
var _utilities_coinFlip_ts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__2(7323);
var _utilities_detect_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__2(7231);
var _utilities_dynamicImport_ts__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__2(7157);
var _utilities_embedOptionStore_ts__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__2(3280);
var _utilities_elem_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__2(7715);
var _utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__2(2760);
var _utilities_extractEmailFromParams_ts__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__2(3832);
var _utilities_hosts_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__2(5857);
var _utilities_inferPageUrl_ts__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__2(5393);
var _utilities_judy_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__2(438);
var _utilities_roundedPlayerDefaults_ts__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__2(3123);
var _utilities_runScript_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__2(1248);
var _utilities_seqid_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__2(1224);
var _utilities_shouldEnableMux_ts__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__2(7211);
var _utilities_simpleMetrics_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__2(1161);
var _utilities_trackingConsentApi_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__2(4755);
var _utilities_url_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__2(2671);
var _utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__2(4997);
var _utilities_wistiaOptions_ts__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__2(9392);
var _utilities_wistiaQueue_ts__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__2(541);
var _utilities_wlog_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__2(6637);
var _utilities_injectJsonLd_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__2(2147);
var _utilities_getInitialMediaData_ts__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__2(5833);
var _utilities_mediaDataError_ts__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__2(959);
var _utilities_remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__2(3411);
var _utilities_camelCaseToKebabCase_ts__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__2(4989);
var _types_gradient_ts__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__2(7350);
var _WistiaPlayer;
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i2, u, a = [], f = true, o = false;
    try {
      if (i2 = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i2.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
  function i2(r2, n2, o2, i3) {
    var c2 = n2 && n2.prototype instanceof Generator ? n2 : Generator, u2 = Object.create(c2.prototype);
    return _regeneratorDefine2(u2, "_invoke", (function(r3, n3, o3) {
      var i4, c3, u3, f2 = 0, p = o3 || [], y = false, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d2(t2, r4) {
        return i4 = t2, c3 = 0, u3 = e, G.n = r4, a;
      } };
      function d(r4, n4) {
        for (c3 = r4, u3 = n4, t = 0; !y && f2 && !o4 && t < p.length; t++) {
          var o4, i5 = p[t], d2 = G.p, l = i5[2];
          r4 > 3 ? (o4 = l === n4) && (u3 = i5[(c3 = i5[4]) ? 5 : (c3 = 3, 3)], i5[4] = i5[5] = e) : i5[0] <= d2 && ((o4 = r4 < 2 && d2 < i5[1]) ? (c3 = 0, G.v = n4, G.n = i5[1]) : d2 < l && (o4 = r4 < 3 || i5[0] > n4 || n4 > l) && (i5[4] = r4, i5[5] = n4, G.n = l, c3 = 0));
        }
        if (o4 || r4 > 1) return a;
        throw y = true, n4;
      }
      return function(o4, p2, l) {
        if (f2 > 1) throw TypeError("Generator is already running");
        for (y && 1 === p2 && d(p2, l), c3 = p2, u3 = l; (t = c3 < 2 ? e : u3) || !y; ) {
          i4 || (c3 ? c3 < 3 ? (c3 > 1 && (G.n = -1), d(c3, u3)) : G.n = u3 : G.v = u3);
          try {
            if (f2 = 2, i4) {
              if (c3 || (o4 = "next"), t = i4[o4]) {
                if (!(t = t.call(i4, u3))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u3 = t.value, c3 < 2 && (c3 = 0);
              } else 1 === c3 && (t = i4.return) && t.call(i4), c3 < 2 && (u3 = TypeError("The iterator does not provide a '" + o4 + "' method"), c3 = 1);
              i4 = e;
            } else if ((t = (y = G.n < 0) ? u3 : r3.call(n3, G)) !== a) break;
          } catch (t2) {
            i4 = e, c3 = 1, u3 = t2;
          } finally {
            f2 = 1;
          }
        }
        return { value: t, done: y };
      };
    })(r2, o2, i3), true), u2;
  }
  var a = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function() {
    return this;
  }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e2) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e2, GeneratorFunctionPrototype) : (e2.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e2, o, "GeneratorFunction")), e2.prototype = Object.create(u), e2;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function() {
    return this;
  }), _regeneratorDefine2(u, "toString", function() {
    return "[object Generator]";
  }), (_regenerator = function _regenerator2() {
    return { w: i2, m: f };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i2 = Object.defineProperty;
  try {
    i2({}, "", {});
  } catch (e2) {
    i2 = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e2, r2, n2, t2) {
    function o(r3, n3) {
      _regeneratorDefine2(e2, r3, function(e3) {
        return this._invoke(r3, n3, e3);
      });
    }
    r2 ? i2 ? i2(e2, r2, { value: n2, enumerable: !t2, configurable: !t2, writable: !t2 }) : e2[r2] = n2 : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i2 = n[a](c), u = i2.value;
  } catch (n2) {
    return void e(n2);
  }
  i2.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function() {
    var t = this, e = arguments;
    return new Promise(function(r, o) {
      var a = n.apply(t, e);
      function _next(n2) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n2);
      }
      function _throw(n2) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n2);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
function _toPropertyKey(t) {
  var i2 = _toPrimitive(t, "string");
  return "symbol" == typeof i2 ? i2 : i2 + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i2 = e.call(t, r || "default");
    if ("object" != typeof i2) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function(t2) {
    return p.apply(e, t2);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)); ) ;
  return t;
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper2(t2) {
    if (null === t2 || !_isNativeFunction(t2)) return t2;
    if ("function" != typeof t2) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t2)) return r.get(t2);
      r.set(t2, Wrapper);
    }
    function Wrapper() {
      return _construct(t2, arguments, _getPrototypeOf(this).constructor);
    }
    return Wrapper.prototype = Object.create(t2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }), _setPrototypeOf(Wrapper, t2);
  }, _wrapNativeSuper(t);
}
function _construct(t, e, r) {
  if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf(p, r.prototype), p;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct2() {
    return !!t;
  })();
}
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
function _classPrivateMethodInitSpec(e, a) {
  _checkPrivateRedeclaration(e, a), a.add(e);
}
function _classPrivateFieldInitSpec(e, t, a) {
  _checkPrivateRedeclaration(e, t), t.set(e, a);
}
function _checkPrivateRedeclaration(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classPrivateGetter(s, r, a) {
  return a(_assertClassBrand(s, r));
}
function _classPrivateFieldGet(s, a) {
  return s.get(_assertClassBrand(s, a));
}
function _classPrivateFieldSet(s, a, r) {
  return s.set(_assertClassBrand(s, a), r), r;
}
function _assertClassBrand(e, t, n) {
  if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
var requiredAttributes = ["media-id"];
var optionalPublicAttributes = ["aspect", "audio-description-control", "autoplay", "big-play-button", "branding", "contrast-icons", "controls-visible-on-load", "copy-link-and-thumbnail", "current-time", "do-not-track", "email", "end-video-behavior", "fullscreen-control", "language", "muted", "opaque-controls", "playback-rate-control", "play-bar-control", "player-color", "playlist-links", "playlist-loop", "play-pause-control", "play-pause-notifier", "popover-animate-thumbnail", "popover-animation", "popover-border-color", "popover-border-radius", "popover-border-width", "popover-box-shadow", "popover-caption", "popover-caption-container", "popover-content", "popover-disable-autoplay", "popover-overlay-color", "popover-overlay-opacity", "popover-prevent-scroll", "popover-show-on-load", "poster", "preload", "quality-control", "quality-max", "quality-min", "resumable", "rounded-player", "seo", "settings-control", "silent-autoplay", "transparent-letterbox", "video-quality", "volume", "volume-control", "wistia-popover"];
var optionalPrivateAttributes = ["big-play-button-border-radius", "control-bar-border-radius", "embed-host", "hls", "page-url", "player-border-radius", "player-force", "stats-url", "swatch", "unique-id", "use-web-component"];
var defaultEmbedOptions = {
  audioDescriptionControl: false,
  autoplay: false,
  bigPlayButton: true,
  bigPlayButtonBorderRadius: void 0,
  contrastIcons: false,
  controlBarBorderRadius: void 0,
  controlsVisibleOnLoad: true,
  copyLinkAndThumbnail: true,
  currentTime: 0,
  doNotTrack: false,
  endVideoBehavior: "default",
  fullscreenControl: true,
  hls: true,
  opaqueControls: false,
  playBarControl: true,
  playerBorderRadius: void 0,
  playerColor: "636155",
  playPauseControl: true,
  playPauseNotifier: true,
  playbackRateControl: true,
  playlistLinks: "",
  playlistLoop: false,
  popoverAnimateThumbnail: false,
  popoverAnimation: "slide",
  popoverBorderColor: "ffffff",
  popoverBorderRadius: 0,
  popoverBorderWidth: 0,
  popoverBoxShadow: true,
  popoverCaption: "",
  popoverCaptionContainer: "",
  popoverContent: void 0,
  popoverDisableAutoplay: false,
  popoverOverlayColor: "000000",
  popoverOverlayOpacity: 0.5,
  popoverPreventScroll: false,
  popoverShowOnLoad: false,
  poster: "",
  qualityControl: true,
  qualityMax: void 0,
  qualityMin: void 0,
  resumable: "auto",
  roundedPlayer: void 0,
  seo: true,
  settingsControl: true,
  silentAutoplay: false,
  state: "beforeplay",
  statsUrl: null,
  transparentLetterbox: false,
  volume: 1,
  volumeControl: true,
  wistiaPopover: false
};
var getSwatchUrl = function getSwatchUrl2(mediaId) {
  var embedHost = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  var fastHost = (0, _utilities_hosts_js__WEBPACK_IMPORTED_MODULE_17__.CX)(embedHost);
  return "https://".concat(fastHost, "/embed/medias/").concat(mediaId, "/swatch");
};
var _api = /* @__PURE__ */ new WeakMap();
var _eventListeners = /* @__PURE__ */ new WeakMap();
var _fullscreenState = /* @__PURE__ */ new WeakMap();
var _impl = /* @__PURE__ */ new WeakMap();
var _internals = /* @__PURE__ */ new WeakMap();
var _jsonLdId = /* @__PURE__ */ new WeakMap();
var _judyContext = /* @__PURE__ */ new WeakMap();
var _logger = /* @__PURE__ */ new WeakMap();
var _oldEngine = /* @__PURE__ */ new WeakMap();
var _playerData = /* @__PURE__ */ new WeakMap();
var _playerType = /* @__PURE__ */ new WeakMap();
var _removeEventListeners = /* @__PURE__ */ new WeakMap();
var _cachedRemapTime = /* @__PURE__ */ new WeakMap();
var _hasElementConnectedToDOM = /* @__PURE__ */ new WeakMap();
var _paddingTop = /* @__PURE__ */ new WeakMap();
var _playPending = /* @__PURE__ */ new WeakMap();
var _preactRoot = /* @__PURE__ */ new WeakMap();
var _preloadThumbnailRoot = /* @__PURE__ */ new WeakMap();
var _publicApiScript = /* @__PURE__ */ new WeakMap();
var _resizeObserver = /* @__PURE__ */ new WeakMap();
var _WistiaPlayer_brand = /* @__PURE__ */ new WeakSet();
var _handleAfterReplace = /* @__PURE__ */ new WeakMap();
var _handleBeforeReplace = /* @__PURE__ */ new WeakMap();
var _handlePreloadThumbnailClick = /* @__PURE__ */ new WeakMap();
var WistiaPlayer = /* @__PURE__ */ (function(_HTMLElement) {
  function WistiaPlayer2() {
    var _Wistia$wistia;
    var _this2;
    _classCallCheck(this, WistiaPlayer2);
    _this2 = _callSuper(this, WistiaPlayer2);
    _classPrivateMethodInitSpec(_this2, _WistiaPlayer_brand);
    _classPrivateFieldInitSpec(_this2, _api, void 0);
    _classPrivateFieldInitSpec(_this2, _eventListeners, {});
    _classPrivateFieldInitSpec(_this2, _fullscreenState, {
      heightBeforeFullscreen: void 0,
      inFullscreen: false,
      nativeFullscreen: false,
      widthBeforeFullscreen: void 0
    });
    _classPrivateFieldInitSpec(_this2, _impl, void 0);
    _classPrivateFieldInitSpec(_this2, _internals, void 0);
    _classPrivateFieldInitSpec(_this2, _jsonLdId, void 0);
    _classPrivateFieldInitSpec(_this2, _judyContext, null);
    _classPrivateFieldInitSpec(_this2, _logger, void 0);
    _classPrivateFieldInitSpec(_this2, _oldEngine, void 0);
    _classPrivateFieldInitSpec(_this2, _playerData, void 0);
    _classPrivateFieldInitSpec(_this2, _playerType, void 0);
    _classPrivateFieldInitSpec(_this2, _removeEventListeners, []);
    _classPrivateFieldInitSpec(_this2, _cachedRemapTime, void 0);
    _classPrivateFieldInitSpec(_this2, _hasElementConnectedToDOM, false);
    _classPrivateFieldInitSpec(_this2, _paddingTop, "0px");
    _classPrivateFieldInitSpec(_this2, _playPending, false);
    _classPrivateFieldInitSpec(_this2, _preactRoot, null);
    _classPrivateFieldInitSpec(_this2, _preloadThumbnailRoot, null);
    _classPrivateFieldInitSpec(_this2, _publicApiScript, (0, _utilities_runScript_js__WEBPACK_IMPORTED_MODULE_21__.j)("".concat((0, _utilities_url_js__WEBPACK_IMPORTED_MODULE_26__.ff)(), "//").concat((0, _appHostname_js__WEBPACK_IMPORTED_MODULE_8__.Ni)("fast"), "/assets/external/publicApi.js")));
    _classPrivateFieldInitSpec(_this2, _resizeObserver, null);
    _classPrivateFieldInitSpec(_this2, _handleAfterReplace, function() {
      _assertClassBrand(_WistiaPlayer_brand, _this2, _maybeInjectJsonLd).call(_this2);
      (0, _utilities_embedOptionStore_ts__WEBPACK_IMPORTED_MODULE_13__.gY)("__".concat(_this2.uniqueId, "_dom_options__"), _classPrivateFieldGet(_playerData, _this2).embedOptions);
    });
    _classPrivateFieldInitSpec(_this2, _handleBeforeReplace, function(event) {
      _this2.mediaId = event.detail.mediaId;
      _this2.uniqueId = _assertClassBrand(_WistiaPlayer_brand, _this2, _generateUniqueId).call(_this2, event.detail.mediaId);
      _classPrivateFieldSet(_cachedRemapTime, _this2, void 0);
    });
    _classPrivateFieldInitSpec(_this2, _handlePreloadThumbnailClick, function() {
      if (_classPrivateFieldGet(_playerType, _this2) !== "carouselHardWall" && _classPrivateFieldGet(_playerType, _this2) !== "notplayable" && _classPrivateFieldGet(_playerType, _this2) !== "passwordprotected") {
        _classPrivateFieldSet(_playPending, _this2, true);
      }
      _assertClassBrand(_WistiaPlayer_brand, _this2, _renderPreloadThumbnail).call(_this2);
    });
    if ("attachInternals" in HTMLElement.prototype && "states" in ElementInternals.prototype) {
      _classPrivateFieldSet(_internals, _this2, _this2.attachInternals());
      _classPrivateFieldGet(_internals, _this2).states.add("--initializing");
    }
    _this2.attachShadow({
      mode: "open"
    });
    _this2.dispatchEvent(new CustomEvent("load-start"));
    _this2.paddingTop = getComputedStyle(_this2).paddingTop;
    _classPrivateFieldSet(_logger, _this2, _utilities_wlog_js__WEBPACK_IMPORTED_MODULE_30__.ct.getPrefixedFunctions("WistiaPlayer"));
    _classPrivateFieldSet(_playerData, _this2, new _utilities_PlayerDataHandler_ts__WEBPACK_IMPORTED_MODULE_7__.I());
    (_Wistia$wistia = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__.s.wistia) !== null && _Wistia$wistia !== void 0 ? _Wistia$wistia : _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__.s.wistia = Date.now();
    return _this2;
  }
  _inherits(WistiaPlayer2, _HTMLElement);
  return _createClass(WistiaPlayer2, [{
    key: "_fullscreenState",
    get: (
      /**
       * @returns {FullscreenState} private fullscreenState of the video.
       */
      function get() {
        return _classPrivateFieldGet(_fullscreenState, this);
      }
    ),
    set: function set(state) {
      _classPrivateFieldSet(_fullscreenState, this, state);
    }
    /**
     * @deprecated The method should not be used
     * @returns {object | null |undefined }  private - old engine being transferred.
     */
  }, {
    key: "_oldEngine",
    get: function get() {
      return _classPrivateFieldGet(_oldEngine, this);
    },
    set: function set(engine) {
      _classPrivateFieldSet(_oldEngine, this, engine);
    }
    /**
     * Returns the aspect ratio (width / height) of the originally uploaded video or given aspect ratio.
     * @returns {number}
     */
  }, {
    key: "aspect",
    get: function get() {
      var _ref, _ref2, _classPrivateFieldGet2, _classPrivateFieldGet3;
      var fallbackAspect = !Number.isNaN(this.offsetWidth / this.offsetHeight) && Number.isFinite(this.offsetWidth / this.offsetHeight) ? this.offsetWidth / this.offsetHeight : _utilities_constants_ts__WEBPACK_IMPORTED_MODULE_6__.R;
      return (_ref = (_ref2 = (_classPrivateFieldGet2 = (_classPrivateFieldGet3 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet3 === void 0 ? void 0 : _classPrivateFieldGet3.aspect()) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : this.embedOptions.aspect) !== null && _ref2 !== void 0 ? _ref2 : _assertClassBrand(_WistiaPlayer_brand, this, _getValueFromAttribute).call(this, "aspect")) !== null && _ref !== void 0 ? _ref : fallbackAspect;
    },
    set: function set(newAspect) {
      var _classPrivateFieldGet4;
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "aspect", newAspect);
      (_classPrivateFieldGet4 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet4 === void 0 ? void 0 : _classPrivateFieldGet4.width((0, _utilities_elem_js__WEBPACK_IMPORTED_MODULE_14__.cG)(this), {
        constrain: true
      });
    }
    /**
     * Returns whether the Audio Description control in the control bar is enabled.
     * @returns {boolean}
     */
  }, {
    key: "audioDescriptionControl",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "audioDescriptionControl");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet5;
      (_classPrivateFieldGet5 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet5 === void 0 ? void 0 : _classPrivateFieldGet5.audioDescriptionControlEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "audioDescriptionControl", shouldDisplay);
    }
    /**
     * sets the authorization property to be used for authorized asset delivery
     * @param {Authorization}
     * @returns {void}
     */
  }, {
    key: "authorization",
    set: function set(auth) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "authorization", auth);
    }
    /**
     * Returns if the player should attempt to autoplay as soon as it's ready.
     * @returns {boolean}
     */
  }, {
    key: "autoplay",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "autoplay");
    },
    set: function set(shouldSetAutoplay) {
      if (typeof shouldSetAutoplay !== "boolean") {
        return;
      }
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "autoplay", shouldSetAutoplay);
      if (shouldSetAutoplay) {
        this.setAttribute("autoplay", "");
      } else {
        this.removeAttribute("autoplay");
      }
    }
    /**
     * Returns if the big play button control will appear in the center of the video before play.
     * @returns {boolean}
     */
  }, {
    key: "bigPlayButton",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "bigPlayButton");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet6;
      (_classPrivateFieldGet6 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet6 === void 0 ? void 0 : _classPrivateFieldGet6.bigPlayButtonEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "bigPlayButton", shouldDisplay);
    }
    /**
     * Returns the border radius of the big play button.
     * @returns {number}
     */
  }, {
    key: "bigPlayButtonBorderRadius",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "bigPlayButtonBorderRadius");
    },
    set: function set(radius) {
      var _classPrivateFieldGet7;
      (_classPrivateFieldGet7 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet7 === void 0 ? void 0 : _classPrivateFieldGet7.setBigPlayButtonBorderRadius(radius);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "bigPlayButtonBorderRadius", Number(radius));
    }
  }, {
    key: "branding",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "branding");
    },
    set: function set(value) {
      if (value === "true" || value === true) {
        _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "branding", true);
      }
    }
    /**
     * Returns a new static normalized TimeRanges object that represents the ranges of the media resource,
     * if any, that the user agent has buffered at the moment the buffered property is accessed.
     * @returns {TimeRanges}
     */
  }, {
    key: "buffered",
    get: function get() {
      var _classPrivateFieldGet8, _classPrivateFieldGet9;
      return (_classPrivateFieldGet8 = (_classPrivateFieldGet9 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet9 === void 0 ? void 0 : _classPrivateFieldGet9.getStandardBuffered()) !== null && _classPrivateFieldGet8 !== void 0 ? _classPrivateFieldGet8 : {};
    }
  }, {
    key: "captionsEnabled",
    get: function get() {
      var _classPrivateFieldGet0, _classPrivateFieldGet1;
      return (_classPrivateFieldGet0 = (_classPrivateFieldGet1 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet1 === void 0 ? void 0 : _classPrivateFieldGet1.captionsEnabled()) !== null && _classPrivateFieldGet0 !== void 0 ? _classPrivateFieldGet0 : false;
    },
    set: function set(enabled) {
      var _classPrivateFieldGet10;
      (_classPrivateFieldGet10 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet10 === void 0 ? void 0 : _classPrivateFieldGet10.captionsEnabled(enabled);
    }
    // the public api has a different syntax for setting the captionsLanguage and getting it
  }, {
    key: "captionsLanguage",
    get: function get() {
      var _classPrivateFieldGet11, _classPrivateFieldGet12;
      return (_classPrivateFieldGet11 = (_classPrivateFieldGet12 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet12 === void 0 ? void 0 : _classPrivateFieldGet12.captionsLanguage()) !== null && _classPrivateFieldGet11 !== void 0 ? _classPrivateFieldGet11 : _assertClassBrand(_WistiaPlayer_brand, this, _defaultLocalization).call(this);
    }
  }, {
    key: "captionsLanguageCode",
    get: function get() {
      var _classPrivateFieldGet13, _classPrivateFieldGet14;
      return (_classPrivateFieldGet13 = (_classPrivateFieldGet14 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet14 === void 0 ? void 0 : _classPrivateFieldGet14.captionsLanguageCode()) !== null && _classPrivateFieldGet13 !== void 0 ? _classPrivateFieldGet13 : _assertClassBrand(_WistiaPlayer_brand, this, _defaultLocalization).call(this).wistiaLanguageCode;
    },
    set: function set(languageCode) {
      var _classPrivateFieldGet15;
      (_classPrivateFieldGet15 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet15 === void 0 ? void 0 : _classPrivateFieldGet15.captionsLanguageCode(languageCode);
    }
  }, {
    key: "captionsLanguages",
    get: function get() {
      var _classPrivateFieldGet16, _classPrivateFieldGet17;
      return (_classPrivateFieldGet16 = (_classPrivateFieldGet17 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet17 === void 0 ? void 0 : _classPrivateFieldGet17.captionsLanguages()) !== null && _classPrivateFieldGet16 !== void 0 ? _classPrivateFieldGet16 : [_assertClassBrand(_WistiaPlayer_brand, this, _defaultLocalization).call(this)];
    }
    /**
     * Returns the status of the contrastIcons embed option, which determines
     * if the the player controls should use icons with accessible contrast or default to white.
     *
     * @returns {boolean}
     */
  }, {
    key: "contrastIcons",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "contrastIcons");
    },
    set: function set(contrastIcons) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "contrastIcons", contrastIcons);
    }
    /**
     * Returns the border radius of the control bar.
     * @returns {number}
     */
  }, {
    key: "controlBarBorderRadius",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "controlBarBorderRadius");
    },
    set: function set(radius) {
      var _classPrivateFieldGet18;
      (_classPrivateFieldGet18 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet18 === void 0 ? void 0 : _classPrivateFieldGet18.setControlBarBorderRadius(radius);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "controlBarBorderRadius", Number(radius));
    }
    /**
     * Getter. Returns all defined controls.
     * @returns {ControlInstances} returns object of defined controls. Please note this may return an
     * empty object if not controls have yet been defined.
     */
  }, {
    key: "controls",
    get: function get() {
      if (_classPrivateFieldGet(_impl, this)) {
        return Object.seal(_objectSpread({}, _classPrivateFieldGet(_impl, this).controls));
      }
      return {};
    }
    /**
     * Returns whether or not to hide the controls on load.
     * @returns {boolean}
     */
  }, {
    key: "controlsVisibleOnLoad",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "controlsVisibleOnLoad");
    },
    set: function set(shouldHide) {
      var _classPrivateFieldGet19;
      (_classPrivateFieldGet19 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet19 === void 0 ? void 0 : _classPrivateFieldGet19.renderUI();
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "controlsVisibleOnLoad", shouldHide);
    }
    /**
     * Returns whether or the copy link and thumbnail option from the context menu
     * is available.
     * @returns {boolean}
     */
  }, {
    key: "copyLinkAndThumbnail",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "copyLinkAndThumbnail");
    },
    set: function set(enabled) {
      var prevVal = this.copyLinkAndThumbnail;
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "copyLinkAndThumbnail", enabled);
      if (prevVal !== enabled) {
        this.dispatchEvent(new CustomEvent("copy-link-and-thumbnail-change", {
          detail: {
            copyLinkAndThumbnail: enabled
          }
        }));
      }
    }
    /**
     * Returns the current time of the video as a decimal in seconds.
     * @returns {number}
     */
  }, {
    key: "currentTime",
    get: function get() {
      var _ref3, _ref4, _classPrivateFieldGet20;
      return (_ref3 = (_ref4 = (_classPrivateFieldGet20 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet20 === void 0 ? void 0 : _classPrivateFieldGet20.time()) !== null && _ref4 !== void 0 ? _ref4 : this.embedOptions.currentTime) !== null && _ref3 !== void 0 ? _ref3 : 0;
    },
    set: function set(newTime) {
      var _classPrivateFieldGet21;
      void ((_classPrivateFieldGet21 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet21 === void 0 ? void 0 : _classPrivateFieldGet21.time(newTime));
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "currentTime", newTime);
    }
    /**
     * @returns {object} helpful object for debugging
     */
  }, {
    key: "debug",
    get: function get() {
      var _classPrivateFieldGet22;
      return {
        impl: _classPrivateFieldGet(_impl, this),
        engine: (_classPrivateFieldGet22 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet22 === void 0 ? void 0 : _classPrivateFieldGet22.engine
      };
    }
    /**
     * Returns the public api instance.
     * @deprecated this is a deprecated method and should not be used.
     * @returns {PublicApi | null}
     */
  }, {
    key: "deprecatedApiDoNotUse",
    get: function get() {
      return _classPrivateFieldGet(_api, this);
    }
    /**
     * Returns the status of the do not track embed option that controls whether the player
     * sends tracking pings.
     * @returns {boolean}
     */
  }, {
    key: "doNotTrack",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "doNotTrack");
    },
    set: function set(dontTrack) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "doNotTrack", dontTrack);
    }
    /**
     * Returns the duration of the video in seconds.
     * @returns {number}
     */
  }, {
    key: "duration",
    get: function get() {
      var _classPrivateFieldGet23, _classPrivateFieldGet24;
      return (_classPrivateFieldGet23 = (_classPrivateFieldGet24 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet24 === void 0 ? void 0 : _classPrivateFieldGet24.duration()) !== null && _classPrivateFieldGet23 !== void 0 ? _classPrivateFieldGet23 : 0;
    }
    /**
     * Returns the email associated with this viewing session.
     * If no email is associated, it will return undefined.
     * NOTE: This attribute will impact the entire page and is not scoped to the player.
     * @returns {string | undefined}
     */
    // the public api doesn't allow for unsetting an email, so we don't wan to allow the setter
    // eslint-disable-next-line @typescript-eslint/related-getter-setter-pairs
  }, {
    key: "email",
    get: function get() {
      var _ref5, _ref6, _extractEmailFromPara, _classPrivateGetter2;
      return (_ref5 = (_ref6 = (_extractEmailFromPara = (0, _utilities_extractEmailFromParams_ts__WEBPACK_IMPORTED_MODULE_16__.i)(_classPrivateGetter(_WistiaPlayer_brand, this, _get_pageUrl))) !== null && _extractEmailFromPara !== void 0 ? _extractEmailFromPara : (_classPrivateGetter2 = (0, _utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_27__.y1)()[_classPrivateGetter(_WistiaPlayer_brand, this, _get_pageUrl)]) === null || _classPrivateGetter2 === void 0 ? void 0 : _classPrivateGetter2.trackEmail) !== null && _ref6 !== void 0 ? _ref6 : this.embedOptions.email) !== null && _ref5 !== void 0 ? _ref5 : void 0;
    },
    set: function set(newEmail) {
      if (this.email === newEmail) {
        return;
      }
      _assertClassBrand(_WistiaPlayer_brand, this, _updateEmail).call(this, newEmail);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "email", newEmail);
    }
    /**
     * Returns the overridding embed host for the player.
     * Internal use only.
     * @returns {string | null | undefined}
     */
    // we don't want to allow for unsetting this option
    // eslint-disable-next-line @typescript-eslint/related-getter-setter-pairs
  }, {
    key: "embedHost",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "embedHost");
    },
    set: function set(newEmbedHost) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "embedHost", newEmbedHost);
    }
    /**
     * Returns all the embed options being set on the WistiaPlayer from attributes and mediaData json
     * @returns {EmbedOptions }
     */
  }, {
    key: "embedOptions",
    get: function get() {
      return _classPrivateFieldGet(_playerData, this).embedOptions;
    }
    /**
     * Returns whether the video has ended playback.
     * @returns {boolean}
     */
  }, {
    key: "ended",
    get: function get() {
      var _classPrivateFieldGet25;
      return ((_classPrivateFieldGet25 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet25 === void 0 ? void 0 : _classPrivateFieldGet25.state()) === "ended";
    }
    /**
     * Returns the current end video behavior value
     * @returns {'default' | 'loop' | 'reset'}
     */
  }, {
    key: "endVideoBehavior",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "endVideoBehavior");
    },
    set: function set(behavior) {
      if (behavior === "loop") {
        var _classPrivateFieldGet26;
        (_classPrivateFieldGet26 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet26 === void 0 ? void 0 : _classPrivateFieldGet26.addLoopBehavior();
      } else {
        var _classPrivateFieldGet27;
        (_classPrivateFieldGet27 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet27 === void 0 ? void 0 : _classPrivateFieldGet27.removeLoopBehavior();
      }
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "endVideoBehavior", behavior);
    }
    /**
     * Returns the embed's event key if it exists.
     * @returns {string | undefined}
     */
  }, {
    key: "eventKey",
    get: function get() {
      var _classPrivateFieldGet28;
      return (_classPrivateFieldGet28 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet28 === void 0 ? void 0 : _classPrivateFieldGet28.eventKey();
    }
    /**
     * Returns if the fullscreen button control will appear in the control bar.
     * @returns {boolean}
     */
  }, {
    key: "fullscreenControl",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "fullscreenControl");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet29;
      (_classPrivateFieldGet29 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet29 === void 0 ? void 0 : _classPrivateFieldGet29.fullscreenControlEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "fullscreenControl", shouldDisplay);
    }
    /**
     * Returns if the video should use HLS playback.
     * Internal only.
     * @returns {boolean}
     */
  }, {
    key: "hls",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "hls");
    },
    set: function set(shouldUseHls) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "hls", shouldUseHls);
    }
    /**
     * Returns whether the video is currently in fullscreen
     * @returns {boolean}
     */
  }, {
    key: "inFullscreen",
    get: function get() {
      var _classPrivateFieldGet30, _classPrivateFieldGet31;
      return (_classPrivateFieldGet30 = (_classPrivateFieldGet31 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet31 === void 0 ? void 0 : _classPrivateFieldGet31.inFullscreen()) !== null && _classPrivateFieldGet30 !== void 0 ? _classPrivateFieldGet30 : false;
    }
  }, {
    key: "inputContext",
    get: function get() {
      var _classPrivateFieldGet32;
      return (_classPrivateFieldGet32 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet32 === void 0 ? void 0 : _classPrivateFieldGet32.getInputContext();
    }
    /**
     * Returns whether instantHLS is enabled for the video.
     * @returns {boolean}
     */
  }, {
    key: "instantHls",
    get: function get() {
      var _classPrivateFieldGet33, _classPrivateFieldGet34;
      return (_classPrivateFieldGet33 = (_classPrivateFieldGet34 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet34 === void 0 ? void 0 : _classPrivateFieldGet34.isInstantHls()) !== null && _classPrivateFieldGet33 !== void 0 ? _classPrivateFieldGet33 : false;
    }
    // the publicApi returns a language object, but you are not allowed to pass that object as a type when setting the language
    // eslint-disable-next-line @typescript-eslint/related-getter-setter-pairs
  }, {
    key: "language",
    get: function get() {
      var _classPrivateFieldGet35, _classPrivateFieldGet36;
      return (_classPrivateFieldGet35 = (_classPrivateFieldGet36 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet36 === void 0 ? void 0 : _classPrivateFieldGet36.language()) !== null && _classPrivateFieldGet35 !== void 0 ? _classPrivateFieldGet35 : _assertClassBrand(_WistiaPlayer_brand, this, _defaultLocalization).call(this);
    },
    set: function set(language) {
      var _classPrivateFieldGet37;
      (_classPrivateFieldGet37 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet37 === void 0 ? void 0 : _classPrivateFieldGet37.language(language);
    }
  }, {
    key: "languages",
    get: function get() {
      var _classPrivateFieldGet38, _classPrivateFieldGet39;
      return (_classPrivateFieldGet38 = (_classPrivateFieldGet39 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet39 === void 0 ? void 0 : _classPrivateFieldGet39.languages()) !== null && _classPrivateFieldGet38 !== void 0 ? _classPrivateFieldGet38 : [_assertClassBrand(_WistiaPlayer_brand, this, _defaultLocalization).call(this)];
    }
    /**
     * Returns all the mediaData set on the WistiaPlayer
     * @returns {MediaData }
     */
  }, {
    key: "mediaData",
    get: function get() {
      return _classPrivateFieldGet(_playerData, this).mediaData;
    }
    /**
     * Returns the hashed id of the media.
     * @returns {string}
     */
  }, {
    key: "mediaId",
    get: function get() {
      var _this$getAttribute;
      return (_this$getAttribute = this.getAttribute("media-id")) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : "";
    },
    set: function set(newMediaId) {
      var prevMediaId = this.mediaId;
      if (prevMediaId === newMediaId) {
        return;
      }
      _classPrivateFieldGet(_logger, this).info("set mediaId", newMediaId);
      this.setAttribute("media-id", newMediaId);
    }
    /**
     * Returns the language of the media stream.
     * @returns {Localization | undefined}
     */
  }, {
    key: "mediaLanguage",
    get: function get() {
      var _classPrivateFieldGet40, _classPrivateFieldGet41;
      return (_classPrivateFieldGet40 = (_classPrivateFieldGet41 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet41 === void 0 ? void 0 : _classPrivateFieldGet41.mediaLanguage()) !== null && _classPrivateFieldGet40 !== void 0 ? _classPrivateFieldGet40 : _assertClassBrand(_WistiaPlayer_brand, this, _defaultLocalization).call(this);
    }
    /**
     * Changes the language of the media stream/content.
     * @param {string} language
     * @returns {void}
     */
  }, {
    key: "mediaLanguageCode",
    get: function get() {
      var _classPrivateFieldGet42, _classPrivateFieldGet43;
      return (_classPrivateFieldGet42 = (_classPrivateFieldGet43 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet43 === void 0 ? void 0 : _classPrivateFieldGet43.mediaLanguageCode()) !== null && _classPrivateFieldGet42 !== void 0 ? _classPrivateFieldGet42 : _assertClassBrand(_WistiaPlayer_brand, this, _defaultLocalization).call(this).wistiaLanguageCode;
    },
    set: function set(languageCode) {
      var _classPrivateFieldGet44;
      (_classPrivateFieldGet44 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet44 === void 0 ? void 0 : _classPrivateFieldGet44.mediaLanguageCode(languageCode);
    }
  }, {
    key: "mediaLanguages",
    get: function get() {
      var _classPrivateFieldGet45, _classPrivateFieldGet46;
      return (_classPrivateFieldGet45 = (_classPrivateFieldGet46 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet46 === void 0 ? void 0 : _classPrivateFieldGet46.mediaLanguages()) !== null && _classPrivateFieldGet45 !== void 0 ? _classPrivateFieldGet45 : [_assertClassBrand(_WistiaPlayer_brand, this, _defaultLocalization).call(this)];
    }
    /**
     * Returns if player is currently muted
     * @returns {boolean}
     */
  }, {
    key: "muted",
    get: function get() {
      var _ref7, _classPrivateFieldGet47, _classPrivateFieldGet48;
      return (_ref7 = (_classPrivateFieldGet47 = (_classPrivateFieldGet48 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet48 === void 0 ? void 0 : _classPrivateFieldGet48.isMuted()) !== null && _classPrivateFieldGet47 !== void 0 ? _classPrivateFieldGet47 : this.embedOptions.muted) !== null && _ref7 !== void 0 ? _ref7 : false;
    },
    set: function set(shouldMute) {
      if (_classPrivateFieldGet(_impl, this)) {
        if (shouldMute) {
          void _classPrivateFieldGet(_impl, this).mute();
        } else {
          void _classPrivateFieldGet(_impl, this).unmute();
        }
      }
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "muted", shouldMute);
    }
    /**
     * Returns the name of the media as it is in the Wistia application.
     * Returns undefined until media data is loaded.
     * @returns {string | undefined}
     */
  }, {
    key: "name",
    get: function get() {
      var _ref8, _classPrivateFieldGet49, _classPrivateFieldGet50, _classPrivateFieldGet51;
      return (_ref8 = (_classPrivateFieldGet49 = _classPrivateFieldGet(_playerData, this).mediaData.name) !== null && _classPrivateFieldGet49 !== void 0 ? _classPrivateFieldGet49 : (_classPrivateFieldGet50 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet50 === void 0 ? void 0 : (_classPrivateFieldGet51 = _classPrivateFieldGet50._mediaData) === null || _classPrivateFieldGet51 === void 0 ? void 0 : _classPrivateFieldGet51.name) !== null && _ref8 !== void 0 ? _ref8 : void 0;
    }
    /**
     * Returns the status of the opaqueControls embed option, which determines
     * if the playbar and big play button are opaque ore semi-transparent
     *
     * @returns {boolean}
     */
  }, {
    key: "opaqueControls",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "opaqueControls");
    },
    set: function set(opaqueControls) {
      var _classPrivateFieldGet52;
      var valueAsBoolean = Boolean(opaqueControls);
      (_classPrivateFieldGet52 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet52 === void 0 ? void 0 : _classPrivateFieldGet52.opaqueControls(valueAsBoolean);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "opaqueControls", valueAsBoolean);
    }
  }, {
    key: "paddingTop",
    get: function get() {
      return _classPrivateFieldGet(_paddingTop, this);
    },
    set: function set(paddingTop) {
      _classPrivateFieldSet(_paddingTop, this, paddingTop);
    }
    /**
     * Returns a boolean that indicates whether the video is paused.
     * @returns {boolean}
     */
  }, {
    key: "paused",
    get: function get() {
      var _classPrivateFieldGet53;
      return ((_classPrivateFieldGet53 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet53 === void 0 ? void 0 : _classPrivateFieldGet53.state()) === "paused";
    }
    /**
     * Returns the percent of the video that has been watched as a decimal between 0 and 1.
     * @returns {number}
     */
  }, {
    key: "percentWatched",
    get: function get() {
      var _classPrivateFieldGet54, _classPrivateFieldGet55;
      return (_classPrivateFieldGet54 = (_classPrivateFieldGet55 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet55 === void 0 ? void 0 : _classPrivateFieldGet55.percentWatched()) !== null && _classPrivateFieldGet54 !== void 0 ? _classPrivateFieldGet54 : 0;
    }
    /**
     * Returns the playback rate of the video.
     * @returns {number}
     */
  }, {
    key: "playbackRate",
    get: function get() {
      var _ref9, _classPrivateFieldGet56, _classPrivateFieldGet57;
      return (_ref9 = (_classPrivateFieldGet56 = (_classPrivateFieldGet57 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet57 === void 0 ? void 0 : _classPrivateFieldGet57.playbackRate()) !== null && _classPrivateFieldGet56 !== void 0 ? _classPrivateFieldGet56 : this.embedOptions.playbackRate) !== null && _ref9 !== void 0 ? _ref9 : 1;
    },
    set: function set(rate) {
      var _classPrivateFieldGet58;
      (_classPrivateFieldGet58 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet58 === void 0 ? void 0 : _classPrivateFieldGet58.playbackRate(rate);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playbackRate", rate);
    }
    /**
     * If set to true, the playback rate control will appear in the setting control.
     * @returns {boolean}
     */
  }, {
    key: "playbackRateControl",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playbackRateControl");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet59;
      (_classPrivateFieldGet59 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet59 === void 0 ? void 0 : _classPrivateFieldGet59.playbackRateControlEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playbackRateControl", shouldDisplay);
    }
    /**
     * Returns if the playbar - which includes the playhead, current time, and scrubbing functionality - will be available.
     * @returns {boolean}
     */
  }, {
    key: "playBarControl",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playBarControl");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet60;
      (_classPrivateFieldGet60 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet60 === void 0 ? void 0 : _classPrivateFieldGet60.playbarControlEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playBarControl", shouldDisplay);
    }
    /**
     * Returns the border radius of the player.
     * @returns {number}
     */
  }, {
    key: "playerBorderRadius",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playerBorderRadius");
    },
    set: function set(radius) {
      var _classPrivateFieldGet61;
      (_classPrivateFieldGet61 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet61 === void 0 ? void 0 : _classPrivateFieldGet61.setPlayerBorderRadius(Number(radius));
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playerBorderRadius", Number(radius));
    }
    /**
     * Returns the base color of the player.
     * @returns {string}
     */
  }, {
    key: "playerColor",
    get: function get() {
      var _this$playerColorGrad;
      if ((_this$playerColorGrad = this.playerColorGradient) !== null && _this$playerColorGrad !== void 0 && _this$playerColorGrad.on) {
        var _getGradientColor;
        return (_getGradientColor = (0, _utilities_gradients_ts__WEBPACK_IMPORTED_MODULE_2__.yz)(this.playerColorGradient)) !== null && _getGradientColor !== void 0 ? _getGradientColor : _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playerColor");
      }
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playerColor");
    },
    set: function set(newColor) {
      var _classPrivateFieldGet62;
      (_classPrivateFieldGet62 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet62 === void 0 ? void 0 : _classPrivateFieldGet62.playerColor(newColor);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playerColor", newColor);
    }
    /**
     * Returns the player color gradient object.
     * @returns {Gradient}
     */
  }, {
    key: "playerColorGradient",
    get: function get() {
      var value = _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playerColorGradient");
      if ((0, _types_gradient_ts__WEBPACK_IMPORTED_MODULE_36__.b)(value)) {
        return value;
      }
      return void 0;
    },
    set: function set(gradient) {
      var _classPrivateFieldGet63;
      if (!(0, _types_gradient_ts__WEBPACK_IMPORTED_MODULE_36__.b)(gradient)) {
        throw new Error("playerColorGradient must be a valid gradient object");
      }
      (_classPrivateFieldGet63 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet63 === void 0 ? void 0 : _classPrivateFieldGet63.playerColorGradient(gradient);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playerColorGradient", gradient);
    }
    /**
     * Returns the overridding player.
     * Internal use only.
     * @returns {Players | undefined}
     */
    // This will return undefined if it's not set, but you are not allowed to set it to undefined
    // eslint-disable-next-line @typescript-eslint/related-getter-setter-pairs
  }, {
    key: "playerForce",
    get: function get() {
      var _ref0;
      return (_ref0 = this.getAttribute("player-force")) !== null && _ref0 !== void 0 ? _ref0 : void 0;
    },
    set: function set(newPlayer) {
      _classPrivateFieldGet(_logger, this).info("set playerForce", newPlayer);
      this.setAttribute("player-force", newPlayer);
    }
    /**
     * Returns the strategy for associating specially crafted links on a page with a video, turning them into a playlist.
     * auto: For each video on the page, look for links after the video, until we come to another Wistia video.
     * manual: Given each link element, look at its 'container' option to determine which video it should connect to.
     * "container": For all embed links in a container whose id matches this given string, connect them to this specific video.
     * @returns {'auto' | 'manual' | string}
     */
  }, {
    key: "playlistLinks",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playlistLinks");
    },
    set: function set(newStrategy) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playlistLinks", newStrategy);
    }
    /**
     * When present or set to true and this video has a playlist, it will loop back to
     * the first video and replay it once the last video has finished.
     * @returns {boolean}
     */
  }, {
    key: "playlistLoop",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playlistLoop");
    },
    set: function set(shouldLoop) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playlistLoop", shouldLoop);
    }
    /**
     * If set to true, the small play button control will be available.
     * @returns {boolean}
     */
  }, {
    key: "playPauseControl",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playPauseControl");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet64;
      (_classPrivateFieldGet64 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet64 === void 0 ? void 0 : _classPrivateFieldGet64.playPauseControlEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playPauseControl", shouldDisplay);
    }
    /**
     * By default, pausing a video will display a brief animation of the pause symbol
     * and resuming the video will display an animation of the play symbol.
     * Setting this embed option to false will remove those animations.
     * @returns {boolean}
     */
  }, {
    key: "playPauseNotifier",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "playPauseNotifier");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet65;
      (_classPrivateFieldGet65 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet65 === void 0 ? void 0 : _classPrivateFieldGet65.playPauseNotifierEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "playPauseNotifier", shouldDisplay);
    }
    /**
     * Getter. Returns all defined plugins.
     * @returns {PluginInstances} returns object of defined plugins. Please note this may return an
     * empty object if not plugins have yet been defined.
     */
  }, {
    key: "plugins",
    get: function get() {
      if (_classPrivateFieldGet(_impl, this)) {
        return Object.seal(_objectSpread({}, _classPrivateFieldGet(_impl, this).plugin));
      }
      return {};
    }
    /**
     * Returns if the play button will expand to cover the thumbnail on hover,
     * while also displaying the duration of the video.
     * @returns {boolean}
     */
  }, {
    key: "popoverAnimateThumbnail",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverAnimateThumbnail");
    },
    set: function set(shouldAnimate) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverAnimateThumbnail", shouldAnimate);
    }
    /**
     * Returns the current state of the video.
     * @returns {PopoverAnimation}
     */
  }, {
    key: "popoverAnimation",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverAnimation");
    },
    set: function set(newAnimation) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverAnimation", newAnimation);
    }
    /**
     * Returns the border color of the popover.
     * @returns {string}
     */
  }, {
    key: "popoverBorderColor",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverBorderColor");
    },
    set: function set(newColor) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverBorderColor", newColor);
    }
    /**
     * Returns the border radius of the popover.
     * @returns {number}
     */
  }, {
    key: "popoverBorderRadius",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverBorderRadius");
    },
    set: function set(newRadius) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverBorderRadius", newRadius);
    }
    /**
     * Returns the border width of the popover.
     * @returns {number}
     */
  }, {
    key: "popoverBorderWidth",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverBorderWidth");
    },
    set: function set(newWidth) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverBorderWidth", newWidth);
    }
    /**
     * Returns if the popover should be displayed with a box shadow.
     * @returns {boolean}
     */
  }, {
    key: "popoverBoxShadow",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverBoxShadow");
    },
    set: function set(shouldDisplayBoxShadow) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverBoxShadow", shouldDisplayBoxShadow);
    }
    /**
     * Returns text set to be displayed directly below the popover.
     * @returns {string}
     */
  }, {
    key: "popoverCaption",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverCaption");
    },
    set: function set(newCaption) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverCaption", newCaption);
    }
    /**
     * Returns the id of the dom element which will be moved beneath the popover.
     * @returns {string}
     */
  }, {
    key: "popoverCaptionContainer",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverCaptionContainer");
    },
    set: function set(newCaptionContainer) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverCaptionContainer", newCaptionContainer);
    }
    /**
     * Returns how the popover content will render.
     * @returns {PopoverContentSettings | string | undefined}
     */
    // This will return undefined if it's not set, but you are not allowed to set it to undefined
    // eslint-disable-next-line @typescript-eslint/related-getter-setter-pairs
  }, {
    key: "popoverContent",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverContent");
    },
    set: function set(newContentType) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverContent", newContentType);
    }
    /**
     * Returns if embed should override the behavior for the autoplay option in Customize for
     * a popover specifically, so that launching the popover doesn't also play the video.
     * @returns {boolean}
     */
  }, {
    key: "popoverDisableAutoplay",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverDisableAutoplay");
    },
    set: function set(shouldDisable) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverDisableAutoplay", shouldDisable);
    }
    /**
     * Returns the overlay's background color in RGB hexadecimal.
     * @returns {string}
     */
  }, {
    key: "popoverOverlayColor",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverOverlayColor");
    },
    set: function set(newColor) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverOverlayColor", newColor);
    }
    /**
     * Returns the overlay's opacity. Expects a decimal value between 0 and 1.
     * @returns {number}
     */
  }, {
    key: "popoverOverlayOpacity",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverOverlayOpacity");
    },
    set: function set(newOpacity) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverOverlayOpacity", newOpacity);
    }
    /**
     * Returns if scrolling should be prevented when the popover is open.
     * @returns {boolean}
     */
  }, {
    key: "popoverPreventScroll",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverPreventScroll");
    },
    set: function set(shouldPreventScroll) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverPreventScroll", shouldPreventScroll);
    }
    /**
     * Returns if popover should immediately open as if it was clicked.
     * @returns {boolean}
     */
  }, {
    key: "popoverShowOnLoad",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "popoverShowOnLoad");
    },
    set: function set(shouldShow) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "popoverShowOnLoad", shouldShow);
    }
    /**
     * Overrides the thumbnail image that appears before the video plays.
     * Expects an absolute URL to an image.
     * @returns {string}
     */
  }, {
    key: "poster",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "poster");
    },
    set: function set(newUrl) {
      var prevVal = this.poster;
      if (prevVal === newUrl) {
        return;
      }
      var prevUrl = this.poster;
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "poster", newUrl);
      this.setAttribute("poster", newUrl);
      if (prevUrl !== newUrl) {
        this.dispatchEvent(new CustomEvent("thumbnailchange"));
      }
    }
    /**
     * Returns the preload setting for the player.
     * @returns {string | undefined}
     * undefined is allowed as a return type because there may be situations
     * where the player and/or engine has not loaded and we don't know what
     * preload setting will be used
     */
  }, {
    key: "preload",
    get: function get() {
      var _ref1, _classPrivateFieldGet66, _classPrivateFieldGet67;
      return (_ref1 = (_classPrivateFieldGet66 = (_classPrivateFieldGet67 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet67 === void 0 ? void 0 : _classPrivateFieldGet67.preloadValue()) !== null && _classPrivateFieldGet66 !== void 0 ? _classPrivateFieldGet66 : this.embedOptions.preload) !== null && _ref1 !== void 0 ? _ref1 : "metadata";
    },
    set: function set(preloadValue) {
      var prevVal = this.preload;
      if (prevVal === preloadValue) {
        return;
      }
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "preload", preloadValue);
      this.setAttribute("preload", preloadValue);
    }
    /**
     * If set to true, the quality control will appear in the setting control.
     * @returns {boolean}
     */
  }, {
    key: "qualityControl",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "qualityControl");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet68;
      (_classPrivateFieldGet68 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet68 === void 0 ? void 0 : _classPrivateFieldGet68.qualityControlEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "qualityControl", shouldDisplay);
    }
    /**
     * Return the max quality allowed for the 'Auto' asset in HLS playback
     * @returns {number | undefined}
     */
  }, {
    key: "qualityMax",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "qualityMax");
    },
    set: function set(quality) {
      var _classPrivateFieldGet69;
      (_classPrivateFieldGet69 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet69 === void 0 ? void 0 : _classPrivateFieldGet69.qualityMax(quality);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "qualityMax", quality);
    }
    /**
     * Return the min quality allowed for the 'Auto' asset in HLS playback
     * @returns {number}
     */
  }, {
    key: "qualityMin",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "qualityMin");
    },
    set: function set(quality) {
      var _classPrivateFieldGet70;
      (_classPrivateFieldGet70 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet70 === void 0 ? void 0 : _classPrivateFieldGet70.qualityMin(quality);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "qualityMin", quality);
    }
    /**
     * Returns the readyState of the inner video HTML element.
     * @returns {number}
     */
  }, {
    key: "readyState",
    get: function get() {
      var _classPrivateFieldGet71, _classPrivateFieldGet72;
      return (_classPrivateFieldGet71 = (_classPrivateFieldGet72 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet72 === void 0 ? void 0 : _classPrivateFieldGet72.getReadyState()) !== null && _classPrivateFieldGet71 !== void 0 ? _classPrivateFieldGet71 : 0;
    }
    /**
     * Returns the current resumable status of the video.
     * @returns {'auto' | boolean}
     */
  }, {
    key: "resumable",
    get: function get() {
      var _assertClassBrand$cal;
      return (_assertClassBrand$cal = _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "resumable")) !== null && _assertClassBrand$cal !== void 0 ? _assertClassBrand$cal : "auto";
    },
    set: function set(resumableState) {
      var _classPrivateFieldGet73;
      (_classPrivateFieldGet73 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet73 === void 0 ? void 0 : _classPrivateFieldGet73.setResumable(resumableState);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "resumable", resumableState);
    }
    /**
     * Returns a value which controls all rounded corners of the player.
     * @returns {number}
     */
  }, {
    key: "roundedPlayer",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "roundedPlayer");
    },
    set: function set(radius) {
      var _classPrivateFieldGet74;
      (_classPrivateFieldGet74 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet74 === void 0 ? void 0 : _classPrivateFieldGet74.setRoundedPlayer(Number(radius));
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "roundedPlayer", Number(radius));
    }
    /**
     * Returns the number of unique seconds that have been watched for the video.
     * This does not include seconds that have been skipped by seeking.
     * @returns {number}
     */
  }, {
    key: "secondsWatched",
    get: function get() {
      var _classPrivateFieldGet75, _classPrivateFieldGet76;
      return (_classPrivateFieldGet75 = (_classPrivateFieldGet76 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet76 === void 0 ? void 0 : _classPrivateFieldGet76.secondsWatched()) !== null && _classPrivateFieldGet75 !== void 0 ? _classPrivateFieldGet75 : 0;
    }
    /**
     * Returns an array where each index represents the number of times the viewer has watched each second of the video.
     * @returns {number[]}
     */
  }, {
    key: "secondsWatchedVector",
    get: function get() {
      var _classPrivateFieldGet77, _classPrivateFieldGet78;
      return (_classPrivateFieldGet77 = (_classPrivateFieldGet78 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet78 === void 0 ? void 0 : _classPrivateFieldGet78.secondsWatchedVector()) !== null && _classPrivateFieldGet77 !== void 0 ? _classPrivateFieldGet77 : [];
    }
    /**
     * Returns whether JSON+LD seo data will be injected.
     * @returns {boolean}
     */
  }, {
    key: "seo",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "seo");
    },
    set: function set(val) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "seo", val);
    }
    /**
     * If set to true, the settings control will appear in the control bar.
     * @returns {boolean}
     */
  }, {
    key: "settingsControl",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "settingsControl");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet79;
      (_classPrivateFieldGet79 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet79 === void 0 ? void 0 : _classPrivateFieldGet79.settingsControlEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "settingsControl", shouldDisplay);
    }
    /**
     * This option allows videos to autoplay in a muted state in contexts where normal autoplay
     * is blocked or not supported (e.g. iOS, Safari 11+, Chrome 66+).
     * allow: The video will default to normal autoplay, with silent autoplay as a fallback if needed.
     * false: The video will not autoplay silently.
     * true: The video will default to autoplaying silently.
     * @returns {boolean | 'allow'}
     */
  }, {
    key: "silentAutoplay",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "silentAutoplay");
    },
    set: function set(silentAutoplayValue) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "silentAutoplay", silentAutoplayValue);
    }
  }, {
    key: "sourceLanguage",
    get: function get() {
      var _classPrivateFieldGet80, _classPrivateFieldGet81, _classPrivateFieldGet82;
      return (_classPrivateFieldGet80 = (_classPrivateFieldGet81 = _classPrivateFieldGet(_playerData, this).mediaData.localizations) === null || _classPrivateFieldGet81 === void 0 ? void 0 : _classPrivateFieldGet81.find(function(loc) {
        return loc.isOriginal;
      })) !== null && _classPrivateFieldGet80 !== void 0 ? _classPrivateFieldGet80 : (_classPrivateFieldGet82 = _classPrivateFieldGet(_playerData, this).mediaData.localizations) === null || _classPrivateFieldGet82 === void 0 ? void 0 : _classPrivateFieldGet82[0];
    }
    /**
     * Returns the source media id for the player. If a player has different localized versions,
     * each will have a different mediaId, but the same sourceMediaId.
     * @returns {string}
     */
  }, {
    key: "sourceMediaId",
    get: function get() {
      var _this$mediaData$sourc;
      return (_this$mediaData$sourc = this.mediaData.sourceHashedId) !== null && _this$mediaData$sourc !== void 0 ? _this$mediaData$sourc : this.mediaId;
    }
    /**
     * Returns the current state of the video.
     * @returns {PlayerState}
     */
  }, {
    key: "state",
    get: function get() {
      var _classPrivateFieldGet83, _classPrivateFieldGet84;
      return (_classPrivateFieldGet83 = (_classPrivateFieldGet84 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet84 === void 0 ? void 0 : _classPrivateFieldGet84.state()) !== null && _classPrivateFieldGet83 !== void 0 ? _classPrivateFieldGet83 : defaultEmbedOptions.state;
    }
    /**
     * Returns the stats url for the player.
     * @returns {string | null}
     */
    // This will return undefined if it's not set, but you are not allowed to set it to undefined
    // eslint-disable-next-line @typescript-eslint/related-getter-setter-pairs
  }, {
    key: "statsUrl",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "statsUrl");
    },
    set: function set(url) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "statsUrl", url);
    }
    /**
     * Returns if a swatch should be shown before the player renders.
     * Internal use only.
     * @returns {boolean | undefined}
     */
    // This will return undefined if it's not set, but you are not allowed to set it to undefined
    // eslint-disable-next-line @typescript-eslint/related-getter-setter-pairs
  }, {
    key: "swatch",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "swatch");
    },
    set: function set(shouldShowSwatch) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "swatch", shouldShowSwatch);
    }
    /**
     * If present, the background behind the video player will be transparent
     * allowing the page color to show through instead of black.
     * @returns {boolean}
     */
  }, {
    key: "transparentLetterbox",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "transparentLetterbox");
    },
    set: function set(shouldSetTransparentLetterbox) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "transparentLetterbox", shouldSetTransparentLetterbox);
    }
    /**
     * Returns the unique id of this embed
     * Expected format is `wistia-mediaId-index`
     * @returns {string}
     */
  }, {
    key: "uniqueId",
    get: function get() {
      var _this$getAttribute2;
      return (_this$getAttribute2 = this.getAttribute("unique-id")) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : "";
    },
    set: function set(id) {
      this.setAttribute("unique-id", id);
    }
    /**
     * Returns if this custom element was created from a legacy translated embed.
     * Internal use only.
     * @returns {boolean}
     */
  }, {
    key: "useWebComponent",
    get: function get() {
      return this.getAttribute("use-web-component") === "true";
    },
    set: function set(val) {
      if (val) {
        this.setAttribute("use-web-component", String(val));
      } else {
        this.removeAttribute("use-web-component");
      }
    }
    /**
     * Returns the current video quality.
     * @returns {number | 'auto'}
     */
  }, {
    key: "videoQuality",
    get: function get() {
      var _ref10, _classPrivateFieldGet85, _classPrivateFieldGet86;
      return (_ref10 = (_classPrivateFieldGet85 = (_classPrivateFieldGet86 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet86 === void 0 ? void 0 : _classPrivateFieldGet86.getVideoQuality()) !== null && _classPrivateFieldGet85 !== void 0 ? _classPrivateFieldGet85 : this.embedOptions.videoQuality) !== null && _ref10 !== void 0 ? _ref10 : "auto";
    },
    set: function set(quality) {
      var _classPrivateFieldGet87;
      (_classPrivateFieldGet87 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet87 === void 0 ? void 0 : _classPrivateFieldGet87.setVideoQuality(quality);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "videoQuality", quality);
    }
    /**
     * Returns the visitor_key of the viewer of this player.
     * @returns {string | null | undefined}
     */
  }, {
    key: "visitorKey",
    get: function get() {
      var _Wistia$visitorKey;
      return (_Wistia$visitorKey = _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__.s.visitorKey) === null || _Wistia$visitorKey === void 0 ? void 0 : _Wistia$visitorKey.value();
    }
    /**
     * Returns the current volume set on the player
     * @returns {number}
     */
  }, {
    key: "volume",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "volume");
    },
    set: function set(level) {
      var _classPrivateFieldGet88;
      (_classPrivateFieldGet88 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet88 === void 0 ? void 0 : _classPrivateFieldGet88.volume(level);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "volume", level);
    }
    /**
     * If set to true, the volume control will appear in the control bar.
     * Note that on mobile, we never show a volume control, as the device
     * volume is used.
     * @returns {boolean}
     */
  }, {
    key: "volumeControl",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "volumeControl");
    },
    set: function set(shouldDisplay) {
      var _classPrivateFieldGet89;
      (_classPrivateFieldGet89 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet89 === void 0 ? void 0 : _classPrivateFieldGet89.volumeControlEnabled(shouldDisplay);
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "volumeControl", shouldDisplay);
    }
    /**
     * Returns if the player embed is a popover.
     * @returns {boolean}
     */
  }, {
    key: "wistiaPopover",
    get: function get() {
      return _assertClassBrand(_WistiaPlayer_brand, this, _getSyncedEmbedOption).call(this, "wistiaPopover");
    },
    set: function set(shouldBePopover) {
      _assertClassBrand(_WistiaPlayer_brand, this, _setSyncedEmbedOption).call(this, "wistiaPopover", shouldBePopover);
    }
  }, {
    key: "addEventListener",
    value: (
      // --------------------------------------------------
      // Public api methods
      // --------------------------------------------------
      /**
       * Adds an event listener to the player.
       * @param {string} eventName - The name of the event to listen for.
       * @param {EventListenerOrEventListenerObject} listener - The function to call when the event occurs.
       * @param {AddEventListenerOptions | boolean} options - Additional options for the event listener.
       */
      function addEventListener(eventName, listener, options) {
        if (!Array.isArray(_classPrivateFieldGet(_eventListeners, this)[eventName])) {
          _classPrivateFieldGet(_eventListeners, this)[eventName] = [];
        }
        _classPrivateFieldGet(_eventListeners, this)[eventName].push({
          listener,
          options
        });
        _superPropGet(WistiaPlayer2, "addEventListener", this, 3)([eventName, listener, options]);
      }
    )
    /**
     * Attempt to enter fullscreen mode.
     * @returns {Promise<void>}
     */
  }, {
    key: "cancelFullscreen",
    value: (function() {
      var _cancelFullscreen = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee() {
        var _classPrivateFieldGet90, _this3 = this;
        return _regenerator().w(function(_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2, (_classPrivateFieldGet90 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet90 === void 0 ? void 0 : _classPrivateFieldGet90.cancelFullscreen().then(function() {
                _this3._fullscreenState.heightBeforeFullscreen = void 0;
                _this3._fullscreenState.widthBeforeFullscreen = void 0;
              }));
          }
        }, _callee, this);
      }));
      function cancelFullscreen() {
        return _cancelFullscreen.apply(this, arguments);
      }
      return cancelFullscreen;
    })()
  }, {
    key: "createOverlay",
    value: (function() {
      var _createOverlay = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee2(name, options) {
        var _classPrivateFieldGet91;
        return _regenerator().w(function(_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!((_classPrivateFieldGet91 = _classPrivateFieldGet(_impl, this)) !== null && _classPrivateFieldGet91 !== void 0 && _classPrivateFieldGet91.defineOverlay)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2, _classPrivateFieldGet(_impl, this).defineOverlay(name, options));
            case 1:
              return _context2.a(2, Promise.reject(new Error("overlay ".concat(name, " cannot be defined at this time"))));
          }
        }, _callee2, this);
      }));
      function createOverlay(_x, _x2) {
        return _createOverlay.apply(this, arguments);
      }
      return createOverlay;
    })()
  }, {
    key: "definePlugin",
    value: (function() {
      var _definePlugin = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee5(name, options) {
        var _this4 = this;
        var addPlugin;
        return _regenerator().w(function(_context5) {
          while (1) switch (_context5.n) {
            case 0:
              addPlugin = /* @__PURE__ */ (function() {
                var _ref11 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee3() {
                  var _classPrivateFieldGet92, _classPrivateFieldGet93;
                  return _regenerator().w(function(_context3) {
                    while (1) switch (_context3.n) {
                      case 0:
                        return _context3.a(2, (_classPrivateFieldGet92 = (_classPrivateFieldGet93 = _classPrivateFieldGet(_api, _this4)) === null || _classPrivateFieldGet93 === void 0 ? void 0 : _classPrivateFieldGet93.addPlugin(name, options)) !== null && _classPrivateFieldGet92 !== void 0 ? _classPrivateFieldGet92 : Promise.reject(new Error("plugin ".concat(name, " cannot be defined"))));
                    }
                  }, _callee3);
                }));
                return function addPlugin2() {
                  return _ref11.apply(this, arguments);
                };
              })();
              if (!_classPrivateFieldGet(_api, this)) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, addPlugin());
            case 1:
              return _context5.a(2, new Promise(function(resolve, reject) {
                _this4.whenApiReady().then(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee4() {
                  return _regenerator().w(function(_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        return _context4.a(2, addPlugin());
                    }
                  }, _callee4);
                }))).then(function(plugin) {
                  return resolve(plugin);
                }).catch(function(err) {
                  if (err instanceof Error) {
                    reject(err);
                  } else {
                    reject(new Error("Promise rejected with non-Error value"));
                  }
                }).catch(function(_error) {
                });
              }));
          }
        }, _callee5, this);
      }));
      function definePlugin(_x3, _x4) {
        return _definePlugin.apply(this, arguments);
      }
      return definePlugin;
    })()
  }, {
    key: "deleteOverlay",
    value: (function() {
      var _deleteOverlay = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee6(name) {
        var _classPrivateFieldGet94;
        return _regenerator().w(function(_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (!((_classPrivateFieldGet94 = _classPrivateFieldGet(_impl, this)) !== null && _classPrivateFieldGet94 !== void 0 && _classPrivateFieldGet94.undefineOverlay)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, _classPrivateFieldGet(_impl, this).undefineOverlay(name));
            case 1:
              return _context6.a(2, Promise.reject(new Error("overlay ".concat(name, " cannot be deleted at this time"))));
          }
        }, _callee6, this);
      }));
      function deleteOverlay(_x5) {
        return _deleteOverlay.apply(this, arguments);
      }
      return deleteOverlay;
    })()
  }, {
    key: "disableControl",
    value: (function() {
      var _disableControl = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee7(name) {
        var _classPrivateFieldGet95;
        return _regenerator().w(function(_context7) {
          while (1) switch (_context7.n) {
            case 0:
              if (!((_classPrivateFieldGet95 = _classPrivateFieldGet(_impl, this)) !== null && _classPrivateFieldGet95 !== void 0 && _classPrivateFieldGet95.setControlEnabled)) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, _classPrivateFieldGet(_impl, this).setControlEnabled(name, false));
            case 1:
              return _context7.a(2, Promise.reject(new Error('control "'.concat(name, '" cannot be disabled at this time'))));
          }
        }, _callee7, this);
      }));
      function disableControl(_x6) {
        return _disableControl.apply(this, arguments);
      }
      return disableControl;
    })()
  }, {
    key: "enableControl",
    value: (function() {
      var _enableControl = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee8(name) {
        var _classPrivateFieldGet96;
        return _regenerator().w(function(_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (!((_classPrivateFieldGet96 = _classPrivateFieldGet(_impl, this)) !== null && _classPrivateFieldGet96 !== void 0 && _classPrivateFieldGet96.setControlEnabled)) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2, _classPrivateFieldGet(_impl, this).setControlEnabled(name, true));
            case 1:
              return _context8.a(2, Promise.reject(new Error('control "'.concat(name, '" cannot be enabled at this time'))));
          }
        }, _callee8, this);
      }));
      function enableControl(_x7) {
        return _enableControl.apply(this, arguments);
      }
      return enableControl;
    })()
  }, {
    key: "enterInputContext",
    value: (function() {
      var _enterInputContext = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee9(context) {
        var _classPrivateFieldGet97, _this5 = this;
        return _regenerator().w(function(_context9) {
          while (1) switch (_context9.n) {
            case 0:
              if (!((_classPrivateFieldGet97 = _classPrivateFieldGet(_impl, this)) !== null && _classPrivateFieldGet97 !== void 0 && _classPrivateFieldGet97.enterInputContext)) {
                _context9.n = 1;
                break;
              }
              return _context9.a(2, new Promise(function(resolve) {
                var _classPrivateFieldGet98;
                var _handler = function handler(event) {
                  var detail = event.detail;
                  if (detail.context === context) {
                    resolve();
                  }
                  _this5.removeEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.ve, _handler);
                };
                _this5.addEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.ve, _handler);
                (_classPrivateFieldGet98 = _classPrivateFieldGet(_impl, _this5)) === null || _classPrivateFieldGet98 === void 0 ? void 0 : _classPrivateFieldGet98.enterInputContext(context);
              }));
            case 1:
              return _context9.a(2, Promise.reject(new Error('input context of name "'.concat(context, '" cannot be enabled at this time'))));
          }
        }, _callee9, this);
      }));
      function enterInputContext(_x8) {
        return _enterInputContext.apply(this, arguments);
      }
      return enterInputContext;
    })()
  }, {
    key: "exitInputContext",
    value: (function() {
      var _exitInputContext = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee0(context) {
        var _classPrivateFieldGet99;
        return _regenerator().w(function(_context0) {
          while (1) switch (_context0.n) {
            case 0:
              if (!((_classPrivateFieldGet99 = _classPrivateFieldGet(_impl, this)) !== null && _classPrivateFieldGet99 !== void 0 && _classPrivateFieldGet99.exitInputContext)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2, Promise.resolve(_classPrivateFieldGet(_impl, this).exitInputContext(context)));
            case 1:
              return _context0.a(2, Promise.reject(new Error('control "'.concat(context, '" cannot be enabled at this time'))));
          }
        }, _callee0, this);
      }));
      function exitInputContext(_x9) {
        return _exitInputContext.apply(this, arguments);
      }
      return exitInputContext;
    })()
    /**
     * Gets initial media data for the video. This method exists purely to make
     * mocking easier in tests and mirrors the import from getInitialMediaData.ts.
     * @param {string} mediaId - The hashed ID of the media
     * @param {FetchMediaDataOptions} options - Options for fetching media data
     * @returns {Promise<MediaData | MediaDataServerErrorResponse>} The media data or error response
     */
  }, {
    key: "getInitialMediaData",
    value: (function() {
      var _getInitialMediaData2 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee1(mediaId, options) {
        return _regenerator().w(function(_context1) {
          while (1) switch (_context1.n) {
            case 0:
              return _context1.a(2, (0, _utilities_getInitialMediaData_ts__WEBPACK_IMPORTED_MODULE_32__.n)(mediaId, options));
          }
        }, _callee1);
      }));
      function getInitialMediaData(_x0, _x1) {
        return _getInitialMediaData2.apply(this, arguments);
      }
      return getInitialMediaData;
    })()
  }, {
    key: "getPlugin",
    value: (function() {
      var _getPlugin = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee10(name) {
        var _this6 = this;
        return _regenerator().w(function(_context10) {
          while (1) switch (_context10.n) {
            case 0:
              return _context10.a(2, new Promise(function(resolve, reject) {
                var _classPrivateFieldGet100;
                if ((_classPrivateFieldGet100 = _classPrivateFieldGet(_api, _this6)) !== null && _classPrivateFieldGet100 !== void 0 && _classPrivateFieldGet100.plugin && name in _classPrivateFieldGet(_api, _this6).plugin) {
                  resolve(_classPrivateFieldGet(_api, _this6).plugin[name]);
                }
                reject(new Error("plugin ".concat(name, " is not defined")));
              }));
          }
        }, _callee10);
      }));
      function getPlugin(_x10) {
        return _getPlugin.apply(this, arguments);
      }
      return getPlugin;
    })()
  }, {
    key: "getRemapTime",
    value: (function() {
      var _getRemapTime = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee11() {
        var _classPrivateFieldGet101, _this7 = this;
        var _t, _t2, _t3;
        return _regenerator().w(function(_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (!(_classPrivateFieldGet(_cachedRemapTime, this) != null)) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2, _classPrivateFieldGet(_cachedRemapTime, this));
            case 1:
              if (!(this.languages.length <= 1)) {
                _context11.n = 2;
                break;
              }
              _classPrivateFieldSet(_cachedRemapTime, this, function(_fromLanguage, _toLanguage, fromTime) {
                return fromTime;
              });
              return _context11.a(2, _classPrivateFieldGet(_cachedRemapTime, this));
            case 2:
              if (!((_classPrivateFieldGet101 = _classPrivateFieldGet(_cachedRemapTime, this)) !== null && _classPrivateFieldGet101 !== void 0)) {
                _context11.n = 3;
                break;
              }
              _classPrivateFieldGet101;
              _context11.n = 5;
              break;
            case 3:
              _t = _classPrivateFieldSet;
              _t2 = _cachedRemapTime;
              _t3 = this;
              _context11.n = 4;
              return (0, _utilities_dynamicImport_ts__WEBPACK_IMPORTED_MODULE_12__.$)("assets/external/timeMapping.js").then(function(_ref13) {
                var remapTime = _ref13.remapTime;
                return function(fromLanguage, toLanguage, fromTime) {
                  var fromTimeInMilliseconds = fromTime * 1e3;
                  var fromLocalization = _assertClassBrand(_WistiaPlayer_brand, _this7, _findLocalizationByLanguage).call(_this7, fromLanguage);
                  var sourceLocalization = _this7.sourceLanguage;
                  var toLocalization = _assertClassBrand(_WistiaPlayer_brand, _this7, _findLocalizationByLanguage).call(_this7, toLanguage);
                  if (fromLocalization == null || toLocalization == null || sourceLocalization == null) {
                    return fromTime;
                  }
                  return remapTime(sourceLocalization, fromLocalization, toLocalization, fromTimeInMilliseconds) / 1e3;
                };
              });
            case 4:
              _t(_t2, _t3, _context11.v);
            case 5:
              return _context11.a(2, _classPrivateFieldGet(_cachedRemapTime, this));
          }
        }, _callee11, this);
      }));
      function getRemapTime() {
        return _getRemapTime.apply(this, arguments);
      }
      return getRemapTime;
    })()
  }, {
    key: "hideOverlay",
    value: (function() {
      var _hideOverlay = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee12(name) {
        var _classPrivateFieldGet102;
        return _regenerator().w(function(_context12) {
          while (1) switch (_context12.n) {
            case 0:
              if (!((_classPrivateFieldGet102 = _classPrivateFieldGet(_impl, this)) !== null && _classPrivateFieldGet102 !== void 0 && _classPrivateFieldGet102.cancelOverlay)) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2, _classPrivateFieldGet(_impl, this).cancelOverlay(name));
            case 1:
              return _context12.a(2, Promise.reject(new Error("overlay ".concat(name, " cannot be cancelled at this time"))));
          }
        }, _callee12, this);
      }));
      function hideOverlay(_x11) {
        return _hideOverlay.apply(this, arguments);
      }
      return hideOverlay;
    })()
  }, {
    key: "hidePopover",
    value: (function() {
      var _hidePopover = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee13() {
        var _this8 = this;
        return _regenerator().w(function(_context13) {
          while (1) switch (_context13.n) {
            case 0:
              return _context13.a(2, new Promise(function(resolve, reject) {
                var _classPrivateFieldGet103;
                if ((_classPrivateFieldGet103 = _classPrivateFieldGet(_api, _this8)) !== null && _classPrivateFieldGet103 !== void 0 && _classPrivateFieldGet103.popover) {
                  _classPrivateFieldGet(_api, _this8).popover.hide();
                  resolve();
                }
                reject(new Error("Popover cannot be accessed"));
              }));
          }
        }, _callee13);
      }));
      function hidePopover() {
        return _hidePopover.apply(this, arguments);
      }
      return hidePopover;
    })()
  }, {
    key: "languagesToLocalizations",
    value: function languagesToLocalizations(languages) {
      var _classPrivateFieldGet104, _classPrivateFieldGet105;
      return (_classPrivateFieldGet104 = (_classPrivateFieldGet105 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet105 === void 0 ? void 0 : _classPrivateFieldGet105.languagesToLocalizations(languages)) !== null && _classPrivateFieldGet104 !== void 0 ? _classPrivateFieldGet104 : [];
    }
  }, {
    key: "languageToLocalization",
    value: function languageToLocalization(language) {
      var _classPrivateFieldGet106, _classPrivateFieldGet107;
      return (_classPrivateFieldGet106 = (_classPrivateFieldGet107 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet107 === void 0 ? void 0 : _classPrivateFieldGet107.languageToLocalization(language)) !== null && _classPrivateFieldGet106 !== void 0 ? _classPrivateFieldGet106 : _assertClassBrand(_WistiaPlayer_brand, this, _defaultLocalization).call(this);
    }
    /**
     * Pauses the video.
     * If this is called and the video's state is "playing,"
     * it's expected that it will change to "paused."
     * @returns {Promise<void>}
     */
  }, {
    key: "pause",
    value: (function() {
      var _pause = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee14() {
        var _classPrivateFieldGet108;
        return _regenerator().w(function(_context14) {
          while (1) switch (_context14.n) {
            case 0:
              return _context14.a(2, (_classPrivateFieldGet108 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet108 === void 0 ? void 0 : _classPrivateFieldGet108.pause());
          }
        }, _callee14, this);
      }));
      function pause() {
        return _pause.apply(this, arguments);
      }
      return pause;
    })()
  }, {
    key: "play",
    value: (function() {
      var _play = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee15() {
        var _classPrivateFieldGet109;
        return _regenerator().w(function(_context15) {
          while (1) switch (_context15.n) {
            case 0:
              return _context15.a(2, (_classPrivateFieldGet109 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet109 === void 0 ? void 0 : _classPrivateFieldGet109.play());
          }
        }, _callee15, this);
      }));
      function play() {
        return _play.apply(this, arguments);
      }
      return play;
    })()
  }, {
    key: "releaseControls",
    value: (function() {
      var _releaseControls = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee16(name) {
        var _classPrivateFieldGet110;
        return _regenerator().w(function(_context16) {
          while (1) switch (_context16.n) {
            case 0:
              return _context16.a(2, (_classPrivateFieldGet110 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet110 === void 0 ? void 0 : _classPrivateFieldGet110.releaseControls(name));
          }
        }, _callee16, this);
      }));
      function releaseControls(_x12) {
        return _releaseControls.apply(this, arguments);
      }
      return releaseControls;
    })()
  }, {
    key: "removeAllEventListeners",
    value: function removeAllEventListeners() {
      var _this9 = this;
      Object.entries(_classPrivateFieldGet(_eventListeners, this)).forEach(function(_ref14) {
        var _ref15 = _slicedToArray(_ref14, 2), type = _ref15[0], listeners = _ref15[1];
        listeners.forEach(function(_ref16) {
          var listener = _ref16.listener, options = _ref16.options;
          _this9.removeEventListener(type, listener, options);
        });
      });
    }
    /**
     * Removes an event listener from the player.
     * @param {string} type - The type of event to remove.
     * @param {EventListenerOrEventListenerObject} listener - The function to remove.
     * @param {EventListenerOptions | boolean} options
     * @returns {void}
     */
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener, options) {
      var listeners = _classPrivateFieldGet(_eventListeners, this)[type];
      if (!Array.isArray(listeners)) return;
      var index = listeners.findIndex(function(entry) {
        return entry.listener === listener && JSON.stringify(entry.options) === JSON.stringify(options);
      });
      if (index !== -1) {
        _superPropGet(WistiaPlayer2, "removeEventListener", this, 3)([type, listener, options]);
        listeners.splice(index, 1);
        if (listeners.length === 0) {
          _classPrivateFieldGet(_eventListeners, this)[type] = [];
        }
      }
    }
    /**
     * Replaces the media and then resolves when the new media is ready to play
     * @param {string} mediaId
     * @param {EmbedOptions} options
     * @returns {Promise<void>}
     */
  }, {
    key: "replaceWithMedia",
    value: (function() {
      var _replaceWithMedia = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee17(mediaId) {
        var _this0 = this;
        var options, _args17 = arguments;
        return _regenerator().w(function(_context17) {
          while (1) switch (_context17.n) {
            case 0:
              options = _args17.length > 1 && _args17[1] !== void 0 ? _args17[1] : {};
              return _context17.a(2, new Promise(function(resolve, reject) {
                var _classPrivateFieldGet111;
                if (!_classPrivateFieldGet(_api, _this0)) {
                  reject(new Error("api not ready to replace"));
                }
                (0, _utilities_injectJsonLd_js__WEBPACK_IMPORTED_MODULE_31__.Z)(_classPrivateFieldGet(_jsonLdId, _this0));
                var _handleAfterReplace2 = function handleAfterReplace() {
                  _this0.removeEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.$1, _handleAfterReplace2);
                  resolve();
                };
                _this0.addEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.$1, _handleAfterReplace2);
                (_classPrivateFieldGet111 = _classPrivateFieldGet(_api, _this0)) === null || _classPrivateFieldGet111 === void 0 ? void 0 : _classPrivateFieldGet111.replaceWith(mediaId, options);
              }));
          }
        }, _callee17);
      }));
      function replaceWithMedia(_x13) {
        return _replaceWithMedia.apply(this, arguments);
      }
      return replaceWithMedia;
    })()
  }, {
    key: "requestControls",
    value: (function() {
      var _requestControls = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee18(name) {
        var _classPrivateFieldGet112;
        return _regenerator().w(function(_context18) {
          while (1) switch (_context18.n) {
            case 0:
              return _context18.a(2, (_classPrivateFieldGet112 = _classPrivateFieldGet(_impl, this)) === null || _classPrivateFieldGet112 === void 0 ? void 0 : _classPrivateFieldGet112.requestControls(name));
          }
        }, _callee18, this);
      }));
      function requestControls(_x14) {
        return _requestControls.apply(this, arguments);
      }
      return requestControls;
    })()
  }, {
    key: "requestFullscreen",
    value: (function() {
      var _requestFullscreen = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee19() {
        var _classPrivateFieldGet113;
        return _regenerator().w(function(_context19) {
          while (1) switch (_context19.n) {
            case 0:
              if (!((_classPrivateFieldGet113 = _classPrivateFieldGet(_impl, this)) !== null && _classPrivateFieldGet113 !== void 0 && _classPrivateFieldGet113.requestFullscreen)) {
                _context19.n = 1;
                break;
              }
              return _context19.a(2, _classPrivateFieldGet(_impl, this).requestFullscreen());
            case 1:
              return _context19.a(2, Promise.reject(new Error("Fullscreen cannot be accessed")));
          }
        }, _callee19, this);
      }));
      function requestFullscreen() {
        return _requestFullscreen.apply(this, arguments);
      }
      return requestFullscreen;
    })()
  }, {
    key: "showOverlay",
    value: (function() {
      var _showOverlay = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee20(name) {
        var _classPrivateFieldGet114;
        return _regenerator().w(function(_context20) {
          while (1) switch (_context20.n) {
            case 0:
              if (!((_classPrivateFieldGet114 = _classPrivateFieldGet(_impl, this)) !== null && _classPrivateFieldGet114 !== void 0 && _classPrivateFieldGet114.requestOverlay)) {
                _context20.n = 1;
                break;
              }
              return _context20.a(2, _classPrivateFieldGet(_impl, this).requestOverlay(name));
            case 1:
              return _context20.a(2, Promise.reject(new Error("overlay ".concat(name, " cannot be requested at this time"))));
          }
        }, _callee20, this);
      }));
      function showOverlay(_x15) {
        return _showOverlay.apply(this, arguments);
      }
      return showOverlay;
    })()
  }, {
    key: "showPopover",
    value: (function() {
      var _showPopover = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee21() {
        var _this1 = this;
        return _regenerator().w(function(_context21) {
          while (1) switch (_context21.n) {
            case 0:
              return _context21.a(2, new Promise(function(resolve, reject) {
                var _classPrivateFieldGet115;
                if ((_classPrivateFieldGet115 = _classPrivateFieldGet(_api, _this1)) !== null && _classPrivateFieldGet115 !== void 0 && _classPrivateFieldGet115.popover) {
                  _classPrivateFieldGet(_api, _this1).popover.show();
                  resolve();
                }
                reject(new Error("Popover cannot be accessed"));
              }));
          }
        }, _callee21);
      }));
      function showPopover() {
        return _showPopover.apply(this, arguments);
      }
      return showPopover;
    })()
  }, {
    key: "updateEmbedOptions",
    value: (function() {
      var _updateEmbedOptions = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee22(options) {
        var _this10 = this;
        return _regenerator().w(function(_context22) {
          while (1) switch (_context22.n) {
            case 0:
              return _context22.a(2, new Promise(function(resolve) {
                _assertClassBrand(_WistiaPlayer_brand, _this10, _setMultipleSyncedEmbedOptions).call(_this10, options);
                resolve(_this10.embedOptions);
              }));
          }
        }, _callee22);
      }));
      function updateEmbedOptions(_x16) {
        return _updateEmbedOptions.apply(this, arguments);
      }
      return updateEmbedOptions;
    })()
  }, {
    key: "whenApiReady",
    value: (function() {
      var _whenApiReady = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee23() {
        var _this11 = this;
        return _regenerator().w(function(_context23) {
          while (1) switch (_context23.n) {
            case 0:
              return _context23.a(2, new Promise(function(resolve) {
                if (_classPrivateFieldGet(_api, _this11)) {
                  _classPrivateFieldGet(_api, _this11).ready(function() {
                    resolve();
                  });
                }
                var _handler2 = function handler() {
                  _this11.removeEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.c5, _handler2);
                  resolve();
                };
                _this11.addEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.c5, _handler2);
              }));
          }
        }, _callee23);
      }));
      function whenApiReady() {
        return _whenApiReady.apply(this, arguments);
      }
      return whenApiReady;
    })()
  }, {
    key: "whenControlMounted",
    value: (function() {
      var _whenControlMounted = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee24(handle) {
        var control;
        return _regenerator().w(function(_context24) {
          while (1) switch (_context24.n) {
            case 0:
              _context24.n = 1;
              return this.whenApiReady();
            case 1:
              if (!(_classPrivateFieldGet(_api, this) === null)) {
                _context24.n = 2;
                break;
              }
              throw new Error("Control API not available");
            case 2:
              _context24.n = 3;
              return _classPrivateFieldGet(_api, this).whenControlMounted(handle);
            case 3:
              control = _context24.v;
              if (!(control === null || control === void 0)) {
                _context24.n = 4;
                break;
              }
              throw new Error("Control not found");
            case 4:
              return _context24.a(2, control);
          }
        }, _callee24, this);
      }));
      function whenControlMounted(_x17) {
        return _whenControlMounted.apply(this, arguments);
      }
      return whenControlMounted;
    })()
    // --------------------------------------------------
    // Custom element lifecycle methods
    // --------------------------------------------------
    /**
     * Called when an observed attribute has been added, removed, updated, or replaced.
     * Also called for initial values when an element is created by the parser, or upgraded.
     * Note: only attributes listed in the observedAttributes property will receive this callback.
     * @param {string} name - The name of the attribute that changed.
     * @param {string} oldValue - The previous value of the attribute, or null if it was added for the first time.
     * @param {string} newValue - The new value of the attribute, or null if it was removed.
     * @returns {void}
     */
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (!_classPrivateFieldGet(_hasElementConnectedToDOM, this)) {
        return;
      }
      if (oldValue === newValue) {
        return;
      }
      if (oldValue === null && newValue === "") {
        return;
      }
      var finalValue = newValue;
      switch (newValue) {
        case "true":
          finalValue = true;
          break;
        case "false":
          finalValue = false;
          break;
        default:
          break;
      }
      this[(0, _utilities_camelCaseToKebabCase_ts__WEBPACK_IMPORTED_MODULE_35__.b)(name)] = finalValue;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _window$wistiaOptions, _this12 = this, _this$embedHost;
      if (_classPrivateFieldGet(_hasElementConnectedToDOM, this)) {
        return;
      }
      _classPrivateFieldSet(_hasElementConnectedToDOM, this, true);
      var mediaId = this.getAttribute("media-id");
      if (mediaId == null) {
        (0, _utilities_simpleMetrics_js__WEBPACK_IMPORTED_MODULE_24__.WO)("player/failure/init-failed");
        throw new Error("media-id attribute is required");
      }
      window.wistiaOptions = (_window$wistiaOptions = window.wistiaOptions) !== null && _window$wistiaOptions !== void 0 ? _window$wistiaOptions : {};
      var opts = (0, _utilities_wistiaOptions_ts__WEBPACK_IMPORTED_MODULE_28__.C)(this.mediaId);
      _classPrivateFieldGet(_playerData, this).setWistiaWindowEmbedOptionSource(opts);
      _classPrivateFieldSet(_logger, this, _utilities_wlog_js__WEBPACK_IMPORTED_MODULE_30__.ct.getPrefixedFunctions("WistiaPlayer ".concat(mediaId)));
      _classPrivateFieldSet(_judyContext, this, (0, _utilities_judy_js__WEBPACK_IMPORTED_MODULE_19__.gC)());
      if (this.getAttribute("react") === "true") {
        (0, _utilities_simpleMetrics_js__WEBPACK_IMPORTED_MODULE_24__.WO)("player/initembed.react");
      }
      _assertClassBrand(_WistiaPlayer_brand, this, _setupEventListeners).call(this);
      _classPrivateFieldGet(_logger, this).info("initialize embed");
      if (!this.useWebComponent) {
        (0, _utilities_wistiaQueue_ts__WEBPACK_IMPORTED_MODULE_29__.z)();
      }
      this.uniqueId = _assertClassBrand(_WistiaPlayer_brand, this, _generateUniqueId).call(this, mediaId);
      _assertClassBrand(_WistiaPlayer_brand, this, _maybeSetupEmbedOptionsFromIframe).call(this);
      _assertClassBrand(_WistiaPlayer_brand, this, _runMethodsFromAttributes).call(this);
      _assertClassBrand(_WistiaPlayer_brand, this, _saveInitialAttributesFromDomOptions).call(this);
      var resizeCallback = function resizeCallback2() {
        _assertClassBrand(_WistiaPlayer_brand, _this12, _renderPreloadThumbnail).call(_this12);
      };
      _classPrivateFieldSet(_resizeObserver, this, new ResizeObserver(resizeCallback));
      _classPrivateFieldGet(_resizeObserver, this).observe(this);
      var optsForFetch = {
        deferFetchingToCarousel: _assertClassBrand(_WistiaPlayer_brand, this, _deferMediaDataFetchingToCarouselEmbed).call(this),
        embedHost: (_this$embedHost = this.embedHost) !== null && _this$embedHost !== void 0 ? _this$embedHost : "",
        overrideMediaLanguage: this.embedOptions.language
      };
      this.getInitialMediaData(mediaId, optsForFetch).then(function(mediaDataOrError) {
        var _mediaData$hashedId;
        if ((0, _utilities_mediaDataError_ts__WEBPACK_IMPORTED_MODULE_33__.V)(mediaDataOrError)) {
          if (mediaDataOrError.iframe === true || mediaDataOrError.iframe === "true") {
            var baseUrl = "".concat((0, _utilities_hosts_js__WEBPACK_IMPORTED_MODULE_17__.v9)(), "//").concat((0, _utilities_hosts_js__WEBPACK_IMPORTED_MODULE_17__.aY)());
            _this12.style.display = "block";
            var computedStyle = getComputedStyle(_this12);
            var hasWidth = computedStyle.width !== "auto" && computedStyle.width !== "0px";
            if (!hasWidth) {
              _this12.style.width = "100%";
            }
            _this12.style.aspectRatio = String(_this12.aspect);
            if (_this12.shadowRoot) {
              _this12.shadowRoot.innerHTML = "<iframe src='".concat(baseUrl, "/embed/iframe/").concat(_this12.mediaId, "' aspect='").concat(_this12.aspect, "' style='width: 100%; height: 100%; border: 0;' scrolling='no'></iframe>");
            }
            return;
          }
        }
        var mediaData = mediaDataOrError;
        _this12.mediaId = (_mediaData$hashedId = mediaData.hashedId) !== null && _mediaData$hashedId !== void 0 ? _mediaData$hashedId : _this12.mediaId;
        _classPrivateFieldGet(_playerData, _this12).setMediaDataSource(mediaData);
        _this12.dispatchEvent(new CustomEvent(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.rO, {
          detail: {
            mediaData: _classPrivateFieldGet(_playerData, _this12).mediaData
          }
        }));
        var bestMatchContainer = document.querySelector("[unique-id='".concat(_this12.uniqueId, "']")) ? _this12.uniqueId : _this12;
        _assertClassBrand(_WistiaPlayer_brand, _this12, _initPlayerEmbed).call(_this12, {
          container: bestMatchContainer,
          mediaData: _classPrivateFieldGet(_playerData, _this12).mediaData
        });
      }).catch(function(error) {
        (0, _utilities_simpleMetrics_js__WEBPACK_IMPORTED_MODULE_24__.WO)("player/failure/init-failed");
        throw new Error(error.message);
      });
      if (this.shadowRoot) {
        if (this.wistiaPopover && this.popoverContent === "link") {
          var slot = document.createElement("slot");
          slot.name = "".concat(this.uniqueId, "-popover-link");
          this.shadowRoot.appendChild(slot);
        }
        _classPrivateFieldSet(_preactRoot, this, document.createElement("div"));
        _assertClassBrand(_WistiaPlayer_brand, this, _renderEmbedTemplate).call(this);
        this.shadowRoot.insertBefore(_classPrivateFieldGet(_preactRoot, this), this.shadowRoot.firstChild);
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _classPrivateFieldGet116, _classPrivateFieldGet117, _this$shadowRoot;
      _classPrivateFieldGet(_removeEventListeners, this).forEach(function(removeListener) {
        return removeListener();
      });
      this.removeAllEventListeners();
      _classPrivateFieldSet(_eventListeners, this, {});
      (0, _utilities_injectJsonLd_js__WEBPACK_IMPORTED_MODULE_31__.Z)(_classPrivateFieldGet(_jsonLdId, this));
      (0, _utilities_remote_data_cache_ts__WEBPACK_IMPORTED_MODULE_34__.s3)(this.mediaId);
      (_classPrivateFieldGet116 = _classPrivateFieldGet(_resizeObserver, this)) === null || _classPrivateFieldGet116 === void 0 ? void 0 : _classPrivateFieldGet116.disconnect();
      _classPrivateFieldSet(_resizeObserver, this, null);
      (0, _utilities_embedOptionStore_ts__WEBPACK_IMPORTED_MODULE_13__.iU)("__".concat(this.uniqueId, "_dom_options__"));
      (_classPrivateFieldGet117 = _classPrivateFieldGet(_api, this)) === null || _classPrivateFieldGet117 === void 0 ? void 0 : _classPrivateFieldGet117.remove();
      _classPrivateFieldSet(_api, this, null);
      (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.replaceChildren();
      _classPrivateFieldSet(_preactRoot, this, null);
      _classPrivateFieldSet(_preloadThumbnailRoot, this, null);
      _classPrivateFieldSet(_hasElementConnectedToDOM, this, false);
    }
    // --------------------------------------------------
    // Private methods
    // --------------------------------------------------
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(requiredAttributes, optionalPublicAttributes, optionalPrivateAttributes);
    }
  }]);
})(/* @__PURE__ */ _wrapNativeSuper(HTMLElement));
_WistiaPlayer = WistiaPlayer;
function _get_pageUrl(_this) {
  var _this$getAttribute3;
  return (_this$getAttribute3 = _this.getAttribute("page-url")) !== null && _this$getAttribute3 !== void 0 ? _this$getAttribute3 : (0, _utilities_inferPageUrl_ts__WEBPACK_IMPORTED_MODULE_18__.H)();
}
function _defaultLocalization() {
  return {
    bcp47LanguageTag: "en",
    familyName: "English",
    familyNativeName: "English",
    name: "English",
    nativeName: "English",
    wistiaLanguageCode: "eng",
    alpha3Bibliographic: "eng",
    alpha3Terminologic: "eng",
    duration: 0,
    genericName: "English",
    genericNativeName: "English",
    hashedId: this.mediaId,
    ietfLanguageTag: "eng",
    isLocalization: true,
    iso6392LanguageCode: "eng",
    sourceLanguage: true,
    timeMappings: []
  };
}
function _deferMediaDataFetchingToCarouselEmbed() {
  return !!document.querySelector('wistia-channel-carousel[player-dom-id="'.concat(this.id, '"]:not([is-inside-playlist-embed="true"][channel-id])'));
}
function _findLocalizationByLanguage(language) {
  var _classPrivateFieldGet118;
  if (language == null) {
    return void 0;
  }
  return (_classPrivateFieldGet118 = _classPrivateFieldGet(_playerData, this).mediaData.localizations) === null || _classPrivateFieldGet118 === void 0 ? void 0 : _classPrivateFieldGet118.find(function(localization) {
    return localization.wistiaLanguageCode === language || localization.bcp47LanguageTag === language;
  });
}
function _generateUniqueId(mediaId) {
  var prefix = "wistia-".concat(mediaId, "-");
  return (0, _utilities_seqid_js__WEBPACK_IMPORTED_MODULE_22__.h)(prefix);
}
function _getSyncedEmbedOption(key) {
  var _ref19, _ref20;
  if (_classPrivateFieldGet(_impl, this) && key in _classPrivateFieldGet(_impl, this)._attrs) {
    return _classPrivateFieldGet(_impl, this)._attrs[key];
  }
  return (_ref19 = (_ref20 = this.embedOptions[key]) !== null && _ref20 !== void 0 ? _ref20 : _assertClassBrand(_WistiaPlayer_brand, this, _getValueFromAttribute).call(this, (0, _utilities_camelCaseToKebabCase_ts__WEBPACK_IMPORTED_MODULE_35__.$)(key))) !== null && _ref19 !== void 0 ? _ref19 : defaultEmbedOptions[key];
}
function _getValueFromAttribute(name) {
  if (!this.hasAttribute(name)) {
    return null;
  }
  switch (this.getAttribute(name)) {
    case "true":
      return true;
    case "false":
      return false;
    case "":
      return true;
    case null:
    default:
      return this.getAttribute(name);
  }
}
function _initPlayerEmbed(_ref21) {
  var container = _ref21.container, mediaData = _ref21.mediaData;
  if (!_classPrivateFieldGet(_hasElementConnectedToDOM, this)) {
    return;
  }
  _classPrivateFieldGet(_playerData, this).updateEmbedOptionOverrides({
    videoFoam: true
  });
  if (mediaData && !(0, _utilities_mediaDataError_ts__WEBPACK_IMPORTED_MODULE_33__.V)(mediaData)) {
    _classPrivateFieldSet(_playerType, this, (0, _utilities_judy_js__WEBPACK_IMPORTED_MODULE_19__.$F)(_classPrivateFieldGet(_judyContext, this), _classPrivateFieldGet(_playerData, this).mediaData, _classPrivateFieldGet(_playerData, this).embedOptions));
    _assertClassBrand(_WistiaPlayer_brand, this, _renderPreloadThumbnail).call(this);
    _assertClassBrand(_WistiaPlayer_brand, this, _maybeInjectJsonLd).call(this);
  }
  if ("attachInternals" in HTMLElement.prototype && "states" in ElementInternals.prototype) {
    var _classPrivateFieldGet119;
    (_classPrivateFieldGet119 = _classPrivateFieldGet(_internals, this)) === null || _classPrivateFieldGet119 === void 0 ? void 0 : _classPrivateFieldGet119.states.delete("--initializing");
  }
  void _assertClassBrand(_WistiaPlayer_brand, this, _initPublicApi).call(this, this.mediaId, {
    container,
    mediaData
  });
}
function _initPublicApi(_x21, _x22) {
  return _initPublicApi2.apply(this, arguments);
}
function _initPublicApi2() {
  _initPublicApi2 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee27(mediaId, options) {
    var _this19 = this;
    var embeddedCallback;
    return _regenerator().w(function(_context27) {
      while (1) switch (_context27.n) {
        case 0:
          _context27.n = 1;
          return _classPrivateFieldGet(_publicApiScript, this);
        case 1:
          if (_wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__.s.PublicApi) {
            _context27.n = 2;
            break;
          }
          (0, _utilities_simpleMetrics_js__WEBPACK_IMPORTED_MODULE_24__.WO)("player/failure/init-failed");
          throw new Error("Wistia.PublicApi is not defined");
        case 2:
          embeddedCallback = function embeddedCallback2() {
            void _assertClassBrand(_WistiaPlayer_brand, _this19, _maybeInitializeMux).call(_this19);
            _assertClassBrand(_WistiaPlayer_brand, _this19, _renderEmbedTemplate).call(_this19);
            if (_classPrivateFieldGet(_playPending, _this19)) {
              void _this19.play();
            }
          };
          this.addEventListener("embedded", embeddedCallback);
          _classPrivateFieldGet(_removeEventListeners, this).push(function() {
            _this19.removeEventListener("embedded", embeddedCallback);
          });
          _classPrivateFieldSet(_api, this, new _wistia_namespace_ts__WEBPACK_IMPORTED_MODULE_3__.s.PublicApi(mediaId, options));
          this.addEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.kY, _classPrivateFieldGet(_handleBeforeReplace, this));
          this.addEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.$1, _classPrivateFieldGet(_handleAfterReplace, this));
          _classPrivateFieldGet(_removeEventListeners, this).push(function() {
            _this19.removeEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.kY, _classPrivateFieldGet(_handleBeforeReplace, _this19));
            _this19.removeEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.$1, _classPrivateFieldGet(_handleAfterReplace, _this19));
          });
          _classPrivateFieldGet(_api, this).ready(function() {
            var _classPrivateFieldGet126, _classPrivateFieldGet127;
            (_classPrivateFieldGet126 = _classPrivateFieldGet(_resizeObserver, _this19)) === null || _classPrivateFieldGet126 === void 0 ? void 0 : _classPrivateFieldGet126.disconnect();
            _classPrivateFieldSet(_resizeObserver, _this19, null);
            (_classPrivateFieldGet127 = _classPrivateFieldGet(_preloadThumbnailRoot, _this19)) === null || _classPrivateFieldGet127 === void 0 ? void 0 : _classPrivateFieldGet127.remove();
            _this19.removeEventListener("click", _classPrivateFieldGet(_handlePreloadThumbnailClick, _this19));
            _this19.dispatchEvent(new CustomEvent(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.c5, {
              detail: {
                mediaId
              }
            }));
            _this19.dispatchEvent(new CustomEvent(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.iP, {
              detail: {
                mediaId,
                api: _classPrivateFieldGet(_api, _this19)
              }
            }));
            _assertClassBrand(_WistiaPlayer_brand, _this19, _maybeSetupLLMOptimizedEmbed).call(_this19);
            if (_classPrivateFieldGet(_impl, _this19)) {
              Object.entries(_classPrivateFieldGet(_impl, _this19)._attrs).forEach(function(_ref26) {
                var _ref27 = _slicedToArray(_ref26, 2), key = _ref27[0], value = _ref27[1];
                _classPrivateFieldGet(_playerData, _this19).updateEmbedOptionOverrides(_defineProperty({}, key, value));
              });
            }
            _assertClassBrand(_WistiaPlayer_brand, _this19, _renderPreloadThumbnail).call(_this19);
          });
        case 3:
          return _context27.a(2);
      }
    }, _callee27, this);
  }));
  return _initPublicApi2.apply(this, arguments);
}
function _isPopoverWithThumbnail() {
  return this.wistiaPopover && ((0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_1__.gD)(this.popoverContent) || (0, _wistia_type_guards__WEBPACK_IMPORTED_MODULE_1__.jw)(this.popoverContent) || this.popoverContent === "thumbnail");
}
function _maybeInitializeMux() {
  return _maybeInitializeMux2.apply(this, arguments);
}
function _maybeInitializeMux2() {
  _maybeInitializeMux2 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee28() {
    var _this20 = this;
    var shouldRandomEnableMux, shouldEnableMuxForPlayer, embedType, mux;
    return _regenerator().w(function(_context28) {
      while (1) switch (_context28.n) {
        case 0:
          if (_classPrivateFieldGet(_api, this)) {
            _context28.n = 1;
            break;
          }
          return _context28.a(2);
        case 1:
          shouldRandomEnableMux = (0, _utilities_coinFlip_ts__WEBPACK_IMPORTED_MODULE_10__.k)(_utilities_shouldEnableMux_ts__WEBPACK_IMPORTED_MODULE_23__._);
          shouldEnableMuxForPlayer = (0, _utilities_shouldEnableMux_ts__WEBPACK_IMPORTED_MODULE_23__.J)(_classPrivateFieldGet(_api, this), shouldRandomEnableMux) && (0, _utilities_trackingConsentApi_js__WEBPACK_IMPORTED_MODULE_25__.D5)();
          embedType = this.useWebComponent ? "translated-web-component" : "web-component";
          if (!shouldEnableMuxForPlayer) {
            _context28.n = 3;
            break;
          }
          _context28.n = 2;
          return (0, _utilities_dynamicImport_ts__WEBPACK_IMPORTED_MODULE_12__.$)("assets/external/wistia-mux.js");
        case 2:
          mux = _context28.v;
          mux.init(_classPrivateFieldGet(_api, this), {
            embedType
          });
          this.addEventListener("visitor-tracking-change", function(event) {
            var isTrackingEnabled = event.detail.isTrackingEnabled;
            if (!isTrackingEnabled) {
              var _classPrivateFieldGet129, _classPrivateFieldGet130;
              (_classPrivateFieldGet129 = _classPrivateFieldGet(_api, _this20)) === null || _classPrivateFieldGet129 === void 0 ? void 0 : (_classPrivateFieldGet130 = _classPrivateFieldGet129.mux) === null || _classPrivateFieldGet130 === void 0 ? void 0 : _classPrivateFieldGet130.destroy();
            }
          });
        case 3:
          return _context28.a(2);
      }
    }, _callee28, this);
  }));
  return _maybeInitializeMux2.apply(this, arguments);
}
function _maybeInjectJsonLd() {
  if (this.seo && _classPrivateFieldGet(_playerType, this) !== "notplayable" && _classPrivateFieldGet(_playerType, this) !== "passwordprotected" && _classPrivateFieldGet(_playerType, this) !== "carouselHardWall") {
    _classPrivateFieldSet(_jsonLdId, this, "w-json-ld-".concat(this.uniqueId));
    (0, _utilities_injectJsonLd_js__WEBPACK_IMPORTED_MODULE_31__.Z)(_classPrivateFieldGet(_jsonLdId, this));
    (0, _utilities_injectJsonLd_js__WEBPACK_IMPORTED_MODULE_31__.g)(_classPrivateFieldGet(_jsonLdId, this), _classPrivateFieldGet(_playerData, this).mediaData, {
      embedOptions: _classPrivateFieldGet(_playerData, this).embedOptions,
      videoHeight: this.offsetHeight,
      videoWidth: this.offsetWidth
    });
  }
}
function _maybeSetupEmbedOptionsFromIframe() {
  if (!window._inWistiaIframe) {
    return;
  }
  var searchParams = new URLSearchParams(window.location.search);
  var iframeEmbedOptions = Object.fromEntries(searchParams.entries());
  iframeEmbedOptions.pageTitle = document.title;
  iframeEmbedOptions._inIframe = true;
  _classPrivateFieldGet(_playerData, this).setIframeEmbedOptionSource(iframeEmbedOptions);
}
function _maybeSetupLLMOptimizedEmbed() {
  var preloadTranscriptForLLMEmbed = this.querySelector(".wistia_preload_transcript_outer_wrapper");
  if (!preloadTranscriptForLLMEmbed) {
    return;
  }
  (0, _utilities_simpleMetrics_js__WEBPACK_IMPORTED_MODULE_24__.WO)("player/initembed.llm-optimized", 1, {
    href: window.location.href,
    mediaId: this.mediaId
  });
  preloadTranscriptForLLMEmbed.remove();
  this.captionsEnabled = true;
}
function _renderEmbedTemplate() {
  var _this$embedHost2, _this13 = this;
  if (!_classPrivateFieldGet(_preactRoot, this)) {
    return;
  }
  var mediaType = _classPrivateFieldGet(_playerData, this).mediaData.mediaType;
  var swatchUrl = getSwatchUrl(this.mediaId, (_this$embedHost2 = this.embedHost) !== null && _this$embedHost2 !== void 0 ? _this$embedHost2 : "");
  var swatchHeight = "100%";
  if (parseFloat(_classPrivateFieldGet(_paddingTop, this)) !== 0 && _classPrivateFieldGet(_paddingTop, this) !== "") {
    swatchHeight = "".concat(parseFloat(_classPrivateFieldGet(_paddingTop, this)), "px");
  }
  var playerBorderRadius = (0, _utilities_roundedPlayerDefaults_ts__WEBPACK_IMPORTED_MODULE_20__.JA)({
    playerBorderRadius: this.playerBorderRadius,
    roundedPlayer: this.roundedPlayer
  });
  (0, preact__WEBPACK_IMPORTED_MODULE_0__.render)((0, preact__WEBPACK_IMPORTED_MODULE_0__.h)(preact__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, (0, preact__WEBPACK_IMPORTED_MODULE_0__.h)("style", null, ":host {\n              display: flex;\n              position: relative;\n              width: 100%;\n              ".concat(mediaType === "Audio" ? "min-height: 45px;" : "", "\n            }")), _assertClassBrand(_WistiaPlayer_brand, this, _shouldDisplaySwatch).call(this) && (0, preact__WEBPACK_IMPORTED_MODULE_0__.h)("div", {
    style: {
      height: swatchHeight,
      left: 0,
      position: "absolute",
      top: 0,
      width: "100%"
    },
    class: "wistia_swatch"
  }, (0, preact__WEBPACK_IMPORTED_MODULE_0__.h)("div", {
    style: {
      height: "100%",
      position: "relative",
      width: "100%"
    }
  }, (0, preact__WEBPACK_IMPORTED_MODULE_0__.h)("div", {
    style: {
      height: "100%",
      left: 0,
      overflow: "hidden",
      position: "absolute",
      top: 0,
      width: "100%",
      borderRadius: "".concat(playerBorderRadius, "px")
    }
  }, (0, preact__WEBPACK_IMPORTED_MODULE_0__.h)("img", {
    src: swatchUrl,
    style: {
      filter: "blur(5px)",
      height: "100%",
      objectFit: "contain",
      width: "100%"
    },
    alt: "",
    "aria-hidden": "true"
  })))), (0, preact__WEBPACK_IMPORTED_MODULE_0__.h)("div", {
    ref: function ref(_ref22) {
      _classPrivateFieldSet(_preloadThumbnailRoot, _this13, _ref22);
    }
  })), _classPrivateFieldGet(_preactRoot, this));
}
function _renderPreloadThumbnail() {
  var _this$playerForce;
  if (!_classPrivateFieldGet(_preloadThumbnailRoot, this)) {
    return;
  }
  var _classPrivateFieldGet120 = _classPrivateFieldGet(_playerData, this).mediaData, assets = _classPrivateFieldGet120.assets, mediaType = _classPrivateFieldGet120.mediaType, carouselHardWall = _classPrivateFieldGet120.carouselHardWall;
  var _classPrivateFieldGet121 = _classPrivateFieldGet(_playerData, this).embedOptions, autoPlay = _classPrivateFieldGet121.autoPlay, plugin = _classPrivateFieldGet121.plugin;
  if (carouselHardWall) {
    return;
  }
  var thumbnailAssets = (0, _utilities_assets_js__WEBPACK_IMPORTED_MODULE_9__.Q0)(assets, {});
  var shouldRenderThumbnail = (!this.wistiaPopover || _assertClassBrand(_WistiaPlayer_brand, this, _isPopoverWithThumbnail).call(this)) && mediaType !== "Audio" && thumbnailAssets.length > 0;
  if (!shouldRenderThumbnail) {
    return;
  }
  var willAutoplay = this.autoplay || autoPlay;
  var hasVideoThumbnail = (plugin === null || plugin === void 0 ? void 0 : plugin.videoThumbnail) !== void 0;
  var shouldRenderPlaceholder = willAutoplay === true || hasVideoThumbnail;
  if (shouldRenderPlaceholder) {
    var height = this.offsetWidth / this.aspect;
    (0, preact__WEBPACK_IMPORTED_MODULE_0__.render)((0, preact__WEBPACK_IMPORTED_MODULE_0__.h)("div", {
      style: {
        width: "100%",
        height: "".concat(height, "px")
      }
    }), _classPrivateFieldGet(_preloadThumbnailRoot, this));
    return;
  }
  (0, preact__WEBPACK_IMPORTED_MODULE_0__.render)((0, preact__WEBPACK_IMPORTED_MODULE_0__.h)(_hooks_usePlayerData_tsx__WEBPACK_IMPORTED_MODULE_5__.z, {
    embedOptions: _classPrivateFieldGet(_playerData, this).embedOptions,
    mediaData: _classPrivateFieldGet(_playerData, this).mediaData
  }, (0, preact__WEBPACK_IMPORTED_MODULE_0__.h)(_components_PreloadThumbnail_tsx__WEBPACK_IMPORTED_MODULE_4__.u, {
    mediaId: this.mediaId,
    playerType: (_this$playerForce = this.playerForce) !== null && _this$playerForce !== void 0 ? _this$playerForce : _classPrivateFieldGet(_playerType, this),
    playerWidth: this.offsetWidth,
    isPlayPending: _classPrivateFieldGet(_playPending, this)
  })), _classPrivateFieldGet(_preloadThumbnailRoot, this));
}
function _runMethodsFromAttributes() {
  var _this14 = this;
  if (_assertClassBrand(_WistiaPlayer_brand, this, _getValueFromAttribute).call(this, "current-time") !== null) {
    this.whenApiReady().then(function() {
      var _ref23, _classPrivateFieldGet122, _classPrivateFieldGet123;
      var newTime = Number(_assertClassBrand(_WistiaPlayer_brand, _this14, _getValueFromAttribute).call(_this14, "current-time"));
      var isClosedPopover = (_ref23 = ((_classPrivateFieldGet122 = _classPrivateFieldGet(_api, _this14)) === null || _classPrivateFieldGet122 === void 0 ? void 0 : _classPrivateFieldGet122.popover) && !_classPrivateFieldGet(_api, _this14).popover.isVisible()) !== null && _ref23 !== void 0 ? _ref23 : false;
      var isMobile = (0, _utilities_detect_js__WEBPACK_IMPORTED_MODULE_11__.GS)();
      var shouldDelayUntilPlay = _this14.state !== "playing" && (isMobile || isClosedPopover);
      void ((_classPrivateFieldGet123 = _classPrivateFieldGet(_impl, _this14)) === null || _classPrivateFieldGet123 === void 0 ? void 0 : _classPrivateFieldGet123.time(newTime, {
        lazy: shouldDelayUntilPlay
      }));
      _assertClassBrand(_WistiaPlayer_brand, _this14, _setSyncedEmbedOption).call(_this14, "currentTime", newTime);
    }).catch(function(_error) {
    });
  }
  if (_assertClassBrand(_WistiaPlayer_brand, this, _getValueFromAttribute).call(this, "email") !== null) {
    _assertClassBrand(_WistiaPlayer_brand, this, _updateEmail).call(this, _assertClassBrand(_WistiaPlayer_brand, this, _getValueFromAttribute).call(this, "email"));
  }
  if (_assertClassBrand(_WistiaPlayer_brand, this, _getValueFromAttribute).call(this, "video-quality") !== null) {
    this.whenApiReady().then(function() {
      var _classPrivateFieldGet124;
      var newQuality = _assertClassBrand(_WistiaPlayer_brand, _this14, _getValueFromAttribute).call(_this14, "video-quality");
      (_classPrivateFieldGet124 = _classPrivateFieldGet(_impl, _this14)) === null || _classPrivateFieldGet124 === void 0 ? void 0 : _classPrivateFieldGet124.setVideoQuality(newQuality);
      _assertClassBrand(_WistiaPlayer_brand, _this14, _setSyncedEmbedOption).call(_this14, "videoQuality", newQuality);
    }).catch(function(_error) {
    });
  }
}
function _saveInitialAttributesFromDomOptions() {
  var _this15 = this;
  var domOptions = Object.fromEntries(Object.entries(this.attributes).map(function(_ref24) {
    var _ref25 = _slicedToArray(_ref24, 2), value = _ref25[1];
    return [(0, _utilities_camelCaseToKebabCase_ts__WEBPACK_IMPORTED_MODULE_35__.b)(value.name), _assertClassBrand(_WistiaPlayer_brand, _this15, _getValueFromAttribute).call(_this15, value.name)];
  }));
  _classPrivateFieldGet(_playerData, this).setDomEmbedOptionSource(domOptions);
  (0, _utilities_embedOptionStore_ts__WEBPACK_IMPORTED_MODULE_13__.gY)("__".concat(this.uniqueId, "_dom_options__"), _classPrivateFieldGet(_playerData, this).embedOptions);
}
function _setMultipleSyncedEmbedOptions(options) {
  var _this16 = this;
  Object.entries(options).forEach(function(entry) {
    var _Object$getOwnPropert;
    var _entry = _slicedToArray(entry, 2), key = _entry[0], value = _entry[1];
    if (value == null) {
      return;
    }
    if ((_Object$getOwnPropert = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(_this16), key)) !== null && _Object$getOwnPropert !== void 0 && _Object$getOwnPropert.set) {
      _this16[key] = value;
    } else {
      _assertClassBrand(_WistiaPlayer_brand, _this16, _setSyncedEmbedOption).call(_this16, key, value);
    }
  });
}
function _setSyncedEmbedOption(key, value) {
  _classPrivateFieldGet(_logger, this).info("set ".concat(key), value.toString());
  if (_classPrivateFieldGet(_impl, this)) {
    _classPrivateFieldGet(_impl, this)._attrs[key] = value;
  }
  _classPrivateFieldGet(_playerData, this).updateEmbedOptionOverrides(_defineProperty({}, key, value));
  _assertClassBrand(_WistiaPlayer_brand, this, _renderPreloadThumbnail).call(this);
}
function _setupEventListeners() {
  var _this17 = this;
  var loadedMediaDataCallback = function loadedMediaDataCallback2(event) {
    _assertClassBrand(_WistiaPlayer_brand, _this17, _updateMediaData).call(_this17, event.detail.mediaData);
  };
  var implCreatedCallback = function implCreatedCallback2(event) {
    _classPrivateFieldSet(_impl, _this17, event.detail.impl);
  };
  this.addEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.rO, loadedMediaDataCallback);
  this.addEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.dp, implCreatedCallback);
  _classPrivateFieldGet(_removeEventListeners, this).push(function() {
    _this17.removeEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.rO, loadedMediaDataCallback);
  }, function() {
    _this17.removeEventListener(_utilities_eventConstants_ts__WEBPACK_IMPORTED_MODULE_15__.dp, implCreatedCallback);
  });
  this.addEventListener("click", _classPrivateFieldGet(_handlePreloadThumbnailClick, this), {
    once: true
  });
}
function _shouldDisplaySwatch() {
  return this.swatch !== false && (!this.wistiaPopover || _assertClassBrand(_WistiaPlayer_brand, this, _isPopoverWithThumbnail).call(this));
}
function _updateEmail(email) {
  var _this18 = this;
  (0, _utilities_wistiaLocalStorage_js__WEBPACK_IMPORTED_MODULE_27__.$B)(function(localStorage2) {
    localStorage2[_classPrivateGetter(_WistiaPlayer_brand, _this18, _get_pageUrl)] = _objectSpread(_objectSpread({}, localStorage2[_classPrivateGetter(_WistiaPlayer_brand, _this18, _get_pageUrl)]), {}, {
      trackEmail: email
    });
  });
  this.dispatchEvent(new CustomEvent("emailchange", {
    detail: {
      email
    }
  }));
}
function _updateMediaData(mediaData) {
  if ((0, _utilities_mediaDataError_ts__WEBPACK_IMPORTED_MODULE_33__.V)(mediaData)) {
    return;
  }
  _classPrivateFieldGet(_playerData, this).setMediaDataSource(mediaData);
  _classPrivateFieldSet(_playerType, this, (0, _utilities_judy_js__WEBPACK_IMPORTED_MODULE_19__.$F)(_classPrivateFieldGet(_judyContext, this), _classPrivateFieldGet(_playerData, this).mediaData, _classPrivateFieldGet(_playerData, this).embedOptions));
  _assertClassBrand(_WistiaPlayer_brand, this, _renderPreloadThumbnail).call(this);
}
var getSwatchMetaData = /* @__PURE__ */ (function() {
  var _ref17 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee25(url) {
    var swatch;
    return _regenerator().w(function(_context25) {
      while (1) switch (_context25.n) {
        case 0:
          swatch = new Image();
          swatch.src = url;
          _context25.n = 1;
          return swatch.decode();
        case 1:
          return _context25.a(2, swatch);
      }
    }, _callee25);
  }));
  return function getSwatchMetaData2(_x18) {
    return _ref17.apply(this, arguments);
  };
})();
var wistiaSwatchElement = /* @__PURE__ */ (function() {
  var _ref18 = _asyncToGenerator(/* @__PURE__ */ _regenerator().m(function _callee26(mediaId, embedHost) {
    var swatchUrl, swatchImg, naturalHeight, naturalWidth, ratio, style;
    return _regenerator().w(function(_context26) {
      while (1) switch (_context26.n) {
        case 0:
          swatchUrl = getSwatchUrl(mediaId, embedHost);
          _context26.n = 1;
          return getSwatchMetaData(swatchUrl);
        case 1:
          swatchImg = _context26.v;
          naturalHeight = swatchImg.naturalHeight, naturalWidth = swatchImg.naturalWidth;
          ratio = naturalHeight / naturalWidth * 100;
          style = document.createElement("style");
          style.innerHTML = "\n    wistia-player[media-id='".concat(mediaId, "']:not(:defined) {\n      padding: ").concat(ratio, "% 0 0 0;\n      background: url(").concat(swatchUrl, ");\n      background-size: contain;\n      filter: blur(5px);\n      display: block;\n    }\n  ");
          return _context26.a(2, style);
      }
    }, _callee26);
  }));
  return function wistiaSwatchElement2(_x19, _x20) {
    return _ref18.apply(this, arguments);
  };
})();
if (customElements.get("wistia-player") === void 0) {
  customElements.define("wistia-player", WistiaPlayer);
}
var __webpack_exports__WistiaPlayer = __webpack_exports__2.$;
var __webpack_exports__wistiaSwatchElement = __webpack_exports__2.A;
export {
  __webpack_exports__WistiaPlayer as WistiaPlayer,
  __webpack_exports__wistiaSwatchElement as wistiaSwatchElement
};
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
/*
 * @license @wistia/type-guards v0.9.3
 *
 * Copyright (c) 2023-2025, Wistia, Inc. and its affiliates.
 *
 * This source code is unlicensed, all rights reserved.
 */
